import '../App.css';

export const MapLogo = () => {
    return (
        <svg id="map-logo" version="1.0" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"
            viewBox="0 0 612.000000 440.000000" preserveAspectRatio="xMidYMid meet">

            <g id="map" transform="translate(0.000000,440.000000) scale(0.100000,-0.100000)" fill="transparent"
                stroke="none">
                <path d="M24 4359 c3 -17 11 -94 17 -172 10 -129 13 -147 41 -196 30 -55 30
-55 18 -128 -12 -69 -14 -72 -37 -67 -65 17 -71 -59 -12 -146 42 -62 73 -144
64 -168 -2 -7 -1 -11 4 -8 4 3 16 -25 26 -62 10 -37 24 -79 31 -94 17 -32 18
-41 4 -33 -16 10 -11 -1 7 -16 14 -12 16 -12 8 0 -6 10 -4 12 4 7 7 -5 10 -15
7 -23 -3 -8 -2 -11 4 -8 5 3 14 -3 19 -14 14 -26 14 -34 -1 -25 -7 4 -8 3 -4
-5 4 -6 11 -9 16 -6 5 3 25 -22 45 -55 20 -32 57 -77 82 -98 36 -31 44 -44 38
-61 -7 -23 -34 -28 -53 -9 -9 9 -9 5 0 -15 7 -14 15 -22 17 -16 2 6 8 5 15 -3
6 -7 10 -11 8 -9 -4 8 31 41 45 41 8 0 61 -38 119 -84 75 -61 142 -104 237
-151 151 -76 199 -114 180 -144 -10 -16 -9 -18 5 -14 13 3 18 -2 19 -19 1 -12
7 -24 13 -26 5 -2 10 -23 10 -46 0 -45 -16 -68 -58 -80 -27 -9 -40 -31 -40
-69 1 -29 -29 -70 -43 -61 -5 3 -9 0 -9 -6 0 -6 -80 -50 -177 -97 -413 -199
-640 -313 -667 -336 -36 -31 -17 -46 23 -18 22 16 31 17 40 8 10 -9 11 -8 6 5
-5 13 10 25 75 58 44 22 86 38 92 34 6 -4 8 -3 5 3 -3 5 10 18 30 27 36 17 38
17 51 -1 13 -17 14 -17 7 5 -6 20 1 26 77 61 74 34 84 36 95 22 10 -14 11 -13
7 4 -4 16 4 25 39 42 43 21 46 21 61 4 25 -28 19 -40 -31 -63 -27 -12 -87 -41
-136 -65 -48 -24 -92 -41 -97 -38 -6 3 -10 2 -10 -4 0 -14 -58 -43 -70 -36 -6
3 -10 2 -10 -4 0 -5 -26 -21 -57 -36 -32 -14 -70 -33 -85 -41 -15 -8 -31 -16
-35 -16 -26 -5 -91 -56 -90 -69 1 -11 7 -15 16 -11 12 5 12 7 1 10 -7 3 6 14
31 26 44 21 44 21 57 1 11 -19 12 -18 6 6 -6 27 16 46 38 32 6 -3 8 -1 5 4
-10 15 35 25 46 10 6 -8 7 -6 3 5 -4 13 3 22 24 33 36 19 54 19 47 2 -3 -8 1
-14 9 -14 7 0 11 5 7 10 -3 5 5 7 18 3 13 -3 18 -3 11 0 -6 3 -10 9 -7 14 3 4
-5 6 -17 2 -43 -11 -8 14 74 52 45 22 122 59 171 83 81 40 87 42 87 23 0 -12
4 -19 9 -16 5 3 7 16 3 28 -4 18 -2 20 16 16 12 -4 22 -2 22 4 0 5 12 8 28 6
21 -2 27 -8 27 -28 1 -14 4 -31 8 -37 5 -8 3 -13 -5 -13 -9 0 -9 -3 2 -10 13
-9 13 -11 0 -20 -9 -6 -10 -10 -3 -10 6 0 15 -20 19 -45 5 -36 3 -50 -11 -65
-10 -11 -22 -17 -26 -14 -5 3 -6 -2 -3 -10 8 -22 -13 -20 -25 2 -6 9 -11 12
-11 6 0 -5 5 -15 11 -21 9 -9 3 -20 -20 -45 -23 -25 -31 -29 -31 -15 0 9 -5
17 -10 17 -7 0 -7 -7 0 -20 8 -16 7 -26 -5 -43 -8 -12 -20 -23 -25 -23 -23 -3
-24 -5 -12 -13 11 -6 10 -12 -5 -26 -10 -10 -17 -20 -16 -22 6 -8 -11 -63 -19
-63 -6 0 -5 -7 2 -15 10 -12 8 -16 -11 -24 -13 -5 -49 -27 -79 -50 -55 -41
-77 -51 -64 -28 5 8 2 7 -10 -2 -15 -12 -19 -12 -34 3 -16 17 -16 18 8 12 22
-6 22 -5 7 4 -10 7 -25 9 -34 5 -14 -5 -13 -8 6 -22 18 -12 20 -17 10 -25 -10
-7 -9 -8 6 -4 20 6 20 6 1 -9 -11 -8 -25 -15 -32 -15 -7 0 -16 -5 -20 -12 -4
-7 -3 -8 4 -4 7 4 12 4 12 1 0 -3 -20 -15 -45 -26 -51 -23 -102 -23 -194 -1
-49 12 -60 17 -45 23 16 6 15 8 -8 8 -42 1 -35 -26 10 -38 145 -38 156 -39
218 -16 100 38 114 44 114 55 0 17 28 11 32 -8 3 -14 5 -13 10 6 3 12 2 20 -3
16 -5 -3 -9 -1 -9 5 0 6 21 22 46 37 34 20 48 24 54 15 5 -9 10 -5 15 11 4 12
7 26 6 30 -1 14 39 3 43 -12 15 -52 17 -80 6 -80 -7 0 -5 -6 4 -16 20 -19 20
-44 0 -131 l-15 -70 -124 -123 -124 -123 -36 31 c-19 18 -39 32 -42 32 -3 0
11 -15 33 -34 34 -29 37 -35 25 -50 -7 -9 -20 -16 -28 -16 -8 0 -12 -4 -9 -9
3 -4 -23 -36 -57 -69 -77 -76 -76 -75 -111 -144 -17 -32 -34 -54 -40 -51 -6 3
-8 3 -4 -2 12 -13 -11 -34 -30 -28 -14 4 -14 3 -3 -5 11 -8 12 -14 4 -24 -18
-23 -12 -46 11 -40 19 6 19 7 3 10 -14 3 -16 7 -6 18 9 11 15 11 25 3 8 -6 11
-15 8 -20 -8 -14 20 -11 40 4 16 12 15 14 -8 36 -24 23 -24 25 -10 53 13 26
17 28 32 16 15 -11 16 -11 4 3 -11 14 -8 24 15 63 16 26 33 44 41 41 8 -3 10
0 6 6 -8 14 126 150 140 142 6 -3 8 -3 4 1 -9 10 42 67 53 60 5 -3 9 1 9 8 0
8 53 65 118 127 64 62 170 164 235 227 64 63 124 114 132 114 12 0 14 -23 12
-139 -2 -110 0 -135 10 -122 7 9 13 21 13 28 0 6 14 16 31 22 29 10 31 14 25
43 -5 31 -5 32 9 13 17 -22 35 -79 35 -113 0 -71 75 -163 149 -182 79 -20 78
-20 61 -30 -11 -7 -5 -10 20 -9 29 0 31 2 15 9 -23 10 -24 9 32 16 36 5 42 3
49 -18 4 -13 7 -30 6 -38 -2 -12 -1 -13 6 -1 13 19 52 -20 52 -52 0 -32 -36
-65 -52 -49 -7 7 -16 12 -22 12 -5 0 -2 -6 8 -13 16 -12 16 -14 3 -26 -13 -10
-20 -9 -39 3 -22 14 -24 14 -25 -4 -1 -11 3 -22 8 -26 8 -5 -62 -64 -76 -64
-3 0 -15 -10 -27 -22 l-21 -21 -8 21 c-6 15 -16 22 -31 21 -22 -2 -22 -2 -2
-6 20 -4 42 -43 25 -43 -5 0 -19 -9 -32 -20 -13 -11 -28 -23 -34 -27 -54 -43
-68 -52 -78 -49 -7 1 -8 1 -4 -2 5 -2 -1 -11 -13 -19 -16 -11 -25 -12 -33 -4
-6 6 -15 11 -21 11 -5 0 -2 -6 9 -13 12 -10 14 -16 7 -21 -7 -4 -12 -4 -12 1
0 4 -7 -3 -16 -15 -8 -12 -25 -22 -36 -22 -12 0 -18 -3 -15 -6 4 -4 -17 -25
-47 -48 -29 -23 -86 -68 -125 -100 -51 -42 -75 -56 -83 -48 -13 13 0 35 18 28
8 -3 11 0 7 10 -5 13 -9 12 -28 -6 -15 -14 -25 -18 -30 -11 -3 6 -12 11 -18
11 -7 0 3 -10 20 -21 18 -12 33 -24 33 -29 0 -4 -15 -19 -34 -34 -19 -14 -40
-31 -48 -38 -40 -38 -45 -40 -78 -23 -17 9 -28 20 -25 25 3 6 -1 7 -9 4 -8 -3
-33 7 -57 22 -35 22 -40 29 -28 38 8 6 15 18 17 26 1 8 -6 4 -17 -10 l-20 -25
-35 19 c-20 10 -33 23 -30 27 3 5 -3 9 -13 9 -26 0 -78 44 -69 59 4 6 12 9 17
6 5 -4 6 2 2 11 -6 16 -8 16 -21 -4 -13 -20 -16 -20 -43 -6 -32 16 -37 31 -14
40 8 4 13 10 10 14 -3 5 -1 11 5 15 5 3 10 11 10 18 0 6 -6 3 -13 -8 -9 -12
-19 -15 -28 -10 -12 7 -12 6 -1 -7 10 -12 10 -17 -1 -26 -9 -8 -19 -5 -37 8
-27 21 -40 25 -40 12 0 -4 14 -16 30 -26 17 -9 28 -21 25 -27 -3 -5 0 -6 8 -4
7 3 27 -7 43 -21 16 -15 29 -26 30 -23 0 2 29 -14 63 -36 63 -39 63 -39 36
-48 -20 -7 -30 -6 -36 4 -7 11 -9 10 -9 -3 0 -10 -8 -18 -17 -19 -10 0 -25 -2
-33 -5 -8 -2 -43 -11 -78 -20 -34 -9 -62 -22 -62 -28 0 -7 18 -30 40 -51 37
-36 39 -41 23 -52 -9 -7 -12 -13 -6 -13 7 0 15 5 18 10 5 8 12 7 23 -2 26 -20
-17 31 -56 65 -38 34 -40 47 -8 47 12 0 38 5 56 11 26 9 34 9 41 -2 7 -11 9
-11 9 2 0 12 19 21 69 34 l70 17 85 -47 c47 -26 86 -50 85 -53 0 -4 -14 -18
-30 -31 l-30 -24 -47 44 -47 44 44 -47 c24 -25 40 -51 37 -57 -11 -17 5 -13
26 6 17 15 19 15 38 -2 16 -15 23 -16 33 -6 9 10 9 11 -4 6 -21 -8 -46 22 -31
37 8 8 16 7 29 -3 16 -12 17 -12 6 2 -30 38 19 28 65 -14 17 -16 19 -23 10
-29 -9 -5 -5 -8 10 -8 19 0 21 3 12 19 -5 11 -15 23 -22 27 -8 5 -6 10 8 15
16 6 15 8 -8 8 -31 1 -58 10 -58 20 0 4 18 22 41 40 40 32 41 33 62 14 22 -18
22 -18 4 3 -16 19 -16 23 -2 34 12 10 18 10 32 -1 16 -13 17 -12 4 4 -13 16
-11 21 20 47 19 16 40 27 47 25 33 -13 45 -14 24 -4 -12 7 -22 15 -22 19 0 12
30 21 43 13 6 -4 8 0 4 9 -7 20 65 80 86 72 8 -3 18 -1 22 5 4 7 0 8 -11 4
-12 -4 -15 -3 -10 5 4 7 14 12 22 12 8 0 14 4 14 9 0 4 26 26 58 48 31 22 78
55 105 73 35 26 50 31 59 22 8 -8 7 -17 -5 -35 -12 -19 -12 -24 -2 -24 19 0
29 46 14 64 -10 12 -10 16 2 23 8 5 46 32 86 61 39 28 75 52 79 53 4 0 19 11
31 24 26 26 49 25 46 -2 0 -10 2 -15 5 -12 3 3 11 1 18 -5 8 -7 14 -6 20 2 4
7 3 9 -3 6 -6 -4 -19 5 -28 19 -18 28 -18 29 28 55 23 13 39 -4 53 -58 8 -32
8 -43 0 -43 -6 0 -5 -4 3 -9 10 -7 11 -13 2 -30 -7 -11 -10 -21 -7 -21 3 0 -1
-20 -8 -44 -10 -32 -10 -48 -3 -55 8 -8 7 -11 -4 -11 -12 0 -12 -2 1 -11 12
-8 12 -12 2 -16 -10 -4 -9 -8 5 -19 17 -13 17 -13 1 -14 -10 0 -18 -4 -18 -10
0 -5 7 -7 15 -4 11 4 15 0 15 -16 0 -18 -4 -21 -21 -17 -16 4 -18 3 -8 -9 6
-7 15 -11 20 -8 5 3 9 -2 9 -10 0 -9 -5 -16 -11 -16 -6 0 -8 -8 -5 -18 3 -10
-2 -49 -12 -87 -15 -59 -21 -69 -38 -67 -18 3 -18 3 1 -13 13 -11 16 -18 8
-21 -7 -3 -9 -12 -6 -20 3 -8 1 -20 -5 -27 -12 -15 -23 -99 -12 -92 7 4 18 41
27 95 2 14 8 26 13 28 5 2 7 9 5 15 -3 7 6 52 18 102 20 77 26 90 48 96 21 6
22 7 3 8 -19 1 -22 9 -29 83 -12 130 -10 149 10 164 10 8 14 14 9 14 -6 0 -9
13 -6 30 2 16 9 30 16 30 6 0 4 5 -4 10 -8 5 -16 17 -17 27 -1 10 -5 31 -9 46
-6 27 -6 27 20 16 29 -14 31 -19 14 -39 -11 -12 -10 -12 4 -1 26 19 58 5 59
-27 1 -18 3 -21 6 -9 6 23 12 20 102 -37 71 -46 84 -62 56 -72 -8 -4 -12 -10
-9 -16 3 -5 13 0 21 11 l14 21 50 -27 c27 -16 47 -33 45 -40 -3 -7 1 -10 8 -7
7 3 38 -12 69 -32 53 -34 70 -54 48 -54 -5 0 -12 -8 -15 -18 -12 -35 -136
-151 -136 -126 0 4 -8 0 -18 -8 -37 -32 -191 -106 -196 -95 -2 7 -5 4 -5 -6
-1 -27 -53 -68 -68 -55 -9 7 -13 7 -13 0 0 -6 5 -12 12 -14 8 -3 -1 -21 -23
-49 -47 -58 -53 -69 -37 -69 7 0 31 26 53 56 22 31 62 74 90 96 43 34 51 37
61 24 6 -9 14 -12 19 -8 4 4 4 -4 1 -18 -6 -22 -6 -23 5 -6 10 16 9 21 -5 31
-9 7 -16 15 -16 18 0 3 30 20 66 38 54 26 68 29 75 18 7 -11 9 -9 9 6 0 13 18
30 50 50 27 17 50 33 50 37 0 11 51 68 60 68 5 0 11 -8 13 -17 4 -17 5 -17 6
0 1 12 9 17 29 16 l27 -1 -25 -8 c-22 -7 -22 -8 -5 -10 11 -1 26 -2 32 -1 20
3 63 -30 56 -43 -3 -6 -2 -8 2 -3 5 4 17 0 27 -9 23 -22 7 -44 -33 -44 -27 0
-59 -34 -45 -48 3 -3 6 -2 6 3 0 4 8 1 18 -6 14 -11 15 -11 5 1 -20 22 -15 40
10 40 14 0 39 -16 62 -40 34 -35 37 -41 24 -57 -13 -17 -13 -17 4 -4 16 13 21
12 44 -11 l25 -25 -32 -23 c-30 -22 -32 -22 -52 -4 l-22 19 20 -27 c17 -23 21
-25 35 -11 14 11 18 12 22 1 4 -9 6 -8 6 3 1 9 13 24 27 34 24 15 28 16 42 1
14 -14 14 -16 -1 -22 -9 -3 -17 -11 -17 -17 0 -5 8 -2 19 7 18 16 20 15 41
-19 l22 -36 -23 -25 c-25 -26 -14 -33 17 -10 17 13 21 12 37 -1 22 -21 32 -11
16 16 -12 17 -10 24 11 46 l24 25 44 -50 c24 -27 48 -50 54 -50 6 0 -10 22
-36 50 -48 52 -54 65 -33 73 7 3 36 -23 67 -59 30 -35 58 -64 63 -64 11 0 -1
17 -66 89 -26 30 -45 57 -40 61 4 4 34 30 66 59 60 53 82 63 73 34 -9 -33 -16
-249 -7 -228 4 11 9 49 10 85 2 36 6 82 9 103 7 36 8 37 27 23 20 -14 20 -14
0 -38 l-20 -23 21 18 c20 16 21 16 38 -2 16 -18 16 -20 -6 -35 -12 -9 -18 -16
-14 -16 5 0 17 7 26 15 15 14 19 13 34 -3 15 -17 15 -20 1 -32 -12 -10 -18
-10 -32 1 -17 13 -17 13 -3 -5 13 -17 12 -21 -14 -43 -16 -13 -26 -27 -23 -30
3 -3 17 8 31 23 19 23 27 26 37 17 10 -10 9 -16 -2 -30 -13 -17 -13 -17 5 -3
16 13 20 12 31 -3 7 -9 16 -17 21 -17 4 0 -7 16 -26 35 -28 29 -31 37 -20 49
7 9 17 13 24 9 6 -3 -2 8 -17 24 -36 39 -23 48 28 20 30 -17 44 -35 65 -84 14
-34 29 -66 33 -70 4 -4 29 14 55 40 40 39 52 46 70 40 22 -8 22 -9 -9 -46 -40
-49 -24 -48 25 2 27 28 43 37 60 34 28 -6 213 12 240 23 13 5 17 4 13 -4 -4
-5 44 16 107 49 63 32 117 59 119 59 3 0 -17 -42 -44 -92 -53 -101 -55 -108
-36 -108 7 0 29 34 50 75 64 129 81 150 144 181 32 15 65 33 73 39 30 24 63
24 123 -1 33 -13 68 -31 78 -40 11 -10 29 -62 45 -133 15 -64 29 -118 31 -120
12 -16 8 20 -17 123 -32 135 -43 150 -133 186 -32 12 -56 28 -54 34 10 29 153
32 162 3 2 -7 15 -82 30 -167 15 -85 31 -162 37 -170 7 -11 8 -8 5 12 -5 32
-1 34 25 11 18 -16 19 -16 25 5 3 12 11 22 18 22 7 0 16 7 19 16 5 14 4 15 -7
5 -11 -9 -17 -8 -27 4 -12 14 -15 13 -35 -5 l-23 -21 -6 36 c-4 20 -10 44 -13
53 -5 14 -2 14 17 -3 l24 -20 -17 25 c-23 34 -21 43 6 26 21 -14 22 -14 24 17
1 29 1 30 -8 8 -8 -19 -12 -21 -24 -11 -8 7 -15 9 -15 4 0 -5 -5 -2 -9 6 -10
17 -25 113 -22 149 0 13 -4 30 -11 38 -9 11 -9 16 1 22 10 6 9 10 -3 14 -12 5
-16 0 -16 -18 0 -24 -2 -25 -75 -25 -41 0 -75 1 -75 3 0 2 29 27 64 55 44 35
71 50 83 46 15 -5 16 -4 3 5 -13 10 -13 12 0 21 8 5 11 10 5 10 -5 0 -3 6 6
13 8 7 25 30 38 53 21 38 49 52 62 32 3 -5 11 10 18 32 7 25 16 38 23 34 7 -4
8 -3 4 4 -10 17 -26 15 -26 -3 0 -8 -4 -15 -10 -15 -5 0 -7 -7 -4 -15 4 -9 0
-15 -10 -15 -20 0 -20 11 -1 57 12 28 18 34 27 25 7 -7 16 -12 22 -12 5 0 2 6
-8 13 -18 13 -18 15 -1 40 9 15 22 24 28 20 5 -3 7 -2 4 4 -4 6 -1 18 7 28 12
17 15 16 54 -10 23 -15 42 -32 42 -36 0 -5 6 -9 13 -9 7 0 23 -7 35 -16 18
-13 21 -19 11 -30 -9 -11 -9 -14 1 -14 7 0 10 -8 8 -18 -3 -11 0 -19 7 -19 7
0 11 6 8 13 -2 6 1 15 7 19 16 10 62 -16 56 -31 -2 -6 3 -11 12 -10 9 0 16 -4
15 -11 -2 -7 4 -10 12 -7 8 4 15 1 15 -7 0 -7 3 -10 6 -6 8 8 94 -50 94 -63 0
-6 6 -9 13 -7 6 1 11 -3 10 -10 -2 -7 4 -10 12 -7 8 4 15 1 15 -5 0 -6 5 -11
10 -11 18 0 90 -52 84 -61 -3 -5 1 -7 8 -4 7 3 25 -6 40 -20 15 -14 30 -25 33
-25 15 0 74 -46 71 -55 -2 -6 4 -11 13 -12 88 -9 197 -29 204 -37 4 -6 5 -19
3 -28 -2 -10 0 -18 5 -18 16 0 39 -104 39 -182 0 -45 4 -78 10 -78 6 0 10 7
10 15 0 9 10 15 23 16 16 1 17 3 5 6 -14 4 -17 15 -15 69 1 35 -2 64 -6 64 -5
0 -6 12 -3 26 4 15 3 23 -3 20 -10 -6 -31 45 -31 75 0 23 -13 22 140 3 169
-22 261 -61 226 -97 -15 -14 -12 -27 6 -27 5 0 7 4 4 9 -3 5 0 14 8 20 11 9
23 6 52 -11 22 -12 41 -26 42 -30 2 -4 10 -8 18 -8 8 0 17 -7 20 -15 4 -8 10
-12 15 -9 12 7 11 -3 -2 -28 -7 -13 -14 -17 -18 -10 -4 7 -12 3 -20 -11 -13
-20 -13 -21 2 -8 12 9 17 10 17 2 0 -6 -10 -16 -22 -21 -13 -5 -17 -9 -10 -9
10 -1 10 -6 2 -21 -8 -16 -8 -20 4 -20 8 0 28 25 45 55 32 56 47 67 57 40 4
-8 9 -13 13 -10 4 2 44 -18 89 -45 l81 -49 38 67 c21 37 40 72 42 77 2 6 13
22 23 37 12 17 17 37 14 50 -3 13 -3 17 0 11 3 -7 13 -13 22 -13 13 0 13 2 -3
14 -18 13 -16 17 28 96 26 45 47 88 47 96 0 7 -15 16 -32 19 -18 4 -61 16 -95
27 -54 16 -63 22 -63 43 0 13 4 26 9 29 4 3 40 -3 80 -14 84 -24 101 -25 101
-6 0 9 -21 21 -55 31 -30 8 -55 17 -55 20 0 2 4 15 10 29 6 18 6 26 -1 26 -6
0 -7 4 -4 10 3 5 0 7 -8 4 -8 -3 -13 -13 -10 -23 5 -21 -24 -48 -37 -35 -11
11 -2 54 11 54 5 0 9 9 9 20 0 11 18 56 40 100 32 63 44 78 57 74 15 -5 16 -4
3 5 -13 9 -10 19 18 76 17 36 27 65 22 65 -5 0 -41 -64 -80 -142 -39 -79 -77
-149 -83 -155 -10 -10 -19 -10 -46 -1 -26 11 -32 17 -28 36 3 15 1 20 -5 14
-5 -5 -10 -19 -11 -31 -1 -11 -4 -21 -7 -21 -4 0 -6 -10 -6 -22 1 -32 -34 -35
-92 -7 -71 34 -222 194 -207 219 5 8 13 6 26 -6 25 -22 24 -9 -1 23 -21 27
-13 53 16 53 20 0 17 9 -7 29 -20 16 -20 18 -5 33 9 9 12 19 8 22 -5 3 -16 -8
-26 -24 -21 -36 -21 -41 -6 -50 7 -4 9 -13 5 -19 -5 -9 -10 -9 -21 0 -7 6 -11
15 -8 20 3 5 -1 9 -9 9 -8 0 -20 7 -28 16 -10 13 -10 17 1 24 10 6 7 9 -11 12
-16 2 -24 9 -23 21 1 9 -4 17 -11 17 -8 0 -39 30 -70 66 -43 50 -53 69 -43 75
10 7 8 9 -6 9 -22 0 -40 21 -61 69 -12 28 -13 36 -3 43 10 6 10 8 1 8 -17 0
-17 27 0 33 9 4 9 6 0 6 -12 1 -19 41 -8 41 9 0 190 -111 200 -123 11 -14 20
-15 125 -23 82 -6 118 -22 143 -63 12 -20 17 -22 17 -8 0 9 1 17 3 17 23 -3
105 -39 100 -44 -4 -3 -8 -14 -9 -22 -1 -9 1 -13 4 -9 4 4 7 10 7 13 1 17 18
32 38 32 19 0 18 -3 -13 -35 -18 -18 -38 -33 -43 -32 -6 1 -13 -7 -15 -18 -3
-16 -1 -18 9 -8 10 10 17 9 33 -5 21 -17 21 -17 4 4 -17 20 -16 21 20 57 l38
37 60 -32 c32 -17 62 -36 65 -41 3 -5 9 -9 12 -9 17 0 47 -11 47 -17 0 -4 -16
-22 -35 -41 -19 -19 -35 -37 -35 -42 0 -4 19 13 42 38 25 27 38 48 32 54 -5 5
-45 29 -90 53 -74 41 -122 55 -197 56 -16 1 -39 12 -54 27 -14 14 -31 23 -39
20 -7 -3 -20 2 -29 10 -8 9 -15 12 -15 8 0 -3 -6 -2 -12 3 -7 5 -44 10 -83 12
-65 3 -99 13 -150 44 -11 6 -50 29 -88 50 -37 21 -67 44 -67 52 0 15 88 68
100 60 4 -3 11 2 14 11 4 9 13 14 21 10 8 -3 15 -1 15 4 0 12 122 80 145 80
10 0 23 7 29 14 6 8 63 42 126 75 109 57 117 59 160 51 59 -11 120 -37 120
-51 0 -7 10 -9 26 -5 15 4 23 3 20 -3 -4 -5 3 -7 16 -3 14 3 19 1 14 -6 -5 -8
-2 -10 9 -6 20 8 12 16 -28 30 -18 6 -38 22 -44 35 -10 20 -13 21 -13 5 0 -12
-5 -16 -16 -12 -9 3 -20 6 -25 6 -6 0 -7 5 -3 12 4 7 3 8 -4 4 -15 -9 -92 12
-92 26 0 7 -4 7 -13 -1 -8 -6 -17 -8 -20 -4 -4 3 -7 2 -7 -4 0 -11 -59 -40
-72 -35 -5 1 -8 -2 -8 -7 0 -5 -24 -21 -52 -37 -64 -33 -138 -37 -187 -8 -17
10 -31 21 -31 24 0 3 11 22 25 43 25 36 45 48 45 26 0 -5 5 -7 11 -3 8 4 5 10
-7 18 -11 6 -21 11 -24 11 -3 0 -12 4 -20 10 -13 7 -13 6 -2 -8 14 -16 9 -37
-9 -37 -6 0 -7 5 -4 10 4 6 3 10 -2 9 -24 -4 -35 2 -29 17 5 13 4 14 -7 6 -8
-7 -17 -9 -20 -5 -4 3 -7 4 -7 1 0 -3 16 -15 36 -27 35 -21 39 -45 6 -35 -13
5 -14 4 -3 -4 7 -5 11 -14 7 -20 -4 -7 -28 -1 -66 15 -33 14 -57 31 -53 36 3
6 1 7 -5 3 -10 -6 -151 40 -162 53 -5 6 -13 8 -109 19 l-64 7 42 53 c23 28 46
52 51 52 6 0 9 3 8 8 -2 4 12 26 31 49 24 31 42 43 60 43 17 0 22 3 13 8 -8 6
0 14 25 27 31 16 60 20 164 20 85 0 131 4 141 12 20 17 60 18 223 4 128 -12
192 -10 298 6 81 12 27 18 -180 19 -202 0 -225 2 -314 26 -53 14 -130 42 -172
61 l-75 35 32 113 c18 63 59 232 91 376 40 177 62 256 67 243 13 -35 16 -22 5
20 -8 30 -8 43 1 52 9 9 12 9 12 -1 0 -7 5 -9 10 -6 13 8 40 -19 40 -39 0 -23
-21 -20 -27 4 -3 11 -9 20 -14 20 -5 0 -3 -11 3 -25 14 -30 36 -33 46 -5 7 19
10 18 62 -17 30 -20 57 -39 60 -42 3 -4 23 -19 45 -34 22 -15 54 -38 70 -50
225 -165 333 -229 240 -142 -20 20 -40 34 -43 31 -6 -7 -32 13 -32 25 0 5 25
9 55 9 30 0 55 5 55 10 0 10 -30 14 -81 11 -41 -3 -134 37 -201 87 -35 25
-119 84 -188 130 -69 46 -124 88 -123 93 2 5 -9 11 -25 15 -48 11 -57 14 -80
32 -22 17 -22 18 -3 38 18 20 67 31 216 50 28 3 52 8 54 10 2 2 11 -2 19 -9
13 -9 14 -9 8 1 -5 8 1 12 19 12 14 0 24 -4 21 -8 -3 -5 1 -9 8 -9 9 0 12 7 8
15 -4 11 -1 14 11 9 9 -3 17 -3 17 2 0 9 101 57 113 53 5 -1 6 2 3 7 -10 15
86 51 107 39 11 -5 16 -16 13 -24 -3 -8 -2 -13 2 -11 4 3 18 -12 31 -34 25
-39 51 -58 51 -36 0 7 -9 18 -20 25 -11 7 -20 19 -20 28 0 8 4 13 9 10 5 -3
12 1 15 9 4 13 2 13 -14 5 -12 -7 -21 -7 -25 0 -3 5 -3 10 2 10 4 0 -3 7 -15
16 -33 23 -27 38 23 65 25 13 45 30 45 38 0 12 -3 11 -17 -1 -10 -9 -33 -23
-51 -33 -32 -16 -35 -15 -48 2 -14 17 -14 17 -5 -4 10 -19 6 -24 -37 -48 -35
-20 -51 -24 -63 -16 -14 8 -16 6 -12 -8 5 -20 -21 -36 -39 -24 -6 3 -8 1 -5
-4 4 -6 -7 -16 -24 -23 -26 -11 -32 -10 -45 6 -14 18 -15 18 -5 -2 10 -20 7
-22 -47 -32 -31 -6 -79 -14 -107 -17 -27 -4 -58 -9 -67 -12 -14 -3 -18 2 -18
21 0 18 -5 26 -17 25 -11 0 -13 -3 -5 -6 20 -8 15 -43 -7 -43 -11 0 -22 6 -24
13 -3 7 -6 4 -6 -6 -1 -13 -8 -18 -23 -15 -13 1 -24 -2 -25 -6 0 -5 -8 -13
-17 -18 -9 -5 -16 -16 -16 -24 0 -12 -11 -9 -50 13 -28 15 -48 33 -46 40 3 7
-1 10 -9 7 -8 -3 -20 -2 -27 2 -7 5 -24 10 -38 12 -13 2 -28 9 -32 15 -6 9 -8
9 -8 -1 0 -9 -7 -11 -22 -6 -13 4 -32 8 -43 9 -11 1 -23 3 -27 4 -5 0 -8 8 -8
16 0 18 36 20 43 3 3 -8 6 -6 6 5 1 12 -7 17 -29 17 -24 0 -30 -4 -30 -21 0
-17 -4 -19 -22 -13 -40 12 -118 54 -118 63 0 5 -12 12 -26 15 -38 10 -112 60
-94 63 216 42 326 59 331 51 4 -7 8 -7 10 1 2 6 22 13 44 17 22 3 69 12 105
19 44 9 67 10 71 3 4 -7 8 -6 11 3 2 7 20 13 40 13 20 1 34 4 32 7 -2 4 11 13
29 20 17 7 40 20 50 29 10 8 20 13 24 12 3 -2 9 0 12 5 3 4 20 18 37 30 24 17
34 19 43 10 9 -9 11 -8 6 3 -7 19 120 104 142 96 8 -3 11 -2 8 3 -5 9 30 34
167 119 73 46 67 47 113 -33 16 -27 30 -44 33 -37 2 6 -10 36 -27 66 l-31 54
32 13 c17 7 26 15 20 17 -6 2 -20 -1 -30 -7 -16 -8 -21 -6 -30 14 -7 14 -16
25 -22 25 -6 0 -9 4 -6 9 4 5 0 11 -6 14 -10 3 -10 7 0 20 11 13 10 15 -6 10
-15 -3 -22 2 -28 19 -4 12 -7 26 -6 31 1 4 -2 7 -8 7 -5 0 -16 13 -24 29 -11
21 -12 31 -3 40 8 8 8 11 0 11 -6 0 -19 7 -28 16 -12 13 -13 19 -4 30 9 12 9
13 -3 9 -9 -4 -21 4 -32 19 -9 15 -14 26 -10 26 4 0 -5 9 -20 21 -31 24 -32
35 -9 63 15 18 14 18 -8 -2 l-26 -22 -18 20 c-20 22 -40 26 -51 8 -4 -7 -3 -8
5 -4 14 9 99 -77 127 -130 11 -21 42 -76 68 -122 26 -45 44 -87 41 -92 -3 -6
-2 -10 4 -10 14 0 53 -68 46 -80 -7 -11 -61 -41 -71 -40 -3 1 -11 -6 -18 -15
-10 -14 -14 -14 -23 -3 -6 7 -13 20 -15 28 -5 23 -38 44 -50 32 -7 -7 -4 -10
8 -9 11 1 18 -4 17 -10 -2 -7 2 -13 8 -13 6 0 9 -7 5 -15 -3 -8 0 -14 6 -12
24 5 16 -20 -11 -36 -28 -17 -30 -17 -40 0 -8 14 -12 16 -22 6 -11 -11 -10
-15 0 -25 11 -10 13 -10 7 0 -4 6 -2 12 3 12 30 0 1 -25 -104 -89 -64 -40
-121 -69 -127 -65 -7 4 -8 3 -4 -4 8 -14 -82 -74 -97 -65 -6 3 -7 2 -4 -4 7
-11 -34 -33 -62 -33 -23 0 -34 23 -18 39 7 7 1 6 -16 -1 -16 -8 -21 -14 -13
-16 8 -2 17 -10 20 -17 5 -14 -1 -17 -66 -30 -9 -1 -19 5 -21 14 -4 15 -5 15
-6 -1 -1 -11 -14 -18 -43 -23 -74 -13 -92 -16 -133 -25 -28 -6 -42 -5 -47 3
-6 9 -8 9 -8 0 0 -11 -53 -25 -140 -37 -19 -3 -59 -10 -88 -17 -29 -6 -56 -9
-58 -6 -3 2 31 42 76 87 44 46 80 84 80 86 0 12 -29 1 -34 -12 -5 -13 -13 -15
-39 -9 -17 4 -50 10 -72 14 -38 6 -40 8 -43 44 -3 33 -1 37 20 37 36 0 68 -11
68 -23 0 -6 -7 -19 -17 -29 -9 -10 -11 -18 -5 -18 6 0 18 13 28 28 15 27 19
28 58 21 22 -5 44 -8 49 -9 18 -1 4 -20 -15 -20 -17 0 -20 -3 -9 -9 9 -6 25
-2 44 10 26 15 31 24 30 58 0 23 -7 47 -17 56 -9 9 -16 24 -16 33 0 14 -2 14
-9 3 -6 -10 -19 -12 -45 -7 -31 6 -35 10 -31 29 11 48 35 201 35 222 0 13 6
26 13 28 9 4 9 6 0 6 -8 1 -13 15 -13 34 0 28 6 35 43 55 23 12 58 36 77 53
19 17 68 59 108 92 40 33 70 62 67 65 -2 3 -24 -12 -49 -31 l-44 -37 -21 36
c-12 20 -24 34 -27 32 -3 -3 4 -21 16 -40 l20 -34 -30 -29 c-20 -19 -30 -24
-30 -14 0 8 -6 3 -13 -11 -7 -13 -31 -38 -55 -54 -36 -26 -45 -28 -52 -16 -7
10 -10 11 -10 3 0 -9 -19 -13 -60 -13 l-60 0 0 33 c0 17 -8 64 -18 102 -15 58
-22 71 -40 73 -20 3 -22 0 -16 -22 8 -32 6 -32 -47 -1 -24 14 -51 25 -59 24
-8 0 3 -9 25 -21 22 -11 49 -28 59 -37 25 -21 56 -89 56 -123 l0 -28 -76 0
c-41 0 -84 5 -95 11 -11 6 -30 12 -42 15 -12 2 -27 11 -34 19 -7 11 -13 12
-18 6 -3 -6 0 -11 7 -12 7 0 -2 -7 -20 -15 -33 -15 -52 -12 -52 8 0 5 6 8 13
5 8 -3 13 3 13 18 0 13 -4 21 -8 19 -5 -3 -6 -9 -3 -14 3 -4 -2 -11 -10 -14
-10 -4 -20 3 -27 19 -6 14 -18 25 -25 25 -8 0 -11 5 -8 10 4 6 10 8 14 6 4 -3
14 4 22 15 17 25 69 54 88 50 8 -1 10 2 5 10 -5 8 -2 11 8 7 9 -4 15 0 15 8 0
22 -30 17 -73 -12 -34 -23 -42 -25 -69 -15 -17 6 -39 11 -48 11 -9 0 -17 7
-17 15 0 8 -5 15 -11 15 -6 0 -8 -9 -4 -22 5 -21 5 -21 -10 2 l-15 25 2 -30
c2 -16 8 -34 14 -40 7 -5 14 -22 18 -37 5 -22 0 -31 -33 -57 -21 -17 -42 -31
-45 -31 -4 0 -18 12 -31 28 -18 21 -26 24 -34 15 -6 -7 -8 -11 -4 -8 7 6 53
-34 53 -46 0 -5 -20 -22 -45 -39 -35 -24 -49 -29 -63 -21 -9 6 -13 11 -8 11 5
0 3 7 -4 15 -6 8 -9 19 -5 25 10 16 -36 -11 -52 -30 -7 -8 -13 -19 -13 -25 0
-5 7 1 16 13 14 20 52 33 40 13 -3 -5 1 -14 9 -21 8 -7 12 -16 10 -20 -8 -13
-66 -40 -86 -40 -10 0 -30 -5 -45 -12 -23 -11 -28 -10 -41 7 -15 20 -15 20 -9
0 5 -17 -2 -22 -44 -36 -46 -14 -50 -14 -50 1 0 9 9 25 21 36 l21 19 -21 16
c-11 9 -18 19 -15 22 3 3 -2 4 -13 2 -10 -2 -22 -4 -27 -4 -6 -1 -1 -7 9 -15
18 -13 17 -13 -9 -11 -24 3 -25 1 -14 -12 11 -14 11 -15 -8 -5 -12 6 -24 8
-28 5 -3 -3 -6 1 -6 11 0 9 -4 15 -9 12 -5 -3 -12 1 -15 10 -4 11 -2 15 8 11
8 -3 20 2 28 11 7 8 8 13 2 9 -7 -4 -23 10 -38 33 -14 22 -29 40 -32 40 -4 0
-2 -6 5 -13 8 -10 7 -17 -2 -27 -9 -10 -9 -11 1 -6 22 13 35 -5 17 -24 -9 -10
-14 -24 -10 -30 9 -14 -14 -41 -29 -34 -6 3 -3 -1 6 -8 12 -11 13 -16 5 -24
-7 -5 -10 -8 -8 -7 7 4 31 -19 31 -29 0 -5 -5 -6 -12 -2 -7 5 -8 3 -3 -6 4 -7
2 -16 -6 -21 -9 -6 -10 -9 -2 -9 6 0 18 9 26 21 l15 20 18 -24 c11 -13 26 -22
34 -19 8 2 -1 -10 -20 -26 -36 -32 -57 -41 -44 -20 4 6 3 8 -3 5 -6 -4 -27 15
-48 41 -36 46 -37 48 -29 112 4 36 6 77 5 92 -1 21 7 31 44 53 25 14 50 23 57
19 6 -4 8 -3 4 4 -3 6 8 20 25 33 25 18 33 19 40 8 5 -9 1 -22 -14 -39 l-22
-25 23 19 c15 14 26 16 33 9 7 -7 0 -18 -21 -37 -24 -20 -29 -30 -21 -39 7 -9
7 -18 1 -25 -7 -8 -7 -9 1 -3 6 5 17 7 23 5 6 -2 29 14 51 36 30 30 42 37 52
28 10 -8 11 -14 1 -27 -6 -9 14 8 45 38 50 48 54 56 39 67 -14 10 -15 14 -2
30 14 17 14 18 -2 5 -15 -11 -21 -11 -33 -1 -14 11 -14 15 2 34 18 21 18 21
-3 4 -19 -17 -21 -17 -39 0 -19 17 -19 16 -2 -4 9 -11 14 -24 10 -29 -5 -4 -3
-5 3 -2 7 4 17 0 24 -8 11 -13 9 -20 -10 -40 -21 -22 -26 -24 -39 -11 -12 13
-12 17 0 33 12 16 12 17 -2 6 -23 -19 -32 -3 -12 21 18 21 18 21 -3 3 -18 -15
-23 -15 -33 -4 -6 8 -8 23 -4 33 6 16 4 17 -9 7 -8 -7 -19 -9 -23 -5 -5 4 -5
2 -2 -4 7 -13 -89 -104 -110 -104 -8 0 -12 3 -10 8 3 4 1 25 -3 47 -8 39 -9
39 -7 -14 1 -46 -3 -57 -21 -69 -21 -14 -22 -13 -22 27 0 22 3 41 8 41 4 0 6
18 4 40 -2 22 -8 40 -12 40 -9 0 -20 -60 -20 -109 0 -28 -3 -33 -19 -28 -12 3
-22 -1 -25 -10 -5 -12 -9 -13 -21 -3 -14 11 -13 15 7 34 12 12 27 20 33 18 5
-2 -12 19 -40 47 -27 28 -51 51 -54 51 -3 0 10 -15 27 -33 18 -18 29 -37 25
-42 -5 -4 -3 -5 4 -1 15 8 27 -10 12 -19 -6 -4 -20 2 -32 12 -23 21 -58 42
-45 28 4 -4 3 -13 -2 -20 -6 -8 4 -25 34 -54 27 -27 46 -39 50 -32 10 15 49
14 44 -1 -3 -7 -25 -27 -50 -44 l-46 -33 -41 51 c-40 50 -41 52 -24 72 18 21
18 21 -4 3 -21 -18 -22 -18 -40 9 -10 15 -17 37 -15 48 2 15 0 17 -6 8 -7 -10
-15 -6 -35 17 -28 34 -37 38 -37 17 0 -8 -3 -16 -7 -19 -5 -2 -3 -2 4 -1 7 2
26 -15 43 -36 18 -22 28 -40 23 -40 -4 0 -1 -5 7 -10 11 -7 3 -10 -30 -11 -36
-2 -39 -3 -13 -6 26 -3 33 -9 36 -31 l4 -27 2 28 c1 28 19 35 39 15 18 -18 14
-27 -10 -22 -13 2 -8 -2 10 -9 30 -11 73 -61 62 -70 -3 -2 -27 -20 -55 -41
-44 -33 -50 -35 -56 -19 -6 15 -8 14 -8 -6 -1 -18 -5 -22 -22 -18 -15 4 -18 2
-10 -7 8 -9 -5 -24 -52 -59 -62 -45 -64 -46 -127 -41 -36 3 -82 5 -102 4 l-38
-1 0 45 c0 32 -5 46 -17 51 -29 12 -93 18 -93 8 0 -4 15 -8 33 -9 56 -1 67 -9
67 -54 0 -35 -3 -40 -22 -40 -58 0 -65 9 -88 91 -21 78 -20 149 2 149 5 0 7
-4 4 -8 -3 -5 1 -9 9 -9 13 0 13 3 -1 18 -9 10 -11 19 -6 23 6 3 12 1 14 -6 5
-14 28 -1 27 15 0 9 -2 8 -6 -1 -2 -6 -9 -9 -14 -6 -6 3 -5 12 3 22 7 10 1 7
-12 -4 -38 -32 -50 -21 -50 47 0 33 4 58 8 55 5 -3 6 8 4 25 -8 56 -29 32 -35
-42 -3 -39 -8 -73 -10 -76 -3 -2 -28 -5 -56 -6 -28 -1 -51 -5 -51 -8 0 -3 -12
-4 -26 -1 -16 3 -21 7 -14 12 8 5 5 9 -9 13 -16 4 -21 0 -21 -14 0 -13 7 -19
21 -19 11 0 17 -4 14 -10 -9 -15 26 -12 75 5 55 19 60 19 31 -5 -15 -13 -18
-20 -9 -20 8 0 18 4 24 10 6 6 10 3 11 -11 1 -12 8 -29 16 -38 17 -19 40 -108
32 -122 -4 -5 -2 -9 3 -9 17 0 20 -49 4 -55 -9 -3 -78 0 -153 6 -137 12 -138
12 -142 38 l-4 26 -2 -27 c-1 -24 -5 -28 -28 -28 -32 0 -48 9 -56 30 -4 12 -6
11 -6 -2 -1 -14 -10 -18 -41 -18 -25 0 -40 5 -40 13 0 9 -3 9 -9 -1 -5 -8 -17
-12 -27 -10 -27 4 -143 346 -122 359 11 7 11 9 -1 9 -8 0 -20 8 -28 18 -14 16
-14 16 -9 0 4 -13 0 -18 -17 -19 -21 -1 -21 -1 3 -8 16 -4 28 -17 34 -39 5
-18 7 -35 4 -38 -3 -3 -29 -2 -57 2 l-51 7 0 55 c0 63 -13 63 -16 -1 -3 -58
-2 -57 -17 -57 -7 0 -21 16 -30 35 -21 44 -21 43 1 48 11 3 7 5 -10 6 -14 0
-28 7 -31 14 -2 6 -7 9 -11 6 -4 -4 5 -32 20 -63 16 -30 26 -57 23 -60 -13
-12 -312 -156 -316 -152 -3 3 -14 -4 -26 -15 -11 -10 -27 -19 -34 -19 -29 0
-65 -28 -56 -43 3 -5 -3 -7 -13 -4 -11 3 -74 9 -141 12 -68 4 -123 10 -123 14
0 4 20 23 44 43 34 29 46 34 57 25 11 -10 11 -9 1 4 -11 14 -7 21 27 48 23 19
42 27 46 21 3 -5 11 -10 18 -10 6 0 2 7 -9 16 -15 13 -16 15 -2 10 11 -3 15
-1 12 8 -3 7 11 25 30 39 l35 27 4 -27 c3 -24 4 -23 6 7 1 29 9 43 47 74 25
21 43 41 40 44 -3 3 -38 -23 -78 -58 -40 -35 -81 -71 -91 -79 -17 -15 -22 -13
-58 27 -22 23 -43 42 -46 42 -3 0 2 -9 12 -20 18 -20 18 -21 -6 -48 l-24 -27
28 24 27 25 23 -23 22 -22 -31 -27 c-17 -15 -56 -49 -88 -77 -31 -27 -60 -51
-65 -53 -4 -1 -11 15 -14 37 -3 22 -13 55 -22 73 -9 18 -26 56 -36 83 -34 86
-54 124 -63 125 -4 0 -6 -6 -3 -12 3 -7 31 -70 61 -140 31 -70 56 -136 56
-147 0 -22 -14 -28 -25 -11 -3 6 -11 10 -17 10 -5 0 0 -9 13 -19 l24 -20 -49
-46 c-28 -25 -56 -43 -63 -40 -8 2 -11 0 -8 -5 9 -15 -67 -99 -89 -100 -42 0
-229 159 -281 240 -29 44 -43 129 -23 141 10 7 9 9 -3 9 -13 0 -18 16 -25 73
-5 45 -9 61 -12 41 -1 -16 4 -77 12 -134 9 -57 14 -105 12 -108 -7 -7 -97 59
-92 67 3 4 -11 14 -30 21 -20 8 -51 31 -69 51 -33 37 -60 79 -51 79 3 0 -6 12
-21 26 -29 29 -42 24 -24 -10 8 -13 10 -29 7 -35 -4 -6 -2 -9 6 -6 7 3 26 -14
42 -39 17 -24 69 -73 123 -112 52 -39 91 -74 88 -81 -2 -7 -1 -12 3 -12 22 4
32 -3 33 -23 0 -19 2 -20 7 -5 6 14 20 4 82 -58 69 -69 73 -76 53 -81 -13 -4
-23 -13 -23 -20 0 -8 -7 -14 -15 -14 -8 0 -15 -5 -15 -11 0 -5 -5 -7 -10 -4
-5 3 -10 2 -10 -3 0 -18 -272 -116 -303 -108 -10 2 -14 0 -10 -7 4 -6 -2 -8
-15 -5 -12 4 -22 2 -22 -2 0 -11 -137 -55 -169 -55 -19 0 -32 13 -59 60 -19
33 -65 112 -102 175 -96 160 -108 192 -120 306 -14 139 -20 174 -32 174 -6 0
-8 -12 -4 -31z m3825 -22 c6 -8 7 -18 3 -22 -4 -5 -2 -5 4 -2 6 3 20 -6 32
-22 l21 -28 -50 -49 c-44 -44 -50 -47 -65 -33 -14 15 -13 18 15 42 l31 26 -21
36 c-17 28 -19 38 -9 50 15 19 24 19 39 2z m519 -11 c4 -18 -14 -46 -29 -46
-11 0 -12 54 -2 64 11 10 28 1 31 -18z m-835 -26 c21 -24 21 -30 4 -30 -18 0
-49 34 -40 43 10 11 17 8 36 -13z m453 -1 c3 -6 -9 -26 -27 -45 -25 -26 -35
-31 -46 -22 -11 9 -8 17 19 45 34 35 43 39 54 22z m390 -37 c16 -11 44 -55 44
-70 0 -9 -10 -12 -32 -10 -28 3 -33 8 -39 38 -10 46 0 61 27 42z m-2116 -27
c5 -14 11 -39 12 -55 1 -16 5 -27 9 -25 5 4 49 -127 49 -147 0 -10 -86 -10
-157 -2 l-53 7 0 77 c0 42 3 98 6 124 l7 46 59 0 c53 0 59 -2 68 -25z m-150
-90 l0 -104 -32 4 -33 5 33 -10 c58 -19 38 -33 -35 -27 -38 4 -89 7 -115 7
l-48 0 -2 38 -1 37 -4 -38 -4 -39 -42 6 c-23 3 -59 5 -79 5 -33 1 -38 4 -38
25 0 19 9 28 43 42 23 10 51 17 62 16 14 -1 16 1 7 6 -20 13 31 32 75 27 33
-4 34 -3 8 3 -29 8 -27 10 60 55 50 25 102 46 118 46 l27 1 0 -105z m2221 68
c3 -42 -5 -71 -34 -128 -32 -64 -37 -111 -18 -181 8 -29 8 -40 -2 -46 -9 -6
-9 -8 2 -8 7 0 11 -6 7 -15 -3 -8 -1 -15 4 -15 5 0 8 -17 7 -37 -1 -21 -4 -36
-7 -34 -3 3 -18 -8 -34 -23 -16 -14 -36 -24 -43 -21 -8 2 -11 1 -8 -4 9 -15
-136 -104 -148 -92 -7 7 -6 16 4 28 12 16 12 17 -2 6 -9 -7 -18 -10 -21 -7 -3
2 -8 -2 -12 -11 -3 -9 -2 -14 3 -11 5 3 14 0 20 -8 9 -11 4 -18 -25 -36 -29
-18 -38 -20 -44 -9 -5 7 -6 17 -3 23 3 5 1 6 -5 2 -18 -11 -14 15 6 38 l17 21
-23 -19 c-13 -12 -26 -16 -30 -10 -5 5 -23 28 -41 52 l-34 43 24 25 23 24 29
-27 c17 -16 26 -21 22 -13 -5 8 -17 21 -27 28 -10 7 -15 19 -12 25 4 7 4 9 -1
5 -4 -4 -15 -2 -24 5 -14 10 -14 10 -4 -4 11 -13 9 -20 -10 -38 l-24 -21 -39
46 c-63 76 -64 77 -51 94 10 13 10 13 -4 2 -14 -10 -19 -8 -33 13 -17 25 -16
27 10 48 68 54 102 76 108 70 3 -3 6 -2 6 4 0 17 76 33 91 19 9 -8 10 -8 5 1
-4 8 8 16 36 23 24 6 57 16 73 23 39 15 194 119 219 146 23 26 46 27 47 4z
m-1474 -35 c-3 -7 -5 -2 -5 12 0 14 2 19 5 13 2 -7 2 -19 0 -25z m24 0 c-3
-21 -6 -26 -9 -15 -3 17 3 47 11 47 2 0 1 -15 -2 -32z m728 -25 c-1 -21 -4
-51 -8 -68 l-6 -29 -33 39 c-17 22 -32 42 -32 45 0 6 62 49 73 49 4 1 6 -16 6
-36z m941 -29 c0 -30 4 -54 8 -54 5 0 8 23 7 50 -1 36 2 50 12 50 8 0 14 -14
15 -37 1 -37 1 -37 5 -5 4 28 8 32 34 32 l29 0 0 -160 0 -160 -35 0 c-29 0
-35 4 -36 23 l-2 22 -4 -22 c-2 -13 -11 -23 -19 -23 -9 0 -12 5 -8 13 6 10 4
10 -7 0 -14 -14 -60 -18 -58 -5 5 28 -2 35 -17 14 -17 -24 -40 -29 -47 -9 -4
7 -6 6 -6 -5 -1 -9 -18 -27 -38 -39 -21 -13 -39 -27 -41 -31 -2 -4 -9 -8 -16
-8 -12 0 -17 27 -30 161 -2 14 -6 31 -11 38 -4 7 -2 24 6 37 9 18 15 21 21 12
6 -10 8 -8 8 4 0 9 -4 19 -9 22 -5 4 0 29 12 56 18 44 25 51 56 56 20 3 51 10
69 16 18 5 39 7 47 4 8 -3 17 -1 20 4 3 5 12 7 20 3 11 -3 15 -21 15 -59z
m208 -41 c-3 -73 -4 -78 -28 -83 -45 -12 -50 -3 -50 81 l0 79 40 0 41 0 -3
-77z m140 65 c28 -28 7 -170 -28 -188 -56 -30 -73 2 -64 115 l7 85 36 0 c21 0
42 -5 49 -12z m-1164 -6 c2 -4 -4 -8 -14 -8 -10 0 -16 4 -14 8 3 4 9 8 14 8 5
0 11 -4 14 -8z m-225 -54 c1 12 5 22 10 22 14 0 81 -95 69 -99 -6 -2 -7 -6 -1
-10 6 -3 8 -23 5 -43 l-4 -38 -97 6 c-53 3 -112 7 -131 9 -19 1 -48 3 -63 4
-36 1 -31 9 43 59 57 39 60 40 61 19 0 -21 1 -21 8 -2 5 11 7 23 4 27 -2 4 16
21 39 38 l43 31 6 -23 7 -23 1 23z m330 -24 c-13 -14 -24 -35 -24 -47 0 -17
-7 -23 -28 -25 -34 -4 -57 13 -52 39 2 10 -1 19 -7 19 -6 0 -9 3 -5 6 8 9 -16
33 -27 26 -5 -3 -6 0 -2 7 6 9 12 8 26 -4 11 -10 24 -14 31 -9 8 5 9 3 3 -7
-18 -29 -12 -43 7 -19 12 14 18 19 14 13 -4 -9 -1 -11 10 -7 9 4 14 13 11 21
-4 9 0 13 12 11 10 -2 16 3 14 10 -2 10 2 10 19 2 l21 -12 -23 -24z m-3039 26
c0 -5 -4 -10 -10 -10 -5 0 -10 5 -10 10 0 6 5 10 10 10 6 0 10 -4 10 -10z
m-711 -84 c-1 -15 -28 46 -28 64 0 8 6 0 14 -19 8 -18 15 -38 14 -45z m1611
44 c0 -16 -7 -20 -30 -20 -36 0 -39 13 -7 28 32 15 37 14 37 -8z m-145 -25
c91 -4 142 -10 147 -18 6 -9 8 -8 8 2 0 9 7 11 23 7 12 -3 99 -8 192 -11 92
-3 172 -8 177 -11 13 -8 9 -64 -4 -64 -9 0 -10 -3 -2 -8 7 -4 9 -32 6 -74 -4
-65 -5 -68 -31 -69 l-26 -2 28 -4 c26 -4 27 -6 27 -71 0 -47 -5 -75 -17 -91
-9 -14 -11 -21 -5 -17 16 10 15 -13 -2 -66 -7 -24 -22 -76 -32 -116 -21 -86
-38 -105 -82 -96 -18 4 -32 12 -32 18 0 7 -3 7 -8 -1 -5 -8 -21 -10 -45 -6
l-37 6 -2 66 -2 66 -3 -66 -4 -65 -97 13 c-171 22 -162 19 -164 61 l-1 37 -4
-38 -4 -37 -57 6 c-34 4 -62 13 -69 22 -8 10 -13 11 -13 4 0 -7 -4 -12 -10
-12 -13 0 -40 54 -40 80 0 12 -4 19 -9 16 -5 -4 -28 28 -51 71 -37 67 -40 78
-27 88 11 8 13 16 6 26 -7 11 -9 11 -9 -3 0 -29 -13 -21 -37 22 -26 44 -29 70
-10 71 8 0 8 2 -2 6 -7 3 -21 12 -30 20 -9 7 -28 24 -44 36 l-27 22 26 33 c16
20 32 31 41 28 9 -4 11 -2 7 6 -5 7 14 30 47 60 30 26 55 43 57 38 2 -5 13 -1
25 10 15 14 30 19 51 15 17 -2 94 -7 171 -10z m646 -54 c1 -14 2 -14 6 2 5 18
23 21 96 11 43 -6 46 -8 56 -49 6 -23 13 -49 17 -58 3 -10 -1 -17 -13 -20 -15
-4 -15 -5 3 -6 16 -1 25 -13 38 -58 10 -32 17 -62 16 -68 -1 -15 -70 -37 -70
-23 0 7 -6 5 -12 -4 -14 -17 -169 -68 -207 -68 -22 0 -22 1 -17 98 3 53 5 135
5 182 l1 86 40 -4 c28 -3 40 -9 41 -21z m2559 4 c0 -8 -4 -15 -10 -15 -5 0
-10 7 -10 15 0 8 5 15 10 15 6 0 10 -7 10 -15z m-2320 -12 c0 -14 2 -15 9 -5
7 11 37 13 152 7 165 -8 179 -10 180 -33 1 -15 2 -15 6 1 3 13 15 17 49 17 39
0 44 -3 45 -22 1 -17 2 -19 6 -5 2 9 9 17 14 17 14 0 71 -119 63 -132 -5 -7
-2 -8 6 -3 10 6 12 4 7 -9 -5 -11 -3 -15 5 -10 8 5 9 2 5 -10 -4 -9 -3 -14 2
-11 5 3 12 1 15 -4 11 -17 -7 -20 -145 -26 -73 -3 -188 -8 -253 -11 -92 -4
-121 -2 -127 8 -7 10 -9 10 -9 1 0 -7 -6 -13 -14 -13 -9 0 -21 21 -31 53 -9
28 -19 58 -21 65 -4 8 4 13 23 13 l28 2 -27 4 c-23 4 -28 10 -28 31 0 19 -3
23 -9 14 -6 -10 -10 -6 -14 15 -3 15 -9 36 -12 46 -6 14 -1 17 34 17 32 0 41
-4 41 -17z m1220 -23 l21 -30 -23 0 c-37 0 -52 15 -44 44 8 31 16 28 46 -14z
m-3509 -2 c8 -15 8 -18 0 -14 -6 4 -16 16 -22 28 -8 15 -8 18 0 14 6 -4 16
-16 22 -28z m4589 7 c6 -17 4 -52 -7 -112 -8 -49 -17 -90 -19 -92 -2 -2 -10 2
-19 9 -12 10 -15 35 -15 116 l0 104 25 0 c18 0 28 -7 35 -25z m128 -8 c23 5
24 4 18 -26 -3 -17 -9 -45 -12 -62 -6 -29 -8 -30 -47 -27 -25 1 -42 -2 -45
-10 -2 -7 2 -10 10 -7 25 10 170 -23 184 -42 16 -22 18 -49 4 -58 -6 -4 -58 1
-116 11 l-105 17 7 46 c9 61 27 103 55 130 12 11 19 21 14 21 -5 0 -17 -7 -27
-17 -16 -14 -18 -14 -18 0 0 8 3 22 6 31 5 14 8 14 27 1 12 -8 31 -12 45 -8z
m-1902 -25 c-5 16 4 17 94 15 54 -1 100 -4 102 -7 2 -3 2 -40 0 -83 -3 -71 -5
-77 -20 -65 -15 11 -15 11 -4 -4 9 -11 12 -44 10 -105 l-3 -88 -45 0 -45 0 -8
60 c-4 33 -5 72 -3 87 3 15 0 28 -7 31 -12 4 -97 156 -97 173 0 4 7 -1 16 -12
13 -16 15 -16 10 -2z m-2812 -44 c-34 -9 -33 -9 -27 25 l6 28 24 -23 24 -23
-27 -7z m3201 41 c2 -3 -2 -81 -8 -174 l-12 -170 -40 1 c-22 1 -62 2 -89 3
l-49 1 5 71 c4 45 11 75 19 80 10 6 11 9 2 9 -8 0 -13 15 -13 40 0 34 3 40 23
41 22 2 22 2 -1 6 -19 4 -23 9 -18 26 3 12 6 35 6 51 l0 28 85 -5 c47 -2 87
-6 90 -8z m87 -31 l1 -33 4 34 c4 32 5 33 41 27 20 -3 52 -6 69 -6 l33 0 -6
-92 c-3 -51 -8 -102 -9 -113 -2 -11 -4 -32 -4 -47 -1 -19 -7 -28 -18 -29 -17
-1 -17 -2 0 -6 11 -3 17 -14 17 -34 0 -27 -3 -29 -35 -29 -21 0 -35 5 -36 13
0 10 -2 10 -6 0 -2 -7 -18 -13 -34 -13 -26 0 -29 4 -30 33 -2 30 -2 30 -6 5
-4 -25 -9 -28 -40 -28 l-35 0 6 58 c3 31 8 110 12 175 l6 117 34 0 c31 0 34
-3 36 -32z m228 12 c45 0 94 -68 93 -129 l-1 -46 7 40 6 40 72 -94 c40 -51 70
-97 67 -102 -3 -5 2 -9 10 -9 9 0 16 -7 16 -15 0 -8 3 -15 8 -15 4 0 13 -9 20
-20 12 -20 11 -20 -35 -16 -27 2 -77 5 -112 5 l-63 1 4 40 c2 22 0 40 -4 40
-5 0 -8 -18 -8 -39 0 -32 -3 -38 -17 -35 -10 3 -45 6 -78 7 -59 2 -60 3 -63
32 -2 23 0 27 7 15 10 -13 11 -13 12 0 0 10 3 8 9 -5 8 -18 9 -17 9 8 1 15 -2
26 -6 26 -26 -4 -33 3 -29 29 2 15 5 30 5 35 1 4 13 8 29 8 l27 2 -29 4 -28 5
6 66 c3 37 6 82 6 101 0 26 3 32 16 27 9 -3 28 -6 44 -6z m-2652 -20 c18 -11
50 -37 70 -58 21 -20 53 -50 72 -65 23 -19 28 -26 15 -23 -19 6 -19 5 -3 -7
10 -8 15 -17 11 -21 -4 -4 -1 -5 7 -2 10 4 28 -15 57 -61 39 -61 41 -68 25
-79 -15 -12 -15 -12 4 -8 19 5 34 -9 33 -31 0 -3 8 -13 16 -22 9 -9 14 -24 12
-35 -3 -10 -1 -16 3 -13 4 3 17 -11 29 -30 l21 -36 -48 -20 c-117 -51 -121
-52 -140 -38 -15 12 -16 12 -4 -2 11 -15 4 -20 -53 -44 -50 -22 -68 -26 -77
-17 -7 7 -17 12 -23 12 -5 0 -3 -5 5 -10 10 -6 11 -10 3 -10 -18 0 -103 43
-103 52 0 4 -5 8 -11 8 -21 0 -192 227 -182 243 4 6 1 7 -7 2 -21 -13 -83 -12
-119 2 -18 7 -45 13 -60 13 -17 0 -37 13 -62 40 -28 30 -44 40 -67 40 -45 0
-48 18 -5 29 21 6 119 38 218 72 99 33 188 61 197 62 9 1 15 4 13 7 -3 5 101
68 115 69 3 1 20 -8 38 -19z m-821 -32 c30 -33 75 -127 67 -140 -5 -7 -3 -8 6
-3 8 5 11 3 8 -6 -7 -20 -30 -22 -108 -9 -78 13 -79 14 -61 109 14 68 51 89
88 49z m968 -43 c22 -18 37 -36 34 -39 -6 -7 -88 46 -94 62 -8 22 19 12 60
-23z m3305 23 c0 -9 4 -8 10 2 7 11 10 2 10 -32 l0 -48 -45 3 c-25 1 -45 0
-45 -4 0 -4 -13 -9 -30 -12 -16 -4 -49 -19 -72 -33 -24 -15 -49 -27 -55 -27
-7 0 -11 -3 -8 -5 3 -3 -21 -22 -53 -43 -47 -31 -58 -35 -61 -22 -3 18 27 46
40 37 5 -3 9 -1 9 4 0 15 110 83 122 76 6 -4 8 -3 5 3 -6 10 59 60 85 65 7 2
19 11 26 21 7 9 18 15 23 12 5 -4 9 -1 9 4 0 6 7 11 15 11 8 0 15 -6 15 -12z
m190 -38 l0 -41 -55 2 c-54 2 -55 3 -57 33 l-1 31 -4 -33 c-6 -48 -37 -40 -41
11 l-3 37 80 0 81 0 0 -40z m-4590 -9 c11 -21 14 -61 4 -61 -14 0 -42 21 -48
36 -6 17 9 44 25 44 5 0 13 -9 19 -19z m4378 -53 c9 -9 12 -9 12 0 0 9 27 12
98 11 53 0 100 -3 103 -5 3 -2 0 -36 -8 -76 -7 -40 -16 -93 -19 -118 -8 -63
-27 -94 -78 -130 -52 -35 -53 -35 -59 -12 -3 11 -5 7 -6 -10 -1 -18 -8 -29
-23 -34 -13 -4 -24 -6 -25 -6 -2 1 -13 -8 -26 -21 -13 -12 -59 -44 -101 -71
-63 -39 -80 -46 -88 -35 -8 11 -9 11 -5 -3 4 -9 -1 -19 -10 -22 -11 -5 -14 -2
-9 9 4 11 2 14 -6 9 -8 -5 -9 -1 -4 12 4 10 4 15 0 11 -4 -4 -13 -2 -20 4 -9
7 -8 0 3 -22 16 -32 16 -33 -8 -51 -28 -23 -227 -148 -246 -155 -8 -3 -13 4
-14 18 -1 17 -3 19 -6 7 -3 -11 -15 -19 -31 -19 l-27 -2 28 -4 c37 -6 34 -15
-14 -42 -34 -19 -43 -21 -50 -10 -7 11 -9 9 -9 -6 0 -28 -109 -93 -121 -73 -6
9 -9 6 -9 -9 0 -13 -2 -23 -4 -23 -2 0 -11 -3 -20 -6 -12 -5 -16 0 -16 20 0
14 -4 26 -8 26 -5 0 -7 -13 -4 -29 3 -22 -2 -32 -25 -48 -51 -36 -53 -36 -53
-9 0 22 5 26 33 28 l32 1 -33 4 c-29 4 -32 7 -26 26 4 12 7 34 6 50 -2 19 3
27 15 28 17 1 17 2 0 6 -17 4 -18 13 -11 96 4 51 12 95 18 99 8 6 7 8 -1 8 -9
0 -11 16 -8 58 12 126 14 147 15 152 1 3 1 33 0 67 -2 89 4 103 46 103 31 0
34 -2 36 -32 l1 -33 4 34 c4 33 5 33 46 27 23 -3 96 -9 162 -12 93 -5 123 -10
132 -23 7 -9 10 -22 8 -28 -2 -7 1 -13 8 -14 15 0 90 -116 83 -128 -3 -5 5
-16 19 -25 17 -11 26 -13 31 -4 4 6 3 8 -4 4 -6 -3 -13 -2 -17 4 -3 5 -1 10 5
10 6 0 2 14 -10 30 -20 28 -20 30 -3 31 13 0 11 3 -8 10 -29 11 -79 89 -57 90
7 0 3 4 -9 9 -30 12 -29 24 5 49 27 19 30 19 45 3 11 -10 17 -12 17 -4 0 7 -4
12 -10 12 -5 0 -10 5 -10 12 0 6 3 9 6 6 3 -3 16 4 28 16 39 36 207 138 250
152 52 16 50 16 64 2z m-1452 -15 c13 -17 14 -17 7 1 -4 13 -3 17 4 13 6 -4
16 -30 22 -58 11 -51 14 -105 4 -80 -3 8 -8 9 -12 3 -7 -12 -109 -18 -135 -7
-11 5 -21 3 -27 -6 -8 -12 -11 -12 -19 1 -5 8 -10 10 -10 3 0 -7 -40 -13 -117
-18 -65 -4 -136 -13 -158 -21 -45 -15 -52 -11 -61 33 -4 22 -2 32 7 36 8 2 7
3 -2 2 -11 -2 -21 13 -33 44 -9 25 -16 49 -16 53 0 7 69 10 389 16 127 2 145
0 157 -15z m1714 1 c0 -21 -41 -258 -45 -263 -2 -1 -9 0 -16 4 -12 8 -10 42
17 188 11 60 20 87 30 87 8 0 14 -7 14 -16z m-4647 -16 c9 -7 19 -26 23 -43 4
-16 5 -28 3 -25 -3 3 -17 22 -32 43 -28 37 -25 48 6 25z m2387 -35 c7 -27 15
-57 18 -68 3 -11 4 -22 3 -24 -2 -2 1 -7 6 -10 7 -5 93 -257 93 -273 0 -4 -10
-9 -22 -11 -20 -4 -20 -4 4 -6 20 -1 29 -9 37 -32 15 -44 14 -59 -6 -59 -18 0
-305 79 -312 86 -2 2 4 13 14 24 10 11 15 20 12 20 -3 0 -15 -10 -26 -21 -19
-20 -23 -21 -68 -9 -26 6 -61 14 -78 17 -16 3 -31 8 -33 12 -1 5 -14 6 -27 3
-29 -5 -32 12 -14 84 8 32 16 44 29 44 10 0 21 -8 23 -17 4 -14 5 -12 6 5 1
16 -5 22 -19 22 -11 0 -20 3 -20 6 0 24 34 129 45 141 18 17 85 46 85 36 0 -5
4 -3 8 2 8 13 92 39 99 31 3 -3 12 2 21 10 11 11 17 12 22 4 5 -8 9 -6 14 5 3
10 12 15 21 11 8 -3 15 -1 15 4 0 6 8 10 19 10 14 0 22 -12 31 -47z m-2318 5
c-9 -9 -15 -9 -24 0 -9 9 -7 12 12 12 19 0 21 -3 12 -12z m68 -30 c0 -10 2
-10 8 -1 4 7 29 11 61 10 l55 -2 58 -80 c32 -44 56 -88 54 -97 -2 -9 1 -15 8
-12 6 2 29 -27 50 -66 22 -38 42 -70 46 -70 3 0 14 -14 24 -32 11 -17 27 -41
37 -52 62 -74 209 -262 209 -270 0 -4 -7 -5 -16 -2 -14 6 -15 4 -4 -9 11 -13
15 -13 22 -3 9 14 7 16 107 -103 29 -35 89 -101 134 -147 l81 -83 -3 -81 c-2
-76 -24 -160 -52 -198 -8 -11 -9 -7 -5 20 16 90 18 153 5 209 -7 33 -16 58
-19 56 -4 -3 -18 7 -31 22 -13 14 -62 43 -109 65 -46 22 -87 42 -90 46 -3 4
-16 8 -29 10 -31 3 -133 61 -126 72 3 4 -3 14 -13 21 -15 13 -16 12 -3 -3 26
-35 -2 -17 -90 54 -49 40 -87 78 -85 84 3 7 -7 22 -22 35 l-27 24 24 -27 c48
-55 -4 -29 -73 36 -48 44 -67 69 -63 80 4 9 1 15 -6 13 -7 -1 -11 6 -11 15 1
10 -3 16 -9 15 -10 -2 -47 53 -91 135 -22 40 -42 103 -51 158 -1 8 -5 22 -8
30 -14 35 -34 129 -29 134 11 12 82 6 82 -6z m198 0 c8 -8 12 -8 12 -1 0 21
56 0 92 -35 38 -36 76 -48 186 -59 l52 -5 85 -111 c54 -71 85 -121 85 -137 0
-14 4 -20 8 -15 13 18 32 16 76 -10 23 -14 54 -25 68 -25 14 0 28 -6 31 -12 2
-7 41 -63 85 -125 68 -94 78 -114 66 -124 -8 -6 -14 -17 -14 -23 0 -6 5 -3 11
7 9 15 18 18 47 12 47 -9 112 -35 112 -45 0 -5 6 -15 13 -22 45 -46 61 -101
32 -112 -9 -3 -12 -12 -8 -23 6 -15 4 -16 -9 -5 -12 9 -18 10 -23 2 -8 -13 -3
-21 17 -24 7 -1 20 -6 28 -11 13 -7 13 -6 2 7 -10 12 -10 18 2 28 9 6 21 9 28
5 7 -4 5 0 -4 7 -11 10 -14 19 -8 29 8 12 12 11 24 -6 8 -11 12 -24 9 -30 -4
-5 -2 -7 2 -2 10 8 65 -41 65 -58 0 -11 -102 -106 -121 -113 -5 -2 -9 2 -9 10
0 11 -2 11 -9 0 -6 -10 -44 -15 -132 -17 l-124 -4 -49 54 c-48 54 -49 55 -31
75 18 20 18 21 -8 48 -15 14 -27 23 -27 20 0 -4 10 -16 22 -28 21 -20 21 -21
4 -38 -12 -11 -20 -13 -23 -6 -2 6 -38 46 -80 88 -41 42 -72 76 -67 76 5 0 -2
7 -14 16 -12 8 -19 20 -16 26 4 6 2 8 -3 5 -6 -4 -16 0 -23 8 -7 8 -10 15 -7
15 3 0 -11 17 -32 38 -66 66 -192 232 -185 244 4 6 3 8 -4 4 -12 -7 -111 123
-147 194 -13 25 -39 67 -59 95 -20 27 -36 53 -36 58 0 4 12 5 28 2 26 -5 26
-5 4 5 -13 5 -28 7 -33 4 -9 -5 -48 33 -49 49 0 12 45 8 58 -5z m4432 -19 c42
-9 49 -13 39 -25 -6 -7 -16 -11 -22 -7 -6 3 -7 1 -3 -5 4 -7 3 -12 -1 -12 -5
0 -16 -12 -25 -27 -25 -41 -67 -83 -83 -83 -16 0 -19 30 -8 93 4 26 9 34 14
25 6 -8 9 -2 9 20 0 36 4 37 80 21z m-724 -35 c-4 -10 -13 -14 -22 -10 -8 3
-13 2 -9 -3 7 -13 -52 -54 -65 -46 -18 11 -8 23 45 58 49 32 63 32 51 1z
m-1221 -14 c3 -5 1 -10 -4 -10 -6 0 -11 5 -11 10 0 6 2 10 4 10 3 0 8 -4 11
-10z m155 -10 c0 -3 -12 -65 -27 -139 -17 -87 -29 -128 -33 -115 -4 11 -7 -5
-7 -36 1 -66 -21 -173 -34 -165 -5 4 -9 1 -9 -4 0 -6 4 -11 9 -11 5 0 8 -8 6
-17 -15 -74 -14 -73 -48 -73 -41 0 -77 24 -78 53 0 18 -2 19 -7 5 -6 -16 -14
-13 -67 22 -103 68 -107 71 -102 90 3 12 0 17 -8 14 -9 -4 -25 30 -51 111 -33
100 -37 117 -24 126 13 9 12 10 -2 5 -13 -4 -20 4 -28 32 -5 20 -10 42 -10 49
0 12 39 27 98 37 30 5 32 4 34 -27 l1 -32 4 31 4 31 95 7 c94 7 120 3 108 -16
-4 -5 4 -3 17 5 13 9 39 15 57 15 18 -1 35 2 38 5 7 7 64 4 64 -3z m78 4 c19
-4 22 -11 22 -48 0 -24 -3 -64 -6 -90 -6 -38 -11 -46 -28 -47 -19 -2 -19 -2 2
-6 22 -4 23 -8 17 -41 -4 -20 -9 -50 -11 -67 -20 -172 -26 -195 -48 -196 -21
-2 -21 -2 0 -6 18 -3 20 -9 15 -41 -6 -33 -10 -38 -41 -43 l-35 -6 33 -2 c30
-1 32 -4 32 -35 0 -19 -7 -42 -16 -50 -9 -10 -11 -16 -4 -16 17 0 2 -112 -18
-127 -9 -8 -11 -13 -4 -13 7 0 12 -15 12 -35 0 -22 -4 -33 -12 -31 -7 1 -10 1
-5 -1 19 -11 3 -83 -18 -83 -7 0 -15 -5 -17 -11 -2 -6 -22 -12 -43 -13 -22 0
-42 -4 -45 -8 -10 -13 -100 -21 -100 -9 0 7 5 9 11 5 8 -4 9 1 4 16 -5 14 -3
20 3 16 6 -4 8 3 5 16 -4 19 -3 20 7 8 9 -12 10 -11 5 9 -5 16 -4 21 4 17 6
-4 11 -5 11 -2 0 2 3 13 6 23 5 15 4 15 -5 3 -9 -13 -11 -13 -11 2 0 9 6 23
13 30 8 7 12 18 10 24 -5 14 25 26 40 17 8 -4 7 -1 -1 9 -14 17 -7 87 11 123
6 11 9 41 8 66 -1 29 3 50 11 57 11 9 13 4 11 -26 l-4 -37 16 40 c18 49 18 45
1 45 -11 0 -8 27 15 138 17 75 41 198 55 272 13 74 26 140 28 146 5 12 29 15
64 8z m135 -14 c12 0 17 -9 18 -27 l2 -28 4 28 c3 21 10 27 30 27 l26 0 -7
-132 c-4 -73 -9 -146 -11 -163 -2 -16 -7 -87 -10 -157 -6 -109 -9 -128 -24
-129 -13 -1 -12 -2 3 -6 14 -4 17 -11 12 -35 -3 -17 -6 -52 -6 -79 0 -44 -2
-49 -22 -50 -22 -2 -22 -2 -2 -6 20 -4 21 -9 17 -71 -3 -37 -6 -72 -8 -77 -4
-15 -201 -69 -221 -61 -11 4 -14 14 -10 33 3 16 8 52 11 81 6 44 10 52 28 53
22 2 22 2 0 6 -18 3 -21 9 -17 31 7 42 28 206 32 252 1 11 10 21 20 21 16 1
15 2 -1 6 -14 4 -17 11 -13 31 3 15 10 59 16 97 6 39 13 81 16 95 2 14 7 66
10 115 3 50 7 105 10 124 5 32 7 33 42 27 20 -3 45 -6 55 -6z m205 -10 c26 0
32 -4 33 -22 l2 -23 4 23 c3 17 11 22 34 22 28 0 29 -2 29 -45 0 -42 -2 -45
-27 -46 l-28 -2 28 -4 c22 -4 27 -9 27 -32 0 -15 -3 -31 -7 -34 -4 -4 -5 -32
-4 -62 2 -47 0 -55 -16 -56 -17 -1 -17 -2 0 -6 15 -4 17 -12 13 -46 -3 -23 -8
-91 -12 -152 -4 -60 -8 -119 -9 -130 -1 -11 -2 -50 -3 -87 -2 -63 -4 -67 -34
-87 -18 -11 -35 -16 -36 -10 -2 5 -12 -1 -22 -13 -19 -24 -126 -86 -133 -78
-2 3 -1 61 4 130 4 69 11 175 14 235 3 61 8 128 10 150 5 46 18 273 17 295 -1
8 2 32 5 54 5 38 6 38 42 32 20 -3 51 -6 69 -6z m1177 -101 c-10 -15 -25 -10
-19 6 4 8 10 12 15 9 5 -3 7 -10 4 -15z m378 -135 c7 -2 41 -8 77 -13 142 -23
133 -20 118 -39 -10 -14 -9 -14 9 1 23 20 37 10 27 -18 -5 -11 -14 -15 -30
-11 -12 3 -25 3 -28 -2 -10 -16 54 -6 66 11 12 15 16 16 32 4 21 -15 13 -42
-10 -33 -20 8 -17 3 13 -25 15 -13 21 -16 14 -6 -12 15 -12 20 1 33 13 13 17
13 38 -4 19 -16 21 -21 11 -40 -7 -13 -16 -20 -20 -18 -5 3 -17 -4 -27 -16
-11 -12 -13 -18 -6 -14 15 9 16 -10 1 -20 -6 -3 -16 -1 -22 5 -6 6 -15 11 -21
11 -6 0 -5 -5 2 -12 16 -16 15 -31 0 -22 -7 4 -10 4 -6 -1 4 -4 3 -14 -3 -21
-9 -11 -16 -11 -33 -2 -19 10 -20 10 -7 -6 13 -15 8 -24 -50 -82 -35 -35 -68
-64 -73 -64 -6 0 5 15 22 33 21 22 28 34 18 34 -8 0 -13 -4 -10 -8 2 -4 -1
-11 -6 -14 -14 -9 -50 23 -50 44 0 12 -5 11 -22 -7 l-22 -22 27 -28 c36 -38
22 -50 -17 -15 l-31 28 28 -31 c34 -37 21 -55 -13 -19 -24 25 -50 33 -50 15 0
-5 -7 -6 -17 -3 -10 4 -14 2 -10 -4 4 -6 1 -13 -5 -16 -7 -2 -10 -8 -5 -12 4
-5 18 2 32 15 14 13 27 21 30 18 3 -3 -8 -17 -25 -32 -17 -14 -28 -26 -23 -26
5 0 14 5 21 12 6 6 15 8 19 4 5 -4 -1 -14 -12 -22 -17 -13 -18 -16 -4 -30 14
-13 17 -13 30 3 13 16 12 17 -3 5 -21 -17 -33 1 -12 19 13 10 17 10 24 0 5 -9
10 -10 14 -2 4 6 2 11 -4 11 -6 0 -8 5 -5 10 3 6 11 10 16 10 6 0 7 -6 3 -12
-5 -8 0 -7 11 2 38 31 8 -7 -39 -50 -27 -25 -46 -39 -41 -31 5 10 4 12 -3 7
-7 -4 -12 -12 -12 -18 0 -6 -8 -20 -17 -30 -16 -18 -17 -18 -42 4 -22 20 -23
20 -8 2 23 -28 22 -34 -8 -34 -52 0 -82 98 -87 290 l-3 95 35 7 35 6 -40 -1
c-36 -2 -40 -5 -45 -32 -7 -36 -40 222 -40 307 0 51 2 57 23 60 14 2 66 -23
140 -66 65 -39 123 -71 130 -72z m-338 59 c21 -189 39 -325 61 -454 13 -81 24
-165 24 -188 l0 -41 -49 0 c-58 0 -175 -23 -227 -45 -46 -19 -44 -19 -45 8 -1
16 -2 18 -6 5 -4 -16 -15 -22 -35 -19 -4 0 -5 -6 -2 -13 4 -11 0 -13 -16 -9
-16 4 -18 8 -8 14 9 6 2 9 -19 9 -31 0 -33 2 -34 38 l-2 37 -6 -36 -6 -37 -45
17 c-25 9 -44 20 -42 24 1 4 2 30 2 57 0 48 1 50 28 51 l27 2 -28 4 -27 4 6
82 c3 45 9 114 13 153 4 39 3 84 -2 99 -6 17 -6 30 1 34 5 3 11 15 13 26 2 10
17 26 34 35 16 8 35 20 42 27 7 6 29 21 50 33 21 13 55 34 75 47 21 14 42 22
49 17 7 -4 10 -3 5 4 -8 13 30 36 44 27 6 -4 9 -1 8 6 -2 8 15 18 42 25 69 19
68 19 75 -43z m-3237 -64 c18 -35 38 -70 44 -76 7 -9 7 -18 -2 -28 -11 -13
-10 -14 3 -9 12 4 20 -1 27 -17 5 -13 16 -32 22 -42 11 -15 10 -21 -9 -36 -12
-10 -20 -21 -16 -24 3 -4 13 4 23 15 l17 22 15 -30 c9 -16 13 -35 10 -43 -3
-8 0 -11 6 -7 7 4 24 -20 43 -59 27 -52 30 -68 20 -78 -10 -9 -15 -8 -25 6 -7
9 -17 17 -21 17 -5 0 0 -9 10 -20 16 -18 16 -20 1 -26 -9 -3 -16 -11 -16 -16
0 -6 15 1 34 16 l34 25 25 -32 25 -33 -60 -48 -60 -48 -29 28 c-16 16 -27 34
-24 42 3 7 0 10 -6 7 -15 -10 -39 27 -33 50 4 14 3 16 -4 7 -7 -11 -16 -5 -40
24 -17 21 -29 41 -26 46 3 4 1 8 -3 8 -16 0 -94 120 -87 132 4 6 3 8 -4 4 -14
-8 -55 50 -46 65 4 7 3 9 -4 5 -13 -8 -54 43 -45 58 3 6 3 8 -2 4 -4 -4 -20 9
-36 30 l-28 37 22 12 c12 6 25 9 29 7 5 -3 8 -1 8 4 0 15 42 22 57 10 10 -8
12 -7 7 6 -4 11 1 19 17 25 13 5 27 7 32 4 4 -2 7 0 7 6 0 10 27 20 44 17 5
-1 25 -31 44 -67z m132 55 c25 -3 92 -12 150 -21 58 -8 113 -15 123 -15 9 1
17 -6 17 -14 0 -8 5 -14 11 -14 5 0 7 5 4 10 -3 6 1 10 9 10 9 0 17 -8 17 -17
1 -17 2 -17 6 0 4 14 11 16 41 11 20 -4 41 -9 46 -12 12 -7 0 -96 -14 -100 -9
-3 -9 -6 -1 -11 8 -5 7 -19 -2 -52 -10 -33 -18 -45 -35 -47 -12 -2 -20 -7 -17
-12 3 -5 13 -6 21 -3 13 5 12 -2 -5 -35 -13 -25 -21 -62 -22 -101 -2 -61 -2
-61 -33 -63 l-31 -1 33 -4 c37 -5 45 -32 10 -34 -17 -1 -19 -2 -5 -6 18 -5 24
-43 6 -43 -5 0 -7 -5 -4 -11 4 -6 4 -26 0 -45 l-6 -35 -57 48 c-31 26 -59 48
-61 50 -1 1 0 7 4 13 5 8 13 6 28 -7 l22 -18 -19 22 c-15 18 -22 20 -33 12
-10 -9 -17 -8 -29 2 -15 12 -14 15 6 31 12 10 19 18 14 18 -4 0 -15 -7 -25
-16 -15 -14 -19 -13 -39 16 -12 17 -19 37 -16 45 3 8 1 14 -5 12 -6 -1 -31 36
-57 83 -42 79 -43 83 -17 60 15 -14 25 -20 22 -14 -8 14 17 37 28 26 5 -4 5
-1 1 6 -7 11 -11 11 -24 -2 -15 -13 -20 -12 -43 7 -32 26 -64 91 -53 108 4 7
3 9 -3 6 -15 -9 -37 19 -29 38 3 8 0 14 -7 12 -7 -1 -11 4 -9 11 1 6 -2 12 -8
12 -5 0 -21 23 -36 52 l-26 51 54 -7 c29 -4 73 -9 98 -12z m520 -75 c25 -6 56
-13 70 -15 47 -9 60 -15 60 -32 0 -12 3 -13 12 -4 15 15 48 16 48 1 0 -5 5 -7
10 -4 17 10 50 -5 50 -23 0 -14 2 -15 9 -3 8 13 24 11 108 -13 163 -47 187
-56 201 -74 7 -9 14 -15 15 -12 3 7 67 -33 67 -43 0 -4 4 -6 8 -3 5 3 18 -3
28 -12 10 -10 36 -28 56 -41 21 -12 47 -36 59 -52 21 -30 20 -61 -4 -119 -6
-14 -11 -27 -12 -30 -9 -36 -19 -50 -36 -50 -10 0 -19 -4 -19 -10 0 -5 7 -7
15 -4 22 9 19 -10 -18 -106 -29 -77 -36 -87 -71 -103 -48 -23 -177 -56 -193
-49 -7 2 -13 17 -13 34 0 16 -4 27 -9 24 -5 -3 -7 -15 -4 -26 3 -11 4 -20 2
-20 -2 0 -38 14 -79 31 -41 17 -108 36 -147 42 -62 10 -73 15 -74 32 -2 18 -2
17 -6 -2 -6 -34 -35 -30 -31 4 2 14 -2 28 -8 30 -7 2 -9 -8 -6 -28 3 -19 1
-29 -5 -26 -5 3 -34 7 -64 7 -67 2 -122 18 -113 32 4 6 2 8 -3 5 -6 -4 -18 2
-28 13 -17 19 -17 21 -2 38 10 10 17 22 17 27 0 4 -10 -4 -21 -19 -19 -25 -23
-26 -38 -12 -12 11 -16 26 -13 51 2 19 8 35 12 35 5 0 6 9 3 20 -3 11 -1 20 4
20 6 0 8 22 6 53 -3 34 -1 47 5 39 7 -11 10 -11 15 2 4 10 1 16 -8 16 -9 0
-15 10 -15 26 0 25 2 26 38 19 20 -4 45 -14 54 -22 16 -14 16 -14 6 8 -9 19
-20 24 -50 26 -22 0 -41 3 -44 5 -7 7 53 140 67 149 12 7 12 9 0 9 -9 0 -11 8
-6 28 4 15 9 38 11 52 7 41 25 90 32 90 4 0 27 -5 52 -11z m-905 -45 c26 -34
26 -36 9 -50 -18 -14 -18 -14 3 -5 19 9 25 7 43 -19 12 -17 18 -30 15 -30 -4
0 2 -8 13 -17 27 -24 120 -159 102 -148 -8 5 -17 10 -20 10 -31 5 -71 19 -76
26 -3 6 0 18 7 27 11 14 11 15 -1 5 -8 -7 -17 -13 -21 -13 -14 0 -100 130 -93
142 4 6 3 8 -3 5 -10 -6 -63 59 -63 76 0 7 35 25 51 26 4 1 19 -15 34 -35z
m3048 -61 c-8 -3 -13 -23 -13 -51 0 -26 -3 -77 -7 -114 -6 -64 -7 -68 -32 -69
l-26 -2 28 -4 c30 -5 37 -22 10 -24 -16 -1 -16 -2 0 -6 11 -3 16 -10 13 -20
-3 -8 -6 -46 -6 -84 0 -68 0 -69 -27 -70 l-28 -2 26 -4 c22 -3 25 -8 21 -35
l-5 -31 -66 7 c-36 3 -83 6 -103 6 -35 0 -38 2 -38 29 0 28 3 30 43 33 l42 3
-47 5 -48 5 0 -39 c0 -38 0 -38 -32 -33 -18 3 -94 9 -168 13 -74 3 -153 9
-175 13 -37 6 -40 9 -40 40 0 27 6 37 30 50 17 9 53 31 80 48 28 17 62 35 77
38 16 4 26 10 24 14 -3 4 5 13 16 20 19 12 20 11 15 -8 -3 -12 -1 -19 4 -15 5
3 9 13 9 22 0 16 111 91 148 100 6 2 12 8 12 13 0 19 19 8 23 -13 4 -20 4 -19
6 4 1 19 12 35 38 53 21 14 41 25 46 25 4 0 17 8 28 19 11 10 37 27 57 37 20
11 43 25 51 32 7 7 16 10 20 6 3 -4 0 -9 -6 -11z m1202 -26 c19 -14 18 -16
-20 -22 -22 -4 -48 -9 -58 -12 -16 -4 -16 -1 5 30 23 37 28 37 73 4z m25 -47
c0 -5 3 -9 8 -9 50 8 48 -10 -50 -428 -40 -174 -55 -223 -67 -223 -12 0 -13
-2 -4 -8 10 -6 9 -23 -6 -75 -10 -38 -21 -70 -24 -73 -4 -4 -163 60 -305 122
-18 8 -41 28 -50 44 -9 16 -21 30 -27 30 -5 1 -26 14 -45 30 -19 17 -40 30
-47 30 -12 0 -28 74 -21 106 2 11 13 20 28 22 14 2 41 16 60 31 53 41 59 44
78 30 15 -12 15 -12 0 7 -17 20 -16 23 80 114 53 52 129 124 168 162 39 37 74
65 78 61 4 -4 10 -2 14 4 13 20 132 41 132 23z m-376 -180 c-13 -13 -59 34
-49 50 5 8 15 4 33 -14 18 -18 23 -29 16 -36z m-83 -43 c-13 -13 -26 -3 -16
12 3 6 11 8 17 5 6 -4 6 -10 -1 -17z m74 4 c-3 -6 -11 -11 -17 -11 -6 0 -6 6
2 15 14 17 26 13 15 -4z m-3298 -118 c26 -23 63 -54 81 -68 17 -15 29 -32 25
-37 -3 -7 -1 -8 5 -4 7 4 36 -13 68 -38 38 -31 65 -46 85 -46 21 0 29 -5 30
-17 1 -16 2 -16 6 0 3 13 10 16 21 11 10 -4 32 -7 50 -7 17 1 32 -4 32 -11 0
-6 4 -4 10 4 14 23 23 5 10 -22 -11 -23 -11 -23 8 2 17 20 27 24 67 21 51 -3
208 -56 213 -71 2 -6 8 -8 13 -5 5 4 23 -1 41 -9 29 -14 39 -14 88 -1 30 8 64
15 76 15 l21 0 -19 -82 c-10 -46 -23 -105 -28 -132 -6 -28 -15 -53 -21 -57 -8
-4 -5 -9 7 -13 17 -5 43 -76 69 -191 16 -71 34 -135 40 -144 3 -6 1 -11 -5
-11 -7 0 -5 -6 4 -15 19 -19 41 -116 33 -147 -10 -40 -58 -86 -118 -112 -43
-19 -59 -22 -68 -13 -9 9 -11 9 -6 -3 4 -12 -18 -23 -96 -50 -56 -19 -107 -35
-113 -35 -6 0 -14 -4 -17 -8 -3 -5 -12 -10 -20 -11 -8 -2 -25 -7 -39 -13 -82
-34 -98 -37 -115 -23 -13 11 -18 10 -28 -3 -11 -14 -22 -14 -117 8 -96 22
-139 33 -312 82 -53 14 -58 18 -58 44 0 28 2 29 50 29 28 0 50 5 50 10 0 17
38 11 43 -7 4 -17 5 -17 6 0 1 23 -27 33 -50 19 -22 -14 -89 -16 -89 -3 0 6
10 26 21 46 17 28 24 33 31 23 7 -10 8 -9 4 5 -7 23 3 47 21 47 8 0 11 5 8 10
-4 6 1 23 10 37 14 21 19 23 27 12 8 -11 9 -10 4 4 -9 29 4 48 28 41 21 -6 21
-6 1 9 -19 14 -19 16 -3 22 10 4 15 11 12 16 -3 5 2 9 11 9 9 0 14 4 11 8 -3
5 0 25 6 46 8 26 14 33 20 24 6 -9 7 -6 3 8 -3 12 -1 33 4 47 7 18 7 28 0 33
-8 4 -7 9 2 15 10 6 7 8 -10 7 -19 -2 -26 3 -32 22 -4 16 -7 19 -8 8 -1 -20
-21 -25 -21 -5 0 8 -3 9 -8 1 -4 -6 -14 -11 -22 -12 -8 0 -31 -5 -50 -9 -43
-11 -83 -5 -74 9 5 7 -2 9 -18 6 -17 -3 -29 1 -37 14 -6 10 -16 18 -23 18 -7
0 -3 -7 8 -15 18 -13 15 -14 -30 -15 -45 0 -48 1 -42 23 3 12 6 30 6 40 0 9 8
18 18 18 16 1 16 2 -1 6 -16 4 -17 12 -11 76 4 51 12 79 27 97 l21 25 -27 -26
c-24 -22 -29 -36 -34 -97 l-6 -72 -42 0 c-50 0 -72 -19 -56 -47 9 -16 10 -15
11 10 0 25 3 27 40 27 l40 0 0 -40 0 -40 -90 0 c-65 0 -90 3 -91 13 0 10 -2
10 -6 0 -5 -15 -44 -16 -156 -7 -72 6 -77 9 -77 30 0 12 4 25 10 29 5 3 7 12
4 19 -3 7 3 69 12 137 9 68 19 154 21 192 l5 67 101 2 c56 1 115 2 131 2 21 1
48 18 99 64 38 34 72 60 76 57 3 -3 5 -42 6 -87 0 -64 3 -82 15 -85 12 -4 12
-2 2 5 -16 11 -6 62 12 62 8 0 8 2 0 8 -6 4 -14 33 -17 64 l-5 57 47 40 c37
32 50 38 60 28 10 -9 11 -8 5 7 -10 26 5 19 63 -31z m1754 -46 c6 -24 4 -28
-19 -33 -15 -3 -39 -10 -54 -16 -14 -5 -36 -7 -48 -3 -20 6 -16 11 36 45 33
21 63 37 68 36 6 -1 13 -14 17 -29z m1319 -31 c-12 -12 -40 0 -40 18 0 11 5
12 24 3 15 -7 21 -16 16 -21z m-3837 -45 c37 -34 53 -65 61 -123 7 -46 -4 -88
-23 -88 -4 0 -11 24 -14 54 -7 74 -43 151 -86 187 l-36 31 35 -17 c19 -10 48
-29 63 -44z m2640 29 c33 0 37 -3 38 -27 l2 -28 4 28 c4 22 10 27 31 27 34 0
48 -10 55 -35 4 -17 5 -17 6 4 1 23 2 23 89 18 48 -3 136 -8 196 -11 60 -3
111 -8 113 -10 2 -2 0 -53 -3 -115 l-7 -111 -31 -1 c-30 -2 -30 -2 -3 -6 25
-4 27 -8 27 -54 l0 -49 -92 6 c-51 3 -99 7 -105 10 -7 2 -14 18 -15 36 l-1 33
-4 -32 c-4 -31 -7 -33 -44 -33 -36 0 -39 2 -40 28 l-2 27 -4 -28 c-3 -20 -9
-27 -21 -23 -9 3 -55 7 -101 10 -46 3 -85 7 -87 8 -1 2 -5 20 -9 41 -7 36 -7
37 23 37 47 0 48 18 1 22 l-42 3 -18 65 c-23 83 -24 78 9 83 26 4 26 4 -4 6
-32 1 -44 18 -44 65 0 14 5 17 23 12 12 -3 39 -6 60 -6z m-108 -37 c0 -17 3
-29 7 -27 6 4 14 -14 23 -53 4 -20 30 -112 77 -273 29 -100 88 -313 88 -317 0
-1 -8 -4 -17 -6 -14 -4 -12 -5 5 -6 12 0 22 -7 22 -13 0 -7 3 -23 6 -35 4 -16
2 -23 -8 -23 -8 0 -23 -7 -34 -16 -18 -15 -18 -15 3 -5 45 22 43 8 -13 -99
-32 -60 -62 -110 -66 -110 -4 0 -8 -8 -8 -19 0 -10 -6 -23 -13 -29 -13 -11
-185 -54 -261 -66 -21 -4 -42 -8 -46 -11 -25 -15 -133 -21 -175 -9 -42 12 -85
35 -86 47 0 7 -2 48 -5 91 -4 59 -2 81 8 88 11 6 11 10 0 16 -10 7 -13 88 -15
380 l-2 371 25 24 c24 24 75 40 275 89 60 15 84 17 97 9 14 -9 18 -8 18 4 0 8
15 19 33 24 50 15 62 10 62 -26z m-155 23 c0 -2 -7 -7 -16 -10 -8 -3 -12 -2
-9 4 6 10 25 14 25 6z m1283 -73 c24 -45 21 -53 -17 -53 -50 0 -198 49 -193
63 5 18 58 41 94 41 18 1 33 4 33 8 0 4 12 8 28 10 20 2 29 -2 33 -17 3 -11
13 -35 22 -52z m87 27 c0 -58 -18 -74 -51 -44 -27 24 -52 72 -44 84 3 6 26 10
51 10 l44 0 0 -50z m-461 -6 c39 -15 71 -30 71 -34 0 -4 11 -5 25 -2 18 3 25
0 25 -11 0 -26 -12 -47 -23 -40 -6 3 -7 1 -3 -6 10 -16 -13 -81 -38 -106 -29
-30 -93 -67 -98 -58 -3 5 -4 3 -2 -3 1 -6 -14 -18 -33 -27 l-35 -15 6 66 c3
37 9 111 12 165 4 53 10 97 15 97 4 0 40 -12 78 -26z m141 -5 c0 -5 -4 -9 -10
-9 -5 0 -10 7 -10 16 0 8 5 12 10 9 6 -3 10 -10 10 -16z m-3276 -30 c-3 -5
-10 -7 -15 -3 -5 3 -7 10 -3 15 3 5 10 7 15 3 5 -3 7 -10 3 -15z m3616 -4 c0
-14 -4 -25 -9 -25 -4 0 -6 11 -3 25 2 14 6 25 8 25 2 0 4 -11 4 -25z m-1725
-15 c-14 -15 -22 -17 -37 -9 -26 14 -13 29 24 29 30 0 31 -1 13 -20z m1415
-15 c0 -8 -7 -15 -15 -15 -8 0 -15 7 -15 15 0 8 7 15 15 15 8 0 15 -7 15 -15z
m-3329 -222 c-12 -103 -21 -194 -21 -200 0 -8 -15 -13 -41 -13 l-40 0 7 82 c5
66 14 95 39 143 37 68 52 112 59 170 6 51 8 55 13 28 2 -12 -5 -107 -16 -210z
m1877 189 c3 -29 0 -32 -25 -33 -27 -2 -27 -2 -3 -6 25 -4 25 -5 22 -83 -3
-66 -6 -80 -20 -81 -16 -1 -16 -2 0 -6 14 -3 16 -21 17 -124 l2 -119 -73 -2
-73 -2 75 -5 75 -6 2 -45 c9 -262 11 -388 4 -399 -7 -11 -18 -7 -50 19 -22 18
-38 37 -34 43 3 6 1 7 -5 3 -5 -3 -12 -3 -14 1 -1 5 -16 15 -33 25 -41 23 -56
73 -99 331 -37 221 -44 295 -26 267 6 -9 10 -10 10 -3 0 6 -4 14 -8 17 -10 6
13 147 28 176 13 24 34 35 84 44 28 5 41 4 47 -6 7 -10 9 -9 9 4 0 11 10 18
33 21 48 6 52 3 55 -31z m1568 7 c57 -21 78 -41 87 -80 4 -14 20 -43 37 -64
17 -22 30 -50 30 -66 0 -15 -23 -77 -51 -136 -41 -88 -52 -105 -60 -90 -13 23
-35 22 -35 -2 0 -11 5 -17 13 -14 27 11 22 -26 -16 -108 l-39 -85 -69 7 c-37
5 -74 8 -80 8 -8 1 -13 16 -13 39 -1 29 -7 41 -28 56 l-27 19 23 -24 c13 -15
22 -38 22 -57 0 -28 -4 -32 -36 -38 -40 -7 -114 12 -127 33 -4 7 -15 13 -23
13 -8 0 -12 -4 -9 -10 3 -5 0 -10 -8 -10 -11 0 -13 10 -11 38 4 46 14 174 14
185 0 4 12 8 28 8 l27 2 -29 4 c-28 4 -28 6 -22 50 3 25 6 54 6 64 0 11 7 19
18 20 14 0 14 2 -3 9 -13 6 -15 9 -5 9 19 1 170 98 185 118 6 8 17 35 24 59 7
24 17 47 22 50 5 3 21 -7 36 -23 26 -25 91 -43 77 -21 -3 5 -13 7 -21 4 -21
-9 -46 20 -38 44 7 23 9 22 101 -11z m204 -5 c0 -24 -3 -25 -27 -19 -42 10
-50 23 -22 34 39 16 49 13 49 -15z m106 -26 c2 -17 -29 -30 -52 -21 -8 3 -14
16 -14 30 0 23 1 23 22 9 33 -23 44 -19 17 5 l-24 21 24 -14 c13 -8 25 -21 27
-30z m-2103 25 c-7 -2 -21 -2 -30 0 -10 3 -4 5 12 5 17 0 24 -2 18 -5z m-35
-95 c-18 -82 -30 -238 -18 -238 4 0 16 -62 29 -138 12 -76 25 -149 28 -162 3
-14 3 -22 0 -19 -12 10 -96 342 -90 352 3 6 1 7 -5 3 -18 -11 -15 28 13 154
22 101 35 129 56 130 3 0 -3 -37 -13 -82z m1932 56 c0 -8 -4 -12 -10 -9 -5 3
-10 10 -10 16 0 5 5 9 10 9 6 0 10 -7 10 -16z m30 -4 c0 -5 -4 -10 -10 -10 -5
0 -10 5 -10 10 0 6 5 10 10 10 6 0 10 -4 10 -10z m70 -29 c0 -41 -71 -57 -78
-17 -5 23 14 36 51 36 20 0 27 -5 27 -19z m165 -1 c3 -5 1 -10 -4 -10 -6 0
-11 5 -11 10 0 6 2 10 4 10 3 0 8 -4 11 -10z m-86 -11 c28 -10 32 -15 29 -43
-6 -61 -68 -38 -68 26 0 32 -2 31 39 17z m-3865 -13 c-5 -12 -64 -29 -64 -19
0 3 58 31 67 33 1 0 0 -6 -3 -14z m61 -19 c-4 -14 -19 -37 -35 -52 l-28 -27
22 44 c30 58 37 70 42 65 3 -3 2 -16 -1 -30z m-75 -30 c0 -29 -7 -37 -26 -30
-14 5 -19 35 -7 46 14 15 33 6 33 -16z m3790 19 c0 -2 -6 -17 -12 -33 l-13
-30 -16 34 -16 33 28 0 c16 0 29 -2 29 -4z m286 -25 c43 -16 116 -47 162 -68
l84 -38 -54 -69 c-29 -38 -60 -77 -68 -87 -10 -11 -35 -20 -70 -24 -68 -8 -82
-18 -17 -14 35 3 47 1 47 -9 0 -8 -9 -16 -20 -19 -11 -3 -17 -10 -14 -15 4 -6
-2 -8 -12 -6 -11 2 -18 10 -16 16 1 7 -7 12 -18 12 -28 0 -25 -7 13 -30 30
-19 31 -21 10 -26 -13 -4 -20 -11 -16 -19 2 -8 -5 -20 -16 -27 -12 -7 -21 -17
-21 -21 0 -5 -9 -22 -21 -38 -17 -25 -27 -29 -65 -29 -24 0 -44 5 -44 10 0 6
7 10 15 10 8 0 19 10 25 23 10 20 10 20 -3 5 -14 -18 -37 -24 -37 -10 0 15 16
30 35 35 18 4 18 5 -2 6 -40 2 -24 21 17 21 31 0 40 -4 41 -17 0 -11 3 -13 6
-5 2 6 10 9 16 5 7 -4 7 -1 -1 9 -8 10 -33 17 -68 20 l-55 3 2 -30 c5 -83 5
-84 -58 -84 -32 1 -61 3 -65 6 -4 2 -43 5 -87 6 -44 1 -82 5 -85 8 -10 9 84
207 101 213 9 4 11 2 7 -6 -4 -6 3 -4 15 5 13 8 29 13 36 11 6 -3 25 -6 41 -8
16 -2 32 -4 37 -5 4 0 7 -6 7 -12 0 -5 -6 -7 -12 -3 -10 6 -10 5 -1 -7 6 -8
13 -30 16 -49 4 -33 4 -32 5 9 2 46 2 46 57 26 11 -4 5 3 -13 15 -30 20 -31
24 -18 39 14 15 13 17 -4 17 -10 0 -16 -4 -14 -8 13 -20 -9 -27 -38 -12 -21
11 -47 15 -78 12 l-47 -5 44 96 c24 53 48 100 52 104 11 11 78 26 85 20 7 -8
-20 -33 -36 -34 -7 0 -4 -4 7 -8 16 -6 23 -2 34 20 7 16 18 26 24 22 6 -3 7
-1 3 5 -7 11 41 62 59 62 6 0 47 -13 91 -29z m-216 -25 c0 -3 -9 -6 -20 -6
-19 0 -27 20 -14 33 6 6 34 -16 34 -27z m-3891 -10 c13 -15 4 -24 -44 -45
l-30 -13 23 24 c12 13 22 30 22 36 0 16 15 15 29 -2z m81 -66 c-5 -36 -10 -84
-10 -107 l0 -43 -45 0 c-40 0 -45 2 -45 23 0 25 21 98 41 140 10 23 58 61 66
53 1 -1 -2 -31 -7 -66z m2720 15 c0 -40 2 -45 23 -44 16 1 18 2 5 6 -13 3 -18
15 -18 44 l0 39 43 -6 c23 -4 44 -11 46 -17 2 -5 7 -4 11 3 6 9 37 9 134 1 70
-6 136 -11 146 -11 20 0 20 4 6 -140 -3 -25 -5 -64 -5 -87 l-1 -43 -47 -1
c-27 -1 -40 -3 -30 -6 9 -2 18 -12 18 -21 1 -15 2 -15 6 1 3 10 14 17 28 17
23 0 24 -2 19 -72 -9 -134 -14 -158 -32 -159 -15 -1 -15 -2 1 -6 13 -3 17 -15
17 -54 0 -32 -4 -49 -12 -50 -7 0 -8 -2 -3 -5 6 -2 8 -29 7 -60 l-4 -56 -56 7
c-32 4 -63 12 -69 17 -9 7 -13 7 -13 0 0 -7 -10 -8 -29 -2 -16 4 -31 6 -34 4
-8 -9 -202 20 -209 30 -5 7 -8 8 -8 1 0 -7 -15 -9 -34 -7 -33 4 -34 5 -23 29
8 18 16 23 31 19 19 -5 19 -4 4 8 -16 12 -15 15 5 47 11 19 22 36 22 39 5 19
30 60 37 60 4 0 7 3 7 8 -3 20 2 32 13 26 7 -4 8 -3 4 5 -4 6 -1 23 8 36 18
27 21 39 8 31 -8 -4 -37 98 -92 319 -26 103 -28 95 24 95 l46 0 0 -45z m-2790
13 c0 -2 -9 -27 -20 -56 -11 -29 -20 -62 -20 -75 0 -12 -4 -27 -8 -34 -4 -7
-61 -18 -127 -27 -118 -14 -120 -14 -142 7 -24 22 -29 37 -13 37 5 0 78 34
162 75 139 67 168 80 168 73z m4427 -65 c104 -46 97 -68 -26 -84 -46 -5 -97
-17 -112 -24 -15 -8 -33 -15 -38 -15 -10 0 99 150 109 150 3 0 33 -12 67 -27z
m126 -49 c12 -12 -14 -44 -34 -44 -15 0 -19 5 -15 16 3 9 6 20 6 25 0 10 33
12 43 3z m36 -30 c-28 -14 -32 -13 -24 8 4 10 14 14 27 10 20 -5 20 -5 -3 -18z
m-4554 -54 c18 0 20 -7 22 -73 0 -42 12 -114 26 -168 43 -163 43 -168 -2 -326
-12 -40 -21 -102 -21 -137 0 -46 -4 -65 -14 -69 -29 -11 -23 105 14 256 11 47
20 104 20 127 0 49 -37 166 -80 250 -21 41 -30 74 -30 106 0 43 2 46 23 40 12
-3 31 -6 42 -6z m-124 -22 l2 -23 4 23 c8 39 30 25 36 -23 4 -25 18 -68 33
-97 24 -48 25 -55 16 -121 -11 -68 -21 -93 -29 -70 -2 7 -11 9 -19 6 -16 -6
-20 22 -4 30 6 3 5 4 -2 3 -20 -4 -23 -46 -4 -46 9 0 16 -5 16 -11 0 -6 6 -9
14 -6 10 4 12 0 8 -15 -4 -15 -11 -19 -33 -16 -16 3 -29 1 -29 -4 0 -4 -6 -8
-12 -8 -7 0 -26 -22 -43 -48 -26 -40 -39 -50 -90 -68 -93 -33 -125 -38 -125
-21 0 8 -7 18 -16 21 -13 5 -11 15 16 63 30 56 100 145 100 128 0 -5 -7 -16
-15 -25 -13 -14 -12 -16 8 -17 17 -2 18 0 7 7 -12 8 -12 10 3 16 11 4 16 13
12 22 -7 18 43 74 58 65 5 -3 6 3 2 16 -5 16 -2 21 12 22 17 1 17 2 1 6 -10 2
-18 13 -18 23 0 10 8 21 18 23 13 4 13 5 -4 6 -18 1 -23 9 -28 53 -5 37 -4 53
6 59 10 7 9 9 -4 9 -32 0 -20 29 15 33 78 10 87 8 88 -15z m223 -45 c-4 -38
-10 -104 -13 -148 l-6 -80 -23 85 c-12 47 -22 102 -22 123 0 31 3 37 23 38
l22 2 -22 4 c-15 3 -23 12 -23 24 0 15 7 19 36 19 l36 0 -8 -67z m167 55 c0
-10 2 -10 6 0 5 13 73 17 73 5 -1 -30 -15 -53 -34 -54 -18 -1 -18 -2 -3 -6 13
-3 16 -10 11 -21 -4 -10 -22 -59 -39 -110 -25 -71 -28 -89 -15 -77 19 17 31
11 23 -13 -4 -13 -3 -14 5 -4 6 10 16 -3 35 -46 27 -63 54 -89 142 -137 61
-34 58 -31 50 -45 -5 -8 -11 -7 -23 2 -15 12 -16 11 -3 -5 13 -16 16 -16 29
-3 13 13 19 13 46 -1 61 -31 62 -31 -50 -109 -58 -41 -110 -72 -114 -69 -5 3
-12 -1 -17 -8 -10 -18 -143 -39 -143 -23 0 7 -3 7 -8 -1 -7 -11 -169 -40 -177
-31 -2 2 -7 32 -9 66 -5 48 0 80 21 149 25 84 33 166 33 361 0 31 4 42 15 42
11 0 15 -12 15 -47 0 -25 2 -44 5 -41 3 3 6 37 6 76 1 57 4 72 17 75 12 3 10
5 -5 6 -19 1 -23 -4 -23 -29 0 -21 -5 -30 -16 -30 -12 0 -14 8 -9 48 13 98 7
92 85 92 49 0 70 -4 71 -12z m149 0 c0 -9 3 -9 8 -2 19 27 133 10 116 -18 -3
-5 -6 -26 -6 -46 0 -32 -2 -34 -12 -19 -7 9 -16 14 -19 10 -4 -3 2 -12 13 -20
25 -17 26 -43 3 -43 -12 0 -14 -3 -6 -8 6 -4 11 -31 11 -60 1 -29 4 -62 8 -74
5 -15 0 -26 -17 -40 -22 -18 -22 -18 -2 -9 31 15 36 14 30 -9 -3 -13 -1 -18 6
-13 7 4 8 0 4 -11 -4 -9 -3 -15 2 -12 18 12 19 -23 1 -39 -17 -15 -22 -16 -37
-4 -17 12 -17 12 -1 -6 17 -18 18 -18 38 0 11 10 22 16 24 14 9 -10 66 -107
66 -113 0 -9 -58 21 -97 50 -17 13 -40 24 -50 24 -10 0 -40 13 -68 28 -43 23
-56 38 -92 107 -46 87 -51 131 -21 191 9 16 23 53 32 82 15 44 21 52 42 52 13
0 24 -6 24 -12z m194 -9 c-3 -5 -1 -9 5 -9 5 0 12 4 16 10 10 15 35 -1 36 -24
2 -20 2 -20 6 2 5 23 27 29 53 12 12 -8 12 -10 1 -10 -8 0 -12 -2 -9 -5 3 -3
20 1 40 9 47 20 128 16 142 -7 8 -14 8 -20 -4 -27 -8 -5 -10 -10 -3 -10 6 0 9
-9 6 -20 -3 -11 -9 -20 -14 -20 -17 0 -22 32 -9 54 11 18 11 19 -1 10 -8 -6
-24 -10 -36 -9 -13 1 -23 -2 -23 -7 0 -4 5 -8 12 -8 6 0 1 -11 -11 -24 -17
-18 -19 -26 -10 -31 7 -5 10 -4 6 2 -4 6 5 21 18 33 29 27 34 17 8 -14 -17
-20 -17 -20 0 -7 16 12 20 12 33 -1 14 -14 14 -19 0 -47 -9 -17 -21 -31 -27
-31 -6 0 -8 -4 -4 -10 3 -5 -2 -18 -12 -28 -10 -10 -19 -24 -21 -31 -5 -23
-49 -81 -55 -74 -4 3 -7 1 -7 -5 0 -7 -8 -12 -17 -13 -16 0 -16 -1 -2 -7 14
-6 12 -15 -16 -69 -18 -34 -37 -58 -41 -55 -4 4 -4 -1 -1 -11 5 -13 3 -17 -5
-15 -21 7 -107 182 -113 228 -3 23 -8 46 -11 51 -3 5 -2 23 1 41 5 22 9 27 16
17 7 -11 9 -9 9 7 0 11 8 28 19 38 16 15 19 15 31 1 7 -8 20 -15 29 -15 10 0
7 5 -9 13 -14 8 -24 19 -22 26 1 7 -2 10 -8 6 -5 -3 -10 -2 -10 3 0 5 -8 12
-18 14 -25 7 -30 75 -5 80 24 6 44 -2 37 -13z m-33 -80 c16 -8 18 -13 9 -25
-7 -7 -17 -11 -23 -7 -5 3 -7 1 -3 -5 3 -6 2 -13 -4 -17 -6 -4 -10 8 -10 29 0
39 2 41 31 25z m2640 -144 l6 -40 2 39 c1 32 4 37 19 31 9 -3 30 -9 45 -12 15
-3 26 -11 24 -17 -3 -6 -11 -9 -18 -8 -8 2 -11 0 -7 -4 4 -4 2 -14 -4 -23 -7
-9 1 -4 18 12 17 15 34 24 38 20 4 -5 6 -1 4 7 -3 16 9 16 140 10 63 -3 63 13
-7 -158 -80 -193 -74 -185 -129 -177 -26 4 -83 10 -127 14 l-80 6 0 55 c0 49
2 55 25 61 l25 7 -24 1 c-23 1 -23 2 -18 79 4 42 6 92 7 110 0 30 2 33 28 30
23 -3 28 -9 33 -43z m534 -11 c39 -3 73 -11 77 -18 6 -8 8 -8 8 2 0 8 21 12
71 12 l70 0 -29 -42 c-42 -62 -64 -97 -89 -147 -13 -24 -32 -50 -43 -58 -12
-8 -20 -22 -19 -31 1 -10 1 -30 0 -46 l-1 -29 -65 6 c-35 3 -79 13 -97 22 -30
15 -31 15 -13 0 19 -16 19 -16 -10 -11 -16 2 -43 5 -59 5 -26 1 -28 3 -14 14
17 13 35 73 19 63 -5 -3 -12 1 -15 10 -5 12 -14 15 -35 11 l-29 -6 30 77 c32
83 44 103 36 60 -3 -16 -2 -28 2 -28 4 0 11 -11 14 -25 4 -14 11 -25 16 -25 6
0 6 9 0 26 -6 14 -10 27 -10 28 0 8 37 43 49 47 8 3 3 9 -15 17 -25 12 -26 12
-13 -4 12 -16 12 -17 -3 -11 -13 4 -18 -1 -21 -21 -3 -18 -4 -13 -6 16 0 24 6
57 15 73 15 29 18 30 62 25 26 -3 79 -8 117 -12z m-3730 -60 c18 -63 15 -102
-16 -221 -19 -74 -23 -98 -27 -161 -2 -26 -4 -27 -42 -24 -34 4 -39 7 -36 26
3 11 5 33 5 49 1 18 7 27 19 28 16 1 16 2 -1 6 -17 4 -17 19 1 78 3 11 6 22 7
25 12 62 18 80 25 75 6 -3 7 1 4 9 -5 13 2 62 22 154 7 34 21 18 39 -44z
m4065 44 c0 -10 2 -10 8 -1 9 14 62 5 69 -13 2 -7 10 -11 17 -8 7 3 52 -9 99
-27 60 -21 87 -36 88 -47 0 -11 3 -12 6 -5 3 10 12 9 36 -4 18 -8 35 -21 39
-27 4 -6 8 -8 8 -3 0 10 73 -28 88 -45 9 -12 -12 -26 -111 -80 -109 -59 -123
-64 -135 -50 -10 13 -14 13 -25 3 -10 -10 -9 -12 2 -9 7 2 16 -3 18 -10 3 -8
-1 -10 -13 -5 -13 5 -15 3 -9 -8 6 -11 4 -11 -8 1 -9 8 -17 21 -19 29 -2 8
-11 23 -21 33 -10 10 -15 23 -12 27 2 5 -2 11 -10 15 -9 3 -12 12 -8 23 6 16
5 17 -12 3 -17 -14 -18 -13 -12 3 3 9 3 17 -1 17 -15 -1 -42 -28 -41 -41 0
-10 2 -11 6 -1 2 6 11 12 18 12 19 0 46 -30 39 -42 -4 -6 -3 -8 3 -5 5 3 20
-12 33 -35 21 -38 22 -42 6 -54 -14 -10 -29 -9 -79 2 -86 20 -128 34 -123 42
2 4 -9 8 -26 8 -17 1 -33 5 -37 10 -3 5 -10 9 -16 9 -39 2 -94 19 -99 32 -7
17 24 74 36 67 4 -3 5 2 2 11 -7 17 13 46 30 44 31 -4 44 3 48 26 3 14 1 25
-3 25 -5 0 -9 -9 -9 -19 0 -13 -6 -19 -19 -18 -24 2 -17 29 19 67 16 17 26 30
23 30 -3 0 0 7 7 15 16 19 100 21 100 3z m-2240 -134 c0 -17 -22 -14 -28 4 -2
7 3 12 12 12 9 0 16 -7 16 -16z m-1910 -6 c-2 -39 -50 -203 -59 -200 -6 1 -11
-3 -11 -8 0 -5 6 -10 13 -11 6 0 0 -6 -15 -12 -14 -7 -78 -66 -142 -131 -65
-65 -120 -116 -123 -112 -3 3 0 31 6 63 12 57 12 123 0 133 -4 3 -10 28 -14
56 l-6 51 107 34 c103 32 108 35 142 82 33 45 59 65 90 66 6 1 12 -5 12 -11z
m2013 -60 c40 -34 74 -65 75 -70 9 -22 -18 -2 -84 62 -39 39 -70 70 -67 70 2
0 36 -28 76 -62z m-162 6 c-11 -15 -21 -24 -21 -20 0 12 33 57 37 52 3 -3 -4
-17 -16 -32z m156 -36 c41 -40 82 -77 91 -82 9 -5 24 -17 32 -26 8 -8 12 -11
8 -6 -20 25 3 20 155 -35 170 -61 276 -112 391 -186 l68 -44 -18 -22 -19 -22
23 20 c15 12 26 15 30 9 4 -6 15 -13 25 -17 15 -6 16 -10 6 -29 -11 -22 -10
-22 6 -7 16 16 20 15 54 -8 20 -14 35 -28 34 -32 -1 -5 -25 -43 -53 -85 -37
-56 -54 -94 -62 -134 -24 -133 -29 -142 -100 -163 -22 -6 -29 -5 -25 4 3 7 -3
13 -13 13 -11 0 -15 -6 -12 -18 3 -12 -2 -19 -12 -19 -9 -1 -20 -2 -24 -3 -4
-1 -43 40 -87 89 -119 136 -110 122 -94 142 13 16 12 17 -2 5 -14 -10 -20 -10
-34 4 -13 14 -14 19 -3 26 10 8 9 9 -4 5 -22 -7 -42 17 -35 44 4 15 2 18 -6
10 -9 -7 -29 8 -68 49 -31 33 -51 61 -45 64 6 2 1 3 -11 3 -22 -1 -21 -3 12
-37 19 -20 35 -39 35 -42 0 -4 17 -23 37 -43 38 -37 38 -37 17 -54 -11 -9 -19
-22 -16 -29 2 -6 -3 -15 -12 -18 -9 -3 -13 -10 -10 -15 8 -13 24 -11 22 2 -2
6 3 14 11 17 9 3 11 0 6 -8 -6 -9 -4 -11 4 -5 9 5 10 10 2 18 -15 15 -14 27 2
23 6 -1 9 -1 4 1 -4 3 -4 9 -1 14 4 6 11 6 20 -2 11 -9 11 -16 2 -33 -10 -19
-10 -20 5 -8 14 12 20 9 49 -24 54 -61 58 -67 46 -82 -8 -9 -8 -16 2 -25 10
-9 11 -9 6 1 -13 23 5 34 25 16 22 -20 25 -40 7 -47 -9 -3 -5 -12 11 -30 21
-23 22 -29 10 -44 -12 -16 -11 -16 8 1 l22 19 -25 20 c-19 14 -23 22 -14 31
11 11 34 -11 97 -92 l21 -28 -71 -45 c-79 -49 -94 -52 -119 -31 -15 12 -16 18
-5 30 10 13 9 14 -10 4 -12 -7 -25 -17 -29 -24 -5 -7 -3 -8 5 -3 7 4 22 -2 37
-16 l24 -22 -41 -30 c-29 -21 -49 -49 -70 -96 -44 -96 -48 -102 -119 -186
l-65 -76 -55 5 c-30 2 -64 8 -74 12 -18 7 -18 8 4 16 13 5 20 11 17 14 -3 3
-15 0 -27 -6 -13 -7 -37 -9 -55 -6 -26 5 -38 16 -54 47 -12 22 -19 45 -16 50
4 5 2 9 -3 9 -5 0 -17 19 -27 43 -10 23 -31 70 -47 105 -16 35 -26 67 -23 72
3 4 -2 10 -10 13 -8 4 -14 19 -14 34 0 15 -3 42 -6 60 -4 17 0 107 9 200 8 92
21 228 27 301 10 108 15 132 28 133 14 1 14 2 1 5 -14 4 -14 20 -3 152 8 81
16 154 20 162 3 8 7 18 7 23 2 17 58 77 73 77 8 0 49 -33 90 -72z m-181 -7
c-3 -4 -12 -71 -21 -147 -9 -83 -20 -141 -28 -146 -9 -6 -9 -8 1 -8 9 0 11
-13 8 -47 -3 -27 -8 -86 -12 -133 -4 -47 -8 -92 -10 -100 -1 -8 -3 -23 -3 -32
-1 -10 -9 -19 -18 -19 -17 -1 -17 -2 0 -6 9 -2 17 -13 17 -24 0 -14 -8 -19
-27 -20 l-28 -2 28 -4 c15 -2 25 -7 23 -11 -4 -7 -18 -141 -17 -172 0 -8 -3
-37 -6 -64 l-5 -48 -30 53 c-16 30 -30 58 -31 64 -1 5 -8 16 -15 23 -7 8 -16
27 -19 43 -3 16 -9 29 -14 29 -5 0 -20 22 -34 49 -18 36 -21 51 -12 54 7 3 5
6 -5 6 -9 1 -20 11 -24 23 -4 13 -16 35 -27 50 -13 17 -21 46 -22 75 -3 56 2
73 21 73 8 0 13 5 12 12 -2 7 11 15 27 19 23 5 25 7 8 8 -29 1 -19 31 11 31
14 0 17 3 8 8 -9 6 0 26 37 76 38 53 50 64 54 50 4 -15 5 -14 6 4 1 23 17 62
30 72 4 3 30 42 60 88 29 45 55 82 58 82 2 0 2 -4 -1 -9z m840 -6 c-4 -12 -2
-13 12 -7 10 5 53 5 102 0 127 -14 133 -15 159 -16 17 -2 22 -6 17 -19 -6 -17
-5 -17 7 -1 10 13 23 15 55 11 27 -4 39 -10 35 -17 -5 -8 -3 -8 8 0 21 17 93
3 97 -19 5 -26 -188 -309 -206 -302 -11 4 -12 2 -4 -7 7 -10 4 -21 -14 -43
-20 -25 -27 -28 -41 -18 -10 6 -17 16 -16 21 1 5 -5 9 -15 8 -11 -1 -16 6 -15
18 1 12 -2 15 -9 8 -7 -7 -27 1 -62 26 -28 19 -56 40 -61 46 -6 6 -15 12 -20
13 -6 1 -54 26 -108 56 -54 30 -164 79 -245 108 l-147 54 65 6 c57 6 175 31
345 74 67 17 68 17 61 0z m934 -25 c0 -28 -15 -40 -51 -40 -25 0 -24 21 1 53
25 32 50 25 50 -13z m-3930 -6 c0 -8 -7 -14 -15 -14 -15 0 -21 21 -9 33 10 9
24 -2 24 -19z m2114 14 c-25 -41 -93 -129 -101 -129 -4 0 -7 -6 -5 -13 1 -8
-11 -27 -27 -44 -15 -17 -27 -33 -25 -35 2 -2 -9 -19 -25 -37 -23 -28 -31 -32
-43 -22 -12 9 -15 9 -15 -3 0 -8 6 -15 14 -15 17 0 6 -24 -33 -65 -15 -16 -27
-32 -27 -35 1 -3 -7 -16 -17 -30 l-18 -25 -14 30 c-7 17 -18 36 -25 43 -7 7
-13 20 -13 28 0 8 -4 14 -9 14 -5 0 -16 15 -25 33 -20 39 -39 70 -47 77 -15
12 -28 50 -23 64 3 8 45 29 92 45 48 17 121 44 162 59 41 15 80 27 85 27 6 0
12 3 15 6 6 8 98 37 118 38 8 1 10 -4 6 -11z m2116 -3 c0 -8 -4 -15 -10 -15
-5 0 -10 7 -10 15 0 8 5 15 10 15 6 0 10 -7 10 -15z m-1744 -42 c-10 -11 -56
8 -56 22 0 14 4 14 31 0 17 -9 28 -19 25 -22z m1891 -18 c54 -19 126 -41 161
-49 35 -8 70 -20 78 -26 29 -25 10 -100 -25 -100 -10 0 -40 17 -67 38 -92 73
-153 100 -286 127 -19 4 -28 12 -28 25 0 30 53 26 167 -15z m-3357 -49 c-12
-31 -26 -56 -31 -56 -6 0 -7 -5 -4 -10 8 -13 -13 -81 -29 -95 -6 -5 -12 -21
-13 -35 -2 -44 -43 -140 -59 -140 -9 0 -12 -5 -8 -12 5 -8 -8 -9 -52 -4 -43 5
-64 12 -77 29 -10 12 -16 17 -13 10 3 -6 0 -14 -6 -16 -8 -3 -6 -6 5 -6 17 -1
17 -3 3 -23 -9 -12 -16 -30 -16 -40 0 -15 -9 -18 -64 -18 -69 0 -99 7 -90 21
3 5 -1 6 -8 4 -29 -11 -80 59 -93 128 -6 32 -5 37 11 38 16 1 16 2 3 6 -17 4
-34 58 -23 74 8 14 82 11 87 -3 4 -9 6 -7 6 3 1 12 25 19 114 32 61 8 124 14
139 12 18 -2 25 1 22 9 -6 17 63 69 78 60 6 -4 8 -3 5 3 -4 6 24 32 61 57 37
26 68 43 70 38 1 -5 -7 -35 -18 -66z m2663 59 c49 -2 92 -6 94 -9 8 -7 -55
-131 -76 -150 -11 -10 -25 -15 -31 -11 -6 3 -38 47 -71 97 -59 88 -60 91 -33
84 15 -4 68 -9 117 -11z m-2553 -5 c19 -6 69 -17 110 -26 42 -8 80 -22 88 -32
6 -8 12 -11 12 -4 0 12 59 6 70 -7 3 -3 21 -7 40 -9 19 -1 36 -7 38 -11 2 -5
12 -7 22 -4 12 3 22 -1 26 -11 3 -9 10 -16 16 -16 5 0 6 6 2 13 -6 10 -4 10 7
0 7 -7 20 -13 28 -13 24 0 54 -59 40 -76 -6 -8 -15 -12 -18 -9 -4 2 -8 -2 -8
-10 0 -8 6 -16 13 -19 8 -3 11 0 8 8 -3 7 2 18 9 25 12 9 19 4 41 -33 14 -25
26 -49 26 -55 0 -18 -20 -23 -37 -9 -15 12 -15 11 -2 -9 12 -21 15 -21 31 -6
10 9 20 14 22 12 16 -20 56 -99 56 -113 0 -24 -39 -78 -51 -71 -5 4 -7 0 -4
-7 6 -17 -21 -52 -34 -43 -6 3 -9 0 -5 -8 7 -19 -91 -160 -118 -170 -12 -4
-46 -3 -76 3 -31 5 -58 10 -61 10 -3 0 0 4 7 9 11 7 11 9 -2 14 -9 4 -16 1
-16 -5 0 -20 -59 1 -121 43 -53 36 -59 43 -47 57 12 15 11 16 -4 4 -21 -17
-42 -6 -33 17 5 12 3 13 -5 5 -9 -9 -36 5 -108 52 -60 40 -107 64 -124 64 -49
0 -48 69 2 172 10 21 23 60 30 88 7 27 17 50 23 50 6 0 8 3 4 6 -5 5 24 102
38 124 8 13 21 13 65 0z m2450 -79 c30 -47 49 -85 44 -92 -4 -7 -3 -9 3 -6 12
8 43 -57 44 -93 1 -14 -2 -54 -6 -90 -9 -73 -79 -240 -101 -240 -16 0 -17 5
-6 28 6 12 3 22 -10 35 -15 14 -18 14 -18 2 0 -8 5 -15 10 -15 6 0 10 -7 10
-15 0 -8 -4 -15 -10 -15 -5 0 -10 5 -10 11 0 5 -4 8 -8 5 -5 -3 -21 5 -36 17
-19 15 -25 27 -21 39 4 10 12 15 18 11 6 -4 7 -1 2 7 -4 7 -2 16 6 21 10 6 10
9 2 9 -7 0 -20 -14 -28 -31 l-16 -30 -28 18 c-97 64 -161 109 -161 113 0 3 13
20 30 38 16 18 29 34 28 35 -7 9 39 66 50 62 7 -2 10 0 7 5 -4 6 3 26 15 46
20 32 24 34 39 20 20 -19 31 -20 31 -5 0 5 -4 8 -9 5 -5 -3 -14 1 -20 8 -10
11 -1 31 41 95 29 44 54 80 54 81 1 0 25 -36 54 -79z m306 55 c15 -12 17 -18
8 -33 -13 -21 -42 -29 -55 -16 -11 11 5 63 19 63 4 0 17 -6 28 -14z m-3971 -6
c-3 -5 -12 -10 -18 -10 -7 0 -6 4 3 10 19 12 23 12 15 0z m4050 -13 c-16 -5
-35 -14 -41 -18 -7 -6 -10 -1 -8 14 1 12 3 22 3 22 1 1 18 -1 39 -4 l37 -4
-30 -10z m216 -24 c1 -10 1 -22 0 -26 -1 -4 8 -3 19 3 34 18 169 -9 193 -38
10 -13 9 -15 -4 -10 -9 4 -16 1 -16 -7 0 -10 5 -11 18 -4 28 14 34 12 81 -33
68 -68 120 -136 113 -149 -6 -8 -10 -7 -17 2 -7 11 -8 11 -6 -1 3 -19 -20 -62
-30 -56 -4 2 -8 -4 -8 -14 0 -10 4 -16 9 -13 4 3 17 -3 28 -13 10 -9 19 -12
19 -7 0 6 -7 16 -15 23 -11 9 -12 16 -5 25 5 6 8 14 5 17 -3 3 4 13 15 23 21
19 28 7 8 -13 -8 -8 -9 -12 -1 -12 6 0 14 6 17 13 5 12 77 -59 113 -111 21
-30 9 -40 -19 -16 l-23 19 18 -22 c11 -13 16 -27 11 -35 -4 -7 2 -5 13 5 11 9
22 17 26 17 15 0 87 -109 87 -131 0 -18 -20 -41 -77 -89 -141 -120 -131 -114
-161 -100 -26 11 -26 11 -9 -8 16 -18 16 -20 -4 -38 -48 -43 -88 -112 -105
-179 -9 -39 -18 -75 -20 -81 -3 -12 -93 -7 -131 7 l-23 8 20 36 c19 33 19 34
1 23 -11 -6 -17 -17 -14 -24 9 -25 -20 -25 -58 1 -40 26 -48 51 -15 49 13 -2
14 1 6 11 -16 19 5 28 29 13 15 -9 17 -15 9 -26 -8 -9 -8 -16 2 -25 10 -9 11
-9 6 1 -4 7 -3 19 3 26 9 10 5 17 -14 30 -22 14 -28 15 -45 3 -11 -8 -18 -16
-15 -19 3 -3 -1 -10 -8 -17 -11 -9 -22 -5 -52 19 -21 16 -42 30 -47 30 -6 0
-8 7 -5 14 4 10 1 13 -8 10 -8 -3 -25 5 -38 18 -14 12 -30 24 -36 26 -7 1 -24
10 -37 19 -20 12 -22 18 -12 25 9 7 8 8 -6 4 -21 -7 -49 11 -39 27 3 6 1 7 -5
3 -15 -9 -54 12 -47 24 4 6 -1 7 -11 3 -13 -5 -16 -2 -12 9 4 10 1 15 -10 14
-9 0 -16 5 -14 12 1 8 -2 11 -8 7 -15 -9 -62 23 -54 37 4 7 3 8 -4 4 -11 -6
-153 82 -166 103 -11 16 14 23 32 9 15 -11 16 -11 6 2 -5 8 -10 22 -10 30 2
30 61 150 74 150 11 0 12 3 4 13 -13 16 48 164 75 185 10 7 18 16 18 20 2 31
109 128 167 151 13 6 67 10 121 10 86 1 97 -1 98 -16z m167 -13 c81 -29 152
-85 248 -200 48 -58 126 -150 172 -205 217 -259 286 -330 348 -361 30 -15 54
-33 54 -40 0 -22 -12 -17 -71 25 -62 45 -184 175 -342 366 -182 219 -271 322
-297 343 -49 38 -138 74 -201 79 -32 3 -59 10 -59 16 0 13 81 0 148 -23z
m-522 -43 c-36 -23 -41 -17 -27 26 l12 35 22 -21 22 -22 -29 -18z m-2216 22
c0 -5 -7 -9 -15 -9 -15 0 -20 12 -9 23 8 8 24 -1 24 -14z m-1258 -44 c3 -4 1
-17 -6 -30 -15 -34 -56 -35 -56 -2 0 13 3 27 7 30 8 8 47 9 55 2z m3438 -34
c-5 -11 -15 -23 -22 -27 -7 -5 -8 -2 -3 7 21 37 44 55 25 20z m-90 -13 c0 -7
-4 -19 -9 -26 -7 -11 -10 -10 -15 3 -10 26 -7 35 9 35 8 0 15 -6 15 -12z m945
-22 c9 -18 54 -80 101 -136 46 -57 82 -105 80 -107 -12 -12 -55 28 -151 140
-104 121 -105 122 -77 128 15 4 28 7 29 8 1 0 9 -14 18 -33z m-4212 -28 c17
-121 66 -206 134 -234 18 -8 60 -14 93 -14 61 0 81 -14 35 -26 -54 -13 -142 1
-184 30 -51 36 -74 74 -94 161 -24 103 -25 125 -3 125 8 0 16 -16 19 -42z
m-93 3 c0 -20 -6 -30 -20 -34 -16 -4 -20 0 -20 22 0 31 7 41 27 41 8 0 13 -11
13 -29z m569 -190 c-15 -5 -22 6 -14 19 6 9 10 9 16 -1 5 -8 4 -15 -2 -18z
m-74 0 c17 -4 44 -15 62 -24 18 -10 48 -17 67 -17 19 0 37 -4 40 -9 3 -5 30
-20 59 -34 30 -14 104 -60 165 -101 87 -60 126 -80 180 -94 l68 -18 -55 -17
c-76 -24 -91 -22 -176 17 -90 41 -144 78 -215 145 -30 29 -77 64 -105 78 -27
14 -54 31 -60 38 -15 17 -91 39 -111 31 -14 -6 -15 -4 -4 9 9 11 21 14 34 10
12 -3 35 -10 51 -14z m2503 -37 c48 -31 89 -60 90 -65 2 -5 8 -9 13 -9 19 0
88 -56 84 -68 -3 -7 0 -10 5 -7 6 3 14 3 20 0 5 -3 -21 -53 -60 -110 -73 -108
-166 -199 -278 -271 -54 -35 -112 -46 -112 -20 0 8 -7 17 -16 20 -8 3 -12 11
-8 17 4 8 3 9 -4 5 -7 -4 -14 3 -17 17 -4 14 -17 30 -30 37 -14 7 -21 18 -18
24 3 6 2 8 -2 3 -13 -11 -45 23 -45 48 0 18 11 26 60 44 73 27 88 48 102 139
11 75 45 147 68 147 8 0 14 -5 13 -10 -1 -6 7 -11 17 -11 13 0 16 4 10 12 -6
6 -7 14 -3 18 4 4 0 4 -9 1 -26 -10 -28 8 -6 43 16 26 23 30 34 21 11 -9 12
-15 2 -28 -8 -11 -6 -10 8 2 18 17 18 19 2 28 -17 9 -25 29 -12 29 3 0 45 -25
92 -56z m-2538 16 c11 -7 4 -10 -25 -10 -29 0 -36 3 -25 10 8 5 20 10 25 10 6
0 17 -5 25 -10z m1065 -190 c-5 -29 -12 -40 -28 -43 -14 -3 -11 -5 8 -4 25 2
31 7 35 32 5 29 7 28 44 -39 25 -44 35 -71 28 -74 -18 -6 -14 -20 5 -18 21 1
86 -118 78 -144 -3 -10 -1 -21 5 -25 5 -3 10 -19 10 -36 0 -20 -5 -29 -17 -30
-17 -1 -17 -2 0 -6 23 -6 22 -33 -1 -33 -10 0 -28 -10 -41 -21 -17 -16 -25
-19 -34 -10 -9 9 -8 14 3 21 8 5 11 12 7 17 -5 4 -12 1 -17 -7 -7 -12 -12 -12
-21 -3 -10 10 -8 17 7 35 l19 23 -22 -19 c-22 -18 -23 -18 -57 10 -36 31 -36
31 -20 149 2 17 4 42 4 57 0 15 3 29 8 32 11 7 2 76 -10 76 -5 0 -7 -3 -5 -7
3 -5 1 -35 -4 -68 -5 -33 -11 -87 -14 -119 -3 -33 -7 -62 -10 -65 -11 -11 -75
64 -76 88 0 22 -2 23 -8 8 -6 -18 -8 -18 -21 -2 -8 10 -14 31 -14 49 1 27 0
27 -3 4 l-4 -27 -60 46 c-56 44 -71 63 -49 63 6 0 10 4 10 10 0 13 32 50 40
45 3 -2 12 6 20 18 12 21 12 21 -5 7 -17 -14 -17 -14 -7 7 7 12 20 20 29 19
10 -2 12 -1 6 1 -21 7 -20 8 71 132 l39 54 39 -82 c33 -69 39 -88 33 -121z
m2989 161 c8 -13 -4 -42 -15 -35 -5 3 -14 14 -19 25 -9 16 -7 19 9 19 11 0 22
-4 25 -9z m-3970 -22 c36 -14 81 -45 129 -88 41 -36 83 -73 93 -81 27 -21 127
-72 207 -105 48 -20 67 -33 67 -47 0 -10 -3 -18 -7 -18 -20 1 -196 70 -235 93
-65 38 -150 117 -144 134 3 8 2 12 -3 9 -5 -3 -14 1 -21 9 -31 37 -107 74
-169 82 -36 5 -66 13 -69 21 -6 20 90 15 152 -9z m4031 -42 c4 5 2 -3 -5 -17
-12 -23 -12 -24 4 -11 20 16 29 11 20 -13 -9 -24 -20 -20 -49 18 -16 21 -23
40 -19 50 6 15 9 14 24 -8 9 -15 20 -23 25 -19z m-4061 2 c29 -8 63 -35 128
-99 49 -49 84 -91 78 -95 -5 -3 -10 -12 -9 -18 0 -9 2 -9 6 1 2 6 12 12 20 12
10 0 13 -6 9 -16 -3 -9 -2 -12 5 -8 6 3 44 -11 85 -31 41 -21 85 -37 98 -37
19 0 22 -5 18 -22 -4 -21 -4 -21 11 -1 11 13 16 15 17 6 0 -7 6 -11 15 -7 19
7 47 -3 39 -15 -3 -5 -1 -9 5 -9 6 0 18 -11 27 -25 16 -24 15 -27 -7 -60 -13
-19 -27 -35 -30 -35 -3 0 -18 11 -33 25 -14 13 -26 22 -26 19 0 -3 -9 0 -20 6
-12 6 -17 17 -14 28 5 13 4 14 -4 4 -8 -11 -17 -9 -51 13 -22 15 -38 32 -34
38 3 6 1 7 -6 3 -10 -7 -81 29 -81 40 0 3 5 15 10 27 l11 22 -17 -22 -16 -22
-36 23 c-21 13 -68 42 -107 65 -105 61 -101 57 -86 75 11 13 11 16 -3 16 -9 0
-16 -4 -16 -10 0 -26 -27 -5 -46 35 l-21 45 31 10 c29 9 29 9 -13 7 -28 -1
-46 3 -48 11 -6 15 56 16 111 1z m4108 -211 c42 -45 74 -86 71 -91 -3 -6 -1
-7 5 -3 5 3 12 3 14 -2 1 -4 24 -20 51 -35 26 -15 47 -32 47 -37 0 -6 7 -10
15 -10 8 0 15 -8 15 -17 0 -13 2 -15 8 -5 11 17 42 4 35 -14 -3 -8 0 -14 7
-14 6 0 8 5 5 10 -3 6 -1 10 5 10 17 0 23 -29 11 -56 -6 -15 -16 -22 -23 -18
-7 4 -8 3 -4 -5 7 -11 -47 -120 -66 -132 -5 -3 -10 -10 -10 -15 -2 -25 -23
-54 -36 -49 -11 4 -12 2 -4 -8 11 -13 9 -18 -23 -65 -1 -1 -32 15 -68 36 -37
22 -63 43 -59 47 4 5 1 5 -5 1 -7 -4 -13 -2 -13 3 0 6 5 11 11 11 5 0 7 5 4
11 -5 6 -11 4 -19 -6 -13 -19 -34 -16 -118 14 -32 12 -64 21 -73 21 -8 0 -16
10 -16 23 -2 22 -2 22 -6 -2 -4 -19 -9 -22 -31 -18 -15 3 -55 9 -90 13 -50 5
-67 12 -83 32 -40 52 -7 155 75 230 25 23 46 46 46 50 0 12 40 33 50 27 6 -3
7 0 4 8 -6 18 21 41 40 34 10 -4 13 -1 10 7 -3 7 2 19 11 26 12 10 18 10 33
-1 15 -13 16 -12 4 3 -12 15 -9 21 20 47 22 20 40 28 53 25 11 -3 55 -42 97
-86z m-4271 19 c-1 -12 -15 -9 -19 4 -3 6 1 10 8 8 6 -3 11 -8 11 -12z m849
-7 c12 -8 12 -10 -5 -10 -11 0 -27 5 -35 10 -12 8 -12 10 5 10 11 0 27 -5 35
-10z m-48 -27 c20 -17 22 -31 10 -51 -14 -21 -72 5 -72 32 0 40 29 49 62 19z
m2268 7 c0 -5 -4 -10 -10 -10 -5 0 -10 5 -10 10 0 6 5 10 10 10 6 0 10 -4 10
-10z m-2230 -10 c0 -5 -2 -10 -4 -10 -3 0 -8 5 -11 10 -3 6 -1 10 4 10 6 0 11
-4 11 -10z m195 -122 c61 -60 98 -102 84 -94 -14 9 -61 29 -104 45 l-78 28
-13 49 c-6 26 -19 53 -28 59 -9 7 -16 20 -16 29 0 29 36 1 155 -116z m-325
118 c0 -11 -19 -15 -25 -6 -3 5 1 10 9 10 9 0 16 -2 16 -4z m3916 -60 c-3 -12
-6 -24 -6 -28 0 -19 -21 -5 -35 22 -20 39 -12 53 21 38 19 -9 24 -17 20 -32z
m-3880 8 c49 -20 49 -21 35 -38 -20 -24 -80 8 -81 42 0 15 0 15 46 -4z m135 6
c20 -11 26 -45 9 -55 -9 -6 -25 1 -59 24 -12 8 -12 12 -2 25 16 19 25 20 52 6z
m3694 -38 c-8 -8 -25 10 -19 20 4 6 9 5 15 -3 4 -7 6 -15 4 -17z m-3729 -23
c19 -11 34 -25 34 -30 0 -12 -3 -12 -49 7 -27 10 -38 20 -34 30 7 18 9 18 49
-7z m1856 -26 c-59 -70 -131 -138 -138 -131 -11 11 23 51 98 115 40 34 75 62
76 63 2 0 -14 -21 -36 -47z m1808 18 c0 -6 -4 -13 -10 -16 -5 -3 -10 1 -10 9
0 9 5 16 10 16 6 0 10 -4 10 -9z m-2230 -24 c14 -12 21 -18 14 -14 -7 4 -15 3
-19 -3 -4 -6 -2 -9 3 -8 11 4 113 -80 110 -90 -4 -13 27 -52 41 -52 9 0 2 -13
-19 -35 -18 -19 -37 -32 -42 -29 -4 3 -13 -6 -20 -20 -16 -36 -167 -129 -261
-160 -63 -21 -277 -51 -277 -39 0 2 31 40 69 85 71 83 75 90 107 168 24 61 37
74 123 133 66 45 76 48 95 37 19 -12 20 -12 7 4 -12 14 -11 18 5 31 26 20 35
19 64 -8z m2294 13 c16 -6 26 -17 26 -29 0 -26 -19 -31 -55 -13 -38 19 -37 16
-29 36 7 18 22 20 58 6z m-5776 -62 c-17 -10 -53 26 -43 42 5 8 14 5 31 -11
18 -17 21 -25 12 -31z m2238 1 c93 -35 90 -47 -4 -16 -50 18 -92 36 -92 40 0
9 18 4 96 -24z m-221 11 c14 -7 8 -8 -20 -3 -22 3 -42 7 -44 9 -9 8 45 2 64
-6z m143 -67 c26 -36 87 -120 136 -185 63 -86 85 -123 78 -130 -16 -16 -29 -2
-107 114 -38 57 -98 140 -133 186 -54 70 -61 82 -43 82 15 0 36 -20 69 -67z
m-98 25 c24 -13 42 -27 41 -32 -2 -5 1 -12 6 -15 4 -3 14 -14 22 -24 12 -16
11 -21 -15 -50 l-29 -32 32 28 31 29 50 -75 c48 -70 50 -75 34 -92 -16 -18
-16 -18 0 -6 12 9 22 10 35 2 10 -6 15 -11 12 -11 -4 0 9 -17 27 -37 41 -44
42 -57 8 -80 -25 -16 -27 -16 -45 8 -11 13 -17 32 -15 42 2 9 0 14 -6 11 -13
-8 -51 34 -42 48 4 6 3 8 -4 4 -6 -3 -44 33 -87 83 -45 53 -103 107 -141 133
-35 24 -64 48 -64 54 0 39 83 46 150 12z m178 1 c34 -11 78 -32 97 -45 42 -28
53 -30 34 -7 -9 11 -3 10 19 -6 17 -12 32 -25 32 -29 0 -3 -5 -1 -12 6 -7 7
-17 12 -23 12 -5 0 22 -29 60 -65 l70 -64 -25 -23 c-14 -13 -19 -18 -10 -13
13 9 13 8 1 -7 -7 -10 -17 -16 -21 -13 -4 3 -13 -2 -20 -10 -7 -8 -20 -15 -29
-15 -12 0 -13 -2 -3 -9 10 -6 10 -10 -2 -20 -12 -10 -22 -2 -59 46 -58 76
-197 272 -197 278 0 10 27 5 88 -16z m3572 11 c0 -5 -4 -10 -10 -10 -5 0 -10
5 -10 10 0 6 5 10 10 10 6 0 10 -4 10 -10z m-3182 -95 c22 -49 52 -116 66
-148 27 -60 25 -61 -34 -18 -80 58 -89 72 -90 131 0 53 10 134 15 128 2 -2 21
-43 43 -93z m3249 63 c15 -6 33 -12 38 -13 31 -4 85 -18 85 -21 0 -3 -23 -45
-51 -94 -32 -57 -56 -90 -67 -90 -16 -1 -16 -1 1 -11 9 -5 17 -16 17 -24 0
-11 -89 -168 -104 -183 -3 -2 -24 9 -48 25 -24 15 -64 39 -90 53 -27 14 -48
28 -48 32 0 4 10 23 21 43 15 24 27 34 37 30 12 -4 13 -3 3 9 -11 13 -10 15 6
11 12 -2 20 2 20 11 0 9 -6 13 -15 9 -15 -6 50 120 76 145 11 11 13 12 7 1 -5
-9 -4 -12 3 -7 6 4 9 13 5 21 -3 9 2 26 11 40 18 28 48 32 93 13z m-2127 -18
c0 -15 -46 -60 -62 -60 -6 0 3 16 22 35 37 38 40 40 40 25z m-1843 -6 c-3 -3
-12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z m1763 -19 c-12 -15 -30 -12
-30 6 0 5 10 9 21 9 18 0 19 -2 9 -15z m-1114 -37 c-3 -13 -6 -34 -6 -47 l0
-25 -30 29 c-28 27 -29 30 -13 47 9 10 25 18 36 18 15 0 18 -5 13 -22z m2440
-46 c-12 -12 -18 8 -10 35 l8 28 4 -28 c2 -16 1 -31 -2 -35z m-1321 -12 c-4
-6 -25 -20 -48 -31 -44 -22 -42 -17 7 19 30 23 52 29 41 12z m-1572 -55 c39
-48 24 -66 -19 -24 -35 33 -44 60 -21 58 6 0 25 -16 40 -34z m3460 -109 c12
-10 -5 -4 -38 14 -33 18 -67 39 -75 47 -18 19 81 -35 113 -61z m-3383 0 c-14
-14 -65 37 -55 54 5 8 16 3 36 -16 20 -19 26 -31 19 -38z m1290 59 c0 -2 -13
-11 -30 -20 -38 -19 -40 -11 -2 9 31 17 32 18 32 11z m-820 -37 c0 -6 -6 -5
-15 2 -8 7 -15 14 -15 16 0 2 7 1 15 -2 8 -4 15 -11 15 -16z m680 -38 c-19
-11 -42 -19 -50 -19 -8 0 3 8 25 18 52 25 70 26 25 1z m-457 -42 c9 1 17 -1
17 -4 0 -8 -63 -74 -71 -74 -10 0 -40 80 -34 90 3 5 20 4 38 -2 17 -5 40 -10
50 -10z m372 12 c-11 -5 -31 -8 -45 -8 -23 0 -22 1 5 8 42 11 65 11 40 0z
m-107 -17 c-10 -2 -28 -2 -40 0 -13 2 -5 4 17 4 22 1 32 -1 23 -4z m885 -30
c-7 -2 -9 -12 -6 -21 5 -16 5 -16 -12 0 -15 14 -15 18 -4 31 10 11 17 12 24 5
7 -7 6 -12 -2 -15z" />
                <path d="M1948 4103 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z" />
                <path d="M1898 4063 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M3997 4013 c-3 -5 4 -15 16 -23 21 -12 21 -12 7 6 -8 10 -15 20 -16
22 -1 2 -4 -1 -7 -5z" />
                <path d="M3960 3990 c0 -22 -2 -26 -23 -48 -20 -22 -22 -22 -34 -6 -7 10 -16
14 -20 11 -3 -4 1 -13 11 -20 16 -12 16 -14 2 -26 -19 -16 -39 -5 -31 18 5 12
4 13 -6 4 -10 -10 -9 -15 1 -28 10 -12 10 -18 0 -30 -7 -9 -20 -13 -28 -10
-12 4 -12 3 -3 -9 10 -12 18 -9 50 25 l38 40 37 -41 c21 -23 40 -39 43 -37 2
3 -14 23 -37 44 -34 33 -39 41 -27 51 11 10 17 9 27 -3 7 -8 17 -12 22 -9 5 3
20 -4 34 -17 13 -12 24 -17 24 -11 0 17 21 15 45 -5 11 -10 8 -6 -7 10 -16 15
-26 33 -22 39 5 7 3 8 -6 3 -8 -5 -18 -1 -27 11 -11 15 -15 16 -22 5 -13 -20
-32 -3 -27 25 3 13 0 24 -5 24 -5 0 -9 -4 -9 -10z m15 -51 c11 -17 -1 -21 -15
-4 -8 9 -8 15 -2 15 6 0 14 -5 17 -11z m55 -14 c7 -9 10 -18 7 -22 -8 -7 -37
15 -37 28 0 14 16 11 30 -6z" />
                <path d="M4136 3971 c-17 -6 -17 -8 -4 -14 10 -3 19 0 22 9 3 8 4 14 3 13 -1
0 -11 -4 -21 -8z" />
                <path d="M4150 3930 c0 -5 7 -7 15 -4 8 4 15 8 15 10 0 2 -7 4 -15 4 -8 0 -15
-4 -15 -10z" />
                <path d="M3987 3879 c12 -12 24 -21 27 -18 2 2 -8 13 -22 23 l-27 19 22 -24z" />
                <path d="M4069 3848 c21 -24 22 -56 1 -43 -4 3 -13 -2 -20 -10 -7 -8 -9 -15
-4 -15 4 0 -3 -11 -16 -25 -31 -33 -18 -32 15 1 14 14 23 30 19 36 -4 6 2 6
15 -1 25 -14 26 -19 4 -45 -10 -12 -14 -18 -9 -14 5 4 16 2 25 -5 14 -10 14
-10 3 4 -11 14 -8 21 18 42 35 30 36 33 11 33 -12 0 -17 -5 -13 -15 3 -9 0
-12 -9 -9 -8 3 -13 14 -12 25 1 11 -10 31 -25 44 l-27 24 24 -27z" />
                <path d="M3903 3845 c0 -11 4 -12 14 -4 7 6 13 13 13 15 0 2 -6 4 -13 4 -8 0
-14 -7 -14 -15z" />
                <path d="M4226 3844 c-6 -16 2 -18 22 -5 11 7 11 9 -1 14 -9 3 -18 -1 -21 -9z" />
                <path d="M4173 3837 c4 -10 2 -17 -6 -17 -8 0 -9 -3 -1 -8 6 -4 13 -14 16 -22
3 -10 6 -6 10 11 3 15 -2 31 -11 39 -13 13 -14 12 -8 -3z" />
                <path d="M3863 3803 c0 -7 4 -13 8 -13 4 0 9 6 12 13 3 8 0 14 -7 14 -7 0 -13
-6 -13 -14z" />
                <path d="M3949 3803 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21 -13z" />
                <path d="M4015 3810 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z" />
                <path d="M4235 3810 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z" />
                <path d="M4253 3774 c0 -16 13 -19 21 -5 3 5 0 11 -7 14 -8 3 -14 -1 -14 -9z" />
                <path d="M4140 3769 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z" />
                <path d="M4193 3741 c0 -11 5 -18 9 -15 4 3 5 11 1 19 -7 21 -12 19 -10 -4z" />
                <path d="M4050 3711 c5 -11 15 -23 21 -27 6 -3 3 5 -6 20 -20 30 -30 35 -15 7z" />
                <path d="M4114 3690 c0 -24 21 -27 30 -4 3 8 2 12 -4 9 -6 -3 -10 -1 -10 4 0
6 -4 11 -8 11 -4 0 -8 -9 -8 -20z" />
                <path d="M4007 3667 c-3 -8 1 -14 8 -14 7 0 11 6 8 14 -3 7 -6 13 -8 13 -2 0
-5 -6 -8 -13z" />
                <path d="M4080 3659 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z" />
                <path d="M4512 4168 c-7 -9 -6 -22 3 -43 l13 -30 1 43 c1 45 -1 49 -17 30z" />
                <path d="M4490 4120 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z" />
                <path d="M4467 4086 c-17 -13 -17 -14 0 -20 10 -4 14 -4 10 0 -4 4 -2 13 4 21
14 17 9 16 -14 -1z" />
                <path d="M4590 4080 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z" />
                <path d="M4339 4042 c8 -6 12 -20 9 -36 -3 -14 -1 -26 4 -26 15 0 4 63 -12 67
-12 4 -13 3 -1 -5z" />
                <path d="M4409 4034 c6 -12 7 -24 4 -28 -3 -3 -1 -6 5 -6 16 0 15 12 -4 36
-15 18 -15 18 -5 -2z" />
                <path d="M4514 4041 c3 -5 -6 -20 -19 -34 -19 -18 -22 -26 -12 -30 19 -7 34 4
39 28 1 11 7 23 11 26 5 3 1 9 -8 12 -9 4 -14 3 -11 -2z" />
                <path d="M4375 4000 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z" />
                <path d="M4530 3970 c-11 -22 -18 -40 -15 -40 2 0 14 18 25 40 11 22 18 40 15
40 -2 0 -14 -18 -25 -40z" />
                <path d="M4585 4000 c-3 -6 1 -7 9 -4 18 7 21 14 7 14 -6 0 -13 -4 -16 -10z" />
                <path d="M4316 3982 c-3 -6 0 -13 6 -15 10 -4 9 -8 -2 -16 -12 -9 -11 -11 8
-11 20 0 22 2 11 23 -16 29 -16 30 -23 19z" />
                <path d="M4390 3970 c0 -6 7 -10 15 -10 8 0 15 2 15 4 0 2 -7 6 -15 10 -8 3
-15 1 -15 -4z" />
                <path d="M4430 3970 c0 -5 7 -7 15 -4 8 4 15 8 15 10 0 2 -7 4 -15 4 -8 0 -15
-4 -15 -10z" />
                <path d="M4470 3959 c0 -5 -4 -8 -9 -5 -5 3 -15 -2 -22 -12 -12 -15 -12 -16 1
-5 10 7 21 8 30 3 18 -11 31 -3 23 15 -6 17 -23 20 -23 4z" />
                <path d="M4394 3926 c-4 -17 -14 -26 -32 -29 -24 -3 -23 -4 6 -6 18 0 31 -5
28 -9 -3 -5 1 -9 8 -9 8 0 12 6 9 14 -3 9 4 13 23 14 27 2 28 2 4 6 -14 3 -29
9 -35 15 -7 8 -6 9 2 4 9 -5 11 -2 7 8 -8 22 -13 20 -20 -8z" />
                <path d="M4547 3933 c-3 -4 6 -16 20 -27 25 -18 25 -18 21 5 -3 23 -31 38 -41
22z" />
                <path d="M4315 3910 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z" />
                <path d="M3478 4032 c-10 -2 -18 -7 -18 -12 0 -5 7 -7 15 -4 8 4 21 1 28 -4 8
-7 18 -7 27 -2 12 8 11 10 -7 10 -12 0 -23 4 -25 8 -1 4 -11 6 -20 4z" />
                <path d="M1523 3965 c0 -27 2 -38 4 -22 2 15 2 37 0 50 -2 12 -4 0 -4 -28z" />
                <path d="M1591 3953 c-1 -18 -7 -23 -28 -24 -28 -2 -28 -2 -3 -6 14 -3 28 -9
31 -15 10 -16 16 15 8 42 -7 24 -7 24 -8 3z" />
                <path d="M1380 3938 c0 -4 14 -8 30 -8 17 0 30 2 30 4 0 2 -13 6 -30 8 -16 3
-30 1 -30 -4z" />
                <path d="M1451 3934 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M1691 3924 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M2005 3930 c-18 -8 -17 -9 8 -9 16 -1 26 3 22 9 -3 6 -7 10 -8 9 -1
0 -11 -4 -22 -9z" />
                <path d="M1860 3893 c0 -24 2 -43 4 -43 8 0 12 60 4 72 -4 8 -8 -4 -8 -29z" />
                <path d="M1382 3895 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z" />
                <path d="M1728 3913 c12 -2 30 -2 40 0 9 3 -1 5 -23 4 -22 0 -30 -2 -17 -4z" />
                <path d="M1692 3880 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z" />
                <path d="M1291 3874 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M1972 3884 c8 -7 108 -7 115 0 4 3 -22 6 -57 6 -35 0 -61 -3 -58 -6z" />
                <path d="M1760 3845 c0 -19 -5 -25 -22 -26 -21 -1 -21 -2 -3 -6 11 -3 23 -10
27 -17 4 -6 8 8 8 32 0 23 -2 42 -5 42 -3 0 -5 -11 -5 -25z" />
                <path d="M1283 3843 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z" />
                <path d="M1513 3805 c0 -27 2 -38 4 -22 2 15 2 37 0 50 -2 12 -4 0 -4 -28z" />
                <path d="M1994 3841 c3 -5 15 -7 26 -4 28 7 25 13 -6 13 -14 0 -23 -4 -20 -9z" />
                <path d="M1443 3833 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z" />
                <path d="M1593 3823 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z" />
                <path d="M1281 3794 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M1948 3803 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M1583 3765 c0 -22 2 -30 4 -17 2 12 2 30 0 40 -3 9 -5 -1 -4 -23z" />
                <path d="M1853 3745 c0 -22 2 -30 4 -17 2 12 2 30 0 40 -3 9 -5 -1 -4 -23z" />
                <path d="M1443 3730 c0 -25 2 -35 4 -22 2 12 2 32 0 45 -2 12 -4 2 -4 -23z" />
                <path d="M1679 3753 c-1 -10 0 -24 1 -32 1 -8 -4 -17 -10 -21 -8 -5 -7 -9 4
-13 13 -5 16 2 16 38 0 43 -9 64 -11 28z" />
                <path d="M1313 3753 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z" />
                <path d="M1372 3730 c0 -19 2 -27 5 -17 2 9 2 25 0 35 -3 9 -5 1 -5 -18z" />
                <path d="M1488 3743 c12 -2 30 -2 40 0 9 3 -1 5 -23 4 -22 0 -30 -2 -17 -4z" />
                <path d="M1272 3715 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z" />
                <path d="M1708 3733 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z" />
                <path d="M1948 3700 c-3 -16 -1 -30 4 -30 4 0 8 14 8 30 0 17 -2 30 -4 30 -2
0 -6 -13 -8 -30z" />
                <path d="M1988 3713 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M2022 3700 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z" />
                <path d="M1518 3703 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M1373 3673 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z" />
                <path d="M1753 3630 c0 -30 2 -42 4 -25 3 16 10 33 16 37 9 6 9 8 0 8 -6 0
-14 8 -16 18 -3 9 -5 -8 -4 -38z" />
                <path d="M1488 3663 c12 -2 30 -2 40 0 9 3 -1 5 -23 4 -22 0 -30 -2 -17 -4z" />
                <path d="M1570 3660 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z" />
                <path d="M1613 3653 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z" />
                <path d="M1853 3633 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z" />
                <path d="M1573 3590 c0 -25 2 -35 4 -22 2 12 2 32 0 45 -2 12 -4 2 -4 -23z" />
                <path d="M1843 3580 c0 -25 2 -35 4 -22 2 12 2 32 0 45 -2 12 -4 2 -4 -23z" />
                <path d="M2025 3595 c0 -28 3 -29 25 -15 10 6 11 10 3 10 -7 0 -13 7 -13 15 0
8 -3 15 -7 15 -5 0 -8 -11 -8 -25z" />
                <path d="M1503 3565 c0 -27 2 -38 4 -22 2 15 2 37 0 50 -2 12 -4 0 -4 -28z" />
                <path d="M1361 3545 l1 -50 8 40 c5 22 4 44 -1 50 -5 5 -9 -11 -8 -40z" />
                <path d="M1432 3545 c1 -36 2 -41 5 -17 3 21 10 32 21 33 14 0 14 2 2 6 -8 3
-18 11 -22 17 -4 6 -7 -11 -6 -39z" />
                <path d="M1528 3563 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M1660 3560 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z" />
                <path d="M1708 3553 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M1753 3553 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z" />
                <path d="M1888 3543 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z" />
                <path d="M1393 3473 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z" />
                <path d="M1573 3463 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z" />
                <path d="M1758 3453 c12 -2 30 -2 40 0 9 3 -1 5 -23 4 -22 0 -30 -2 -17 -4z" />
                <path d="M1928 3443 c12 -2 30 -2 40 0 9 3 -1 5 -23 4 -22 0 -30 -2 -17 -4z" />
                <path d="M1742 3420 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z" />
                <path d="M1662 3400 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z" />
                <path d="M1928 3393 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M2182 3881 c-11 -7 -10 -10 3 -15 20 -7 38 1 30 15 -7 11 -16 11 -33
0z" />
                <path d="M2295 3860 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z" />
                <path d="M2210 3806 c0 -8 4 -17 9 -20 5 -4 7 3 4 14 -6 23 -13 26 -13 6z" />
                <path d="M2138 3793 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z" />
                <path d="M2290 3783 c14 -3 28 -10 32 -17 5 -7 8 -5 8 7 0 13 -8 17 -32 16
-28 -2 -29 -2 -8 -6z" />
                <path d="M2348 3753 c-10 -2 -18 -9 -18 -14 0 -6 10 -5 23 2 37 20 36 23 -5
12z" />
                <path d="M2180 3715 c0 -8 4 -15 10 -15 5 0 7 7 4 15 -4 8 -8 15 -10 15 -2 0
-4 -7 -4 -15z" />
                <path d="M2430 3910 c8 -5 22 -10 30 -10 13 0 13 1 0 10 -8 5 -22 10 -30 10
-13 0 -13 -1 0 -10z" />
                <path d="M2482 3840 c0 -19 2 -27 5 -17 2 9 2 25 0 35 -3 9 -5 1 -5 -18z" />
                <path d="M2573 3810 c0 -30 2 -43 4 -27 2 15 2 39 0 55 -2 15 -4 2 -4 -28z" />
                <path d="M2610 3846 c0 -8 71 -12 76 -4 3 4 -13 8 -35 8 -23 0 -41 -2 -41 -4z" />
                <path d="M2875 3840 c-4 -6 11 -10 34 -10 23 0 41 4 41 8 0 12 -68 13 -75 2z" />
                <path d="M2672 3800 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z" />
                <path d="M2772 3800 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z" />
                <path d="M2623 3763 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z" />
                <path d="M4842 3755 l-23 -12 25 -5 c20 -4 26 -1 26 13 0 11 -1 19 -2 18 -2
-1 -13 -7 -26 -14z" />
                <path d="M4888 3753 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M3020 3830 c0 -6 -4 -8 -10 -5 -5 3 -10 1 -10 -4 0 -13 10 -14 29 -2
9 6 10 11 2 15 -6 4 -11 2 -11 -4z" />
                <path d="M3100 3816 c0 -2 8 -10 18 -17 15 -13 16 -12 3 4 -13 16 -21 21 -21
13z" />
                <path d="M3042 3775 c9 -11 18 -33 20 -50 3 -29 4 -29 9 7 3 21 3 35 0 33 -2
-3 -14 3 -25 12 -21 18 -21 18 -4 -2z" />
                <path d="M3232 3860 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z" />
                <path d="M3291 3844 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M3228 3813 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M3291 3804 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M3280 3681 c0 -33 -4 -40 -22 -44 -20 -4 -19 -4 5 -6 25 -1 27 2 27
38 0 33 4 40 23 44 19 4 18 4 -5 6 -26 1 -28 -2 -28 -38z" />
                <path d="M3218 3665 c-2 -19 0 -35 4 -35 4 0 8 16 8 35 0 19 -2 35 -4 35 -2 0
-6 -16 -8 -35z" />
                <path d="M3509 3828 c-5 -38 -5 -38 31 -37 29 2 30 3 8 6 -22 3 -27 10 -30 36
l-3 32 -6 -37z" />
                <path d="M3388 3803 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z" />
                <path d="M3430 3799 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z" />
                <path d="M3432 3740 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z" />
                <path d="M3438 3703 c12 -2 30 -2 40 0 9 3 -1 5 -23 4 -22 0 -30 -2 -17 -4z" />
                <path d="M3502 3685 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z" />
                <path d="M3428 3623 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z" />
                <path d="M3681 3834 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M3680 3801 c0 -5 -10 -12 -22 -14 -17 -3 -14 -5 9 -6 25 -1 31 2 27
14 -7 17 -14 20 -14 6z" />
                <path d="M3673 3665 c0 -22 2 -30 4 -17 2 12 2 30 0 40 -3 9 -5 -1 -4 -23z" />
                <path d="M3758 3683 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z" />
                <path d="M3843 3575 c0 -22 2 -30 4 -17 2 12 2 30 0 40 -3 9 -5 -1 -4 -23z" />
                <path d="M1026 3691 c-4 -5 3 -7 14 -4 23 6 26 13 6 13 -8 0 -17 -4 -20 -9z" />
                <path d="M958 3663 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M1075 3640 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z" />
                <path d="M945 3569 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z" />
                <path d="M1126 3532 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6 -4
-9 -8z" />
                <path d="M957 3517 c-3 -7 3 -13 14 -13 13 0 15 3 7 13 -6 7 -12 13 -13 13 -2
0 -5 -6 -8 -13z" />
                <path d="M1153 3494 c0 -16 13 -19 21 -5 3 5 0 11 -7 14 -8 3 -14 -1 -14 -9z" />
                <path d="M995 3470 c-2 -3 5 -6 15 -7 11 -1 22 2 24 5 3 4 -4 8 -15 8 -11 0
-22 -3 -24 -6z" />
                <path d="M1245 3470 c-3 -6 1 -7 9 -4 18 7 21 14 7 14 -6 0 -13 -4 -16 -10z" />
                <path d="M923 3435 c0 -7 6 -11 14 -8 7 3 13 6 13 8 0 2 -6 5 -13 8 -8 3 -14
-1 -14 -8z" />
                <path d="M1190 3439 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z" />
                <path d="M1030 3436 c0 -2 8 -10 18 -17 15 -13 16 -12 3 4 -13 16 -21 21 -21
13z" />
                <path d="M1126 3416 c7 -19 20 -21 30 -3 4 6 4 9 -1 5 -4 -4 -14 -3 -22 4 -11
8 -12 7 -7 -6z" />
                <path d="M1269 3413 c-12 -16 -12 -17 2 -6 9 7 19 10 22 6 4 -3 7 -1 7 5 0 17
-16 15 -31 -5z" />
                <path d="M1064 3392 c5 -8 1 -19 -10 -28 -16 -12 -13 -12 14 1 17 8 32 18 32
22 0 3 -3 3 -7 0 -3 -4 -13 -1 -21 6 -13 10 -14 9 -8 -1z" />
                <path d="M1220 3390 c0 -5 4 -10 9 -10 6 0 13 5 16 10 3 6 -1 10 -9 10 -9 0
-16 -4 -16 -10z" />
                <path d="M1165 3360 c-3 -5 -2 -10 4 -10 5 0 13 5 16 10 3 6 2 10 -4 10 -5 0
-13 -4 -16 -10z" />
                <path d="M1110 3331 c5 -11 15 -23 21 -27 6 -3 3 5 -6 20 -20 30 -30 35 -15 7z" />
                <path d="M1000 3336 c0 -2 8 -10 18 -17 15 -13 16 -12 3 4 -13 16 -21 21 -21
13z" />
                <path d="M1036 3288 c3 -5 10 -6 15 -3 13 9 11 12 -6 12 -8 0 -12 -4 -9 -9z" />
                <path d="M4572 3780 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z" />
                <path d="M4390 3685 c-7 -9 -19 -14 -26 -11 -8 3 -11 0 -7 -10 7 -19 16 -18
31 6 7 12 17 18 22 15 6 -3 10 -1 10 4 0 16 -16 13 -30 -4z" />
                <path d="M4501 3684 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M4421 3644 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M4280 3604 c0 -14 4 -23 9 -20 5 3 7 15 4 26 -7 28 -13 25 -13 -6z" />
                <path d="M4350 3615 c0 -5 5 -17 10 -25 5 -8 10 -10 10 -5 0 6 -5 17 -10 25
-5 8 -10 11 -10 5z" />
                <path d="M4420 3596 c0 -2 7 -9 15 -16 13 -11 14 -10 9 4 -5 14 -24 23 -24 12z" />
                <path d="M4258 3553 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z" />
                <path d="M4414 3530 c-5 -4 -20 -10 -34 -13 -16 -3 -10 -5 18 -6 23 0 42 3 42
8 0 15 -16 21 -26 11z" />
                <path d="M4212 3510 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z" />
                <path d="M4298 3503 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M3932 3465 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z" />
                <path d="M4168 3483 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z" />
                <path d="M3833 3415 c0 -27 2 -40 4 -28 2 13 13 24 26 26 l22 4 -22 2 c-14 1
-23 9 -26 24 -2 12 -4 0 -4 -28z" />
                <path d="M4300 3446 c0 -8 -6 -17 -12 -19 -8 -3 -6 -6 5 -6 11 -1 17 6 17 19
0 11 -2 20 -5 20 -3 0 -5 -6 -5 -14z" />
                <path d="M3742 3430 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z" />
                <path d="M4228 3443 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z" />
                <path d="M4428 3443 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M4168 3433 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M4358 3433 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M4475 3430 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z" />
                <path d="M3688 3423 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M4218 3413 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M4407 3400 c3 -11 7 -20 9 -20 2 0 4 9 4 20 0 11 -4 20 -9 20 -5 0
-7 -9 -4 -20z" />
                <path d="M3993 3403 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z" />
                <path d="M4148 3403 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M4358 3403 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M4297 3394 c-14 -14 -7 -30 15 -31 13 -1 18 1 12 5 -6 4 -13 13 -15
20 -3 7 -8 10 -12 6z" />
                <path d="M4013 3345 c0 -27 2 -38 4 -22 2 15 2 37 0 50 -2 12 -4 0 -4 -28z" />
                <path d="M4248 3383 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M3652 3350 c0 -19 2 -27 5 -17 2 9 2 25 0 35 -3 9 -5 1 -5 -18z" />
                <path d="M4178 3373 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M4412 3354 c-7 -8 -8 -14 -3 -14 10 0 25 19 20 25 -2 1 -10 -3 -17
-11z" />
                <path d="M3920 3341 c0 -12 -8 -21 -22 -24 -23 -4 -23 -4 -1 -6 14 -1 23 -9
26 -23 2 -13 5 -2 6 25 0 26 -1 47 -4 47 -3 0 -5 -9 -5 -19z" />
                <path d="M4320 3337 c0 -10 8 -17 18 -17 9 0 13 4 7 8 -5 4 -13 11 -17 16 -5
5 -8 2 -8 -7z" />
                <path d="M4270 3320 c-6 -11 -8 -20 -6 -20 3 0 10 9 16 20 6 11 8 20 6 20 -3
0 -10 -9 -16 -20z" />
                <path d="M4058 3303 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M3732 3275 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z" />
                <path d="M3818 3250 c-3 -16 -1 -30 4 -30 4 0 8 14 8 30 0 17 -2 30 -4 30 -2
0 -6 -13 -8 -30z" />
                <path d="M3658 3233 c12 -2 30 -2 40 0 9 3 -1 5 -23 4 -22 0 -30 -2 -17 -4z" />
                <path d="M4102 3205 c0 -22 2 -32 5 -23 2 9 12 19 21 21 16 4 16 5 0 6 -9 0
-19 9 -21 19 -3 9 -5 -1 -5 -23z" />
                <path d="M3848 3223 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M3643 3185 c0 -22 2 -30 4 -17 2 12 2 30 0 40 -3 9 -5 -1 -4 -23z" />
                <path d="M3948 3213 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M3987 3212 c6 -4 13 -21 16 -37 4 -27 4 -27 6 8 1 29 -3 37 -16 37
-12 0 -14 -3 -6 -8z" />
                <path d="M3910 3156 c0 -32 -3 -35 -32 -39 -32 -4 -32 -4 5 -5 37 -2 37 -2 37
38 0 22 -2 40 -5 40 -3 0 -5 -15 -5 -34z" />
                <path d="M3721 3154 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M4030 3131 c0 -12 -8 -21 -22 -24 -20 -4 -19 -4 5 -6 23 -1 27 3 27
24 0 14 -2 25 -5 25 -3 0 -5 -9 -5 -19z" />
                <path d="M3697 3123 c13 -2 24 -13 26 -26 4 -18 5 -17 6 6 1 23 -3 27 -26 26
-23 -1 -24 -2 -6 -6z" />
                <path d="M3810 3120 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z" />
                <path d="M3812 3075 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z" />
                <path d="M3633 2995 c0 -22 2 -30 4 -17 2 12 2 30 0 40 -3 9 -5 -1 -4 -23z" />
                <path d="M3703 3013 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z" />
                <path d="M3713 2955 c0 -22 2 -30 4 -17 2 12 2 30 0 40 -3 9 -5 -1 -4 -23z" />
                <path d="M3671 2908 c0 -16 2 -18 6 -8 3 8 11 18 17 22 7 5 4 8 -6 8 -12 0
-18 -7 -17 -22z" />
                <path d="M3738 2923 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z" />
                <path d="M2663 3660 c0 -25 2 -35 4 -22 2 12 2 32 0 45 -2 12 -4 2 -4 -23z" />
                <path d="M2762 3655 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z" />
                <path d="M2940 3666 c0 -8 -10 -17 -22 -19 -20 -4 -19 -4 5 -6 21 -1 27 4 27
19 0 11 -2 20 -5 20 -3 0 -5 -6 -5 -14z" />
                <path d="M3012 3660 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z" />
                <path d="M2490 3629 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z" />
                <path d="M2693 3633 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z" />
                <path d="M2831 3604 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M2403 3642 c0 -12 5 -22 9 -22 11 0 10 12 -2 30 -7 12 -9 10 -7 -8z" />
                <path d="M2420 3590 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z" />
                <path d="M2210 3578 c0 -13 7 -18 28 -17 21 1 22 2 7 6 -11 3 -23 10 -27 17
-5 7 -8 5 -8 -6z" />
                <path d="M2321 3574 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M2370 3570 c-13 -9 -13 -10 0 -10 8 0 22 5 30 10 13 9 13 10 0 10 -8
0 -22 -5 -30 -10z" />
                <path d="M2430 3555 c0 -8 4 -15 10 -15 5 0 7 7 4 15 -4 8 -8 15 -10 15 -2 0
-4 -7 -4 -15z" />
                <path d="M2382 3534 c-10 -12 -10 -14 2 -14 8 0 16 -3 19 -7 2 -5 2 -3 1 4 -2
6 2 13 9 16 7 2 6 5 -4 9 -8 3 -20 -1 -27 -8z" />
                <path d="M2221 3524 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M2267 3495 c-4 -8 -2 -17 3 -20 6 -4 10 3 10 14 0 25 -6 27 -13 6z" />
                <path d="M2230 3480 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z" />
                <path d="M2434 3457 l-19 -22 21 18 c17 14 23 15 27 5 4 -9 6 -9 6 -1 2 22
-16 23 -35 0z" />
                <path d="M2161 3440 c0 -8 4 -24 9 -35 5 -13 9 -14 9 -5 0 8 -4 24 -9 35 -5
13 -9 14 -9 5z" />
                <path d="M2330 3441 c0 -5 5 -13 10 -16 6 -3 10 -2 10 4 0 5 -4 13 -10 16 -5
3 -10 2 -10 -4z" />
                <path d="M2240 3419 c0 -4 14 -9 30 -11 17 -3 30 -1 30 3 0 4 -13 9 -30 11
-16 3 -30 1 -30 -3z" />
                <path d="M2198 3413 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M2356 3384 c1 -6 -2 -16 -7 -21 -6 -6 -4 -10 5 -10 8 0 17 9 19 19 3
10 1 16 -3 13 -5 -3 -10 -2 -13 2 -2 5 -3 3 -1 -3z" />
                <path d="M2475 3390 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z" />
                <path d="M2247 3370 c-3 -11 -1 -20 4 -20 5 0 9 9 9 20 0 11 -2 20 -4 20 -2 0
-6 -9 -9 -20z" />
                <path d="M2087 3350 c-3 -12 0 -20 8 -20 8 0 11 8 8 20 -3 11 -7 20 -8 20 -1
0 -5 -9 -8 -20z" />
                <path d="M2190 3340 c0 -5 7 -7 15 -4 8 4 15 8 15 10 0 2 -7 4 -15 4 -8 0 -15
-4 -15 -10z" />
                <path d="M2313 3335 c0 -8 4 -15 9 -15 4 0 8 4 8 9 0 6 -4 12 -8 15 -5 3 -9
-1 -9 -9z" />
                <path d="M2120 3326 c0 -2 9 -6 20 -9 11 -3 20 -1 20 4 0 5 -9 9 -20 9 -11 0
-20 -2 -20 -4z" />
                <path d="M2371 3314 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M2501 3304 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M2321 3294 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M2366 3282 c6 -4 14 -14 17 -22 4 -12 6 -12 6 2 1 9 7 19 14 21 6 3
-1 6 -18 6 -16 0 -25 -3 -19 -7z" />
                <path d="M2521 3214 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M2548 3223 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M2488 3213 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M227 3565 c9 -19 18 -33 21 -31 4 5 -26 66 -33 66 -3 0 3 -16 12 -35z" />
                <path d="M186 3501 c-15 -6 -16 -9 -5 -13 8 -3 20 1 27 8 14 15 7 17 -22 5z" />
                <path d="M302 3460 c-7 -12 -16 -19 -20 -16 -5 3 -8 -6 -8 -19 0 -14 5 -26 11
-29 8 -3 10 5 7 20 -4 22 -1 24 19 21 13 -2 18 -2 12 0 -7 3 -13 9 -13 14 0 6
4 7 10 4 6 -3 7 1 4 9 -8 20 -7 20 -22 -4z" />
                <path d="M201 3454 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M211 3414 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M359 3397 c25 -27 43 -39 22 -14 -6 8 -7 18 -3 23 4 5 3 6 -2 2 -5
-4 -16 -2 -25 4 -9 7 -5 0 8 -15z" />
                <path d="M246 3391 c-3 -5 1 -11 9 -14 9 -4 12 -1 8 9 -6 16 -10 17 -17 5z" />
                <path d="M300 3376 c0 -2 8 -10 18 -17 15 -13 16 -12 3 4 -13 16 -21 21 -21
13z" />
                <path d="M210 3349 c0 -15 8 -35 18 -46 9 -10 14 -14 10 -8 -4 7 -5 15 -1 18
3 4 1 7 -6 7 -7 0 -11 6 -8 13 3 8 1 20 -4 28 -6 10 -9 7 -9 -12z" />
                <path d="M285 3350 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z" />
                <path d="M250 3330 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z" />
                <path d="M300 3319 c0 -22 32 -30 49 -11 12 12 11 13 -9 7 -15 -5 -25 -2 -31
6 -7 11 -9 11 -9 -2z" />
                <path d="M435 3312 c6 -4 37 -35 69 -69 53 -56 58 -64 45 -79 -13 -16 -12 -16
8 -3 23 14 23 14 -29 66 -29 29 -48 53 -44 53 5 0 -3 9 -17 20 -14 11 -29 20
-34 20 -4 0 -3 -4 2 -8z" />
                <path d="M376 3288 c5 -8 2 -9 -10 -5 -9 4 -15 3 -11 -2 3 -5 -1 -11 -7 -14
-8 -2 -9 -8 -4 -13 5 -5 11 -4 13 4 3 6 9 10 14 6 5 -3 9 0 9 7 0 8 4 8 15 -1
21 -17 19 -27 -6 -35 -11 -4 -18 -9 -16 -12 3 -2 15 0 26 7 43 22 42 -3 -1
-31 -23 -16 -38 -29 -31 -29 6 0 15 5 18 10 4 6 10 8 15 5 4 -3 11 3 14 12 6
14 9 14 29 -4 12 -11 30 -20 40 -20 13 0 0 18 -45 64 -62 62 -76 74 -62 51z
m99 -106 c-6 -7 -35 18 -35 31 0 5 9 2 20 -8 11 -10 18 -20 15 -23z" />
                <path d="M307 3279 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 -14 6 -15 5 -6 -5z" />
                <path d="M268 3273 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M311 3236 c-9 -11 -9 -16 1 -22 7 -4 10 -4 6 1 -4 4 -3 14 3 22 6 7
9 13 6 13 -2 0 -10 -6 -16 -14z" />
                <path d="M280 3223 c0 -6 8 -17 18 -24 16 -13 16 -13 2 6 -8 11 -16 22 -17 24
-2 2 -3 0 -3 -6z" />
                <path d="M399 3120 l-24 -20 29 14 c16 8 34 12 39 9 6 -3 7 -1 3 5 -10 17 -20
15 -47 -8z" />
                <path d="M453 3093 c0 -16 2 -16 27 -1 16 10 23 9 42 -7 l23 -20 -19 22 c-20
24 -73 28 -73 6z" />
                <path d="M396 3092 c-2 -4 5 -19 15 -32 17 -20 18 -21 10 -4 -6 12 -8 24 -5
27 3 3 1 8 -5 11 -5 4 -12 3 -15 -2z" />
                <path d="M594 3063 c31 -34 30 -56 -1 -32 -16 12 -17 12 -6 -2 7 -9 9 -19 5
-24 -4 -4 3 -3 15 4 30 15 38 14 23 -4 -7 -8 -10 -15 -7 -15 2 0 9 6 16 13 8
10 1 23 -32 53 -30 28 -34 30 -13 7z" />
                <path d="M497 3055 c10 -13 22 -25 27 -25 5 0 -1 11 -14 25 -30 32 -36 32 -13
0z" />
                <path d="M715 3020 c27 -27 51 -50 54 -50 3 0 -17 23 -44 50 -27 28 -51 50
-54 50 -3 0 17 -22 44 -50z" />
                <path d="M553 3042 c-8 -14 -8 -19 1 -19 7 0 13 9 13 19 1 10 1 18 0 18 -1 0
-7 -8 -14 -18z" />
                <path d="M569 2997 c12 -15 11 -20 -5 -40 l-19 -22 23 19 c21 19 23 19 42 1
17 -15 23 -16 33 -5 8 9 8 11 0 6 -6 -3 -18 -1 -25 6 -7 7 -25 22 -38 33 -19
16 -22 16 -11 2z" />
                <path d="M657 2989 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 -14 6 -15 5 -6 -5z" />
                <path d="M675 2930 c-3 -5 -13 -6 -23 -3 -9 3 -15 4 -12 2 3 -2 17 -14 31 -27
25 -22 27 -22 40 -5 13 17 13 17 -5 3 -18 -14 -19 -13 -13 2 4 13 2 15 -11 11
-15 -6 -15 -5 -3 10 7 9 11 17 8 17 -3 0 -8 -4 -12 -10z" />
                <path d="M775 2920 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z" />
                <path d="M731 2898 c-8 -13 -15 -37 -15 -55 -1 -29 0 -31 17 -16 9 9 17 26 17
37 0 16 -3 18 -9 7 -5 -8 -11 -9 -15 -3 -3 5 1 15 9 22 13 11 21 8 48 -16 31
-28 31 -28 -2 9 -19 20 -35 37 -36 37 0 0 -6 -10 -14 -22z" />
                <path d="M835 2900 c10 -11 20 -20 23 -20 3 0 -3 9 -13 20 -10 11 -20 20 -23
20 -3 0 3 -9 13 -20z" />
                <path d="M616 2878 c3 -5 10 -6 15 -3 13 9 11 12 -6 12 -8 0 -12 -4 -9 -9z" />
                <path d="M845 2834 c-20 -18 -23 -22 -8 -15 12 6 25 16 28 22 5 7 15 4 28 -8
l22 -18 -19 23 c-11 12 -20 22 -20 22 -1 -1 -14 -12 -31 -26z" />
                <path d="M834 2798 c-4 -7 -4 -10 1 -6 4 4 14 0 21 -10 7 -9 15 -14 18 -11 3
3 -2 14 -13 23 -15 14 -21 15 -27 4z" />
                <path d="M930 2786 c0 -2 8 -10 18 -17 15 -13 16 -12 3 4 -13 16 -21 21 -21
13z" />
                <path d="M995 2710 c10 -11 20 -20 23 -20 3 0 -3 9 -13 20 -10 11 -20 20 -23
20 -3 0 3 -9 13 -20z" />
                <path d="M580 3440 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z" />
                <path d="M986 3167 c3 -10 -4 -17 -23 -22 l-28 -7 23 -12 c12 -7 19 -16 15
-21 -4 -5 -1 -4 9 3 14 11 17 10 21 -5 3 -12 5 -10 6 8 1 23 -2 26 -26 22 -26
-3 -27 -3 -5 6 23 11 29 26 12 36 -5 3 -7 0 -4 -8z" />
                <path d="M929 3063 c-13 -16 -20 -25 -15 -20 5 4 19 -1 30 -10 21 -18 21 -18
4 3 -17 19 -17 21 -1 37 10 9 15 17 12 17 -3 0 -16 -12 -30 -27z" />
                <path d="M843 2995 c0 -8 4 -12 8 -9 4 2 10 -4 12 -13 4 -15 5 -15 6 -2 0 9
-5 22 -12 28 -10 8 -14 7 -14 -4z" />
                <path d="M921 2946 c-9 -11 -9 -16 0 -22 7 -4 9 -3 5 4 -12 20 15 24 37 5 l22
-18 -19 23 c-22 26 -29 27 -45 8z" />
                <path d="M1010 2956 c0 -2 8 -10 18 -17 15 -13 16 -12 3 4 -13 16 -21 21 -21
13z" />
                <path d="M1215 2877 c-4 -26 -5 -50 -2 -53 8 -8 20 60 15 83 -3 10 -8 -4 -13
-30z" />
                <path d="M940 2900 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z" />
                <path d="M1080 2875 c13 -14 26 -25 28 -25 3 0 -5 11 -18 25 -13 14 -26 25
-28 25 -3 0 5 -11 18 -25z" />
                <path d="M957 2865 c-4 -8 -2 -17 3 -20 6 -4 10 3 10 14 0 25 -6 27 -13 6z" />
                <path d="M980 2862 c0 -4 15 -22 33 -40 31 -30 33 -30 44 -13 10 16 7 23 -15
42 l-27 24 23 -26 c17 -20 20 -29 11 -35 -8 -4 -23 5 -41 25 -15 17 -28 28
-28 23z" />
                <path d="M1226 2815 c-3 -9 0 -15 9 -15 9 0 12 6 9 15 -4 8 -7 15 -9 15 -2 0
-5 -7 -9 -15z" />
                <path d="M1190 2771 c0 -5 7 -12 16 -15 14 -5 15 -4 4 9 -14 17 -20 19 -20 6z" />
                <path d="M1339 2758 c15 -20 36 -23 46 -8 3 6 -1 7 -10 4 -8 -4 -23 0 -33 7
-15 13 -16 12 -3 -3z" />
                <path d="M1325 2706 c0 -18 3 -22 13 -14 9 8 9 14 1 24 -15 18 -14 18 -14 -10z" />
                <path d="M1382 2701 c-11 -7 -11 -9 0 -14 9 -3 15 1 15 9 0 8 -1 14 -1 14 -1
0 -7 -4 -14 -9z" />
                <path d="M1480 2706 c0 -2 8 -10 18 -17 15 -13 16 -12 3 4 -13 16 -21 21 -21
13z" />
                <path d="M1305 2660 c-4 -6 -11 -8 -16 -5 -5 3 -6 -1 -3 -9 8 -21 11 -20 24 4
11 20 6 29 -5 10z" />
                <path d="M1373 2643 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z" />
                <path d="M4800 3570 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z" />
                <path d="M4748 3543 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M2752 3500 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z" />
                <path d="M3011 3504 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M3002 3460 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z" />
                <path d="M2830 3453 c0 -12 3 -14 8 -6 4 6 30 13 57 16 l50 3 -57 2 c-49 2
-58 -1 -58 -15z" />
                <path d="M2618 3423 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M2613 3383 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z" />
                <path d="M2708 3373 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M2742 3355 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z" />
                <path d="M2783 3373 c4 -3 1 -13 -5 -22 -8 -10 -4 -9 10 3 26 23 27 26 5 26
-9 0 -13 -3 -10 -7z" />
                <path d="M2905 3370 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z" />
                <path d="M2982 3350 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z" />
                <path d="M2642 3320 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z" />
                <path d="M2841 3324 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M2740 3312 c0 -7 -17 -12 -42 -12 -50 0 -46 -9 7 -14 35 -2 58 15 41
31 -3 4 -6 1 -6 -5z" />
                <path d="M2768 3293 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M2835 3290 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z" />
                <path d="M2868 3283 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z" />
                <path d="M2666 3248 c3 -5 10 -6 15 -3 13 9 11 12 -6 12 -8 0 -12 -4 -9 -9z" />
                <path d="M2675 3220 c-10 -11 -16 -22 -14 -24 2 -2 12 7 22 20 22 29 17 32 -8
4z" />
                <path d="M2788 3233 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z" />
                <path d="M2831 3224 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M2732 3200 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z" />
                <path d="M2949 3192 c-3 -20 -2 -29 4 -23 5 5 7 19 5 32 -3 20 -5 19 -9 -9z" />
                <path d="M2758 3183 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z" />
                <path d="M2873 3173 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z" />
                <path d="M2822 3130 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z" />
                <path d="M2881 3134 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M2873 3086 c1 -11 9 -21 17 -23 10 -3 11 -2 4 4 -6 4 -14 15 -17 23
-5 11 -6 9 -4 -4z" />
                <path d="M2921 3054 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M3031 3364 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M3010 3265 c0 -8 2 -15 4 -15 2 0 6 7 10 15 3 8 1 15 -4 15 -6 0 -10
-7 -10 -15z" />
                <path d="M3048 3273 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z" />
                <path d="M2990 3164 c0 -8 5 -12 10 -9 6 4 8 11 5 16 -9 14 -15 11 -15 -7z" />
                <path d="M3033 3163 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z" />
                <path d="M2981 3104 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M3011 3024 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M2998 2983 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M2967 2736 c-4 -10 1 -12 14 -9 23 6 24 9 5 16 -8 3 -17 0 -19 -7z" />
                <path d="M2948 2690 c42 -26 56 -26 17 0 -16 11 -34 20 -40 20 -5 0 5 -9 23
-20z" />
                <path d="M2915 2600 c3 -4 14 -10 25 -13 11 -3 18 -2 15 3 -3 4 -14 10 -25 13
-11 3 -18 2 -15 -3z" />
                <path d="M3212 3510 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z" />
                <path d="M3243 3453 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z" />
                <path d="M3261 3388 c0 -14 -7 -29 -13 -31 -7 -3 3 -5 22 -5 19 0 27 2 18 5
-9 2 -19 16 -21 31 l-4 27 -2 -27z" />
                <path d="M3201 3364 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M3190 3278 c0 -13 7 -18 28 -17 21 1 22 2 7 6 -11 3 -23 10 -27 17
-5 7 -8 5 -8 -6z" />
                <path d="M3252 3245 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z" />
                <path d="M3181 3194 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M3183 3153 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z" />
                <path d="M3241 3114 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M3171 3094 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M3160 3049 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z" />
                <path d="M3161 3004 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M3232 3000 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z" />
                <path d="M3123 2963 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z" />
                <path d="M3225 2960 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z" />
                <path d="M3222 2885 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z" />
                <path d="M3098 2853 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M3142 2835 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z" />
                <path d="M3248 2843 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z" />
                <path d="M3212 2770 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z" />
                <path d="M3131 2744 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M3188 2733 c12 -2 30 -2 40 0 9 3 -1 5 -23 4 -22 0 -30 -2 -17 -4z" />
                <path d="M3122 2655 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z" />
                <path d="M3200 2661 c0 -14 -8 -21 -27 -24 -26 -4 -26 -4 5 -6 28 -1 32 2 32
24 0 14 -2 25 -5 25 -3 0 -5 -9 -5 -19z" />
                <path d="M3382 3443 c20 -3 28 -11 30 -31 3 -26 4 -26 9 6 5 31 5 32 -30 31
-29 -2 -31 -3 -9 -6z" />
                <path d="M3483 3360 c0 -25 2 -35 4 -22 2 12 2 32 0 45 -2 12 -4 2 -4 -23z" />
                <path d="M3408 3343 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z" />
                <path d="M3400 3275 c0 -14 4 -25 9 -25 4 0 6 11 3 25 -2 14 -6 25 -8 25 -2 0
-4 -11 -4 -25z" />
                <path d="M3470 3250 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z" />
                <path d="M3472 3190 c0 -19 2 -27 5 -17 2 9 2 25 0 35 -3 9 -5 1 -5 -18z" />
                <path d="M3373 3143 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z" />
                <path d="M3392 3100 c0 -19 2 -27 5 -17 2 9 2 25 0 35 -3 9 -5 1 -5 -18z" />
                <path d="M3463 3015 c0 -22 2 -30 4 -17 2 12 2 30 0 40 -3 9 -5 -1 -4 -23z" />
                <path d="M3393 3033 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z" />
                <path d="M3383 2940 c0 -25 2 -35 4 -22 2 12 2 32 0 45 -2 12 -4 2 -4 -23z" />
                <path d="M3418 2943 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M3452 2875 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z" />
                <path d="M3408 2833 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z" />
                <path d="M3373 2775 c0 -22 2 -30 4 -17 2 12 2 30 0 40 -3 9 -5 -1 -4 -23z" />
                <path d="M3353 2723 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z" />
                <path d="M4850 3315 c0 -8 2 -15 4 -15 2 0 6 7 10 15 3 8 1 15 -4 15 -6 0 -10
-7 -10 -15z" />
                <path d="M4915 3300 c3 -5 11 -10 16 -10 6 0 7 5 4 10 -3 6 -11 10 -16 10 -6
0 -7 -4 -4 -10z" />
                <path d="M4853 3245 c0 -27 2 -38 4 -22 2 15 2 37 0 50 -2 12 -4 0 -4 -28z" />
                <path d="M4976 3268 c3 -4 9 -8 15 -8 5 0 9 4 9 8 0 5 -7 9 -15 9 -8 0 -12 -4
-9 -9z" />
                <path d="M4911 3244 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M5121 3234 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M4768 3213 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M4972 3200 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z" />
                <path d="M4762 3175 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z" />
                <path d="M5050 3155 c0 -38 0 -38 -19 -19 -10 10 -17 22 -15 25 2 3 -3 6 -11
6 -21 0 -19 -4 20 -38 26 -23 33 -35 26 -47 -4 -10 -6 -23 -4 -30 3 -7 -1 -19
-8 -28 -10 -13 -14 -12 -31 6 -21 22 -36 25 -58 9 -12 -8 -10 -9 8 -4 16 5 30
1 43 -11 20 -18 20 -18 -3 -37 -13 -10 -18 -16 -11 -13 6 3 14 0 16 -6 4 -8 6
-7 6 4 1 9 13 25 27 35 24 18 25 24 25 97 0 43 -3 81 -6 84 -3 3 -5 -12 -5
-33z" />
                <path d="M5156 3182 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z" />
                <path d="M5210 3135 c0 -2 6 -8 13 -14 10 -8 14 -7 14 2 0 8 -6 14 -14 14 -7
0 -13 -1 -13 -2z" />
                <path d="M5130 3126 c0 -3 8 -12 17 -22 16 -15 15 -18 -19 -49 l-36 -33 29
-28 c23 -22 32 -25 42 -15 10 10 8 11 -7 5 -15 -6 -17 -4 -11 6 5 8 4 11 -2 7
-6 -4 -16 0 -23 9 -11 12 -8 20 19 48 29 30 31 36 19 55 -11 19 -28 28 -28 17z" />
                <path d="M4850 3108 c0 -12 7 -18 23 -17 15 0 17 2 7 6 -8 3 -18 11 -22 17 -5
7 -8 4 -8 -6z" />
                <path d="M4935 3109 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z" />
                <path d="M5115 3089 c-4 -6 -14 -8 -22 -5 -8 3 -11 1 -8 -5 4 -5 1 -18 -6 -27
-7 -9 1 -4 19 12 18 17 32 31 32 33 0 7 -9 2 -15 -8z" />
                <path d="M4852 3050 c0 -19 2 -27 5 -17 2 9 2 25 0 35 -3 9 -5 1 -5 -18z" />
                <path d="M4805 3050 c10 -11 20 -20 23 -20 3 0 -3 9 -13 20 -10 11 -20 20 -23
20 -3 0 3 -9 13 -20z" />
                <path d="M4840 2949 c0 -5 5 -7 10 -4 6 3 10 1 10 -4 0 -6 4 -11 10 -11 5 0 7
7 4 15 -7 17 -34 21 -34 4z" />
                <path d="M4826 2927 c3 -10 9 -15 12 -12 3 3 0 11 -7 18 -10 9 -11 8 -5 -6z" />
                <path d="M4956 2931 c-4 -5 3 -7 14 -4 23 6 26 13 6 13 -8 0 -17 -4 -20 -9z" />
                <path d="M4873 2888 c2 -12 9 -24 16 -26 10 -3 10 0 2 16 -8 15 -8 22 2 25 7
3 5 6 -5 6 -13 1 -17 -5 -15 -21z" />
                <path d="M4890 2816 c0 -2 7 -7 16 -10 8 -3 12 -2 9 4 -6 10 -25 14 -25 6z" />
                <path d="M4564 3329 c-3 -6 -15 -8 -27 -5 -18 4 -19 4 -5 -11 14 -14 18 -13
37 6 12 12 17 21 12 21 -6 0 -13 -5 -17 -11z" />
                <path d="M4511 3291 c-8 -5 -9 -11 -3 -15 5 -3 12 1 16 9 6 17 6 18 -13 6z" />
                <path d="M4584 3269 c0 -10 3 -16 7 -13 4 2 9 -4 12 -13 2 -10 4 -4 4 13 0 17
-5 31 -11 31 -7 0 -12 -8 -12 -18z" />
                <path d="M4465 3261 c-3 -5 -2 -12 3 -15 5 -3 9 1 9 9 0 17 -3 19 -12 6z" />
                <path d="M4527 3248 c7 -8 10 -17 7 -20 -2 -3 2 -8 11 -12 13 -4 14 -2 5 14
-5 10 -16 22 -23 26 -9 6 -9 5 0 -8z" />
                <path d="M4437 3242 c-3 -4 5 -19 18 -34 14 -16 27 -23 30 -18 4 6 10 8 15 5
4 -3 11 3 14 12 4 10 4 14 0 10 -4 -4 -13 -2 -21 5 -11 8 -12 7 -7 -6 3 -9 2
-16 -3 -16 -15 0 -44 36 -36 43 3 4 4 7 0 7 -3 0 -8 -3 -10 -8z" />
                <path d="M4336 3178 c3 -5 10 -6 15 -3 13 9 11 12 -6 12 -8 0 -12 -4 -9 -9z" />
                <path d="M4611 3154 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M4340 3106 c0 -2 8 -10 18 -17 15 -13 16 -12 3 4 -13 16 -21 21 -21
13z" />
                <path d="M4395 3090 c4 -6 13 -10 21 -10 8 0 14 -5 14 -11 0 -5 -4 -7 -10 -4
-12 7 -50 -12 -50 -25 0 -6 5 -10 11 -10 5 0 8 4 5 9 -8 13 18 21 51 16 15 -2
22 -2 15 1 -6 3 -10 9 -7 14 3 4 -9 13 -25 19 -18 6 -28 6 -25 1z" />
                <path d="M4560 3079 c0 -5 5 -7 10 -4 6 3 10 -1 10 -9 0 -9 5 -16 10 -16 6 0
10 -7 10 -15 0 -9 6 -12 15 -9 8 4 15 10 15 16 0 5 -4 7 -9 4 -5 -3 -14 1 -21
9 -7 8 -9 15 -4 15 11 0 -18 20 -28 20 -5 0 -8 -5 -8 -11z" />
                <path d="M4280 3072 c0 -5 7 -9 15 -9 8 0 12 4 9 9 -3 4 -9 8 -15 8 -5 0 -9
-4 -9 -8z" />
                <path d="M4426 3031 c-7 -10 37 -41 56 -41 7 1 -2 9 -21 19 -23 12 -30 20 -20
24 8 3 9 6 2 6 -6 1 -14 -3 -17 -8z" />
                <path d="M4562 3024 c-11 -12 -9 -16 17 -25 17 -6 31 -14 31 -18 0 -4 7 -8 15
-8 8 0 15 4 15 9 0 4 8 8 18 9 14 0 14 2 -3 8 -11 5 -23 4 -26 -1 -9 -14 -58
12 -52 28 7 18 1 17 -15 -2z" />
                <path d="M4402 3005 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z" />
                <path d="M4551 2983 c-1 -7 -7 -11 -13 -9 -7 1 -10 1 -5 -1 4 -3 7 -12 7 -21
1 -15 2 -15 11 1 6 10 8 23 5 30 -3 9 -5 9 -5 0z" />
                <path d="M4308 2973 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z" />
                <path d="M4473 2968 c3 -9 1 -18 -6 -21 -6 -2 -4 -6 5 -10 22 -8 29 15 10 33
-14 13 -15 12 -9 -2z" />
                <path d="M4371 2954 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M4418 2963 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M4565 2939 c-10 -30 -2 -32 12 -3 6 13 7 24 3 24 -5 0 -12 -9 -15
-21z" />
                <path d="M4510 2940 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z" />
                <path d="M4410 2910 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z" />
                <path d="M4361 2894 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M4470 2901 c0 -5 7 -12 16 -15 14 -5 15 -4 4 9 -14 17 -20 19 -20 6z" />
                <path d="M4515 2880 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z" />
                <path d="M4420 2871 c0 -5 -8 -11 -17 -13 -15 -3 -14 -5 5 -10 17 -5 22 -2 22
13 0 10 -2 19 -5 19 -3 0 -5 -4 -5 -9z" />
                <path d="M4540 2869 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z" />
                <path d="M4320 2830 c0 -22 2 -40 4 -40 2 0 6 18 8 40 2 22 0 40 -4 40 -5 0
-8 -18 -8 -40z" />
                <path d="M4517 2811 c3 -12 9 -21 13 -21 12 0 5 33 -8 38 -6 2 -8 -5 -5 -17z" />
                <path d="M4350 2766 c0 -2 16 -6 35 -8 19 -2 35 0 35 4 0 4 -16 8 -35 8 -19 0
-35 -2 -35 -4z" />
                <path d="M4481 2708 c1 -55 5 -50 11 15 2 20 0 37 -4 37 -4 0 -7 -24 -7 -52z" />
                <path d="M4420 2720 c0 -11 2 -20 4 -20 2 0 6 9 9 20 3 11 1 20 -4 20 -5 0 -9
-9 -9 -20z" />
                <path d="M4550 2714 c0 -14 4 -23 9 -20 5 3 7 15 4 26 -7 28 -13 25 -13 -6z" />
                <path d="M4358 2703 c12 -2 30 -2 40 0 9 3 -1 5 -23 4 -22 0 -30 -2 -17 -4z" />
                <path d="M4522 2690 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z" />
                <path d="M4360 2673 c14 -3 28 -10 32 -17 5 -7 8 -5 8 7 0 13 -8 17 -32 16
-28 -2 -29 -2 -8 -6z" />
                <path d="M1370 3282 c6 -13 14 -21 18 -18 3 4 -2 14 -12 24 -18 16 -18 16 -6
-6z" />
                <path d="M1266 3218 c3 -5 10 -6 15 -3 13 9 11 12 -6 12 -8 0 -12 -4 -9 -9z" />
                <path d="M1435 3220 c-4 -6 -11 -8 -16 -5 -5 4 -9 1 -9 -4 0 -16 16 -13 30 4
7 8 10 15 7 15 -3 0 -9 -5 -12 -10z" />
                <path d="M1360 3180 c5 -10 16 -22 23 -26 9 -6 9 -5 0 8 -7 8 -10 17 -7 20 2
3 -2 8 -11 12 -13 4 -14 2 -5 -14z" />
                <path d="M1316 3157 c-16 -12 -16 -14 -3 -14 9 0 18 6 21 14 3 7 4 13 3 13 -2
0 -11 -6 -21 -13z" />
                <path d="M1432 3149 c-9 -13 -19 -18 -30 -14 -9 3 -13 3 -9 -1 4 -4 -2 -18
-14 -30 -15 -16 -17 -24 -8 -29 7 -5 10 -4 6 2 -4 6 0 16 8 23 12 10 19 10 33
-1 15 -12 16 -12 5 2 -11 13 -10 19 5 32 15 13 21 14 31 4 11 -10 11 -8 2 11
-14 27 -13 27 -29 1z" />
                <path d="M1473 3115 c4 -5 -5 -21 -20 -37 -15 -15 -24 -28 -22 -28 3 0 18 13
33 29 21 22 25 31 14 37 -7 4 -10 3 -5 -1z" />
                <path d="M1474 3018 c22 -33 22 -33 22 -8 0 10 -2 17 -5 15 -2 -3 -11 1 -19 8
-11 9 -11 4 2 -15z" />
                <path d="M1405 3020 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z" />
                <path d="M1555 2989 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z" />
                <path d="M1443 2973 c4 -3 1 -13 -6 -21 -10 -13 -9 -14 1 -8 7 4 19 3 27 -4
12 -10 12 -7 2 14 -7 14 -16 26 -21 26 -5 0 -6 -3 -3 -7z" />
                <path d="M1524 2930 c0 -10 2 -17 5 -15 2 3 11 -1 19 -8 11 -9 11 -4 -2 16
-22 32 -22 32 -22 7z" />
                <path d="M1506 2881 c-3 -5 1 -11 9 -14 9 -4 12 -1 8 9 -6 16 -10 17 -17 5z" />
                <path d="M1560 2820 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z" />
                <path d="M1625 3290 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z" />
                <path d="M1728 3275 c-3 -14 -1 -25 3 -25 5 0 9 11 9 25 0 14 -2 25 -4 25 -2
0 -6 -11 -8 -25z" />
                <path d="M1815 3279 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z" />
                <path d="M1606 3253 c-6 -14 -5 -15 5 -6 7 7 10 15 7 18 -3 3 -9 -2 -12 -12z" />
                <path d="M1795 3242 c-13 -9 -13 -44 0 -49 6 -1 10 11 11 27 1 17 1 30 0 30
-1 0 -5 -4 -11 -8z" />
                <path d="M1873 3223 c11 -3 16 -11 13 -19 -3 -8 -1 -14 4 -14 6 0 10 9 10 20
0 14 -6 20 -22 19 -19 -1 -19 -2 -5 -6z" />
                <path d="M1565 3200 c-3 -5 -2 -10 4 -10 5 0 13 5 16 10 3 6 2 10 -4 10 -5 0
-13 -4 -16 -10z" />
                <path d="M1828 3193 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M1920 3175 c0 -14 2 -25 4 -25 2 0 6 11 8 25 3 14 1 25 -3 25 -5 0
-9 -11 -9 -25z" />
                <path d="M1766 3155 c4 -8 8 -15 10 -15 2 0 4 7 4 15 0 8 -4 15 -10 15 -5 0
-7 -7 -4 -15z" />
                <path d="M1803 3163 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z" />
                <path d="M1881 3154 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M1885 3123 c11 -3 23 -10 26 -15 3 -5 9 -3 12 6 5 13 0 16 -26 15
-21 -1 -25 -3 -12 -6z" />
                <path d="M1950 3115 c0 -8 2 -15 4 -15 2 0 6 7 10 15 3 8 1 15 -4 15 -6 0 -10
-7 -10 -15z" />
                <path d="M1788 3099 c-15 -16 -15 -19 -3 -19 8 0 15 -7 15 -17 0 -27 10 -9 14
25 4 36 -2 39 -26 11z" />
                <path d="M1716 3084 c-9 -24 -2 -26 12 -4 7 11 8 20 3 20 -5 0 -12 -7 -15 -16z" />
                <path d="M1840 3076 c0 -2 9 -6 20 -9 11 -3 20 -1 20 4 0 5 -9 9 -20 9 -11 0
-20 -2 -20 -4z" />
                <path d="M1682 3047 c7 -8 19 -14 26 -14 11 0 10 4 -4 14 -10 7 -22 13 -26 13
-5 0 -3 -6 4 -13z" />
                <path d="M1726 3023 c-6 -14 -5 -15 5 -6 7 7 10 15 7 18 -3 3 -9 -2 -12 -12z" />
                <path d="M1762 3024 c-7 -8 -8 -14 -3 -14 10 0 25 19 20 25 -2 1 -10 -3 -17
-11z" />
                <path d="M1861 3024 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M1909 3031 c-14 -5 -15 -8 -4 -18 10 -10 15 -9 19 4 8 20 5 22 -15
14z" />
                <path d="M1655 3000 c10 -11 23 -20 28 -20 6 0 1 9 -11 20 -12 11 -24 20 -28
20 -4 0 1 -9 11 -20z" />
                <path d="M1770 2990 c-6 -11 -8 -20 -6 -20 3 0 10 9 16 20 6 11 8 20 6 20 -3
0 -10 -9 -16 -20z" />
                <path d="M1808 2978 c4 -16 7 -18 10 -8 3 8 10 18 16 22 6 5 2 8 -11 8 -17 0
-20 -4 -15 -22z" />
                <path d="M1729 2956 c6 -7 8 -16 4 -20 -4 -4 0 -4 10 0 23 8 21 20 -4 27 -15
4 -18 2 -10 -7z" />
                <path d="M1848 2943 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M1770 2935 c0 -4 11 -16 24 -26 15 -12 23 -27 21 -39 -2 -11 0 -20 6
-20 14 0 11 48 -3 53 -7 2 3 9 22 15 21 6 27 11 15 11 -11 0 -27 -4 -35 -9
-10 -6 -20 -4 -32 7 -10 9 -18 13 -18 8z" />
                <path d="M1712 2904 c10 -10 20 -16 22 -13 3 3 -5 11 -17 18 -21 13 -21 12 -5
-5z" />
                <path d="M1848 2883 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M1838 2823 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M1832 2760 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z" />
                <path d="M2072 3230 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z" />
                <path d="M2125 3230 c-19 -8 -19 -9 3 -9 12 -1 22 4 22 9 0 6 -1 10 -2 9 -2 0
-12 -4 -23 -9z" />
                <path d="M2161 3224 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M2132 3190 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z" />
                <path d="M2060 3160 c0 -6 7 -10 15 -10 8 0 15 2 15 4 0 2 -7 6 -15 10 -8 3
-15 1 -15 -4z" />
                <path d="M2401 3148 c0 -10 -7 -18 -13 -19 -7 0 -3 -4 10 -10 13 -5 20 -13 17
-19 -3 -5 -2 -10 4 -10 17 0 22 18 7 23 -8 3 -16 16 -19 29 -3 15 -5 17 -6 6z" />
                <path d="M2100 3146 c0 -2 7 -6 15 -10 8 -3 15 -1 15 4 0 6 -7 10 -15 10 -8 0
-15 -2 -15 -4z" />
                <path d="M2145 3140 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z" />
                <path d="M2462 3135 c16 -17 16 -20 2 -36 -14 -16 -10 -23 60 -90 l76 -73 -21
-22 c-12 -13 -31 -24 -43 -26 -18 -3 -17 -4 7 -9 15 -4 25 -4 22 -1 -3 3 5 16
17 29 16 17 24 20 35 12 7 -6 11 -14 10 -18 -2 -3 7 -16 20 -28 13 -12 23 -18
23 -14 0 5 -31 43 -70 84 -60 64 -68 76 -55 87 12 10 19 10 33 -1 15 -13 16
-12 4 3 -8 9 -11 21 -9 25 3 5 -3 9 -13 10 -12 1 -17 -3 -14 -11 3 -7 -1 -18
-9 -24 -11 -9 -19 -6 -38 14 -23 25 -24 26 -5 40 11 7 18 15 15 16 -2 2 -17
14 -34 28 -16 13 -22 16 -13 5z m23 -44 c-3 -6 -11 -11 -17 -11 -6 0 -6 6 2
15 14 17 26 13 15 -4z" />
                <path d="M2250 3128 c0 -7 4 -19 9 -26 7 -11 9 -11 13 0 3 7 -1 19 -8 26 -11
10 -14 10 -14 0z" />
                <path d="M2355 3120 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z" />
                <path d="M2570 3101 c-7 -15 -7 -19 5 -17 8 1 18 6 22 11 5 4 2 5 -6 0 -11 -6
-13 -4 -8 8 9 23 0 21 -13 -2z" />
                <path d="M2228 3073 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M2265 3070 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z" />
                <path d="M2645 3070 c-7 -12 19 -42 29 -33 3 3 8 -2 12 -11 3 -9 10 -13 15
-10 11 6 12 25 2 22 -14 -4 -54 23 -48 33 4 5 4 9 1 9 -3 0 -8 -5 -11 -10z" />
                <path d="M2008 3053 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z" />
                <path d="M2096 3042 c7 -4 13 -16 15 -27 3 -11 12 -21 22 -23 12 -3 15 1 11
13 -6 13 -8 14 -15 3 -6 -9 -9 -7 -9 9 0 12 8 23 18 26 9 3 1 5 -18 6 -19 0
-30 -3 -24 -7z" />
                <path d="M2281 3043 c-1 -7 -8 -13 -16 -13 -8 0 -15 -9 -15 -19 0 -14 -8 -21
-27 -24 -26 -4 -26 -4 5 -6 26 -1 32 3 32 19 0 11 7 20 15 20 8 0 15 -5 15
-12 0 -6 2 -9 5 -6 3 3 1 16 -4 29 -5 13 -10 18 -10 12z" />
                <path d="M2178 3033 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M1983 3013 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z" />
                <path d="M2434 3004 c-18 -14 -18 -15 4 -4 12 6 22 13 22 15 0 8 -5 6 -26 -11z" />
                <path d="M2731 3004 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M2058 3003 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M2594 2998 c-4 -7 -3 -10 1 -5 5 4 21 -4 36 -19 19 -19 29 -22 34
-13 5 7 4 10 -3 5 -6 -3 -14 -1 -19 6 -4 7 -15 19 -25 26 -13 11 -18 11 -24 0z" />
                <path d="M2057 2983 c-4 -3 -7 -11 -7 -17 0 -6 5 -5 12 2 6 6 9 14 7 17 -3 3
-9 2 -12 -2z" />
                <path d="M2296 2982 c-4 -7 -2 -12 3 -12 20 0 11 -36 -13 -59 -17 -16 -30 -20
-49 -16 -14 4 -28 2 -31 -4 -4 -7 -1 -8 8 -5 23 9 20 -22 -6 -59 -13 -19 -16
-27 -6 -19 13 10 17 10 22 0 4 -9 5 -9 4 2 -2 28 14 70 28 70 21 0 68 52 69
77 0 12 -3 20 -6 17 -4 -2 -9 1 -11 8 -3 9 -6 9 -12 0z" />
                <path d="M2471 2963 c13 -17 31 -34 39 -38 12 -5 12 -4 3 6 -9 9 -9 18 -2 33
9 19 9 19 -4 4 -13 -16 -15 -16 -37 5 l-23 22 24 -32z" />
                <path d="M2091 2976 c3 -3 20 -8 39 -11 25 -4 31 -3 20 5 -14 9 -68 15 -59 6z" />
                <path d="M2821 2964 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M2380 2960 c8 -5 20 -10 25 -10 6 0 3 5 -5 10 -8 5 -19 10 -25 10 -5
0 -3 -5 5 -10z" />
                <path d="M2144 2928 l-29 -33 33 29 c17 17 32 31 32 33 0 8 -8 1 -36 -29z" />
                <path d="M2242 2935 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z" />
                <path d="M2068 2943 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M2540 2925 c-7 -9 -11 -17 -9 -20 3 -2 10 5 17 15 14 24 10 26 -8 5z" />
                <path d="M2710 2929 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z" />
                <path d="M2067 2893 c-32 -33 -40 -36 -56 -26 -16 10 -20 9 -25 -3 -9 -23 -7
-31 3 -16 11 18 55 -4 89 -43 23 -26 23 -27 5 -48 l-18 -22 22 18 c24 21 48
14 38 -11 -5 -13 -2 -12 15 3 24 21 25 26 6 19 -8 -3 -17 0 -22 7 -4 8 7 25
30 46 21 19 36 35 34 36 -2 1 -13 8 -25 15 -27 14 -33 15 -33 3 0 -5 10 -11
23 -15 22 -5 22 -6 -10 -37 l-31 -32 -28 26 c-24 23 -26 28 -14 44 12 15 12
16 0 6 -34 -31 -30 -9 5 27 21 22 37 40 34 40 -2 0 -21 -17 -42 -37z" />
                <path d="M2475 2909 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z" />
                <path d="M2796 2907 c3 -10 9 -15 12 -12 3 3 0 11 -7 18 -10 9 -11 8 -5 -6z" />
                <path d="M2350 2900 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z" />
                <path d="M2318 2895 c-4 -4 -4 -14 -1 -22 3 -8 0 -18 -6 -23 -10 -5 -9 -9 3
-13 9 -4 16 -2 16 3 0 5 8 11 18 13 15 4 15 5 0 6 -9 0 -18 10 -20 22 -2 11
-6 18 -10 14z" />
                <path d="M2445 2849 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z" />
                <path d="M2690 2851 c0 -5 7 -12 16 -15 14 -5 15 -4 4 9 -14 17 -20 19 -20 6z" />
                <path d="M2560 2823 c0 -14 2 -15 9 -4 6 9 22 12 50 9 22 -2 41 0 41 4 0 5
-22 8 -50 8 -41 0 -50 -3 -50 -17z" />
                <path d="M2772 2816 c7 -7 19 -11 26 -8 11 4 11 6 0 13 -7 5 -19 9 -26 9 -10
0 -10 -3 0 -14z" />
                <path d="M2420 2798 c-10 -22 -10 -22 4 -4 8 10 20 15 27 10 8 -4 10 -3 5 4
-11 18 -24 14 -36 -10z" />
                <path d="M2838 2803 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M2460 2780 c-6 -11 -8 -20 -6 -20 3 0 10 9 16 20 6 11 8 20 6 20 -3
0 -10 -9 -16 -20z" />
                <path d="M2501 2791 c-9 -6 -10 -11 -2 -15 6 -4 8 -12 5 -18 -4 -6 -2 -8 4 -4
6 3 10 15 9 26 -1 11 -1 20 -2 20 0 0 -6 -4 -14 -9z" />
                <path d="M2623 2755 c0 -27 2 -38 4 -22 2 15 2 37 0 50 -2 12 -4 0 -4 -28z" />
                <path d="M2713 2783 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z" />
                <path d="M1975 2751 c17 -19 23 -32 14 -28 -9 3 -16 0 -16 -9 0 -9 8 -12 25
-9 17 3 22 0 18 -10 -3 -9 0 -12 8 -9 8 3 20 -4 28 -15 8 -12 17 -18 21 -15 3
3 -13 24 -36 46 -23 23 -40 46 -39 52 2 6 0 8 -4 3 -4 -4 -17 1 -28 10 -12 10
-7 2 9 -16z" />
                <path d="M2262 2760 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z" />
                <path d="M2211 2754 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M2396 2753 c-6 -14 -5 -15 5 -6 7 7 10 15 7 18 -3 3 -9 -2 -12 -12z" />
                <path d="M2543 2756 c0 -8 6 -12 14 -9 7 3 10 9 7 14 -8 14 -21 11 -21 -5z" />
                <path d="M2761 2754 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M2039 2743 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8 -17
-17z" />
                <path d="M2648 2743 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z" />
                <path d="M2705 2740 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z" />
                <path d="M2161 2724 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M2461 2724 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M2492 2733 c-6 -2 -10 -9 -6 -14 8 -14 21 -11 21 6 0 8 -1 15 -1 14
-1 0 -7 -3 -14 -6z" />
                <path d="M2527 2723 c-14 -14 -6 -23 21 -22 23 2 24 2 4 6 -12 2 -20 9 -17 14
7 10 1 12 -8 2z" />
                <path d="M2096 2701 c-16 -17 -16 -19 2 -23 12 -4 23 2 32 16 10 17 10 19 -1
9 -18 -18 -34 -16 -19 2 18 22 6 18 -14 -4z" />
                <path d="M2180 2716 c0 -2 7 -6 15 -10 8 -3 15 -1 15 4 0 6 -7 10 -15 10 -8 0
-15 -2 -15 -4z" />
                <path d="M2251 2694 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M2365 2700 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z" />
                <path d="M2608 2693 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M2668 2693 c17 -2 47 -2 65 0 17 2 3 4 -33 4 -36 0 -50 -2 -32 -4z" />
                <path d="M1928 2673 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M2146 2663 c-6 -14 -5 -15 5 -6 7 7 10 15 7 18 -3 3 -9 -2 -12 -12z" />
                <path d="M2432 2663 c1 -5 -6 -22 -15 -40 -21 -40 -21 -38 5 -40 18 -2 19 0 8
7 -13 8 -13 13 3 39 20 33 21 41 7 41 -5 0 -9 -3 -8 -7z" />
                <path d="M2191 2644 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M2380 2651 c0 -5 -7 -17 -16 -25 -17 -17 -10 -19 21 -6 11 5 15 9 8
9 -7 1 -10 8 -7 16 4 8 3 15 0 15 -3 0 -6 -4 -6 -9z" />
                <path d="M2468 2637 c3 -12 7 -16 10 -9 2 6 15 12 30 12 33 0 26 7 -14 13 -28
4 -31 3 -26 -16z" />
                <path d="M2711 2634 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M2568 2633 c12 -2 30 -2 40 0 9 3 -1 5 -23 4 -22 0 -30 -2 -17 -4z" />
                <path d="M2128 2608 c4 -16 7 -18 10 -8 3 8 10 18 16 22 6 5 2 8 -11 8 -17 0
-20 -4 -15 -22z" />
                <path d="M2508 2585 c-2 -19 0 -35 4 -35 4 0 8 16 8 35 0 19 -2 35 -4 35 -2 0
-6 -16 -8 -35z" />
                <path d="M2306 2594 c-4 -9 -4 -19 -1 -22 3 -3 5 0 5 7 0 7 4 9 10 6 6 -3 7 1
4 9 -8 20 -10 20 -18 0z" />
                <path d="M2459 2571 c8 -5 11 -16 8 -25 -3 -8 -2 -18 2 -21 5 -2 11 6 13 20 3
15 0 26 -9 29 -22 9 -30 7 -14 -3z" />
                <path d="M2685 2570 l-30 -8 33 -1 c17 0 32 4 32 9 0 6 -1 9 -2 9 -2 -1 -16
-5 -33 -9z" />
                <path d="M2380 2560 c20 -13 33 -13 25 0 -3 6 -14 10 -23 10 -15 0 -15 -2 -2
-10z" />
                <path d="M2680 2530 c0 -5 7 -10 16 -10 8 0 12 5 9 10 -3 6 -10 10 -16 10 -5
0 -9 -4 -9 -10z" />
                <path d="M4178 3093 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z" />
                <path d="M4033 2993 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z" />
                <path d="M4168 2983 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z" />
                <path d="M4080 2926 c0 -11 -15 -16 -52 -19 l-53 -3 52 -2 c45 -2 52 -5 56
-24 2 -13 5 -4 6 20 0 23 -1 42 -4 42 -3 0 -5 -7 -5 -14z" />
                <path d="M3898 2913 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M3888 2872 c-3 -9 -1 -26 3 -37 6 -15 8 -11 8 18 1 40 -4 48 -11 19z" />
                <path d="M3980 2838 l-5 -48 40 2 c36 1 37 2 8 5 -30 4 -32 7 -35 46 l-3 42
-5 -47z" />
                <path d="M3833 2853 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z" />
                <path d="M4005 2845 c23 -8 85 -10 85 -3 0 4 -21 8 -47 7 -27 0 -43 -2 -38 -4z" />
                <path d="M3702 2800 c0 -19 2 -27 5 -17 2 9 2 25 0 35 -3 9 -5 1 -5 -18z" />
                <path d="M3792 2795 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z" />
                <path d="M3838 2803 c12 -2 32 -2 45 0 12 2 2 4 -23 4 -25 0 -35 -2 -22 -4z" />
                <path d="M4138 2783 c12 -2 30 -2 40 0 9 3 -1 5 -23 4 -22 0 -30 -2 -17 -4z" />
                <path d="M3612 2730 c0 -19 2 -27 5 -17 2 9 2 25 0 35 -3 9 -5 1 -5 -18z" />
                <path d="M3693 2743 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z" />
                <path d="M3852 2733 c20 -3 28 -11 31 -31 4 -24 4 -24 6 6 1 30 -1 32 -31 31
-30 -2 -30 -2 -6 -6z" />
                <path d="M5450 3059 c0 -4 -3 -15 -6 -24 -6 -15 -4 -15 13 -5 22 14 26 37 6
37 -7 0 -13 -4 -13 -8z" />
                <path d="M5329 3043 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8 -17
-17z" />
                <path d="M5370 3018 c0 -9 5 -20 10 -23 13 -8 13 5 0 25 -8 13 -10 13 -10 -2z" />
                <path d="M5240 2965 c-19 -20 -39 -34 -45 -31 -6 2 -11 -5 -11 -15 0 -24 1
-24 24 1 l19 21 31 -35 c25 -29 31 -32 37 -18 3 9 3 13 -1 9 -4 -4 -20 5 -36
20 l-28 27 27 28 c15 15 25 28 22 28 -3 0 -20 -16 -39 -35z" />
                <path d="M5326 2893 c-6 -14 -5 -15 5 -6 7 7 10 15 7 18 -3 3 -9 -2 -12 -12z" />
                <path d="M5220 2891 c0 -5 6 -11 13 -14 9 -3 9 -8 1 -17 -8 -8 -14 -9 -18 -1
-4 6 -12 11 -17 11 -5 0 -2 -11 8 -24 16 -22 20 -23 35 -9 9 8 22 12 27 8 6
-3 11 -1 11 4 0 6 -7 11 -17 11 -9 0 -14 3 -10 6 3 4 0 13 -8 20 -16 16 -25
18 -25 5z" />
                <path d="M5090 2813 c-41 -43 -66 -69 -54 -60 19 15 23 16 33 3 7 -8 10 -20 6
-26 -3 -5 -2 -10 4 -10 18 0 17 25 -2 40 -19 16 -19 17 9 41 35 31 90 89 83
89 -2 0 -38 -35 -79 -77z" />
                <path d="M5302 2855 c-11 -12 -10 -15 3 -15 8 0 15 7 15 15 0 18 -2 18 -18 0z" />
                <path d="M5174 2832 c5 -8 11 -26 15 -40 7 -26 8 -26 13 -5 4 15 -1 28 -15 40
-11 10 -17 12 -13 5z" />
                <path d="M5240 2781 c0 -6 4 -13 10 -16 6 -3 7 1 4 9 -7 18 -14 21 -14 7z" />
                <path d="M5365 2782 c-6 -4 -11 -14 -13 -22 -3 -12 0 -12 14 2 18 18 17 33 -1
20z" />
                <path d="M5298 2757 c12 -7 19 -16 16 -20 -4 -4 -2 -7 4 -7 23 0 20 17 -4 29
-33 15 -45 14 -16 -2z" />
                <path d="M5260 2720 c-24 -15 -7 -18 20 -3 14 7 18 13 10 13 -8 0 -22 -4 -30
-10z" />
                <path d="M5107 2709 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 -14 6 -15 5 -6 -5z" />
                <path d="M5213 2696 c-6 -7 -8 -18 -4 -24 4 -6 11 -1 18 14 12 26 5 31 -14 10z" />
                <path d="M5017 2689 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 -14 6 -15 5 -6 -5z" />
                <path d="M5027 2630 c3 -13 0 -20 -8 -21 -20 -1 22 -17 46 -18 18 -1 18 0 -3
15 -12 8 -22 22 -22 30 0 8 -4 14 -9 14 -5 0 -7 -9 -4 -20z" />
                <path d="M5208 2633 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M4928 2623 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M5150 2586 c0 -8 4 -17 9 -20 5 -4 7 3 4 14 -6 23 -13 26 -13 6z" />
                <path d="M4890 2536 c0 -2 8 -10 18 -17 15 -13 16 -12 3 4 -13 16 -21 21 -21
13z" />
                <path d="M5194 2511 c20 -22 26 -25 26 -13 0 4 -10 13 -22 21 -23 14 -23 14
-4 -8z" />
                <path d="M5266 2481 c-3 -4 1 -17 10 -27 14 -18 15 -18 5 2 -6 12 -7 24 -4 28
3 3 4 6 0 6 -3 0 -8 -4 -11 -9z" />
                <path d="M1722 2747 c7 -8 19 -14 26 -14 11 0 10 4 -4 14 -10 7 -22 13 -26 13
-5 0 -3 -6 4 -13z" />
                <path d="M1690 2725 c7 -9 15 -13 17 -11 7 7 -7 26 -19 26 -6 0 -6 -6 2 -15z" />
                <path d="M1655 2721 c-3 -5 -2 -12 3 -15 5 -3 9 1 9 9 0 17 -3 19 -12 6z" />
                <path d="M1811 2684 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M1821 2644 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M1697 2617 c-3 -9 1 -18 9 -21 16 -6 18 2 5 22 -7 11 -9 11 -14 -1z" />
                <path d="M1790 2627 c0 -9 31 -37 41 -37 5 0 9 5 9 12 0 6 -3 8 -7 5 -3 -4
-15 0 -25 10 -10 9 -18 13 -18 10z" />
                <path d="M1750 2615 c0 -6 5 -16 11 -22 13 -13 2 -36 -15 -30 -6 3 -12 -4 -12
-14 0 -17 2 -17 26 4 14 12 26 22 27 22 1 0 -7 11 -17 25 -11 14 -20 20 -20
15z" />
                <path d="M1870 2593 c0 -21 3 -24 9 -14 5 8 7 20 4 28 -8 21 -13 15 -13 -14z" />
                <path d="M1648 2593 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M1680 2566 c0 -2 8 -10 18 -17 15 -13 16 -12 3 4 -13 16 -21 21 -21
13z" />
                <path d="M1779 2498 c-16 -24 -17 -28 -3 -13 10 11 25 26 33 33 9 7 10 12 4
12 -7 0 -22 -15 -34 -32z" />
                <path d="M2086 2507 c4 -6 16 -18 26 -25 23 -17 23 -38 1 -51 -10 -6 -13 -10
-8 -10 6 0 19 6 29 14 11 8 16 15 11 15 -4 0 0 10 11 22 14 17 15 20 2 9 -19
-14 -42 -6 -32 11 4 7 2 8 -4 4 -7 -4 -12 -3 -12 2 0 6 -7 13 -16 16 -10 4
-13 2 -8 -7z" />
                <path d="M1720 2475 c18 -19 35 -33 37 -31 5 4 -56 66 -65 66 -3 0 9 -16 28
-35z" />
                <path d="M1877 2491 c-4 -17 -3 -21 5 -13 5 5 8 16 6 23 -3 8 -7 3 -11 -10z" />
                <path d="M1922 2465 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z" />
                <path d="M2307 2463 c57 -3 73 -7 76 -21 3 -12 5 -11 6 6 1 21 -2 22 -76 20
l-78 -2 72 -3z" />
                <path d="M2485 2419 c-62 -30 -56 -30 29 1 26 10 44 20 40 23 -5 3 -36 -8 -69
-24z" />
                <path d="M1777 2428 c2 -5 19 -7 38 -5 18 1 31 4 28 7 -8 8 -71 6 -66 -2z" />
                <path d="M1856 2414 c-3 -7 0 -16 6 -20 6 -4 8 -3 4 4 -4 6 3 12 16 14 l23 3
-22 7 c-14 4 -24 1 -27 -8z" />
                <path d="M1940 2422 c0 -6 -6 -10 -12 -8 -7 1 -10 1 -5 -1 4 -3 4 -10 1 -16
-4 -7 1 -4 11 5 11 10 16 21 12 24 -4 4 -7 2 -7 -4z" />
                <path d="M2581 2414 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M2611 2414 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M2206 2405 c4 -8 11 -15 16 -15 6 0 5 6 -2 15 -7 8 -14 15 -16 15 -2
0 -1 -7 2 -15z" />
                <path d="M1957 2390 c-3 -11 -3 -20 -1 -20 2 0 8 9 14 20 6 11 7 20 2 20 -6 0
-12 -9 -15 -20z" />
                <path d="M2105 2400 c-4 -6 -11 -8 -16 -5 -5 3 -6 -1 -2 -11 6 -15 7 -15 15 0
8 14 12 15 26 4 15 -12 16 -11 3 5 -16 20 -18 20 -26 7z" />
                <path d="M2390 2382 c-8 -4 -16 -14 -18 -22 -3 -11 3 -9 20 5 13 11 25 21 27
22 9 6 -15 1 -29 -5z" />
                <path d="M1710 2359 c-22 -18 -22 -19 -3 -10 12 6 25 16 28 21 9 15 3 12 -25
-11z" />
                <path d="M1852 2355 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z" />
                <path d="M2140 2359 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z" />
                <path d="M2587 2363 c19 -3 34 -11 36 -21 3 -12 5 -10 6 6 1 19 -3 22 -36 20
-37 -1 -37 -1 -6 -5z" />
                <path d="M2106 2347 c3 -10 9 -15 12 -12 3 3 0 11 -7 18 -10 9 -11 8 -5 -6z" />
                <path d="M2452 2330 c0 -19 2 -27 5 -17 2 9 2 25 0 35 -3 9 -5 1 -5 -18z" />
                <path d="M2493 2353 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z" />
                <path d="M1770 2341 c0 -6 4 -13 10 -16 6 -3 7 1 4 9 -7 18 -14 21 -14 7z" />
                <path d="M1640 2329 l-35 -6 35 -3 35 -3 -40 -6 -40 -7 31 -5 c34 -6 67 11 56
27 -4 5 -23 7 -42 3z" />
                <path d="M2225 2320 c-3 -6 1 -7 9 -4 18 7 21 14 7 14 -6 0 -13 -4 -16 -10z" />
                <path d="M1720 2300 c0 -11 4 -20 9 -20 5 0 7 9 4 20 -3 11 -7 20 -9 20 -2 0
-4 -9 -4 -20z" />
                <path d="M1751 2304 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M2368 2313 c12 -2 30 -2 40 0 9 3 -1 5 -23 4 -22 0 -30 -2 -17 -4z" />
                <path d="M1810 2294 c0 -8 5 -12 10 -9 6 4 8 11 5 16 -9 14 -15 11 -15 -7z" />
                <path d="M2520 2300 l-35 -7 38 -2 c20 0 37 4 37 9 0 6 -1 9 -2 9 -2 -1 -19
-5 -38 -9z" />
                <path d="M2638 2298 c5 -5 16 -8 23 -6 8 3 3 7 -10 11 -17 4 -21 3 -13 -5z" />
                <path d="M1700 2280 c6 -11 13 -20 16 -20 2 0 0 9 -6 20 -6 11 -13 20 -16 20
-2 0 0 -9 6 -20z" />
                <path d="M1780 2300 c-7 -18 -5 -49 3 -41 5 5 7 17 4 27 -3 11 -6 17 -7 14z" />
                <path d="M2324 2289 c-13 -5 -14 -8 -4 -8 8 -1 -6 -22 -35 -51 l-50 -51 -6 28
c-6 27 -7 27 -8 -6 -1 -25 -11 -43 -40 -71 -30 -29 -36 -40 -25 -44 8 -3 13
-2 10 3 -3 4 8 20 23 35 21 20 30 24 34 14 3 -8 6 -5 6 7 1 31 110 133 146
137 l30 3 -31 6 c-17 3 -40 2 -50 -2z" />
                <path d="M2591 2284 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M1855 2280 c-3 -6 -11 -8 -16 -5 -5 4 -9 2 -9 -4 0 -16 18 -22 26
-10 5 9 11 7 20 -6 8 -10 16 -17 18 -14 2 2 -4 14 -14 27 -11 13 -21 18 -25
12z" />
                <path d="M2098 2283 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z" />
                <path d="M2441 2283 c-8 -3 1 -11 25 -19 21 -7 40 -11 42 -9 2 2 -6 6 -17 10
-12 3 -21 11 -21 16 0 10 -7 10 -29 2z" />
                <path d="M1650 2269 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z" />
                <path d="M2030 2276 c0 -2 9 -6 20 -9 11 -3 20 -1 20 4 0 5 -9 9 -20 9 -11 0
-20 -2 -20 -4z" />
                <path d="M1795 2250 c-3 -6 1 -7 9 -4 18 7 21 14 7 14 -6 0 -13 -4 -16 -10z" />
                <path d="M2530 2250 c-9 -6 -10 -10 -3 -10 6 0 13 -8 15 -17 3 -16 4 -16 10
-2 9 23 -4 40 -22 29z" />
                <path d="M1645 2240 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z" />
                <path d="M1698 2245 c-8 -8 3 -55 13 -55 5 0 4 11 -1 25 -7 20 -6 25 5 25 8 0
15 -6 15 -14 0 -19 26 -40 35 -26 3 5 0 10 -8 10 -8 0 -17 9 -20 20 -5 19 -27
27 -39 15z" />
                <path d="M1810 2228 c-19 -6 -30 -12 -24 -15 7 -2 27 3 45 11 39 17 29 19 -21
4z" />
                <path d="M2048 2222 c-4 -15 -1 -18 14 -14 11 2 16 8 11 11 -4 3 -11 10 -14
14 -4 4 -9 -1 -11 -11z" />
                <path d="M2342 2210 c0 -19 2 -27 5 -17 2 9 2 25 0 35 -3 9 -5 1 -5 -18z" />
                <path d="M2492 2215 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z" />
                <path d="M1891 2198 c0 -20 -7 -39 -13 -41 -10 -4 -10 -6 0 -6 17 -1 24 21 19
56 -3 24 -4 23 -6 -9z" />
                <path d="M2580 2220 c8 -5 20 -10 25 -10 6 0 3 5 -5 10 -8 5 -19 10 -25 10 -5
0 -3 -5 5 -10z" />
                <path d="M1640 2200 c0 -11 -4 -20 -10 -20 -5 0 -10 -7 -10 -15 0 -8 5 -15 11
-15 5 0 7 5 4 10 -3 6 -1 10 4 10 6 0 11 9 11 19 0 11 6 22 13 24 7 3 5 6 -5
6 -12 1 -18 -6 -18 -19z" />
                <path d="M2422 2183 c-2 -44 8 -53 38 -32 12 8 10 9 -7 4 -19 -5 -22 -2 -26
32 l-4 38 -1 -42z" />
                <path d="M2535 2190 c-3 -5 -2 -10 4 -10 5 0 13 5 16 10 3 6 2 10 -4 10 -5 0
-13 -4 -16 -10z" />
                <path d="M1668 2183 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M1958 2158 c2 -11 8 -16 11 -11 3 4 10 11 14 14 4 4 -1 9 -11 11 -15
4 -18 1 -14 -14z" />
                <path d="M2280 2151 c0 -16 -6 -32 -12 -34 -8 -3 -6 -6 5 -6 13 -1 17 7 17 34
0 19 -2 35 -5 35 -3 0 -5 -13 -5 -29z" />
                <path d="M2485 2170 c-3 -6 1 -7 9 -4 18 7 21 14 7 14 -6 0 -13 -4 -16 -10z" />
                <path d="M1700 2156 c0 -13 -6 -15 -27 -11 -26 5 -25 4 5 -10 20 -9 30 -20 26
-27 -4 -7 -3 -8 5 -4 6 4 10 18 8 31 -4 29 -17 45 -17 21z" />
                <path d="M1782 2150 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z" />
                <path d="M2651 2136 l-24 -31 28 27 c16 15 27 29 24 31 -2 3 -15 -10 -28 -27z" />
                <path d="M1360 2148 c0 -4 9 -8 20 -8 11 0 20 4 20 8 0 4 -9 8 -20 8 -11 0
-20 -4 -20 -8z" />
                <path d="M2000 2150 c0 -4 9 -10 20 -13 11 -3 20 -2 20 3 0 4 -9 10 -20 13
-11 3 -20 2 -20 -3z" />
                <path d="M1418 2143 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M1978 2105 c-2 -19 0 -35 4 -35 4 0 8 16 8 35 0 19 -2 35 -4 35 -2 0
-6 -16 -8 -35z" />
                <path d="M2537 2120 c-3 -11 -1 -20 4 -20 5 0 9 9 9 20 0 11 -2 20 -4 20 -2 0
-6 -9 -9 -20z" />
                <path d="M1828 2123 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M1911 2105 c0 -16 3 -25 7 -19 4 6 14 14 22 17 12 4 12 6 -2 6 -9 1
-19 7 -21 14 -3 6 -6 -1 -6 -18z" />
                <path d="M2441 2114 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M1737 2109 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 -14 6 -15 5 -6 -5z" />
                <path d="M2100 2110 c8 -5 20 -10 25 -10 6 0 3 5 -5 10 -8 5 -19 10 -25 10 -5
0 -3 -5 5 -10z" />
                <path d="M1493 2103 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z" />
                <path d="M1777 2103 c-12 -12 -7 -19 15 -20 13 -1 18 1 13 5 -6 4 -13 11 -16
15 -3 4 -9 4 -12 0z" />
                <path d="M2483 2103 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z" />
                <path d="M2585 2103 c11 -3 23 -10 27 -17 5 -7 8 -5 8 7 0 12 -7 17 -27 16
-22 -1 -23 -2 -8 -6z" />
                <path d="M2084 2086 c-6 -6 -8 -20 -4 -31 6 -16 8 -15 13 10 6 35 6 37 -9 21z" />
                <path d="M2351 2084 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M2430 2080 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z" />
                <path d="M2141 2064 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M2256 2052 c-3 -5 12 -16 32 -26 27 -12 32 -13 17 -2 -11 9 -25 20
-32 26 -7 5 -14 6 -17 2z" />
                <path d="M2533 2053 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z" />
                <path d="M2603 2053 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z" />
                <path d="M2622 2006 c-2 -32 -5 -37 -19 -32 -17 6 -17 5 0 -8 9 -7 17 -25 17
-39 0 -20 -6 -27 -27 -30 -22 -3 -20 -4 10 -6 23 0 36 3 32 9 -3 6 0 10 7 10
10 0 10 2 1 8 -6 4 -14 34 -16 67 -2 38 -4 46 -5 21z" />
                <path d="M2131 2004 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M2260 1946 c0 -34 -5 -56 -12 -59 -8 -3 -6 -6 5 -6 14 -1 17 8 17 59
0 33 -2 60 -5 60 -3 0 -5 -24 -5 -54z" />
                <path d="M2211 1974 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M2050 1962 c0 -10 -5 -23 -12 -30 -9 -9 -9 -12 0 -12 7 0 12 4 12 9
0 13 37 1 52 -17 11 -13 10 -15 -4 -9 -21 8 -20 -12 2 -30 13 -11 13 -13 0
-14 -8 -1 -19 -1 -24 0 -5 1 -5 -6 -2 -15 4 -10 1 -21 -6 -26 -10 -6 -10 -8 0
-8 8 0 16 9 19 20 6 24 16 25 33 5 7 -8 17 -12 23 -8 6 3 0 10 -13 15 -18 7
-21 11 -12 20 9 9 18 6 39 -13 15 -13 22 -16 14 -7 -7 9 -10 22 -7 27 4 5 1
13 -5 17 -8 5 -9 3 -4 -6 5 -8 3 -11 -5 -8 -21 7 -23 26 -4 30 16 3 16 4 0 17
-9 8 -16 10 -15 5 4 -21 -2 -26 -16 -14 -18 15 -19 30 -2 30 7 0 22 6 33 14
19 14 19 14 -1 13 -11 -1 -22 -5 -25 -8 -3 -3 -17 -9 -32 -13 -23 -5 -28 -3
-28 11 0 14 2 15 9 4 5 -8 11 -9 15 -3 3 5 -1 13 -10 16 -23 9 -24 8 -24 -12z
m70 -82 c0 -5 -2 -10 -4 -10 -3 0 -8 5 -11 10 -3 6 -1 10 4 10 6 0 11 -4 11
-10z" />
                <path d="M2385 1971 c3 -6 -12 -12 -32 -14 l-38 -4 43 -1 c31 -2 42 2 42 13 0
8 -5 15 -11 15 -5 0 -8 -4 -4 -9z" />
                <path d="M2530 1968 c0 -11 8 -18 20 -18 11 0 20 5 20 11 0 5 -5 7 -11 3 -6
-3 -15 0 -20 7 -7 11 -9 10 -9 -3z" />
                <path d="M2171 1944 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M2440 1935 c0 -8 5 -15 11 -15 6 0 8 -7 4 -17 -5 -14 -4 -15 6 -6 10
10 10 15 0 27 -10 12 -8 15 16 19 27 4 27 4 -4 6 -23 1 -33 -3 -33 -14z" />
                <path d="M2722 1925 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z" />
                <path d="M1928 1910 c-2 -14 -1 -37 3 -52 6 -21 4 -25 -7 -21 -10 3 -12 0 -8
-10 3 -9 12 -13 19 -11 13 5 65 -54 65 -74 0 -7 4 -12 8 -12 14 0 10 29 -5 34
-8 3 -11 10 -8 16 3 5 1 10 -6 10 -9 0 -9 3 0 14 10 12 9 13 -7 9 -23 -5 -32
6 -39 48 -3 19 0 29 9 29 9 0 9 3 2 8 -6 4 -13 14 -16 22 -4 10 -7 7 -10 -10z" />
                <path d="M2389 1893 c-1 -21 -1 -44 0 -50 1 -7 -4 -13 -11 -13 -10 0 -10 -2 1
-9 8 -5 11 -16 8 -25 -4 -9 -2 -16 3 -16 6 0 10 28 10 61 0 54 2 60 15 49 22
-18 18 -3 -5 20 l-20 20 -1 -37z" />
                <path d="M2178 1895 c2 -14 8 -25 12 -25 5 0 6 9 3 19 -4 14 1 21 19 24 18 3
17 5 -8 6 -28 1 -31 -1 -26 -24z" />
                <path d="M2667 1900 c3 -11 7 -20 9 -20 2 0 4 9 4 20 0 11 -4 20 -9 20 -5 0
-7 -9 -4 -20z" />
                <path d="M2342 1880 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z" />
                <path d="M2547 1880 c-3 -11 -1 -23 4 -26 5 -3 9 6 9 20 0 31 -6 34 -13 6z" />
                <path d="M2218 1860 c2 -16 6 -30 8 -30 2 0 4 14 4 30 0 17 -4 30 -8 30 -5 0
-7 -13 -4 -30z" />
                <path d="M2288 1883 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M2513 1883 c4 -6 -2 -21 -12 -34 -19 -23 -20 -23 -39 -6 -15 14 -22
15 -28 6 -4 -7 -3 -10 3 -6 6 4 16 1 22 -7 9 -11 5 -19 -20 -40 -24 -20 -29
-30 -20 -39 8 -8 11 -7 11 7 0 9 4 15 9 11 6 -3 24 13 42 35 32 39 33 40 53
23 21 -18 21 -18 3 4 -11 12 -16 26 -13 32 4 5 1 13 -5 17 -7 4 -9 3 -6 -3z" />
                <path d="M2708 1883 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z" />
                <path d="M2590 1836 c0 -3 9 -10 20 -16 11 -6 20 -8 20 -6 0 3 -9 10 -20 16
-11 6 -20 8 -20 6z" />
                <path d="M2650 1821 c-13 -25 -13 -31 2 -31 6 0 8 3 5 6 -3 4 -2 15 4 25 5 11
7 19 5 19 -3 0 -10 -9 -16 -19z" />
                <path d="M2261 1804 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M2295 1810 c-16 -7 -17 -9 -3 -9 9 -1 20 4 23 9 7 11 7 11 -20 0z" />
                <path d="M2090 1801 c0 -5 5 -13 10 -16 6 -3 10 -2 10 4 0 5 -4 13 -10 16 -5
3 -10 2 -10 -4z" />
                <path d="M2208 1785 c9 -11 19 -22 21 -25 2 -3 1 3 -2 13 -4 12 -1 17 10 17
26 0 6 13 -22 15 -23 1 -23 0 -7 -20z" />
                <path d="M2587 1793 c3 -7 8 -13 12 -13 4 0 8 6 8 13 0 8 -6 14 -13 14 -7 0
-10 -6 -7 -14z" />
                <path d="M2716 1795 c4 -8 8 -15 10 -15 2 0 4 7 4 15 0 8 -4 15 -10 15 -5 0
-7 -7 -4 -15z" />
                <path d="M1915 1771 c0 -16 3 -27 8 -24 4 2 7 15 7 29 0 13 -3 24 -7 24 -5 0
-8 -13 -8 -29z" />
                <path d="M2460 1746 l-44 -51 45 43 c47 45 75 57 43 20 l-19 -23 22 19 c18 15
20 22 12 33 -6 7 -12 13 -13 12 0 -1 -21 -24 -46 -53z" />
                <path d="M2153 1775 c0 -8 4 -15 9 -15 5 0 6 -5 2 -12 -4 -7 -3 -8 4 -4 9 5 9
13 2 27 -13 23 -17 24 -17 4z" />
                <path d="M2318 1783 c12 -2 30 -2 40 0 9 3 -1 5 -23 4 -22 0 -30 -2 -17 -4z" />
                <path d="M1850 1748 c-19 -17 -27 -29 -18 -25 9 3 19 2 22 -4 2 -5 3 -4 2 3
-2 7 6 23 17 36 29 32 18 27 -23 -10z" />
                <path d="M2696 1767 c3 -8 11 -14 19 -14 20 0 19 4 -5 17 -15 8 -18 8 -14 -3z" />
                <path d="M2115 1745 c0 -22 17 -27 32 -10 5 4 2 5 -6 0 -11 -6 -13 -4 -8 8 3
8 0 17 -6 20 -7 3 -12 -5 -12 -18z" />
                <path d="M2577 1755 c-4 -8 -3 -16 1 -19 4 -3 9 4 9 15 2 23 -3 25 -10 4z" />
                <path d="M2271 1744 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M2610 1741 c-7 -15 -7 -22 2 -27 7 -4 10 -4 6 1 -4 4 -3 16 3 26 5
11 7 19 5 19 -3 0 -10 -9 -16 -19z" />
                <path d="M2332 1720 c0 -19 2 -27 5 -17 2 9 2 25 0 35 -3 9 -5 1 -5 -18z" />
                <path d="M1884 1721 c0 -11 6 -17 13 -14 6 3 9 11 6 19 -7 20 -19 17 -19 -5z" />
                <path d="M2031 1721 c-8 -5 -9 -11 -3 -15 5 -3 12 1 16 9 6 17 6 18 -13 6z" />
                <path d="M2240 1722 c0 -6 5 -14 11 -17 6 -4 8 -14 5 -22 -3 -8 -1 -11 5 -8
12 8 41 -14 34 -25 -10 -17 25 -18 42 -2 10 9 14 14 9 10 -21 -17 -38 -8 -34
16 3 14 1 31 -3 38 -7 11 -9 11 -9 0 0 -7 -4 -10 -10 -7 -5 3 -10 0 -10 -7 -1
-7 -9 -3 -20 11 -11 13 -20 18 -20 13z m60 -42 c0 -5 -2 -10 -4 -10 -3 0 -8 5
-11 10 -3 6 -1 10 4 10 6 0 11 -4 11 -10z" />
                <path d="M2376 1721 c-4 -5 -2 -12 3 -15 5 -4 12 -2 15 3 4 5 2 12 -3 15 -5 4
-12 2 -15 -3z" />
                <path d="M2455 1700 c-17 -16 -26 -18 -57 -11 -22 5 -38 5 -38 0 0 -5 8 -9 18
-10 37 -1 55 -8 81 -31 l26 -23 -22 25 -23 26 22 22 c13 12 20 22 17 22 -2 0
-13 -9 -24 -20z" />
                <path d="M1922 1690 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z" />
                <path d="M2057 1699 c-9 -6 -15 -14 -12 -19 3 -4 -9 -20 -26 -34 -17 -14 -27
-26 -22 -26 15 0 64 56 56 63 -3 4 1 7 10 7 10 0 17 5 17 10 0 12 0 12 -23 -1z" />
                <path d="M2197 1696 c-4 -10 -1 -13 8 -9 8 3 12 9 9 14 -7 12 -11 11 -17 -5z" />
                <path d="M2627 1696 c-4 -10 -1 -13 8 -9 8 3 12 9 9 14 -7 12 -11 11 -17 -5z" />
                <path d="M1787 1680 c-3 -11 -1 -20 4 -20 5 0 9 9 9 20 0 11 -2 20 -4 20 -2 0
-6 -9 -9 -20z" />
                <path d="M1835 1683 c-8 -23 -6 -29 5 -13 9 13 11 13 20 0 8 -12 10 -11 10 6
0 23 -26 28 -35 7z" />
                <path d="M2666 1692 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6 -4
-9 -8z" />
                <path d="M2165 1670 c-4 -6 -2 -17 4 -24 6 -7 8 -16 4 -19 -3 -4 -1 -7 5 -7
15 0 16 17 1 25 -6 4 -8 13 -5 21 6 16 0 19 -9 4z" />
                <path d="M2230 1660 c6 -11 13 -20 16 -20 2 0 0 9 -6 20 -6 11 -13 20 -16 20
-2 0 0 -9 6 -20z" />
                <path d="M1920 1643 c0 -11 3 -14 8 -7 4 6 14 14 22 17 10 4 8 6 -7 6 -16 1
-23 -5 -23 -16z" />
                <path d="M2066 1635 c-19 -29 -22 -46 -3 -20 9 12 19 15 28 10 11 -7 12 -6 2
7 -7 8 -10 18 -6 21 3 4 4 7 1 7 -3 0 -13 -11 -22 -25z" />
                <path d="M1831 1634 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M1770 1628 c0 -4 9 -8 20 -8 11 0 20 4 20 8 0 4 -9 8 -20 8 -11 0
-20 -4 -20 -8z" />
                <path d="M2256 1627 c-16 -12 -16 -14 -3 -14 9 0 18 6 21 14 3 7 4 13 3 13 -2
0 -11 -6 -21 -13z" />
                <path d="M2368 1633 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M1861 1604 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M2125 1610 c-4 -6 -11 -7 -17 -4 -7 4 -8 2 -4 -5 6 -9 12 -9 24 1 10
7 19 14 21 15 2 2 -1 3 -7 3 -6 0 -14 -5 -17 -10z" />
                <path d="M2455 1610 c-3 -6 1 -7 9 -4 18 7 21 14 7 14 -6 0 -13 -4 -16 -10z" />
                <path d="M2193 1595 c0 -8 4 -15 9 -15 4 0 8 4 8 9 0 6 -4 12 -8 15 -5 3 -9
-1 -9 -9z" />
                <path d="M2565 1600 c-4 -6 -11 -8 -16 -5 -5 4 -9 1 -9 -4 0 -17 27 -13 34 4
6 17 0 20 -9 5z" />
                <path d="M2052 1584 c-21 -9 -30 -19 -26 -26 6 -9 9 -9 12 0 2 7 9 12 17 12 7
0 18 7 25 15 15 18 15 18 -28 -1z" />
                <path d="M2316 1573 c-14 -20 -16 -27 -6 -36 10 -9 11 -9 6 1 -4 7 -2 19 4 28
11 12 14 12 27 -3 8 -10 12 -13 9 -6 -4 6 2 14 11 16 14 4 13 5 -4 6 -12 0
-23 5 -25 10 -1 5 -11 -2 -22 -16z" />
                <path d="M2265 1579 c-4 -6 -4 -13 -1 -16 3 -4 6 -1 6 6 0 8 6 11 16 7 8 -3
12 -2 9 4 -8 13 -22 13 -30 -1z" />
                <path d="M2591 1581 c-8 -5 -9 -11 -3 -15 5 -3 12 1 16 9 6 17 6 18 -13 6z" />
                <path d="M2000 1565 c-1 -5 -1 -25 0 -42 1 -21 -3 -33 -11 -33 -7 0 -10 -3 -6
-6 3 -3 11 -2 19 3 9 5 11 20 7 48 -3 22 -7 36 -9 30z" />
                <path d="M2136 1557 c-18 -13 -18 -14 0 -21 10 -4 15 -4 11 0 -4 4 -2 13 4 21
15 17 8 17 -15 0z" />
                <path d="M2213 1553 c0 -7 4 -13 7 -13 4 0 12 6 18 13 8 10 6 13 -7 13 -10 0
-18 -6 -18 -13z" />
                <path d="M1846 1525 c-3 -8 -1 -15 4 -15 6 0 10 7 10 15 0 8 -2 15 -4 15 -2 0
-6 -7 -10 -15z" />
                <path d="M2280 1519 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z" />
                <path d="M2040 1510 c-8 -5 -10 -10 -5 -10 6 0 17 5 25 10 8 5 11 10 5 10 -5
0 -17 -5 -25 -10z" />
                <path d="M1931 1494 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M1881 1484 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M2254 1480 c0 -9 5 -17 11 -17 6 0 11 8 11 17 0 9 -5 17 -11 17 -6 0
-11 -8 -11 -17z" />
                <path d="M3743 2573 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z" />
                <path d="M3873 2520 c0 -36 2 -50 4 -32 2 17 2 47 0 65 -2 17 -4 3 -4 -33z" />
                <path d="M3918 2563 c12 -2 32 -2 45 0 12 2 2 4 -23 4 -25 0 -35 -2 -22 -4z" />
                <path d="M3963 2500 c0 -25 2 -35 4 -22 2 12 2 32 0 45 -2 12 -4 2 -4 -23z" />
                <path d="M3682 2500 c0 -19 2 -27 5 -17 2 9 2 25 0 35 -3 9 -5 1 -5 -18z" />
                <path d="M3723 2503 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z" />
                <path d="M3770 2456 l-5 -58 48 4 c26 3 47 1 47 -4 0 -5 5 -6 10 -3 25 16 7
27 -40 23 l-49 -3 -3 50 -3 50 -5 -59z" />
                <path d="M3903 2493 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z" />
                <path d="M3925 2400 l-30 -8 30 0 c17 0 50 3 75 7 l45 8 -45 1 c-25 0 -58 -4
-75 -8z" />
                <path d="M4050 2388 c0 -4 14 -8 30 -8 17 0 30 2 30 4 0 2 -13 6 -30 8 -16 3
-30 1 -30 -4z" />
                <path d="M3672 2360 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z" />
                <path d="M4052 2350 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z" />
                <path d="M3453 2585 c0 -8 4 -12 9 -9 5 3 6 10 3 15 -9 13 -12 11 -12 -6z" />
                <path d="M3532 2575 c4 -4 0 -14 -10 -21 -9 -7 -12 -14 -6 -14 6 0 17 6 23 14
9 11 9 16 -1 22 -7 4 -10 4 -6 -1z" />
                <path d="M3496 2512 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6 -4
-9 -8z" />
                <path d="M3338 2463 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M3070 2450 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z" />
                <path d="M3210 2441 c0 -6 5 -13 10 -16 6 -3 10 -2 10 4 0 5 8 12 18 14 10 3
6 5 -10 6 -16 0 -28 -3 -28 -8z" />
                <path d="M3531 2294 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M3532 2261 c-11 -7 -11 -9 2 -14 10 -4 16 -1 16 8 0 17 -1 17 -18 6z" />
                <path d="M3070 2250 c8 -5 20 -10 25 -10 6 0 3 5 -5 10 -8 5 -19 10 -25 10 -5
0 -3 -5 5 -10z" />
                <path d="M3458 2233 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M3291 2204 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M3105 2180 c3 -5 11 -10 16 -10 6 0 7 5 4 10 -3 6 -11 10 -16 10 -6
0 -7 -4 -4 -10z" />
                <path d="M3320 2096 c0 -8 4 -17 9 -20 5 -4 7 3 4 14 -6 23 -13 26 -13 6z" />
                <path d="M3571 2094 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M3581 2034 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M3116 2007 c3 -10 9 -15 12 -12 3 3 0 11 -7 18 -10 9 -11 8 -5 -6z" />
                <path d="M3600 1926 c0 -8 -6 -17 -12 -19 -8 -3 -6 -6 5 -6 11 -1 17 6 17 19
0 11 -2 20 -5 20 -3 0 -5 -6 -5 -14z" />
                <path d="M3625 1920 c-7 -12 2 -12 30 0 19 8 19 9 -2 9 -12 1 -25 -3 -28 -9z" />
                <path d="M3381 1904 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M3548 1893 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M3505 1880 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z" />
                <path d="M3390 1867 c0 -8 -3 -17 -7 -20 -5 -2 -2 -2 5 -1 6 2 12 0 12 -5 0
-4 7 -8 15 -8 19 0 19 -1 -5 27 -15 17 -20 19 -20 7z" />
                <path d="M3596 1857 c3 -10 9 -15 12 -12 3 3 0 11 -7 18 -10 9 -11 8 -5 -6z" />
                <path d="M3545 1841 c-3 -6 -9 -10 -13 -7 -4 2 -16 0 -27 -5 -15 -6 -12 -8 13
-5 36 5 49 12 40 22 -3 3 -9 0 -13 -5z" />
                <path d="M3567 1795 c-15 -14 -24 -25 -20 -25 11 0 25 12 42 33 19 24 11 21
-22 -8z" />
                <path d="M3620 1805 c-14 -8 -20 -14 -15 -14 6 0 21 6 35 14 14 8 21 14 15 14
-5 0 -21 -6 -35 -14z" />
                <path d="M3206 1785 c-3 -8 -1 -15 4 -15 6 0 10 7 10 15 0 8 -2 15 -4 15 -2 0
-6 -7 -10 -15z" />
                <path d="M3411 1784 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M3135 1770 c-3 -5 -13 -7 -23 -4 -14 5 -14 3 2 -6 14 -10 20 -10 26
0 4 7 13 9 20 5 9 -5 11 -4 6 3 -9 14 -23 15 -31 2z" />
                <path d="M3490 1731 c0 -6 5 -13 12 -17 6 -4 8 -3 4 4 -3 6 3 12 16 15 20 4
19 4 -4 6 -16 0 -28 -3 -28 -8z" />
                <path d="M3348 1683 c12 -2 32 -2 45 0 12 2 2 4 -23 4 -25 0 -35 -2 -22 -4z" />
                <path d="M3258 1673 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M3276 1643 c-6 -14 -5 -15 5 -6 7 7 10 15 7 18 -3 3 -9 -2 -12 -12z" />
                <path d="M3180 1621 c0 -6 4 -13 10 -16 6 -3 7 1 4 9 -7 18 -14 21 -14 7z" />
                <path d="M3566 1603 c-6 -14 -5 -15 5 -6 7 7 10 15 7 18 -3 3 -9 -2 -12 -12z" />
                <path d="M4241 2524 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M4350 2509 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z" />
                <path d="M4230 2476 c0 -8 4 -17 9 -20 5 -4 7 3 4 14 -6 23 -13 26 -13 6z" />
                <path d="M4266 2454 c-4 -9 -4 -19 -1 -22 2 -3 7 3 11 12 4 9 4 19 1 22 -2 3
-7 -3 -11 -12z" />
                <path d="M4298 2433 c6 -3 12 -12 12 -21 0 -15 2 -15 10 -2 14 22 12 26 -12
27 -13 0 -17 -1 -10 -4z" />
                <path d="M4252 2380 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z" />
                <path d="M2791 2424 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M2861 2344 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M2780 2325 c0 -14 4 -25 9 -25 4 0 6 11 3 25 -2 14 -6 25 -8 25 -2 0
-4 -11 -4 -25z" />
                <path d="M2920 2340 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z" />
                <path d="M2861 2301 c-1 -20 -5 -22 -28 -17 -21 5 -24 4 -13 -4 13 -8 12 -10
-5 -11 -11 0 -14 -3 -7 -6 10 -4 10 -8 0 -21 -7 -10 0 -6 15 8 24 21 30 22 37
10 6 -9 10 -10 10 -3 0 6 10 14 23 16 22 4 22 4 0 6 -14 1 -23 9 -26 24 -4 22
-4 22 -6 -2z" />
                <path d="M2875 2230 c-19 -8 -19 -9 3 -9 12 -1 22 4 22 9 0 6 -1 10 -2 9 -2 0
-12 -4 -23 -9z" />
                <path d="M2971 2204 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M2913 2203 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z" />
                <path d="M2895 2180 l-40 -7 42 -2 c23 0 45 4 48 9 3 6 3 9 -2 9 -4 -1 -26 -5
-48 -9z" />
                <path d="M2963 2163 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z" />
                <path d="M2931 2103 c0 -12 -9 -24 -18 -26 -10 -3 0 -5 22 -5 22 0 32 2 23 5
-9 2 -19 14 -21 26 l-4 22 -2 -22z" />
                <path d="M2870 1981 c0 -6 4 -13 10 -16 6 -3 7 1 4 9 -7 18 -14 21 -14 7z" />
                <path d="M4548 2483 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M4590 2464 c8 -8 23 -20 34 -26 19 -10 18 -8 -3 16 -26 27 -53 37
-31 10z" />
                <path d="M4561 2454 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M4505 2419 c-11 -16 -1 -19 13 -3 7 8 8 14 3 14 -5 0 -13 -5 -16 -11z" />
                <path d="M4547 2423 c-4 -3 -7 -11 -7 -17 0 -6 4 -5 9 3 7 11 15 10 42 -8 l34
-23 -30 26 c-32 28 -38 30 -48 19z" />
                <path d="M4430 2410 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z" />
                <path d="M4525 2369 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z" />
                <path d="M4557 2339 c-4 -16 -3 -18 9 -8 7 6 11 15 8 20 -8 13 -11 11 -17 -12z" />
                <path d="M4335 2330 c-3 -6 1 -7 9 -4 18 7 21 14 7 14 -6 0 -13 -4 -16 -10z" />
                <path d="M4585 2330 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z" />
                <path d="M4408 2318 c6 -6 18 -8 28 -6 14 3 12 5 -9 10 -19 3 -25 2 -19 -4z" />
                <path d="M4505 2319 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z" />
                <path d="M4474 2302 c4 -7 3 -12 -2 -12 -6 0 -12 -7 -16 -15 -8 -22 7 -18 21
5 9 14 10 21 1 26 -7 4 -8 3 -4 -4z" />
                <path d="M4580 2304 c0 -5 -11 -22 -24 -39 -19 -24 -26 -27 -38 -18 -10 9 -23
9 -44 3 l-29 -10 33 5 c17 2 32 0 32 -5 0 -6 7 -10 14 -10 17 0 72 68 62 77
-3 3 -6 2 -6 -3z" />
                <path d="M4270 2256 c0 -2 8 -10 18 -17 15 -13 16 -12 3 4 -13 16 -21 21 -21
13z" />
                <path d="M4398 2233 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M4357 2124 c-11 -15 -24 -21 -35 -18 -14 5 -14 4 -2 -4 12 -9 12 -14
-5 -34 -10 -13 -3 -7 16 12 l34 34 6 -34 c4 -22 7 -27 8 -12 0 13 7 22 18 22
15 0 15 1 1 13 -9 6 -18 19 -20 29 -2 13 -6 12 -21 -8z" />
                <path d="M4428 2093 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M4224 2067 c-8 -18 -8 -24 3 -24 7 0 13 11 13 24 0 29 -2 29 -16 0z" />
                <path d="M4538 2083 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z" />
                <path d="M4266 2013 c-29 -29 -29 -47 0 -50 18 -3 18 -2 0 5 -17 7 -16 10 9
40 33 39 28 42 -9 5z" />
                <path d="M4556 1965 c-9 -26 -7 -32 5 -12 6 10 9 21 6 23 -2 3 -7 -2 -11 -11z" />
                <path d="M4340 1915 c13 -14 26 -25 28 -25 3 0 -5 11 -18 25 -13 14 -26 25
-28 25 -3 0 5 -11 18 -25z" />
                <path d="M4526 1895 c-9 -26 -7 -32 5 -12 6 10 9 21 6 23 -2 3 -7 -2 -11 -11z" />
                <path d="M4809 2243 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21 -13z" />
                <path d="M4960 2249 c0 -3 13 -18 29 -33 24 -23 29 -25 35 -11 3 10 2 14 -5 9
-6 -3 -21 4 -35 17 -13 12 -24 20 -24 18z" />
                <path d="M4881 2214 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M4770 2171 c0 -5 7 -12 16 -15 14 -5 15 -4 4 9 -14 17 -20 19 -20 6z" />
                <path d="M4928 2103 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z" />
                <path d="M4740 2037 c0 -19 21 -37 42 -37 10 0 18 7 18 17 0 13 3 14 12 5 7
-7 17 -12 23 -12 5 0 -3 9 -20 20 -34 23 -75 26 -75 7z m50 -6 c0 -16 -28 -20
-34 -5 -4 9 1 14 14 14 11 0 20 -4 20 -9z" />
                <path d="M4963 1994 c0 -8 7 -12 16 -9 23 7 45 -10 35 -26 -6 -11 -5 -11 9 0
21 16 21 16 -24 35 -31 13 -36 13 -36 0z" />
                <path d="M4857 1930 c3 -11 7 -20 8 -20 1 0 5 9 8 20 3 12 0 20 -8 20 -8 0
-11 -8 -8 -20z" />
                <path d="M4862 1880 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z" />
                <path d="M4755 1881 c-3 -5 -1 -12 5 -16 5 -3 10 1 10 9 0 18 -6 21 -15 7z" />
                <path d="M4842 1870 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z" />
                <path d="M3888 2233 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M4040 2230 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z" />
                <path d="M3838 2223 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M4039 2190 c-3 -21 -9 -25 -37 -22 -18 1 -41 -2 -50 -7 -14 -8 -13
-10 8 -10 14 0 34 -1 44 -1 26 -1 49 23 44 46 -4 15 -5 14 -9 -6z" />
                <path d="M3870 2177 c0 -20 31 -31 44 -16 8 9 8 10 -1 5 -6 -3 -19 1 -27 10
-14 13 -16 13 -16 1z" />
                <path d="M4073 2113 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z" />
                <path d="M3934 2068 l-29 -33 33 29 c30 28 37 36 29 36 -2 0 -16 -15 -33 -32z" />
                <path d="M3900 2016 c0 -2 9 -6 20 -9 11 -3 18 -1 14 4 -5 9 -34 13 -34 5z" />
                <path d="M3773 2003 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z" />
                <path d="M3894 1945 c-4 -8 -11 -12 -17 -8 -6 3 -7 1 -3 -5 10 -16 14 -15 26
8 6 11 8 20 5 20 -3 0 -8 -7 -11 -15z" />
                <path d="M3909 1873 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8 -17
-17z" />
                <path d="M4003 1883 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z" />
                <path d="M4103 1815 c0 -27 2 -38 4 -22 2 15 2 37 0 50 -2 12 -4 0 -4 -28z" />
                <path d="M3833 1836 c0 -8 6 -12 14 -9 7 3 10 9 7 14 -8 14 -21 11 -21 -5z" />
                <path d="M4010 1841 c0 -5 -3 -16 -6 -25 -3 -9 -2 -16 3 -16 5 0 10 11 11 25
1 14 0 25 -3 25 -3 0 -5 -4 -5 -9z" />
                <path d="M4070 1795 c0 -32 3 -56 6 -52 3 3 6 26 6 52 0 26 -3 49 -6 53 -3 3
-6 -21 -6 -53z" />
                <path d="M3946 1824 c-5 -14 -4 -15 9 -4 17 14 19 20 6 20 -5 0 -12 -7 -15
-16z" />
                <path d="M3803 1785 c0 -8 4 -12 9 -9 4 3 8 9 8 15 0 5 -4 9 -8 9 -5 0 -9 -7
-9 -15z" />
                <path d="M3956 1784 c-7 -19 1 -34 17 -34 7 0 6 4 -3 10 -12 8 -13 11 -1 19 8
5 9 11 3 15 -5 3 -13 -1 -16 -10z" />
                <path d="M3760 1776 c0 -3 9 -10 20 -16 11 -6 20 -8 20 -6 0 3 -9 10 -20 16
-11 6 -20 8 -20 6z" />
                <path d="M4026 1771 c-4 -6 -2 -11 4 -11 7 0 9 -9 6 -22 l-6 -23 12 23 c12 24
-3 55 -16 33z" />
                <path d="M3843 1763 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z" />
                <path d="M3736 1752 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6 -4
-9 -8z" />
                <path d="M3936 1734 c-7 -19 0 -34 17 -34 9 0 8 3 -1 8 -7 5 -10 16 -6 25 3 9
4 17 1 17 -3 0 -8 -7 -11 -16z" />
                <path d="M3850 1726 c0 -4 68 -46 76 -46 2 0 4 5 4 11 0 5 -4 8 -9 4 -6 -3
-14 3 -20 12 -6 10 -11 14 -11 10 0 -4 -9 -3 -20 3 -11 6 -20 9 -20 6z" />
                <path d="M3746 1689 c3 -5 -2 -22 -11 -38 -14 -28 -14 -30 0 -24 9 3 14 8 11
11 -3 2 -1 13 5 23 8 16 13 17 32 8 22 -12 22 -12 2 8 -19 19 -49 28 -39 12z" />
                <path d="M4000 1680 c0 -5 -8 -10 -17 -11 -11 0 -13 -3 -5 -6 6 -2 10 -10 6
-16 -3 -7 2 -3 10 7 9 11 22 23 28 28 9 5 8 8 -4 8 -10 0 -18 -4 -18 -10z" />
                <path d="M4069 1671 c9 -6 11 -16 7 -27 -6 -15 -4 -16 5 -7 14 14 5 43 -13 43
-10 0 -9 -3 1 -9z" />
                <path d="M3900 1666 c0 -2 7 -7 16 -10 8 -3 12 -2 9 4 -6 10 -25 14 -25 6z" />
                <path d="M3817 1649 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 -14 6 -15 5 -6 -5z" />
                <path d="M4003 1635 c-6 -15 -7 -27 -2 -31 5 -3 8 -2 7 3 -1 4 3 18 10 31 7
12 9 22 5 22 -4 0 -13 -11 -20 -25z" />
                <path d="M3885 1639 c-4 -6 -13 -8 -21 -5 -8 3 -11 0 -7 -10 3 -8 -3 -21 -13
-29 -11 -7 -15 -17 -11 -21 4 -4 14 2 23 14 14 21 16 21 49 5 19 -9 32 -21 29
-27 -3 -6 2 -2 11 9 9 11 21 19 26 18 16 -5 10 6 -11 17 -16 9 -18 8 -14 -5 8
-20 -10 -19 -41 1 -23 15 -26 42 -3 28 7 -4 8 -2 4 4 -9 15 -13 15 -21 1z" />
                <path d="M3801 1616 c-9 -10 -8 -15 2 -19 8 -3 13 3 13 14 0 23 0 23 -15 5z" />
                <path d="M4020 1603 c0 -19 21 -27 33 -13 9 10 9 11 -2 5 -8 -4 -17 -2 -22 6
-6 9 -9 10 -9 2z" />
                <path d="M3880 1586 c0 -3 9 -10 20 -16 11 -6 20 -8 20 -6 0 3 -9 10 -20 16
-11 6 -20 8 -20 6z" />
                <path d="M4020 1559 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z" />
                <path d="M878 2203 c-2 -5 -1 -30 3 -58 l6 -50 1 58 c2 52 -2 69 -10 50z" />
                <path d="M787 2167 c-3 -8 1 -14 9 -14 16 0 19 13 5 21 -5 3 -11 0 -14 -7z" />
                <path d="M810 2131 c0 -12 20 -36 20 -24 0 6 8 13 18 15 12 3 9 6 -10 10 -16
3 -28 2 -28 -1z" />
                <path d="M768 2113 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z" />
                <path d="M838 2033 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M806 2001 c-3 -4 6 -6 19 -3 14 2 25 6 25 8 0 8 -39 4 -44 -5z" />
                <path d="M880 1990 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z" />
                <path d="M808 1973 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z" />
                <path d="M868 1953 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M830 1900 c0 -11 4 -20 9 -20 5 0 7 9 4 20 -3 11 -7 20 -9 20 -2 0
-4 -9 -4 -20z" />
                <path d="M850 1910 c0 -5 4 -10 9 -10 6 0 13 5 16 10 3 6 -1 10 -9 10 -9 0
-16 -4 -16 -10z" />
                <path d="M842 1830 c0 -19 2 -27 5 -17 2 9 2 25 0 35 -3 9 -5 1 -5 -18z" />
                <path d="M754 1778 c-10 -12 -14 -18 -7 -15 6 4 16 0 22 -10 6 -10 11 -13 11
-7 0 5 -5 15 -11 21 -8 8 -8 13 0 17 15 10 33 -3 27 -20 -3 -8 0 -11 10 -7 7
3 14 12 14 20 0 8 -4 12 -9 8 -5 -3 -12 -1 -16 5 -9 15 -20 12 -41 -12z" />
                <path d="M1273 1975 c0 -27 2 -38 4 -22 2 15 2 37 0 50 -2 12 -4 0 -4 -28z" />
                <path d="M1200 1983 c0 -11 3 -14 8 -7 4 6 14 14 22 17 10 4 8 6 -7 6 -16 1
-23 -5 -23 -16z" />
                <path d="M1203 1910 c0 -30 2 -43 4 -27 2 15 2 39 0 55 -2 15 -4 2 -4 -28z" />
                <path d="M1195 1840 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z" />
                <path d="M1143 1780 c0 -25 2 -35 4 -22 2 12 2 32 0 45 -2 12 -4 2 -4 -23z" />
                <path d="M1240 1761 c0 -6 4 -13 10 -16 6 -3 7 1 4 9 -7 18 -14 21 -14 7z" />
                <path d="M1170 1737 c0 -8 -8 -18 -17 -20 -17 -4 -17 -5 0 -6 18 -1 35 25 23
36 -3 4 -6 -1 -6 -10z" />
                <path d="M1201 1662 c-9 -20 -9 -35 -1 -53 10 -24 10 -24 5 4 -3 15 -1 37 6
48 6 11 9 23 6 25 -2 3 -10 -8 -16 -24z" />
                <path d="M1232 1655 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z" />
                <path d="M1303 1633 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z" />
                <path d="M1434 1579 c-3 -6 -2 -15 3 -20 5 -5 9 -1 9 11 0 23 -2 24 -12 9z" />
                <path d="M1231 1554 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M1350 1550 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z" />
                <path d="M1218 1475 c-3 -14 -1 -25 3 -25 5 0 9 11 9 25 0 14 -2 25 -4 25 -2
0 -6 -11 -8 -25z" />
                <path d="M1440 1498 c0 -3 6 -11 14 -17 10 -9 17 -7 27 6 12 16 12 17 -2 6
-12 -10 -18 -10 -27 -1 -7 7 -12 9 -12 6z" />
                <path d="M1141 1444 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M1192 1440 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z" />
                <path d="M1310 1426 c0 -2 8 -10 18 -17 15 -13 16 -12 3 4 -13 16 -21 21 -21
13z" />
                <path d="M1380 1400 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z" />
                <path d="M1202 1360 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z" />
                <path d="M1141 1334 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M1405 2000 c-3 -6 1 -7 9 -4 18 7 21 14 7 14 -6 0 -13 -4 -16 -10z" />
                <path d="M1456 1927 c3 -10 9 -15 12 -12 3 3 0 11 -7 18 -10 9 -11 8 -5 -6z" />
                <path d="M1430 1676 c0 -2 8 -10 18 -17 15 -13 16 -12 3 4 -13 16 -21 21 -21
13z" />
                <path d="M1470 1668 c0 -4 4 -8 9 -8 6 0 12 4 15 8 3 5 -1 9 -9 9 -8 0 -15 -4
-15 -9z" />
                <path d="M1590 2014 c-8 -10 -10 -15 -3 -11 7 4 16 0 22 -10 12 -20 13 -7 2
20 -7 18 -8 18 -21 1z" />
                <path d="M1731 1994 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M1639 1983 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21 -13z" />
                <path d="M1700 1930 l-25 -8 27 -1 c15 -1 30 4 33 9 7 11 0 11 -35 0z" />
                <path d="M1775 1929 c-4 -6 -4 -13 -1 -16 3 -4 6 -1 6 6 0 7 5 9 12 5 7 -4 8
-3 4 4 -9 15 -13 15 -21 1z" />
                <path d="M1726 1895 c-3 -9 0 -15 9 -15 9 0 12 6 9 15 -4 8 -7 15 -9 15 -2 0
-5 -7 -9 -15z" />
                <path d="M1605 1877 c8 -13 13 -26 10 -28 -2 -3 6 -11 18 -18 20 -13 21 -13 9
1 -10 13 -10 17 0 21 9 4 7 6 -4 6 -9 1 -20 10 -23 21 -3 11 -11 20 -16 20 -5
0 -3 -10 6 -23z" />
                <path d="M1684 1851 c-1 -21 2 -26 10 -18 15 13 15 47 1 47 -5 0 -10 -13 -11
-29z" />
                <path d="M1741 1844 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M1572 1834 c-14 -16 -5 -18 17 -5 7 5 9 11 5 14 -5 3 -15 -1 -22 -9z" />
                <path d="M1653 1788 c-1 -10 4 -17 10 -15 7 1 13 -12 15 -30 3 -28 1 -31 -20
-27 -21 4 -21 4 -3 -5 11 -4 23 -7 28 -4 11 6 9 73 -3 73 -17 0 -11 18 8 23 9
3 6 4 -9 4 -16 -1 -25 -7 -26 -19z" />
                <path d="M1735 1790 c27 -12 43 -12 25 0 -8 5 -22 9 -30 9 -10 0 -8 -3 5 -9z" />
                <path d="M1728 1763 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M1570 1755 c0 -2 6 -8 13 -14 10 -8 14 -7 14 2 0 8 -6 14 -14 14 -7
0 -13 -1 -13 -2z" />
                <path d="M1610 1715 c0 -8 2 -15 4 -15 2 0 6 7 10 15 3 8 1 15 -4 15 -6 0 -10
-7 -10 -15z" />
                <path d="M1645 1640 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z" />
                <path d="M4365 1800 c-3 -6 1 -7 9 -4 18 7 21 14 7 14 -6 0 -13 -4 -16 -10z" />
                <path d="M4476 1787 c3 -10 9 -15 12 -12 3 3 0 11 -7 18 -10 9 -11 8 -5 -6z" />
                <path d="M4220 1768 c0 -9 -8 -19 -17 -21 -10 -2 -8 -3 4 -2 12 1 24 -3 27 -9
2 -6 5 -4 5 4 0 8 -4 22 -9 30 -8 13 -10 13 -10 -2z" />
                <path d="M4269 1757 c6 -8 7 -18 3 -22 -4 -5 -2 -5 5 -1 14 8 6 36 -9 36 -7 0
-6 -5 1 -13z" />
                <path d="M4440 1720 c-8 -6 -11 -10 -6 -10 5 0 1 -9 -9 -20 -10 -11 -16 -22
-13 -25 2 -3 15 9 27 26 24 33 25 44 1 29z" />
                <path d="M4210 1700 c0 -11 2 -20 4 -20 2 0 6 9 9 20 3 11 1 20 -4 20 -5 0 -9
-9 -9 -20z" />
                <path d="M4292 1673 c-2 -36 1 -43 17 -43 16 0 21 -8 24 -42 l4 -43 1 43 c2
37 5 42 26 42 14 0 27 3 29 8 3 4 -17 5 -43 4 l-49 -4 -4 39 -4 38 -1 -42z" />
                <path d="M4212 1645 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z" />
                <path d="M4383 1560 c0 -25 2 -35 4 -22 2 12 2 32 0 45 -2 12 -4 2 -4 -23z" />
                <path d="M4263 1553 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z" />
                <path d="M4655 1760 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z" />
                <path d="M4738 1749 c6 -9 8 -19 4 -24 -4 -4 5 0 21 10 30 20 37 31 9 16 -13
-7 -23 -6 -32 2 -12 10 -12 9 -2 -4z" />
                <path d="M4679 1711 c13 -8 13 -12 1 -28 -13 -17 -13 -17 4 -1 19 16 15 38 -7
38 -8 0 -7 -4 2 -9z" />
                <path d="M4786 1685 c-3 -8 -1 -15 4 -15 6 0 10 7 10 15 0 8 -2 15 -4 15 -2 0
-6 -7 -10 -15z" />
                <path d="M4791 1634 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M4552 1615 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z" />
                <path d="M4624 1599 c-1 -27 2 -36 8 -26 4 9 7 25 5 36 -6 37 -13 31 -13 -10z" />
                <path d="M4606 1534 c-4 -10 -12 -14 -22 -10 -14 5 -15 4 -4 -9 11 -14 14 -13
27 5 8 12 13 23 10 26 -2 3 -7 -3 -11 -12z" />
                <path d="M4666 1524 c-5 -14 -4 -15 9 -4 17 14 19 20 6 20 -5 0 -12 -7 -15
-16z" />
                <path d="M5036 1745 c4 -8 8 -15 10 -15 2 0 4 7 4 15 0 8 -4 15 -10 15 -5 0
-7 -7 -4 -15z" />
                <path d="M5090 1715 c13 -14 24 -25 25 -25 0 0 1 8 1 19 0 11 -5 17 -13 14 -7
-3 -13 0 -13 6 0 6 -5 11 -12 11 -6 0 -1 -11 12 -25z" />
                <path d="M5176 1731 c-4 -5 3 -7 14 -4 23 6 26 13 6 13 -8 0 -17 -4 -20 -9z" />
                <path d="M5151 1723 c-1 -6 -4 -20 -7 -30 -5 -17 -5 -17 6 0 6 10 9 23 6 30
-3 9 -5 9 -5 0z" />
                <path d="M5366 1663 c-6 -14 -5 -15 5 -6 7 7 10 15 7 18 -3 3 -9 -2 -12 -12z" />
                <path d="M5000 1650 c27 -21 40 -25 40 -12 0 4 -15 13 -32 20 l-33 12 25 -20z" />
                <path d="M5150 1659 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z" />
                <path d="M5040 1625 c-8 -9 -8 -15 -2 -15 12 0 26 19 19 26 -2 2 -10 -2 -17
-11z" />
                <path d="M5160 1629 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z" />
                <path d="M5301 1614 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M4937 1608 c2 -5 10 -8 18 -8 8 0 16 3 18 8 3 4 -5 7 -18 7 -13 0
-21 -3 -18 -7z" />
                <path d="M5328 1613 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M5064 1588 c-5 -7 -3 -8 6 -3 10 6 12 4 7 -8 -3 -10 -2 -17 3 -17 6
0 10 5 10 10 0 6 8 10 18 11 14 0 14 2 -3 9 -28 12 -33 12 -41 -2z" />
                <path d="M4966 1573 c-6 -14 -5 -15 5 -6 7 7 10 15 7 18 -3 3 -9 -2 -12 -12z" />
                <path d="M5299 1588 c-6 -12 -3 -55 4 -51 4 3 6 12 2 21 -3 8 0 19 7 24 10 6
10 8 1 8 -7 0 -14 -1 -14 -2z" />
                <path d="M5342 1564 c-7 -8 -8 -14 -3 -14 10 0 25 19 20 25 -2 1 -10 -3 -17
-11z" />
                <path d="M5110 1556 c0 -8 4 -17 9 -20 5 -4 7 3 4 14 -6 23 -13 26 -13 6z" />
                <path d="M5074 1530 c1 -8 10 -16 21 -17 15 -1 15 0 3 3 -9 3 -19 11 -21 17
-2 7 -3 5 -3 -3z" />
                <path d="M5267 1523 c-4 -3 -7 -11 -7 -17 0 -6 5 -5 12 2 6 6 9 14 7 17 -3 3
-9 2 -12 -2z" />
                <path d="M5178 1492 c7 -5 10 -16 6 -27 -7 -16 -6 -16 14 1 12 10 22 23 22 29
0 5 -4 4 -9 -4 -6 -9 -11 -10 -15 -2 -4 6 -13 11 -19 11 -9 0 -8 -3 1 -8z" />
                <path d="M786 1467 c-17 -12 -15 -14 17 -13 20 1 40 5 44 10 4 4 -5 4 -21 0
-21 -5 -27 -4 -22 5 9 15 4 14 -18 -2z" />
                <path d="M735 1440 c-3 -6 1 -7 9 -4 18 7 21 14 7 14 -6 0 -13 -4 -16 -10z" />
                <path d="M663 1418 c2 -24 27 -30 27 -6 0 5 4 7 9 3 5 -3 12 -1 16 4 3 6 -4 8
-17 6 -12 -3 -25 0 -29 7 -4 6 -6 0 -6 -14z" />
                <path d="M2814 1516 c11 -9 16 -16 12 -16 -5 0 -3 -6 3 -13 6 -8 8 -17 4 -20
-3 -4 5 -7 18 -7 22 1 22 2 7 14 -13 10 -15 15 -6 24 9 9 9 15 -1 25 -10 10
-11 8 -5 -7 7 -18 6 -18 -22 -1 -23 13 -25 14 -10 1z" />
                <path d="M2871 1434 c6 -7 16 -11 21 -8 11 7 3 17 -18 20 -12 2 -13 -1 -3 -12z" />
                <path d="M2831 1424 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M3103 1427 c-3 -7 -3 -9 2 -5 9 9 35 -9 35 -24 0 -5 -6 -6 -12 -1 -7
4 -2 -7 12 -24 27 -35 47 -37 42 -6 -2 12 3 20 12 20 8 0 13 -4 10 -9 -3 -4 2
-8 10 -8 9 0 16 5 16 10 0 15 -60 39 -79 32 -8 -3 -12 -1 -8 5 4 6 -2 13 -13
16 -11 3 -23 0 -27 -6z m60 -41 c4 -10 1 -13 -8 -9 -8 3 -12 9 -9 14 7 12 11
11 17 -5z" />
                <path d="M2907 1385 c10 -13 22 -25 27 -25 5 0 -1 11 -14 25 -30 32 -36 32
-13 0z" />
                <path d="M2802 1393 c15 -2 29 -12 31 -21 3 -12 5 -10 6 6 1 19 -4 22 -31 21
-30 -2 -30 -2 -6 -6z" />
                <path d="M2971 1313 c7 -12 15 -20 18 -17 3 2 -3 12 -13 22 -17 16 -18 16 -5
-5z" />
                <path d="M3301 1303 c-10 -26 -10 -27 4 -9 8 11 15 23 15 28 0 15 -7 8 -19
-19z" />
                <path d="M2912 1280 c0 -19 2 -27 5 -17 2 9 2 25 0 35 -3 9 -5 1 -5 -18z" />
                <path d="M2822 1260 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z" />
                <path d="M3010 1266 c0 -2 8 -10 18 -17 15 -13 16 -12 3 4 -13 16 -21 21 -21
13z" />
                <path d="M3436 1246 c3 -8 -2 -28 -11 -45 -22 -43 -2 -39 24 4 20 34 20 35 1
45 -16 8 -18 8 -14 -4z" />
                <path d="M3300 1226 c0 -2 7 -7 16 -10 8 -3 12 -2 9 4 -6 10 -25 14 -25 6z" />
                <path d="M2868 1213 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M2908 1213 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M3045 1201 c26 -6 30 -11 28 -36 -2 -28 -2 -29 9 -8 14 29 -5 53 -41
52 -25 -1 -25 -2 4 -8z" />
                <path d="M2992 1165 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z" />
                <path d="M3570 1174 c0 -2 9 -8 20 -14 15 -8 18 -8 14 3 -4 11 -34 21 -34 11z" />
                <path d="M2901 1154 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M3450 1153 c0 -1 8 -7 18 -12 13 -7 19 -6 19 2 0 7 -9 13 -19 13 -10
0 -18 -1 -18 -3z" />
                <path d="M3106 1142 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6 -4
-9 -8z" />
                <path d="M2763 1133 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z" />
                <path d="M2813 1105 c0 -22 2 -30 4 -17 2 12 2 30 0 40 -3 9 -5 -1 -4 -23z" />
                <path d="M3645 1130 c-3 -5 1 -10 10 -10 9 0 13 5 10 10 -3 6 -8 10 -10 10 -2
0 -7 -4 -10 -10z" />
                <path d="M2897 1114 c3 -9 9 -12 12 -7 3 4 10 11 15 16 5 4 0 7 -12 7 -15 0
-20 -4 -15 -16z" />
                <path d="M3055 1120 c-19 -8 -19 -9 3 -9 12 -1 22 4 22 9 0 6 -1 10 -2 9 -2 0
-12 -4 -23 -9z" />
                <path d="M3676 1085 c-3 -9 -2 -13 4 -10 14 9 12 -8 -2 -25 -7 -8 -3 -6 10 5
12 10 19 21 15 24 -5 4 -11 10 -14 14 -4 4 -9 1 -13 -8z" />
                <path d="M3720 1096 c0 -2 8 -10 18 -17 15 -13 16 -12 3 4 -13 16 -21 21 -21
13z" />
                <path d="M3765 1079 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z" />
                <path d="M2770 1052 c0 -4 10 -13 23 -21 22 -14 22 -14 3 8 -20 22 -26 25 -26
13z" />
                <path d="M2873 1043 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z" />
                <path d="M3307 1037 c-3 -8 0 -14 7 -14 7 0 13 6 13 14 0 7 -4 13 -8 13 -4 0
-9 -6 -12 -13z" />
                <path d="M3033 1033 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z" />
                <path d="M3370 1031 c0 -5 7 -12 16 -15 14 -5 15 -4 4 9 -14 17 -20 19 -20 6z" />
                <path d="M3148 1005 c2 -14 6 -25 8 -25 2 0 4 11 4 25 0 14 -4 25 -9 25 -4 0
-6 -11 -3 -25z" />
                <path d="M3347 1023 c-4 -3 -7 -11 -7 -17 0 -6 5 -5 12 2 6 6 9 14 7 17 -3 3
-9 2 -12 -2z" />
                <path d="M2888 995 c-3 -14 -1 -25 3 -25 5 0 9 11 9 25 0 14 -2 25 -4 25 -2 0
-6 -11 -8 -25z" />
                <path d="M2981 1004 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M3062 1000 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z" />
                <path d="M3630 966 c0 -2 8 -10 18 -17 15 -13 16 -12 3 4 -13 16 -21 21 -21
13z" />
                <path d="M2958 943 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z" />
                <path d="M3103 933 c15 -2 37 -2 50 0 12 2 0 4 -28 4 -27 0 -38 -2 -22 -4z" />
                <path d="M3624 853 c-13 -20 -13 -25 -2 -16 8 7 17 11 19 8 3 -2 5 5 5 15 0
25 0 25 -22 -7z" />
                <path d="M3175 860 c-4 -6 -12 -7 -18 -4 -7 4 -4 -2 6 -12 16 -17 18 -17 32
-1 8 9 10 12 3 7 -19 -15 -32 -12 -18 5 7 8 10 15 7 15 -3 0 -9 -5 -12 -10z" />
                <path d="M2815 840 c-3 -6 1 -7 10 -4 8 4 23 0 33 -7 15 -13 16 -12 3 4 -15
19 -36 22 -46 7z" />
                <path d="M3660 830 c-6 -11 -8 -20 -6 -20 3 0 10 9 16 20 6 11 8 20 6 20 -3 0
-10 -9 -16 -20z" />
                <path d="M3586 788 c-11 -17 -14 -28 -8 -24 6 3 13 2 17 -4 3 -5 11 -10 18
-10 6 0 2 6 -8 14 -17 12 -17 16 -6 30 8 9 12 18 9 21 -2 2 -12 -10 -22 -27z" />
                <path d="M2840 793 c15 -31 24 -34 38 -13 9 14 9 21 0 26 -6 4 -8 3 -4 -4 12
-19 -15 -24 -30 -6 -14 18 -14 18 -4 -3z" />
                <path d="M3509 793 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8 -17
-17z" />
                <path d="M2795 790 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z" />
                <path d="M2748 783 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z" />
                <path d="M2791 754 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M3327 752 c-16 -17 -14 -20 21 -53 20 -19 33 -30 29 -25 -4 5 1 19
10 30 17 20 17 21 -2 4 -18 -17 -20 -17 -42 4 -21 20 -22 23 -6 40 9 10 14 18
11 18 -3 0 -12 -8 -21 -18z" />
                <path d="M3190 725 c-12 -13 -28 -21 -34 -18 -6 4 -2 -3 8 -15 20 -24 36 -31
17 -9 -8 11 -5 19 13 36 20 19 28 21 48 11 22 -11 22 -10 4 4 -26 21 -28 20
-56 -9z" />
                <path d="M3241 683 c-19 -18 -38 -30 -43 -27 -4 3 -5 -2 -2 -11 6 -14 8 -14
20 2 11 16 15 16 36 4 21 -13 22 -13 9 3 -12 14 -11 18 5 31 10 8 25 12 32 10
18 -7 14 3 -5 13 -13 6 -27 -1 -52 -25z" />
                <path d="M2793 683 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z" />
                <path d="M2910 680 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z" />
                <path d="M3317 676 c-4 -10 -1 -13 8 -9 8 3 12 9 9 14 -7 12 -11 11 -17 -5z" />
                <path d="M2947 666 c-10 -8 -14 -16 -10 -19 5 -3 14 3 21 14 14 22 13 23 -11
5z" />
                <path d="M2782 645 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z" />
                <path d="M2717 633 c-17 -16 -6 -33 21 -32 23 2 24 2 5 6 -32 6 -29 21 5 26
l27 4 -26 2 c-14 0 -29 -2 -32 -6z" />
                <path d="M3287 604 c7 -20 29 -23 29 -5 0 9 -8 17 -17 17 -9 0 -15 -6 -12 -12z" />
                <path d="M2976 591 c4 -8 11 -28 15 -45 6 -29 7 -29 8 -5 1 14 -6 34 -15 45
-8 10 -12 13 -8 5z" />
                <path d="M3234 572 c23 -26 23 -26 23 -7 0 8 -3 13 -5 10 -3 -3 -12 1 -21 7
-10 8 -9 4 3 -10z" />
                <path d="M2897 543 c9 -16 18 -29 18 -31 1 -1 10 8 21 20 17 20 17 21 1 8 -16
-12 -20 -12 -28 1 -5 8 -9 17 -9 22 0 4 -5 7 -10 7 -6 0 -3 -12 7 -27z" />
                <path d="M2783 529 c11 -7 23 -7 35 0 14 9 11 10 -18 10 -29 0 -32 -1 -17 -10z" />
                <path d="M2881 481 c-8 -5 -9 -11 -3 -15 5 -3 12 1 16 9 6 17 6 18 -13 6z" />
                <path d="M2790 470 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z" />
                <path d="M3111 460 c14 -31 19 -36 19 -24 0 6 -7 19 -16 30 -14 18 -14 18 -3
-6z" />
                <path d="M2830 460 c-8 -5 -10 -10 -5 -10 6 0 17 5 25 10 8 5 11 10 5 10 -5 0
-17 -5 -25 -10z" />
                <path d="M2943 448 c3 -9 1 -19 -6 -22 -7 -2 -5 -5 5 -5 24 -1 29 12 10 29
-14 13 -15 12 -9 -2z" />
                <path d="M2895 410 c-3 -6 1 -7 9 -4 18 7 21 14 7 14 -6 0 -13 -4 -16 -10z" />
                <path d="M2855 401 c3 -5 -1 -12 -7 -14 -8 -4 -7 -6 4 -6 23 -1 32 15 12 23
-8 3 -13 2 -9 -3z" />
                <path d="M3126 395 c-3 -8 -1 -15 4 -15 6 0 10 7 10 15 0 8 -2 15 -4 15 -2 0
-6 -7 -10 -15z" />
                <path d="M3045 390 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z" />
                <path d="M2975 360 c-3 -5 -2 -10 4 -10 5 0 13 5 16 10 3 6 2 10 -4 10 -5 0
-13 -4 -16 -10z" />
                <path d="M3055 360 c-3 -5 -2 -10 4 -10 10 0 27 -38 23 -52 -3 -12 16 -10 23
2 3 6 2 10 -4 10 -10 0 -27 38 -23 53 3 11 -16 9 -23 -3z" />
                <path d="M2933 344 c0 -16 13 -19 21 -5 3 5 0 11 -7 14 -8 3 -14 -1 -14 -9z" />
                <path d="M2887 324 c2 -7 11 -10 19 -7 19 7 18 10 -5 16 -13 3 -18 1 -14 -9z" />
                <path d="M2986 331 c-3 -5 0 -11 7 -14 8 -3 14 1 14 9 0 16 -13 19 -21 5z" />
                <path d="M2946 311 c-3 -5 0 -11 7 -14 8 -3 14 1 14 9 0 16 -13 19 -21 5z" />
                <path d="M2900 291 c0 -6 5 -13 12 -17 6 -4 8 -3 4 4 -3 5 0 13 6 15 8 3 6 6
-4 6 -10 1 -18 -3 -18 -8z" />
                <path d="M3013 274 c0 -16 13 -19 21 -5 3 5 0 11 -7 14 -8 3 -14 -1 -14 -9z" />
                <path d="M2972 251 c-11 -7 -10 -9 3 -14 9 -4 14 -3 10 2 -3 5 1 12 7 14 7 3
9 6 3 6 -5 0 -16 -3 -23 -8z" />
                <path d="M2910 224 l-25 -15 25 7 c14 3 29 10 35 15 15 14 -7 10 -35 -7z" />
                <path d="M2937 197 c-3 -8 1 -14 8 -14 7 0 11 6 8 14 -6 16 -10 16 -16 0z" />
                <path d="M3013 190 c-35 -14 -27 -20 10 -8 17 6 34 13 36 14 8 7 -24 3 -46 -6z" />
                <path d="M3059 173 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8 -17
-17z" />
                <path d="M2678 1403 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z" />
                <path d="M2648 1363 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z" />
                <path d="M2653 1313 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z" />
                <path d="M2607 1286 c-5 -12 0 -16 21 -15 16 0 21 3 12 6 -8 3 -18 10 -21 15
-3 5 -9 3 -12 -6z" />
                <path d="M2613 1233 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z" />
                <path d="M2580 1186 c0 -2 7 -6 15 -10 8 -3 15 -1 15 4 0 6 -7 10 -15 10 -8 0
-15 -2 -15 -4z" />
                <path d="M2608 1143 c12 -2 32 -2 45 0 12 2 2 4 -23 4 -25 0 -35 -2 -22 -4z" />
                <path d="M2548 1113 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z" />
                <path d="M2592 1100 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z" />
                <path d="M2653 1103 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z" />
                <path d="M2523 1063 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z" />
                <path d="M2663 1053 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z" />
                <path d="M2538 993 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z" />
                <path d="M2582 980 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z" />
                <path d="M2498 943 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z" />
                <path d="M2578 933 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z" />
                <path d="M2571 871 c1 -16 3 -19 6 -9 2 9 14 18 26 20 20 3 19 4 -5 9 -25 6
-28 4 -27 -20z" />
                <path d="M2648 793 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M3631 1546 c2 -2 15 -9 29 -15 24 -11 24 -11 6 3 -16 13 -49 24 -35
12z" />
                <path d="M3516 1502 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6 -4
-9 -8z" />
                <path d="M3438 1483 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M3556 1475 c3 -7 1 -23 -6 -34 -6 -12 -8 -21 -6 -21 3 0 12 13 20 29
13 25 13 30 1 35 -9 3 -12 0 -9 -9z" />
                <path d="M3660 1470 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z" />
                <path d="M3760 1476 c0 -3 9 -10 20 -16 11 -6 20 -8 20 -6 0 3 -9 10 -20 16
-11 6 -20 8 -20 6z" />
                <path d="M3647 1443 c-11 -11 -8 -20 7 -20 8 0 12 6 9 14 -6 15 -7 15 -16 6z" />
                <path d="M3806 1442 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6 -4
-9 -8z" />
                <path d="M3477 1433 c-11 -11 -8 -20 7 -20 8 0 12 6 9 14 -6 15 -7 15 -16 6z" />
                <path d="M3370 1410 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z" />
                <path d="M3733 1408 c-22 -28 -24 -38 -8 -32 9 4 13 9 11 12 -3 3 -1 11 5 19
6 7 9 13 6 13 -2 0 -9 -6 -14 -12z" />
                <path d="M3517 1395 c3 -8 9 -12 14 -9 12 7 11 11 -5 17 -10 4 -13 1 -9 -8z" />
                <path d="M3550 1386 c0 -3 9 -10 20 -16 11 -6 20 -8 20 -6 0 3 -9 10 -20 16
-11 6 -20 8 -20 6z" />
                <path d="M3910 1379 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z" />
                <path d="M3805 1369 c-4 -6 -14 -8 -22 -4 -12 4 -13 3 -5 -8 7 -8 10 -16 7
-18 -2 -3 4 -5 15 -5 13 0 16 4 10 11 -6 7 -5 16 2 23 7 7 9 12 6 12 -4 0 -10
-5 -13 -11z" />
                <path d="M3596 1352 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z" />
                <path d="M3685 1330 c-4 -6 -11 -8 -16 -5 -5 4 -9 4 -9 1 0 -3 8 -10 18 -15
14 -7 18 -6 18 10 0 22 -2 23 -11 9z" />
                <path d="M3870 1315 c-7 -9 -11 -17 -9 -20 3 -2 10 5 17 15 14 24 10 26 -8 5z" />
                <path d="M3740 1270 c-6 -11 -8 -20 -6 -20 3 0 10 9 16 20 6 11 8 20 6 20 -3
0 -10 -9 -16 -20z" />
                <path d="M3816 1231 c-3 -5 1 -11 9 -14 9 -4 12 -1 8 9 -6 16 -10 17 -17 5z" />
                <path d="M3846 1202 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6 -4
-9 -8z" />
                <path d="M2325 1370 c9 -17 14 -34 11 -39 -3 -4 1 -8 9 -8 19 0 19 -1 -6 41
-26 44 -36 48 -14 6z" />
                <path d="M2430 1370 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z" />
                <path d="M2286 1347 c3 -10 9 -15 12 -12 3 3 0 11 -7 18 -10 9 -11 8 -5 -6z" />
                <path d="M2397 1227 c-3 -8 1 -14 9 -14 16 0 19 13 5 21 -5 3 -11 0 -14 -7z" />
                <path d="M2415 1170 c-3 -6 1 -7 9 -4 18 7 21 14 7 14 -6 0 -13 -4 -16 -10z" />
                <path d="M1230 1251 c0 -6 4 -13 10 -16 6 -3 7 1 4 9 -7 18 -14 21 -14 7z" />
                <path d="M1170 1211 c0 -6 4 -13 10 -16 6 -3 7 1 4 9 -7 18 -14 21 -14 7z" />
                <path d="M1285 1180 c10 -11 20 -20 23 -20 3 0 -3 9 -13 20 -10 11 -20 20 -23
20 -3 0 3 -9 13 -20z" />
                <path d="M1196 1165 c4 -8 11 -15 16 -15 6 0 5 6 -2 15 -7 8 -14 15 -16 15 -2
0 -1 -7 2 -15z" />
                <path d="M1243 1153 c-13 -8 -23 -22 -23 -30 0 -15 8 -9 39 30 16 21 13 21
-16 0z" />
                <path d="M4321 1454 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M4303 1412 c-7 -4 -9 -13 -4 -21 6 -9 10 -7 14 8 3 12 4 21 4 21 -1
0 -7 -4 -14 -8z" />
                <path d="M1878 1413 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M1866 1385 c-3 -8 -1 -15 4 -15 6 0 10 7 10 15 0 8 -2 15 -4 15 -2 0
-6 -7 -10 -15z" />
                <path d="M1940 1380 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z" />
                <path d="M1711 1354 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M1961 1344 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M2019 1351 c8 -5 11 -16 8 -25 -3 -8 -2 -18 2 -21 5 -2 11 9 13 25 4
25 1 30 -16 30 -16 0 -18 -2 -7 -9z" />
                <path d="M2081 1343 c-18 -19 -11 -22 17 -8 16 9 19 14 10 17 -7 3 -19 -1 -27
-9z" />
                <path d="M1658 1325 c2 -14 6 -25 8 -25 2 0 4 11 4 25 0 14 -4 25 -9 25 -4 0
-6 -11 -3 -25z" />
                <path d="M1882 1305 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z" />
                <path d="M1970 1310 c0 -8 5 -22 10 -30 9 -13 10 -13 10 0 0 8 -5 22 -10 30
-9 13 -10 13 -10 0z" />
                <path d="M1716 1285 c-3 -8 -1 -15 4 -15 6 0 10 7 10 15 0 8 -2 15 -4 15 -2 0
-6 -7 -10 -15z" />
                <path d="M1925 1280 c-16 -7 -17 -9 -3 -9 9 -1 20 4 23 9 7 11 7 11 -20 0z" />
                <path d="M2100 1270 c6 -11 13 -20 16 -20 2 0 0 9 -6 20 -6 11 -13 20 -16 20
-2 0 0 -9 6 -20z" />
                <path d="M1866 1261 c-4 -5 3 -7 14 -4 23 6 26 13 6 13 -8 0 -17 -4 -20 -9z" />
                <path d="M1661 1244 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M1781 1234 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M1821 1241 c-8 -5 -9 -11 -3 -15 5 -3 12 1 16 9 6 17 6 18 -13 6z" />
                <path d="M1945 1240 c-13 -6 -15 -9 -5 -9 8 0 22 4 30 9 18 12 2 12 -25 0z" />
                <path d="M2173 1244 c9 -15 -19 -38 -34 -29 -8 6 -8 2 0 -14 7 -11 14 -21 17
-21 3 0 3 4 -1 9 -3 5 5 17 17 25 18 13 20 18 9 28 -8 8 -11 8 -8 2z" />
                <path d="M1716 1232 c6 -4 14 -16 18 -27 6 -16 5 -18 -5 -7 -18 17 -30 15 -23
-3 9 -22 31 -18 45 6 8 15 8 19 0 15 -6 -4 -11 0 -11 8 0 9 -8 16 -17 16 -11
0 -14 -3 -7 -8z" />
                <path d="M1679 1199 c5 -15 8 -29 5 -32 -3 -2 2 -7 10 -10 13 -5 13 -2 4 21
-16 36 -32 54 -19 21z" />
                <path d="M1956 1201 c-4 -5 3 -7 14 -4 23 6 26 13 6 13 -8 0 -17 -4 -20 -9z" />
                <path d="M1920 1190 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z" />
                <path d="M2094 1170 c0 -13 4 -16 10 -10 7 7 7 13 0 20 -6 6 -10 3 -10 -10z" />
                <path d="M2056 1137 c3 -10 9 -15 12 -12 3 3 0 11 -7 18 -10 9 -11 8 -5 -6z" />
                <path d="M1930 1126 c0 -2 7 -6 15 -10 8 -3 15 -1 15 4 0 6 -7 10 -15 10 -8 0
-15 -2 -15 -4z" />
                <path d="M2008 1103 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M2070 1101 c0 -5 7 -15 17 -22 15 -13 15 -12 4 9 -12 23 -21 28 -21
13z" />
                <path d="M2265 1080 c9 -16 18 -30 21 -30 2 0 -2 14 -11 30 -9 17 -18 30 -21
30 -2 0 2 -13 11 -30z" />
                <path d="M1914 1068 l-19 -23 25 20 c14 11 27 21 29 22 2 2 0 3 -6 3 -5 0 -18
-10 -29 -22z" />
                <path d="M1976 1050 c10 -16 19 -28 21 -26 5 5 -22 56 -30 56 -5 0 0 -13 9
-30z" />
                <path d="M2214 1048 l-19 -23 23 19 c21 18 27 26 19 26 -2 0 -12 -10 -23 -22z" />
                <path d="M1675 1050 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z" />
                <path d="M1839 1043 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8 -17
-17z" />
                <path d="M2154 1048 c-4 -7 -4 -10 1 -6 4 4 14 0 22 -10 13 -15 13 -15 3 6
-12 25 -16 27 -26 10z" />
                <path d="M2116 1027 c3 -10 9 -15 12 -12 3 3 0 11 -7 18 -10 9 -11 8 -5 -6z" />
                <path d="M2280 1015 c-7 -8 -16 -12 -21 -9 -5 3 -9 1 -9 -5 0 -19 15 -17 37 6
12 13 18 23 14 23 -5 0 -14 -7 -21 -15z" />
                <path d="M2010 985 c0 -5 5 -17 10 -25 5 -8 10 -10 10 -5 0 6 -5 17 -10 25 -5
8 -10 11 -10 5z" />
                <path d="M2215 960 c-16 -17 -16 -20 -3 -15 9 4 19 13 22 21 7 19 2 18 -19 -6z" />
                <path d="M1961 904 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M1996 907 c3 -10 9 -15 12 -12 3 3 0 11 -7 18 -10 9 -11 8 -5 -6z" />
                <path d="M2132 906 c-22 -12 -22 -13 -6 -27 13 -10 16 -10 10 -1 -5 8 -1 19
10 27 24 18 16 18 -14 1z" />
                <path d="M2046 883 c-8 -20 -5 -22 15 -14 14 5 15 8 4 18 -10 10 -15 9 -19 -4z" />
                <path d="M1925 880 c4 -6 11 -8 16 -5 5 4 9 -8 9 -26 0 -30 1 -31 22 -17 12 8
24 21 26 29 2 8 -2 6 -8 -3 -14 -22 -30 -23 -30 -2 0 9 5 13 13 9 6 -4 3 1 -7
9 -22 18 -51 22 -41 6z" />
                <path d="M2135 840 c-3 -6 1 -7 9 -4 18 7 21 14 7 14 -6 0 -13 -4 -16 -10z" />
                <path d="M2015 830 c-19 -8 -19 -9 3 -9 12 -1 22 4 22 9 0 6 -1 10 -2 9 -2 0
-12 -4 -23 -9z" />
                <path d="M2080 821 l-25 -7 25 -7 c21 -6 22 -9 10 -17 -13 -8 -13 -10 1 -10
12 0 16 8 15 25 0 14 -1 25 -1 24 0 -1 -11 -4 -25 -8z" />
                <path d="M4150 1360 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z" />
                <path d="M4193 1304 c4 -4 2 -13 -5 -21 -8 -11 -7 -12 5 -7 10 3 17 -1 20 -13
3 -10 4 -6 4 9 -1 15 -8 30 -16 33 -9 3 -12 3 -8 -1z" />
                <path d="M4161 1252 c-1 -21 -2 -21 -23 -8 -22 14 -23 14 -23 -10 0 -20 2 -22
11 -10 8 12 14 12 22 4 8 -8 13 -7 18 5 3 9 4 22 1 29 -3 7 -6 3 -6 -10z" />
                <path d="M4013 1228 c-22 -28 -24 -38 -8 -32 9 4 13 9 11 12 -3 3 -1 11 5 19
6 7 9 13 6 13 -2 0 -9 -6 -14 -12z" />
                <path d="M4200 1207 c0 -7 9 -13 20 -13 11 0 20 1 20 3 0 1 -9 7 -20 13 -15 8
-20 8 -20 -3z" />
                <path d="M4030 1192 c0 -5 7 -9 15 -9 8 0 12 4 9 9 -3 4 -9 8 -15 8 -5 0 -9
-4 -9 -8z" />
                <path d="M4090 1187 c-17 -14 -26 -42 -10 -32 9 6 34 45 28 45 -2 0 -10 -6
-18 -13z" />
                <path d="M4141 1163 c-1 -7 -7 -11 -13 -9 -7 1 -10 1 -5 -1 4 -3 7 -12 7 -21
1 -15 2 -15 11 1 6 10 8 23 5 30 -3 9 -5 9 -5 0z" />
                <path d="M4191 1154 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M4221 1154 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M3990 1125 c-7 -9 -8 -15 -2 -15 5 0 12 7 16 15 3 8 4 15 2 15 -2 0
-9 -7 -16 -15z" />
                <path d="M4191 1114 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M4035 1100 c-4 -6 -11 -7 -17 -4 -7 4 -8 2 -4 -4 4 -6 3 -20 -3 -30
-7 -14 -6 -18 10 -18 11 0 15 4 10 9 -6 6 -4 19 6 33 8 13 13 24 10 24 -3 0
-9 -5 -12 -10z" />
                <path d="M4241 1094 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M4170 1040 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z" />
                <path d="M4660 1365 c0 -14 4 -25 9 -25 5 0 7 9 4 19 -3 13 1 21 14 24 15 4
14 5 -4 6 -18 1 -23 -4 -23 -24z" />
                <path d="M4563 1358 c-7 -7 -8 -19 -4 -26 5 -9 13 -7 27 9 10 13 14 19 7 16
-6 -4 -13 -2 -15 4 -2 7 -8 7 -15 -3z" />
                <path d="M4760 1366 c0 -2 7 -6 15 -10 8 -3 15 -1 15 4 0 6 -7 10 -15 10 -8 0
-15 -2 -15 -4z" />
                <path d="M4915 1360 c27 -12 43 -12 25 0 -8 5 -22 9 -30 9 -10 0 -8 -3 5 -9z" />
                <path d="M4730 1343 c0 -7 8 -16 18 -21 19 -11 45 -5 37 8 -3 5 -13 6 -21 3
-9 -3 -20 0 -25 8 -6 9 -9 10 -9 2z" />
                <path d="M4517 1322 c-10 -10 -17 -23 -17 -28 0 -5 5 -1 11 9 6 9 14 15 20 12
5 -4 9 1 9 9 0 20 -3 20 -23 -2z" />
                <path d="M4595 1330 c-3 -5 -2 -10 4 -10 5 0 13 5 16 10 3 6 2 10 -4 10 -5 0
-13 -4 -16 -10z" />
                <path d="M4645 1320 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z" />
                <path d="M4685 1314 c-6 -2 -9 -24 -7 -49 2 -25 8 -42 13 -39 5 3 7 9 4 14 -3
5 4 19 15 30 15 15 28 19 48 15 19 -5 23 -4 12 3 -26 17 -63 25 -56 13 4 -6 0
-11 -9 -11 -11 0 -15 5 -11 15 3 8 4 15 3 14 -1 0 -7 -2 -12 -5z" />
                <path d="M4475 1289 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z" />
                <path d="M4856 1285 c4 -8 8 -15 10 -15 2 0 4 7 4 15 0 8 -4 15 -10 15 -5 0
-7 -7 -4 -15z" />
                <path d="M4436 1262 l-19 -27 24 22 c12 12 21 24 18 27 -2 2 -13 -8 -23 -22z" />
                <path d="M4880 1276 c0 -2 8 -10 18 -17 15 -13 16 -12 3 4 -13 16 -21 21 -21
13z" />
                <path d="M4930 1276 c0 -2 7 -7 16 -10 8 -3 12 -2 9 4 -6 10 -25 14 -25 6z" />
                <path d="M4813 1248 c-1 -11 1 -16 5 -12 4 5 11 12 15 15 5 3 2 9 -5 12 -9 3
-14 -3 -15 -15z" />
                <path d="M5006 1261 c-12 -5 -15 -10 -9 -14 6 -4 16 0 23 8 14 17 13 17 -14 6z" />
                <path d="M4442 1229 c-30 -27 -32 -31 -17 -45 9 -9 17 -15 18 -13 1 2 11 15
22 29 l20 25 -23 -19 c-12 -11 -25 -16 -29 -13 -9 9 38 58 48 51 5 -3 9 0 9 5
0 18 -13 12 -48 -20z" />
                <path d="M4543 1250 c1 -4 -17 -26 -41 -49 -24 -24 -41 -45 -39 -47 2 -2 12 5
22 16 20 22 45 27 45 8 0 -6 3 -8 6 -5 4 4 2 13 -5 20 -9 11 -8 17 2 26 8 6
18 7 22 3 5 -4 5 -2 1 5 -3 6 2 16 11 22 16 9 16 10 -4 8 -12 0 -21 -4 -20 -7z" />
                <path d="M4630 1230 c0 -16 4 -30 8 -30 5 0 7 14 4 30 -2 17 -6 30 -8 30 -2 0
-4 -13 -4 -30z" />
                <path d="M4920 1249 c0 -9 -7 -24 -16 -35 -8 -10 -13 -14 -10 -7 9 18 -7 23
-22 7 -8 -9 -9 -14 -2 -14 6 0 9 -4 6 -9 -4 -5 3 -7 13 -4 20 5 49 59 37 70
-3 3 -6 0 -6 -8z" />
                <path d="M4722 1234 c-14 -16 -5 -18 17 -5 7 5 9 11 5 14 -5 3 -15 -1 -22 -9z" />
                <path d="M4842 1225 c-6 -14 -17 -25 -24 -25 -9 0 -8 -3 2 -10 19 -13 33 -13
25 0 -3 5 -1 19 5 31 7 11 10 23 7 25 -2 2 -9 -7 -15 -21z" />
                <path d="M4390 1225 c-7 -9 -10 -18 -7 -21 3 -3 10 4 17 15 13 25 8 27 -10 6z" />
                <path d="M4723 1212 c-18 -11 -1 -30 20 -23 16 6 17 9 5 18 -7 7 -19 9 -25 5z" />
                <path d="M5045 1200 c10 -11 20 -20 23 -20 3 0 -3 9 -13 20 -10 11 -20 20 -23
20 -3 0 3 -9 13 -20z" />
                <path d="M4671 1180 c-11 -26 -11 -34 -1 -43 10 -9 11 -9 6 1 -4 7 -2 19 4 27
6 8 10 21 8 30 -2 11 -8 5 -17 -15z" />
                <path d="M4559 1181 c9 -6 11 -18 7 -35 -5 -19 -3 -24 8 -20 8 3 12 13 9 25
-3 12 0 19 8 20 8 0 5 4 -6 9 -27 11 -44 12 -26 1z" />
                <path d="M4626 1174 c-4 -9 -4 -19 -1 -22 2 -3 7 3 11 12 4 9 4 19 1 22 -2 3
-7 -3 -11 -12z" />
                <path d="M4366 1167 c3 -9 0 -25 -7 -35 -7 -9 1 -4 19 12 31 29 46 50 19 27
-10 -8 -17 -7 -26 2 -10 9 -11 8 -5 -6z" />
                <path d="M4721 1154 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M5085 1150 c10 -11 20 -20 23 -20 3 0 -3 9 -13 20 -10 11 -20 20 -23
20 -3 0 3 -9 13 -20z" />
                <path d="M4406 1141 c-16 -18 -16 -19 1 -17 11 0 17 -5 15 -14 -3 -12 0 -12
15 1 10 9 25 14 33 12 13 -4 13 -3 0 6 -9 6 -18 7 -26 0 -14 -12 -29 5 -19 21
10 16 -1 11 -19 -9z" />
                <path d="M4516 1145 c4 -8 8 -15 10 -15 2 0 4 7 4 15 0 8 -4 15 -10 15 -5 0
-7 -7 -4 -15z" />
                <path d="M4850 1149 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z" />
                <path d="M4951 1140 c-1 -26 15 -50 33 -50 5 0 3 6 -6 13 -9 6 -19 23 -21 37
l-4 25 -2 -25z" />
                <path d="M4605 1120 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z" />
                <path d="M4506 1105 c4 -10 0 -15 -12 -16 -11 0 -14 -3 -7 -6 9 -3 10 -10 3
-22 -6 -12 -5 -18 3 -18 7 0 13 7 14 16 1 9 4 26 8 39 5 13 3 22 -4 22 -5 0
-8 -7 -5 -15z" />
                <path d="M4325 1090 c-2 -3 10 -7 26 -8 16 -1 29 1 29 6 0 9 -49 11 -55 2z" />
                <path d="M4595 1085 c-3 -8 -7 -22 -10 -31 -3 -8 -10 -12 -16 -8 -8 5 -9 3 -4
-6 4 -7 2 -15 -5 -20 -8 -5 -8 -9 4 -13 9 -4 15 -2 13 2 -1 5 3 8 8 8 6 -1 9
-8 9 -14 -2 -19 4 -16 16 7 8 16 8 20 -2 18 -7 -2 -13 3 -12 10 3 43 4 43 24
32 26 -14 25 -9 0 13 -18 15 -21 15 -25 2z" />
                <path d="M4712 1080 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z" />
                <path d="M4827 1088 c-3 -8 5 -14 20 -14 13 -1 23 -1 21 0 -2 1 -10 7 -19 14
-13 10 -18 10 -22 0z" />
                <path d="M4530 1086 c0 -2 7 -7 16 -10 8 -3 12 -2 9 4 -6 10 -25 14 -25 6z" />
                <path d="M5014 1076 c11 -9 24 -16 30 -16 12 0 7 5 -24 19 -24 11 -24 11 -6
-3z" />
                <path d="M4363 1042 c-7 -8 -25 -29 -39 -48 -15 -19 -34 -34 -43 -34 -10 0
-17 -8 -17 -19 0 -16 4 -17 23 -8 13 6 21 12 18 15 -8 8 15 31 28 28 7 -1 9
-1 5 1 -12 7 11 43 25 39 6 -1 8 -1 4 2 -15 8 14 30 33 25 23 -6 23 -4 8 -40
-17 -42 -17 -52 -3 -46 8 2 12 10 9 18 -3 7 1 19 9 26 7 8 12 20 9 28 -3 8 0
11 5 8 5 -3 10 0 10 7 0 17 -66 15 -84 -2z" />
                <path d="M4840 1045 c0 -8 5 -15 10 -15 6 0 10 7 10 15 0 8 -4 15 -10 15 -5 0
-10 -7 -10 -15z" />
                <path d="M4936 1037 c3 -10 9 -15 12 -12 3 3 0 11 -7 18 -10 9 -11 8 -5 -6z" />
                <path d="M4701 1019 c-1 -17 5 -29 15 -33 13 -5 14 -3 6 6 -5 7 -12 22 -15 33
-4 16 -5 14 -6 -6z" />
                <path d="M4796 1027 c2 -7 15 -13 29 -13 33 -2 32 2 -4 14 -22 8 -29 8 -25 -1z" />
                <path d="M4867 1013 c-4 -3 -7 -11 -7 -17 0 -6 5 -5 12 2 6 6 9 14 7 17 -3 3
-9 2 -12 -2z" />
                <path d="M5244 975 c24 -31 25 -37 14 -54 -10 -14 -18 -17 -28 -10 -22 13 -34
11 -22 -3 7 -10 4 -20 -13 -40 -21 -25 -24 -26 -45 -11 -21 15 -22 15 -15 -7
5 -15 1 -28 -16 -46 -12 -13 -18 -24 -12 -24 6 0 22 13 36 29 14 17 27 28 30
25 2 -3 16 9 30 26 14 16 30 30 35 30 5 0 18 10 30 23 l22 23 -26 37 c-13 20
-30 37 -36 37 -6 0 2 -16 16 -35z" />
                <path d="M4882 980 c-16 -26 -15 -41 2 -34 7 3 14 16 14 30 0 29 0 29 -16 4z" />
                <path d="M4921 991 c-8 -5 -9 -11 -3 -15 5 -3 12 1 16 9 6 17 6 18 -13 6z" />
                <path d="M4445 980 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7
-4 -4 -10z" />
                <path d="M4489 951 c-6 -17 -15 -28 -20 -25 -5 3 -6 -2 -3 -10 3 -8 12 -12 20
-9 8 3 12 8 10 12 -2 3 -1 14 3 23 4 13 10 15 21 8 9 -6 11 -13 5 -17 -15 -12
-17 -40 -2 -40 7 0 13 7 13 16 1 9 5 25 9 35 6 13 5 17 -2 13 -6 -4 -19 0 -27
9 -15 14 -17 13 -27 -15z" />
                <path d="M4580 970 c0 -5 9 -14 20 -20 11 -6 20 -9 20 -8 0 2 -9 11 -20 21
-11 9 -20 13 -20 7z" />
                <path d="M5115 950 c-10 -11 -24 -20 -32 -20 -7 0 -13 -7 -13 -15 0 -13 4 -13
28 2 15 10 29 20 32 24 3 3 14 11 25 17 20 11 20 11 -1 12 -11 0 -29 -9 -39
-20z" />
                <path d="M4686 945 c-3 -8 -1 -15 4 -15 6 0 10 7 10 15 0 8 -2 15 -4 15 -2 0
-6 -7 -10 -15z" />
                <path d="M4840 935 c33 -19 49 -19 24 0 -10 8 -26 14 -34 14 -9 0 -4 -6 10
-14z" />
                <path d="M4576 924 c-3 -8 -11 -12 -17 -8 -8 4 -9 3 -5 -4 4 -7 14 -12 22 -12
8 0 13 4 10 9 -4 5 -1 11 6 13 8 3 9 6 1 11 -6 4 -14 0 -17 -9z" />
                <path d="M4638 928 c5 -5 16 -8 23 -6 8 3 3 7 -10 11 -17 4 -21 3 -13 -5z" />
                <path d="M4897 923 c-4 -3 -7 -13 -7 -22 1 -13 3 -13 11 2 11 19 8 33 -4 20z" />
                <path d="M4327 909 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 -14 6 -15 5 -6 -5z" />
                <path d="M4370 916 c0 -2 7 -7 16 -10 8 -3 12 -2 9 4 -6 10 -25 14 -25 6z" />
                <path d="M4612 915 c4 -4 -7 -21 -23 -36 -17 -16 -27 -29 -22 -29 5 0 19 9 30
19 12 11 24 17 29 13 4 -4 3 -1 -1 7 -6 11 -4 13 8 8 25 -9 21 0 -5 14 -13 6
-20 8 -16 4z" />
                <path d="M4685 910 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7
-4 -4 -10z" />
                <path d="M5166 905 c-11 -8 -15 -15 -9 -15 6 0 16 7 23 15 16 19 11 19 -14 0z" />
                <path d="M4727 891 c-4 -17 -3 -21 5 -13 5 5 8 16 6 23 -3 8 -7 3 -11 -10z" />
                <path d="M4843 889 c-3 -11 -9 -17 -12 -12 -3 5 -14 1 -23 -9 -10 -10 -13 -18
-8 -18 6 0 8 -12 5 -27 -3 -16 -3 -23 1 -16 3 7 13 9 22 6 13 -4 14 -3 3 5 -7
5 -10 15 -7 21 4 6 2 11 -5 11 -7 0 -10 3 -7 6 4 3 16 1 27 -5 17 -10 20 -9
15 4 -4 8 -1 15 5 15 6 0 11 9 11 20 0 26 -20 26 -27 -1z" />
                <path d="M4666 891 c-4 -6 -2 -11 3 -11 6 0 11 -5 11 -11 0 -5 -4 -8 -9 -4 -5
3 -13 0 -17 -6 -4 -8 -3 -9 4 -5 8 5 12 0 12 -13 0 -15 -5 -19 -17 -15 -16 5
-16 4 0 -6 22 -14 25 -12 31 25 6 33 -7 65 -18 46z" />
                <path d="M4312 874 c-7 -8 -9 -14 -5 -15 4 0 0 -3 -9 -7 -12 -5 -15 -11 -8
-21 7 -12 11 -10 21 12 6 14 19 28 28 29 14 3 14 4 1 10 -8 3 -21 -1 -28 -8z" />
                <path d="M4757 882 c-3 -4 -2 -15 2 -24 6 -17 7 -17 18 1 10 15 9 20 -2 25 -8
3 -16 2 -18 -2z" />
                <path d="M4508 868 c5 -5 16 -8 23 -6 8 3 3 7 -10 11 -17 4 -21 3 -13 -5z" />
                <path d="M4398 853 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M4701 837 c-13 -21 -12 -21 5 -5 10 10 16 20 13 22 -3 3 -11 -5 -18
-17z" />
                <path d="M4355 840 c3 -5 14 -10 23 -10 15 0 15 2 2 10 -20 13 -33 13 -25 0z" />
                <path d="M4870 846 c0 -2 8 -10 18 -17 15 -13 16 -12 3 4 -13 16 -21 21 -21
13z" />
                <path d="M4560 830 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z" />
                <path d="M4717 824 c-3 -4 -2 -15 4 -26 5 -10 7 -23 4 -28 -3 -6 -2 -10 3 -10
6 0 15 14 21 30 6 18 6 30 0 30 -5 0 -9 -5 -9 -11 0 -5 -5 -7 -10 -4 -6 4 -8
11 -5 16 7 10 2 12 -8 3z" />
                <path d="M5042 818 c-7 -7 -12 -16 -12 -21 0 -5 7 -1 16 8 9 9 14 18 12 20 -2
3 -10 -1 -16 -7z" />
                <path d="M4340 816 c0 -2 7 -7 16 -10 8 -3 12 -2 9 4 -6 10 -25 14 -25 6z" />
                <path d="M4463 792 c-3 -12 -9 -22 -12 -22 -4 0 -8 -7 -8 -15 0 -8 2 -15 3
-15 8 0 35 63 29 68 -3 3 -8 -4 -12 -16z" />
                <path d="M4545 800 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7
-4 -4 -10z" />
                <path d="M4634 789 c0 -23 3 -23 21 -5 12 12 12 15 -3 18 -12 4 -18 -1 -18
-13z" />
                <path d="M4685 799 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z" />
                <path d="M4893 793 c-3 -10 -8 -22 -11 -27 -3 -5 0 -6 5 -3 11 7 25 47 17 47
-3 0 -7 -8 -11 -17z" />
                <path d="M4387 786 c-4 -10 -1 -13 8 -9 8 3 12 9 9 14 -7 12 -11 11 -17 -5z" />
                <path d="M4533 760 c-1 -11 2 -20 5 -20 4 0 8 9 9 20 1 11 -2 20 -5 20 -4 0
-8 -9 -9 -20z" />
                <path d="M4477 763 c-12 -11 -8 -21 13 -26 11 -3 18 -1 14 4 -3 5 1 9 8 9 9 0
9 3 -2 10 -18 12 -24 12 -33 3z" />
                <path d="M5030 761 c0 -6 4 -13 10 -16 6 -3 7 1 4 9 -7 18 -14 21 -14 7z" />
                <path d="M4595 750 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7
-4 -4 -10z" />
                <path d="M4713 743 c4 -3 2 -12 -4 -20 -9 -9 -8 -13 0 -13 6 0 11 2 11 4 0 2
3 11 6 20 4 10 1 16 -7 16 -7 0 -9 -3 -6 -7z" />
                <path d="M5065 741 c-3 -5 -2 -12 3 -15 5 -3 9 1 9 9 0 17 -3 19 -12 6z" />
                <path d="M4817 727 c-3 -9 -14 -17 -24 -17 -15 0 -16 -2 -3 -10 11 -7 11 -10
2 -10 -7 0 -10 -5 -6 -11 4 -8 10 -5 17 7 6 11 15 22 20 25 5 4 7 13 5 20 -3
9 -6 8 -11 -4z" />
                <path d="M4516 715 c-9 -26 -7 -32 5 -12 6 10 9 21 6 23 -2 3 -7 -2 -11 -11z" />
                <path d="M4546 695 c4 -8 10 -12 15 -9 11 6 2 24 -11 24 -5 0 -7 -7 -4 -15z" />
                <path d="M5124 696 c10 -8 23 -17 29 -19 6 -2 6 -12 -2 -27 -11 -24 -11 -24 3
-6 22 28 20 33 -16 51 -28 14 -30 14 -14 1z" />
                <path d="M4708 693 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M4638 673 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M4683 672 c-8 -5 -7 -11 3 -19 15 -14 27 -3 16 14 -4 7 -13 9 -19 5z" />
                <path d="M4595 650 c-4 -6 -11 -7 -17 -4 -7 4 -8 2 -4 -4 10 -16 23 -15 30 3
6 17 0 20 -9 5z" />
                <path d="M4620 630 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z" />
                <path d="M4655 610 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7
-4 -4 -10z" />
                <path d="M4850 573 c0 -11 3 -14 8 -7 4 6 14 14 22 17 10 4 8 6 -7 6 -16 1
-23 -5 -23 -16z" />
                <path d="M4687 569 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 -14 6 -15 5 -6 -5z" />
                <path d="M4833 536 c0 -8 6 -12 14 -9 7 3 10 9 7 14 -8 14 -21 11 -21 -5z" />
                <path d="M4959 539 c-11 -7 -10 -9 3 -9 9 0 19 -8 21 -17 4 -17 5 -17 6 0 2
31 21 18 22 -15 2 -28 2 -29 6 -8 3 14 9 28 14 31 5 3 -6 10 -25 16 -19 6 -40
7 -47 2z" />
                <path d="M5075 520 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z" />
                <path d="M4770 500 c0 -5 7 -10 15 -10 8 0 15 5 15 10 0 6 -7 10 -15 10 -8 0
-15 -4 -15 -10z" />
                <path d="M4913 503 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z" />
                <path d="M4975 430 c27 -12 35 -12 35 0 0 6 -12 10 -27 9 -25 0 -26 -1 -8 -9z" />
                <path d="M5001 383 c1 -23 2 -24 6 -6 2 13 13 24 26 26 18 4 17 5 -5 6 -24 1
-28 -3 -27 -26z" />
                <path d="M3953 965 c0 -8 4 -12 9 -9 5 3 6 10 3 15 -9 13 -12 11 -12 -6z" />
                <path d="M3799 896 c19 -20 37 -36 39 -36 8 0 -44 59 -58 65 -8 3 1 -10 19
-29z" />
                <path d="M3899 908 c11 -15 11 -22 -3 -45 l-17 -28 22 25 c12 14 25 24 30 23
5 -2 6 4 2 13 -3 8 -8 12 -11 10 -3 -3 -12 0 -21 7 -14 11 -14 10 -2 -5z" />
                <path d="M3984 903 c4 -7 16 -18 26 -23 16 -9 18 -8 14 5 -4 9 -9 13 -12 11
-3 -3 -12 0 -20 7 -13 9 -14 9 -8 0z" />
                <path d="M3963 864 c9 -11 15 -24 12 -27 -3 -4 -2 -5 2 -2 3 3 13 -1 22 -8 14
-10 14 -10 3 5 -8 9 -10 23 -6 29 4 8 3 9 -5 5 -6 -4 -20 -2 -29 5 -15 12 -15
12 1 -7z" />
                <path d="M3855 826 c10 -14 19 -26 22 -26 7 0 -17 39 -28 46 -6 3 -3 -5 6 -20z" />
                <path d="M4115 839 c-4 -6 -14 -8 -22 -4 -12 4 -13 3 -5 -8 7 -8 9 -17 5 -20
-3 -4 -4 -7 -1 -7 3 0 13 11 22 25 9 14 14 25 12 25 -3 0 -8 -5 -11 -11z" />
                <path d="M3940 826 c0 -2 7 -9 15 -16 9 -7 15 -8 15 -2 0 5 -7 12 -15 16 -8 3
-15 4 -15 2z" />
                <path d="M4050 797 c0 -2 6 -10 14 -16 11 -9 16 -9 22 1 4 7 4 10 -1 6 -4 -4
-14 -3 -22 3 -7 6 -13 9 -13 6z" />
                <path d="M3741 774 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M3805 760 c10 -11 20 -20 23 -20 3 0 -3 9 -13 20 -10 11 -20 20 -23
20 -3 0 3 -9 13 -20z" />
                <path d="M4039 733 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21 -13z" />
                <path d="M3840 719 c0 -6 -7 -8 -16 -5 -8 3 -12 2 -9 -3 9 -15 44 -9 38 6 -6
16 -13 17 -13 2z" />
                <path d="M3975 662 c-5 -19 -8 -22 -20 -12 -9 7 -15 8 -15 2 0 -18 28 -21 43
-4 23 28 27 39 12 39 -7 0 -16 -11 -20 -25z" />
                <path d="M3850 645 l25 -27 -43 -40 -43 -40 -25 23 c-20 18 -22 25 -11 38 11
14 10 14 -6 2 -17 -13 -16 -15 8 -41 14 -14 22 -30 18 -35 -5 -5 3 -1 16 8 19
12 28 14 38 5 11 -9 9 -15 -14 -29 -15 -11 -23 -19 -17 -19 6 0 31 18 55 41
24 22 38 38 32 34 -7 -3 -20 -2 -29 3 -13 7 -13 10 -1 21 10 8 17 9 22 1 3 -5
12 -10 18 -10 7 0 6 4 -3 11 -10 7 -11 12 -4 15 6 3 20 12 30 20 18 14 17 15
-13 9 -29 -6 -32 -4 -27 12 5 15 4 15 -5 3 -6 -8 -11 -10 -11 -4 0 7 -8 15
-17 18 -13 5 -10 -1 7 -19z m10 -94 c0 -4 -3 -11 -7 -14 -8 -9 -34 13 -28 24
6 9 35 1 35 -10z" />
                <path d="M3799 643 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21 -13z" />
                <path d="M3700 633 c0 -6 8 -17 18 -24 16 -13 16 -13 2 6 -8 11 -16 22 -17 24
-2 2 -3 0 -3 -6z" />
                <path d="M2390 970 c0 -11 4 -20 9 -20 5 0 7 9 4 20 -3 11 -7 20 -9 20 -2 0
-4 -9 -4 -20z" />
                <path d="M2418 903 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M2381 874 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M2368 843 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M2310 826 c0 -2 7 -7 16 -10 8 -3 12 -2 9 4 -6 10 -25 14 -25 6z" />
                <path d="M2372 795 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z" />
                <path d="M2308 793 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z" />
                <path d="M2288 773 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M2326 769 c3 -6 0 -16 -7 -21 -12 -8 -11 -9 1 -5 18 4 27 37 10 37
-6 0 -8 -5 -4 -11z" />
                <path d="M2428 773 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M2361 698 c2 -30 2 -30 6 -6 2 15 12 29 21 31 12 3 10 5 -5 6 -20 1
-23 -4 -22 -31z" />
                <path d="M2388 673 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M2557 589 c-12 -10 -17 -26 -14 -41 4 -21 4 -21 6 4 1 18 7 28 21 30
11 2 17 7 12 14 -5 8 -13 5 -25 -7z" />
                <path d="M2605 600 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z" />
                <path d="M2585 514 c0 -29 11 -32 18 -5 3 11 0 22 -7 24 -6 3 -11 -6 -11 -19z" />
                <path d="M2550 500 c0 -11 4 -20 8 -20 4 0 8 9 8 20 0 11 -4 20 -8 20 -4 0 -8
-9 -8 -20z" />
                <path d="M2475 500 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7
-4 -4 -10z" />
                <path d="M2508 503 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M5475 750 c10 -11 20 -20 23 -20 3 0 -3 9 -13 20 -10 11 -20 20 -23
20 -3 0 3 -9 13 -20z" />
                <path d="M5510 706 c0 -2 8 -10 18 -17 15 -13 16 -12 3 4 -13 16 -21 21 -21
13z" />
                <path d="M5430 696 c0 -2 8 -10 18 -17 15 -13 16 -12 3 4 -13 16 -21 21 -21
13z" />
                <path d="M5375 670 c15 -21 25 -25 49 -21 l31 6 -30 3 c-16 2 -39 11 -49 20
-19 17 -19 17 -1 -8z" />
                <path d="M5501 642 c0 -11 2 -12 6 -4 2 6 9 10 13 7 5 -3 11 -2 14 3 2 4 -4 9
-15 9 -12 1 -19 -4 -18 -15z" />
                <path d="M5540 635 c0 -2 6 -8 13 -14 10 -8 14 -7 14 2 0 8 -6 14 -14 14 -7 0
-13 -1 -13 -2z" />
                <path d="M5355 589 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z" />
                <path d="M5614 583 c0 -9 -5 -18 -13 -21 -8 -3 -11 0 -7 6 3 6 1 14 -5 18 -8
4 -9 3 -5 -5 4 -7 -2 -15 -16 -20 -18 -7 -9 -9 40 -12 35 -2 71 -1 80 3 20 8
4 11 -40 8 -21 -1 -27 2 -22 13 3 8 1 18 -4 21 -5 3 -9 -2 -8 -11z" />
                <path d="M5317 523 c-11 -11 -8 -20 7 -20 8 0 12 6 9 14 -6 15 -7 15 -16 6z" />
                <path d="M5730 500 c0 -11 39 -20 45 -10 3 4 -6 10 -20 12 -14 3 -25 2 -25 -2z" />
                <path d="M5165 490 c27 -12 43 -12 25 0 -8 5 -22 9 -30 9 -10 0 -8 -3 5 -9z" />
                <path d="M5702 474 c10 -10 20 -15 24 -12 3 4 -5 12 -18 18 -22 12 -22 12 -6
-6z" />
                <path d="M5215 470 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7
-4 -4 -10z" />
                <path d="M5802 471 c-11 -7 -11 -9 0 -14 9 -3 15 1 15 9 0 8 -1 14 -1 14 -1 0
-7 -4 -14 -9z" />
                <path d="M5280 441 c0 -6 4 -13 10 -16 6 -3 7 1 4 9 -7 18 -14 21 -14 7z" />
                <path d="M5690 439 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z" />
                <path d="M5228 404 c12 -8 22 -25 23 -37 0 -21 1 -21 8 -2 6 14 2 24 -15 37
-12 10 -26 18 -30 18 -5 0 2 -7 14 -16z" />
                <path d="M5707 399 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 -14 6 -15 5 -6 -5z" />
                <path d="M5450 396 c0 -2 7 -6 15 -10 8 -3 15 -1 15 4 0 6 -7 10 -15 10 -8 0
-15 -2 -15 -4z" />
                <path d="M5639 372 c-12 -15 -12 -16 2 -5 13 10 20 9 38 -8 12 -11 18 -26 15
-32 -5 -9 -3 -8 6 0 11 10 18 9 34 -5 11 -9 16 -11 12 -5 -4 7 -27 26 -50 43
-41 27 -45 28 -57 12z" />
                <path d="M5300 376 c0 -2 7 -6 15 -10 8 -3 15 -1 15 4 0 6 -7 10 -15 10 -8 0
-15 -2 -15 -4z" />
                <path d="M5700 376 c0 -2 7 -7 16 -10 8 -3 12 -2 9 4 -6 10 -25 14 -25 6z" />
                <path d="M5388 363 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M5458 353 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M5570 345 c0 -8 -8 -15 -17 -16 -11 0 -13 -3 -5 -6 6 -2 10 -10 6
-16 -3 -7 2 -3 10 7 15 19 22 46 11 46 -3 0 -5 -7 -5 -15z" />
                <path d="M5656 309 c6 -10 -33 -22 -46 -14 -5 3 -7 0 -5 -7 3 -8 14 -14 25
-14 10 0 17 2 15 4 -2 3 5 12 17 22 17 13 18 17 5 17 -9 0 -14 -4 -11 -8z" />
                <path d="M5470 290 c0 -6 7 -10 15 -10 8 0 15 2 15 4 0 2 -7 6 -15 10 -8 3
-15 1 -15 -4z" />
                <path d="M3535 519 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z" />
                <path d="M3600 475 c-7 -8 -16 -12 -21 -9 -5 3 -9 0 -9 -5 0 -17 15 -13 35 9
10 11 16 20 13 20 -3 0 -11 -7 -18 -15z" />
                <path d="M3650 476 c0 -2 8 -10 18 -17 15 -13 16 -12 3 4 -13 16 -21 21 -21
13z" />
                <path d="M3536 421 c-15 -17 -15 -19 1 -32 15 -11 16 -11 6 1 -10 11 -9 17 4
32 9 10 14 18 11 18 -3 0 -12 -8 -22 -19z" />
                <path d="M3603 424 c9 -11 14 -24 10 -27 -3 -4 2 -7 12 -7 10 0 15 3 12 7 -4
3 1 16 10 27 18 21 18 21 -3 4 -19 -17 -21 -17 -39 0 -19 17 -19 16 -2 -4z" />
                <path d="M3687 384 c2 -6 0 -15 -6 -19 -6 -3 -11 -12 -11 -18 0 -7 9 -1 20 13
23 30 25 37 6 37 -8 0 -12 -6 -9 -13z" />
                <path d="M3476 375 c-11 -8 -15 -15 -9 -15 6 0 16 7 23 15 16 19 11 19 -14 0z" />
                <path d="M3569 364 c-23 -25 -23 -26 -2 -13 13 7 25 19 27 26 8 19 2 16 -25
-13z" />
                <path d="M3505 320 l-20 -9 20 0 c17 -1 18 -3 5 -12 -12 -8 -12 -10 -1 -7 8 2
15 12 17 21 1 9 2 17 1 16 -1 0 -11 -4 -22 -9z" />
                <path d="M2169 423 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8 -17
-17z" />
                <path d="M2430 294 c25 -27 47 -49 50 -47 2 2 -18 25 -45 51 l-49 47 44 -51z" />
                <path d="M5890 389 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z" />
                <path d="M5986 323 c-6 -14 -5 -15 5 -6 7 7 10 15 7 18 -3 3 -9 -2 -12 -12z" />
                <path d="M5850 310 c-6 -11 -8 -20 -6 -20 3 0 10 9 16 20 6 11 8 20 6 20 -3 0
-10 -9 -16 -20z" />
                <path d="M5879 297 c7 -10 10 -17 6 -17 -4 0 -2 -6 4 -13 6 -8 7 -18 3 -22 -4
-5 -1 -5 6 -1 10 6 10 11 1 22 -16 20 5 18 39 -3 l27 -17 -25 25 c-14 14 -27
24 -29 22 -2 -1 -13 3 -25 9 -19 10 -20 10 -7 -5z" />
                <path d="M5820 260 c-6 -11 -8 -20 -6 -20 3 0 10 9 16 20 6 11 8 20 6 20 -3 0
-10 -9 -16 -20z" />
                <path d="M5855 234 c-9 -14 -14 -28 -11 -32 3 -3 6 0 6 7 0 8 5 9 19 1 16 -8
19 -7 16 8 -2 9 -4 19 -5 22 -1 3 -2 8 -1 13 2 14 -7 7 -24 -19z" />
                <path d="M5915 240 c-3 -5 -3 -10 2 -10 4 0 1 -5 -7 -10 -9 -6 -10 -10 -3 -10
7 0 17 9 23 20 11 20 -3 30 -15 10z" />
                <path d="M5745 190 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z" />
                <path d="M5770 196 c0 -3 9 -10 20 -16 11 -6 20 -8 20 -6 0 3 -9 10 -20 16
-11 6 -20 8 -20 6z" />
                <path d="M5863 193 c8 -13 -19 -37 -32 -29 -6 4 -8 -2 -6 -14 5 -28 -5 -51
-19 -43 -8 4 -8 2 1 -7 9 -10 16 -8 35 10 12 13 16 19 8 15 -9 -5 -8 0 4 14
23 26 28 48 14 58 -6 3 -8 1 -5 -4z" />
                <path d="M5893 175 c4 -5 0 -17 -10 -27 -9 -10 -13 -18 -8 -18 4 0 2 -7 -5
-15 -7 -8 -8 -15 -3 -15 5 0 17 14 27 30 9 17 22 28 27 25 5 -4 9 -4 9 -1 0 3
-10 11 -22 17 -13 6 -20 8 -15 4z" />
                <path d="M5847 73 c3 -7 6 -13 8 -13 2 0 5 6 8 13 3 8 -1 14 -8 14 -7 0 -11
-6 -8 -14z" />
                <path d="M1268 4383 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M3714 4369 c-19 -22 -19 -22 4 -8 12 8 22 17 22 21 0 12 -6 9 -26
-13z" />
                <path d="M4165 4379 c-4 -6 -13 -8 -21 -5 -8 3 -11 0 -7 -9 3 -8 -2 -18 -11
-21 -9 -3 -16 -11 -16 -17 0 -5 9 -2 19 7 21 19 46 13 35 -7 -4 -7 5 -1 19 12
15 14 27 27 27 29 0 3 -9 -3 -19 -12 -22 -20 -40 -4 -21 19 7 8 10 15 7 15 -3
0 -9 -5 -12 -11z" />
                <path d="M4880 4375 c0 -8 4 -15 10 -15 5 0 7 7 4 15 -4 8 -8 15 -10 15 -2 0
-4 -7 -4 -15z" />
                <path d="M5450 4374 c6 -6 7 -14 3 -18 -4 -4 0 -4 8 -1 21 8 20 31 -2 31 -12
0 -15 -4 -9 -12z" />
                <path d="M5591 4366 l26 -28 -21 -38 c-16 -30 -18 -42 -9 -51 9 -9 11 -7 6 10
-3 13 -1 21 6 21 7 0 10 4 7 9 -3 4 1 16 8 27 12 16 16 17 32 4 18 -14 18 -14
1 6 -9 11 -14 24 -10 29 5 4 2 5 -5 1 -8 -5 -24 1 -40 15 l-27 23 26 -28z" />
                <path d="M5973 4376 c0 -6 8 -19 17 -28 14 -15 17 -15 17 -3 0 8 -5 15 -10 15
-5 0 -7 6 -4 13 3 8 0 14 -7 14 -7 0 -13 -5 -13 -11z" />
                <path d="M861 4364 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M923 4365 c0 -8 4 -15 9 -15 4 0 8 7 8 15 0 8 -4 15 -8 15 -5 0 -9
-7 -9 -15z" />
                <path d="M1132 4360 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z" />
                <path d="M1158 4373 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M1322 4375 c8 -8 77 -9 85 -2 3 4 -15 7 -42 7 -27 0 -46 -2 -43 -5z" />
                <path d="M1462 4350 c0 -19 2 -27 5 -17 2 9 2 25 0 35 -3 9 -5 1 -5 -18z" />
                <path d="M1750 4376 c0 -2 8 -10 18 -17 15 -13 16 -12 3 4 -13 16 -21 21 -21
13z" />
                <path d="M2322 4360 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z" />
                <path d="M2470 4370 c8 -5 20 -10 25 -10 6 0 3 5 -5 10 -8 5 -19 10 -25 10 -5
0 -3 -5 5 -10z" />
                <path d="M3031 4376 c2 -2 22 -6 44 -9 27 -4 35 -3 25 3 -14 9 -79 15 -69 6z" />
                <path d="M4072 4355 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z" />
                <path d="M4566 4371 c-3 -5 1 -11 9 -14 9 -4 12 -1 8 9 -6 16 -10 17 -17 5z" />
                <path d="M5526 4352 c-13 -24 -13 -29 -1 -29 8 0 12 4 9 8 -3 5 0 18 6 29 6
11 8 20 6 20 -3 0 -12 -13 -20 -28z" />
                <path d="M5897 4355 c10 -13 22 -25 27 -25 5 0 -1 11 -14 25 -30 32 -36 32
-13 0z" />
                <path d="M2512 4325 c0 -23 3 -30 5 -17 3 16 12 22 31 23 l27 2 -25 4 c-14 3
-28 10 -32 17 -4 6 -7 -7 -6 -29z" />
                <path d="M3019 4323 l-34 -38 38 34 c20 19 37 36 37 38 0 8 -8 0 -41 -34z" />
                <path d="M6086 4347 c-16 -12 -16 -14 -3 -14 9 0 18 6 21 14 3 7 4 13 3 13 -2
0 -11 -6 -21 -13z" />
                <path d="M2345 4345 c23 -8 85 -10 85 -3 0 4 -21 8 -47 7 -27 0 -43 -2 -38 -4z" />
                <path d="M4026 4333 c-6 -14 -5 -15 5 -6 7 7 10 15 7 18 -3 3 -9 -2 -12 -12z" />
                <path d="M4501 4341 c-23 -6 -23 -7 -5 -21 11 -8 16 -10 12 -6 -4 5 0 15 10
22 19 15 18 15 -17 5z" />
                <path d="M5204 4331 c0 -10 5 -17 11 -15 13 5 56 -41 48 -50 -4 -3 -1 -6 5 -6
15 0 16 17 2 25 -6 4 -7 12 -4 18 4 7 3 9 -1 4 -5 -4 -20 4 -35 18 -23 22 -26
23 -26 6z" />
                <path d="M1555 4330 c4 -6 -11 -11 -37 -11 -32 -2 -36 -3 -14 -6 36 -6 79 5
71 17 -3 6 -11 10 -16 10 -6 0 -7 -4 -4 -10z" />
                <path d="M2602 4315 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z" />
                <path d="M4593 4325 c0 -7 6 -11 14 -8 7 3 13 6 13 8 0 2 -6 5 -13 8 -8 3 -14
-1 -14 -8z" />
                <path d="M4635 4330 c-4 -6 -4 -14 -1 -17 3 -4 6 -1 6 5 0 24 19 11 23 -15 4
-28 4 -28 3 1 -1 31 -19 45 -31 26z" />
                <path d="M5290 4325 c-7 -9 -8 -15 -2 -15 5 0 12 7 16 15 3 8 4 15 2 15 -2 0
-9 -7 -16 -15z" />
                <path d="M1297 4323 c38 -3 53 -9 57 -21 3 -12 4 -12 3 3 -2 17 -10 20 -57 21
l-55 1 52 -4z" />
                <path d="M1790 4326 c0 -2 8 -10 18 -17 15 -13 16 -12 3 4 -13 16 -21 21 -21
13z" />
                <path d="M4243 4308 c-22 -22 -22 -22 -45 -2 l-23 19 20 -25 c11 -14 20 -26
21 -27 0 -2 13 11 29 27 33 34 31 41 -2 8z" />
                <path d="M5025 4320 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z" />
                <path d="M5683 4318 c-20 -27 -21 -34 -3 -34 13 0 16 4 10 11 -6 7 -5 16 2 23
7 7 9 12 6 12 -3 0 -10 -6 -15 -12z" />
                <path d="M2883 4285 c0 -22 2 -30 4 -17 2 12 2 30 0 40 -3 9 -5 -1 -4 -23z" />
                <path d="M2955 4300 c10 -11 20 -20 23 -20 3 0 -3 9 -13 20 -10 11 -20 20 -23
20 -3 0 3 -9 13 -20z" />
                <path d="M6010 4309 c0 -15 18 -19 23 -6 3 8 -1 14 -9 14 -8 0 -14 -4 -14 -8z" />
                <path d="M878 4285 c-3 -14 -2 -25 2 -25 11 0 20 39 10 45 -4 3 -10 -6 -12
-20z" />
                <path d="M938 4303 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M4060 4285 c-19 -20 -26 -23 -39 -13 -9 7 -5 0 8 -15 14 -15 29 -27
35 -27 5 0 2 6 -8 13 -17 13 -17 15 9 35 16 12 26 24 23 27 -2 3 -15 -6 -28
-20z" />
                <path d="M4552 4296 c-33 -19 -35 -23 -15 -30 9 -4 14 -4 11 0 -4 3 3 15 15
25 25 21 22 22 -11 5z" />
                <path d="M5305 4300 c-3 -5 -2 -10 4 -10 5 0 13 5 16 10 3 6 2 10 -4 10 -5 0
-13 -4 -16 -10z" />
                <path d="M5491 4287 c-13 -21 -12 -21 5 -5 10 10 16 20 13 22 -3 3 -11 -5 -18
-17z" />
                <path d="M4102 4280 c-12 -12 -22 -24 -22 -27 0 -4 11 4 25 17 23 22 29 30 22
30 -2 0 -13 -9 -25 -20z" />
                <path d="M5339 4283 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8 -17
-17z" />
                <path d="M6084 4284 c-18 -14 -18 -15 4 -4 12 6 22 13 22 15 0 8 -5 6 -26 -11z" />
                <path d="M267 4277 c-3 -8 1 -14 8 -14 7 0 11 6 8 14 -3 7 -6 13 -8 13 -2 0
-5 -6 -8 -13z" />
                <path d="M5754 4276 c-13 -10 -23 -11 -32 -4 -9 8 -11 7 -6 -6 8 -20 13 -20
44 4 29 22 24 27 -6 6z" />
                <path d="M1140 4269 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z" />
                <path d="M3080 4276 c0 -2 9 -6 20 -9 11 -3 20 -1 20 4 0 5 -9 9 -20 9 -11 0
-20 -2 -20 -4z" />
                <path d="M3197 4269 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 -14 6 -15 5 -6 -5z" />
                <path d="M5116 4262 c-15 -18 -15 -20 6 -38 l23 -19 -18 21 c-16 19 -16 22 -2
34 13 11 19 10 36 -5 11 -11 18 -24 15 -31 -8 -22 18 -4 43 29 l25 32 -27 -24
-27 -24 -23 21 c-28 27 -30 27 -51 4z" />
                <path d="M5397 4273 c-3 -5 4 -15 16 -23 21 -12 21 -12 7 6 -8 10 -15 20 -16
22 -1 2 -4 -1 -7 -5z" />
                <path d="M6037 4259 c7 -27 19 -31 33 -14 11 13 10 14 -5 9 -12 -5 -16 -4 -12
3 4 6 1 13 -7 16 -10 4 -12 0 -9 -14z" />
                <path d="M815 4260 c11 -5 27 -9 35 -9 9 0 8 4 -5 9 -11 5 -27 9 -35 9 -9 0
-8 -4 5 -9z" />
                <path d="M3470 4266 c0 -2 8 -10 18 -17 15 -13 16 -12 3 4 -13 16 -21 21 -21
13z" />
                <path d="M4484 4254 c-18 -14 -18 -15 4 -4 12 6 22 13 22 15 0 8 -5 6 -26 -11z" />
                <path d="M5290 4260 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z" />
                <path d="M5643 4255 c0 -8 4 -12 9 -9 4 3 8 9 8 15 0 5 -4 9 -8 9 -5 0 -9 -7
-9 -15z" />
                <path d="M2383 4253 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z" />
                <path d="M4577 4247 c4 -6 -2 -8 -15 -5 -15 4 -19 2 -15 -8 7 -18 8 -17 38 2
15 10 37 14 55 12 16 -3 30 -1 30 4 0 5 -22 8 -49 7 -30 -2 -48 -7 -44 -12z" />
                <path d="M5320 4251 c0 -6 4 -13 10 -16 6 -3 7 1 4 9 -7 18 -14 21 -14 7z" />
                <path d="M470 4240 c0 -6 7 -10 15 -10 8 0 15 2 15 4 0 2 -7 6 -15 10 -8 3
-15 1 -15 -4z" />
                <path d="M2528 4243 c18 -2 45 -2 60 0 15 2 0 4 -33 4 -33 0 -45 -2 -27 -4z" />
                <path d="M5257 4226 c-5 -15 -6 -31 -2 -34 3 -3 5 0 5 6 0 6 8 9 18 6 10 -4
13 -3 6 3 -7 4 -14 17 -16 28 -3 17 -5 15 -11 -9z" />
                <path d="M5555 4239 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z" />
                <path d="M5674 4241 c6 -10 -43 -46 -51 -38 -2 3 -13 -2 -22 -11 -10 -9 -26
-22 -37 -29 -15 -9 -12 -9 14 0 17 6 32 15 32 19 0 4 5 8 11 8 5 0 26 11 45
24 27 18 32 25 19 30 -9 3 -14 2 -11 -3z" />
                <path d="M291 4237 c2 -1 13 -9 24 -17 19 -14 19 -14 6 3 -7 9 -18 17 -24 17
-6 0 -8 -1 -6 -3z" />
                <path d="M1094 4224 c-18 -14 -18 -15 4 -4 12 6 22 13 22 15 0 8 -5 6 -26 -11z" />
                <path d="M2411 4224 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M3734 4219 c-19 -22 -19 -22 4 -8 12 8 22 17 22 21 0 12 -6 9 -26
-13z" />
                <path d="M3984 4208 l-29 -33 33 29 c17 17 32 31 32 33 0 8 -8 1 -36 -29z" />
                <path d="M5072 4227 c-13 -16 -9 -50 6 -55 15 -5 15 11 0 26 -8 8 -8 15 2 27
7 8 10 15 7 15 -2 0 -9 -6 -15 -13z" />
                <path d="M5461 4228 c-1 -9 -4 -18 -8 -21 -5 -2 -2 -2 5 -1 7 2 17 -5 24 -15
10 -17 13 -17 26 -4 8 8 21 12 29 9 11 -4 11 -1 3 14 -12 23 -21 26 -17 8 1
-7 -4 -12 -10 -10 -7 1 -13 -3 -13 -9 0 -16 -20 0 -30 25 -6 15 -9 17 -9 4z" />
                <path d="M5740 4236 c0 -2 8 -10 18 -17 15 -13 16 -12 3 4 -13 16 -21 21 -21
13z" />
                <path d="M718 4223 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z" />
                <path d="M3507 4219 c7 -9 11 -18 8 -20 -2 -3 4 -5 14 -5 10 0 18 6 18 13 0 7
-4 10 -9 7 -5 -3 -17 0 -26 8 -15 11 -15 11 -5 -3z" />
                <path d="M4124 4208 l-19 -23 23 19 c21 18 27 26 19 26 -2 0 -12 -10 -23 -22z" />
                <path d="M4905 4220 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z" />
                <path d="M1390 4210 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z" />
                <path d="M3190 4204 c0 -8 5 -12 10 -9 6 4 8 11 5 16 -9 14 -15 11 -15 -7z" />
                <path d="M3946 4204 c-23 -23 -20 -30 4 -9 11 10 20 20 20 22 0 7 -9 2 -24
-13z" />
                <path d="M3988 4175 c-26 -25 -42 -45 -37 -45 5 0 24 16 41 35 26 30 33 34 47
23 14 -11 14 -11 4 3 -7 9 -10 19 -6 22 3 4 4 7 2 7 -2 0 -25 -21 -51 -45z" />
                <path d="M4661 4204 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M585 4200 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z" />
                <path d="M738 4203 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M1593 4203 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z" />
                <path d="M2593 4175 c0 -22 2 -30 4 -17 2 12 2 30 0 40 -3 9 -5 -1 -4 -23z" />
                <path d="M2412 4175 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z" />
                <path d="M5130 4185 c-7 -8 -17 -12 -24 -9 -6 3 -3 -1 6 -9 10 -8 14 -18 10
-22 -4 -5 -1 -5 6 -1 11 6 17 -5 13 -26 0 -4 6 -5 15 -1 13 5 11 9 -8 30 -23
24 -23 25 -4 39 11 8 15 14 9 14 -6 0 -16 -7 -23 -15z" />
                <path d="M478 4183 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M3867 4173 c3 -7 6 -13 8 -13 2 0 5 6 8 13 3 8 -1 14 -8 14 -7 0 -11
-6 -8 -14z" />
                <path d="M5214 4170 c0 -15 4 -16 18 -9 10 5 18 13 18 16 0 3 -3 3 -7 0 -3 -4
-11 -3 -17 3 -8 6 -12 3 -12 -10z" />
                <path d="M5670 4182 c0 -7 5 -12 12 -12 9 0 9 -3 0 -12 -9 -9 -15 -8 -25 6
-13 17 -14 18 -20 2 -4 -10 -12 -14 -18 -10 -8 5 -8 1 0 -13 6 -11 7 -24 3
-28 -9 -10 15 3 51 27 25 18 31 16 28 -4 0 -5 5 -7 12 -5 6 1 11 -4 10 -10 -2
-7 1 -13 6 -13 6 0 8 -9 6 -19 -3 -14 1 -18 11 -14 10 4 17 -2 21 -16 3 -11
10 -21 15 -21 5 0 6 5 3 10 -3 6 0 17 8 25 13 13 17 12 30 -9 10 -14 12 -27 6
-33 -5 -5 -1 -9 10 -9 11 0 17 5 14 10 -4 5 1 7 10 3 9 -3 16 -3 16 1 -3 19 2
23 17 11 10 -8 8 0 -6 24 -12 20 -24 37 -26 37 -7 0 1 -25 11 -32 9 -7 -10
-27 -25 -28 -8 0 -45 64 -42 73 1 4 -3 7 -9 7 -8 0 -8 5 1 15 13 16 35 10 24
-6 -3 -5 0 -8 8 -7 7 2 12 -3 10 -10 -1 -8 2 -11 9 -6 7 4 -1 19 -25 42 -35
36 -36 36 -53 17 -17 -18 -17 -18 0 -5 23 17 45 -1 23 -19 -12 -10 -13 -18 -5
-33 11 -21 -5 -53 -23 -42 -5 3 -5 11 2 19 7 9 6 16 -7 26 -16 13 -17 12 -4
-3 8 -11 9 -18 3 -18 -6 0 -16 9 -22 19 -13 25 -13 34 0 26 6 -3 10 -2 10 3 0
6 -7 13 -16 16 -8 3 -12 2 -9 -4 11 -18 -8 -11 -32 12 -13 12 -23 16 -23 10z
m-19 -45 c-13 -13 -26 -3 -16 12 3 6 11 8 17 5 6 -4 6 -10 -1 -17z" />
                <path d="M2500 4165 c0 -8 4 -15 10 -15 5 0 7 7 4 15 -4 8 -8 15 -10 15 -2 0
-4 -7 -4 -15z" />
                <path d="M5173 4162 c10 -10 14 -22 10 -27 -5 -4 -2 -5 5 -1 11 6 10 12 -4 27
-9 10 -19 19 -22 19 -3 0 2 -8 11 -18z" />
                <path d="M5326 4156 c11 -14 25 -27 31 -30 19 -8 -6 28 -29 43 -20 12 -20 12
-2 -13z" />
                <path d="M581 4154 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M5017 4150 c4 -13 0 -26 -8 -31 -8 -5 -9 -9 -4 -9 6 0 17 5 25 10 11
7 20 4 33 -13 l18 -22 -13 28 c-7 17 -17 26 -25 23 -9 -4 -13 0 -11 11 2 9 -2
18 -9 20 -7 3 -9 -3 -6 -17z" />
                <path d="M405 4150 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7
-4 -4 -10z" />
                <path d="M2538 4153 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z" />
                <path d="M5530 4151 c0 -7 -4 -9 -10 -6 -5 3 -10 1 -10 -4 0 -6 4 -11 9 -11
13 0 25 20 17 27 -3 4 -6 1 -6 -6z" />
                <path d="M1599 4129 c-3 -14 -3 -34 1 -44 6 -18 7 -18 11 1 3 10 3 30 -1 44
l-6 25 -5 -26z" />
                <path d="M2698 4143 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M3373 4143 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z" />
                <path d="M3790 4138 c0 -4 4 -8 9 -8 6 0 12 4 15 8 3 5 -1 9 -9 9 -8 0 -15 -4
-15 -9z" />
                <path d="M5070 4143 c0 -19 21 -27 33 -13 9 10 9 11 -2 5 -8 -4 -17 -2 -22 6
-6 9 -9 10 -9 2z" />
                <path d="M5423 4143 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z" />
                <path d="M1532 4120 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z" />
                <path d="M2501 4124 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M209 4113 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21 -13z" />
                <path d="M1259 4113 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21 -13z" />
                <path d="M2692 4105 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z" />
                <path d="M3897 4115 c3 -8 9 -12 14 -9 12 7 11 11 -5 17 -10 4 -13 1 -9 -8z" />
                <path d="M5108 4116 c-17 -13 -14 -26 5 -26 6 0 7 3 4 7 -4 3 -2 12 4 20 14
16 9 16 -13 -1z" />
                <path d="M572 4100 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z" />
                <path d="M2792 4095 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z" />
                <path d="M3978 4098 c2 -10 6 -18 8 -18 2 0 8 8 13 18 7 14 6 18 -8 18 -12 0
-17 -6 -13 -18z" />
                <path d="M5325 4110 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z" />
                <path d="M5365 4096 c-11 -12 -18 -20 -16 -19 7 4 29 -22 24 -29 -2 -5 1 -8 7
-8 7 0 10 -7 6 -15 -3 -8 0 -14 7 -12 7 1 11 -5 9 -13 -2 -8 0 -12 4 -7 9 9
13 47 5 44 -3 -1 -7 2 -8 6 -1 4 -9 15 -18 23 -15 16 -12 34 6 34 6 0 7 -6 3
-12 -4 -7 -4 -10 1 -6 4 4 15 2 24 -4 9 -7 5 0 -8 15 -14 15 -25 27 -25 26 -1
-1 -10 -11 -21 -23z" />
                <path d="M5534 4113 c4 -8 2 -13 -6 -14 -7 0 -2 -5 11 -10 31 -12 33 -9 8 16
-11 11 -17 14 -13 8z" />
                <path d="M5644 4104 c-10 -8 -13 -13 -6 -9 7 4 19 2 27 -5 11 -9 12 -7 8 9 -6
25 -5 25 -29 5z" />
                <path d="M401 4094 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M1120 4091 c5 -11 15 -23 21 -27 6 -3 3 5 -6 20 -20 30 -30 35 -15 7z" />
                <path d="M4970 4099 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z" />
                <path d="M5155 4101 c-3 -6 0 -8 9 -5 8 3 16 -1 19 -10 4 -14 5 -14 3 0 -1 20
-21 30 -31 15z" />
                <path d="M5279 4082 c5 -9 15 -24 23 -32 7 -8 12 -13 11 -11 -2 2 2 10 7 17 8
9 6 12 -7 10 -10 0 -17 4 -16 11 1 6 -4 14 -13 17 -11 4 -12 2 -5 -12z" />
                <path d="M5103 4073 c-18 -9 -33 -20 -33 -24 0 -9 57 19 65 32 8 11 7 11 -32
-8z" />
                <path d="M5468 4083 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z" />
                <path d="M2377 4073 c15 -3 23 -13 25 -31 3 -26 4 -26 9 6 5 31 4 32 -25 31
-23 -1 -25 -3 -9 -6z" />
                <path d="M1172 4058 c-7 -7 -12 -16 -12 -20 0 -15 27 -8 41 10 11 14 11 15 -1
5 -20 -18 -35 -16 -20 2 15 18 9 20 -8 3z" />
                <path d="M2550 4063 c14 -3 28 -9 31 -15 4 -5 9 -3 12 6 5 13 -1 16 -31 15
-28 -1 -31 -3 -12 -6z" />
                <path d="M2685 4060 c-3 -5 1 -10 10 -10 9 0 13 5 10 10 -3 6 -8 10 -10 10 -2
0 -7 -4 -10 -10z" />
                <path d="M3106 4055 c-11 -8 -15 -15 -9 -15 6 0 16 7 23 15 16 19 11 19 -14 0z" />
                <path d="M3183 4030 c0 -25 2 -35 4 -22 2 12 2 32 0 45 -2 12 -4 2 -4 -23z" />
                <path d="M5040 4060 c0 -9 7 -25 15 -36 8 -12 11 -24 8 -28 -3 -3 -1 -6 5 -6
7 0 12 4 12 9 0 6 8 8 19 6 12 -2 18 2 17 13 0 9 7 18 18 20 10 2 16 0 12 -6
-3 -5 2 -13 12 -17 16 -6 16 -7 -2 -21 -12 -8 -14 -14 -7 -14 8 0 11 -6 7 -16
-3 -8 -2 -13 3 -10 11 7 33 -18 24 -27 -3 -4 -1 -7 6 -7 8 0 11 -7 7 -15 -4
-13 -2 -14 14 -5 20 11 27 21 13 19 -21 -3 -24 3 -12 18 10 12 10 15 1 9 -17
-10 -54 35 -41 51 7 7 6 14 -1 18 -6 3 -8 9 -6 13 2 4 -2 12 -9 19 -10 9 -21
6 -49 -13 l-37 -25 -14 33 c-8 18 -14 26 -15 18z" />
                <path d="M5195 4060 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z" />
                <path d="M5436 4054 c-3 -8 -2 -12 4 -9 6 3 10 1 10 -5 0 -6 11 -8 26 -6 34 7
44 16 16 16 -12 0 -22 5 -22 10 0 16 -27 12 -34 -6z" />
                <path d="M5545 4060 c-18 -8 -17 -9 8 -9 15 -1 27 4 27 9 0 12 -8 12 -35 0z" />
                <path d="M5683 4055 c0 -8 4 -15 9 -15 4 0 8 4 8 9 0 6 -4 12 -8 15 -5 3 -9
-1 -9 -9z" />
                <path d="M411 4044 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M2738 4053 c12 -2 32 -2 45 0 12 2 2 4 -23 4 -25 0 -35 -2 -22 -4z" />
                <path d="M5223 4040 c-18 -11 -33 -22 -33 -25 0 -2 16 5 35 16 19 12 35 23 35
25 0 6 -3 5 -37 -16z" />
                <path d="M3058 4043 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M5591 4041 c-8 -5 -9 -11 -3 -15 5 -3 12 1 16 9 6 17 6 18 -13 6z" />
                <path d="M890 4036 c0 -2 8 -10 18 -17 15 -13 16 -12 3 4 -13 16 -21 21 -21
13z" />
                <path d="M3240 4036 c0 -2 7 -7 16 -10 8 -3 12 -2 9 4 -6 10 -25 14 -25 6z" />
                <path d="M3101 4014 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M5324 4014 c-18 -14 -18 -15 4 -4 12 6 22 13 22 15 0 8 -5 6 -26 -11z" />
                <path d="M5614 4022 c3 -6 0 -12 -6 -15 -7 -2 -9 -8 -5 -13 4 -5 12 -2 16 5 5
7 14 10 20 7 6 -4 11 -5 11 -2 0 3 -10 10 -21 17 -13 6 -19 7 -15 1z" />
                <path d="M5710 4016 c0 -9 5 -16 10 -16 6 0 10 4 10 9 0 6 -4 13 -10 16 -5 3
-10 -1 -10 -9z" />
                <path d="M5793 4015 c0 -8 4 -12 9 -9 5 3 6 10 3 15 -9 13 -12 11 -12 -6z" />
                <path d="M5926 4015 c10 -8 24 -14 29 -14 6 0 1 6 -9 14 -11 8 -24 15 -30 15
-5 0 -1 -7 10 -15z" />
                <path d="M421 4011 c0 -3 6 -22 14 -41 l13 -35 -2 41 c-1 25 -6 41 -13 41 -7
0 -13 -3 -12 -6z" />
                <path d="M540 4009 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z" />
                <path d="M1164 4009 c-3 -6 -2 -15 3 -20 5 -5 9 -1 9 11 0 23 -2 24 -12 9z" />
                <path d="M2723 4013 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z" />
                <path d="M2921 4015 c1 -19 18 -51 18 -35 0 8 -4 22 -9 30 -5 8 -9 11 -9 5z" />
                <path d="M5880 4009 c0 -5 -4 -8 -9 -5 -5 3 -12 -1 -15 -9 -4 -13 -2 -13 14
-5 23 12 35 30 21 30 -6 0 -11 -5 -11 -11z" />
                <path d="M5244 3994 c-10 -8 -13 -13 -6 -9 7 4 12 0 12 -9 0 -9 4 -16 9 -16
16 0 22 -32 9 -49 -11 -14 -11 -14 3 -4 18 15 33 5 19 -11 -6 -8 -3 -12 10
-12 15 0 16 4 9 18 -6 10 -7 23 -4 28 4 6 3 9 -2 8 -4 -2 -9 1 -10 5 -1 4 -9
15 -18 24 -9 8 -14 22 -11 29 7 18 4 18 -20 -2z" />
                <path d="M5355 4000 c-4 -6 -10 -8 -15 -5 -4 3 -11 -2 -14 -10 -4 -13 -2 -13
14 -5 18 10 36 30 26 30 -3 0 -8 -5 -11 -10z" />
                <path d="M5001 3984 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M5815 3990 c4 -6 1 -19 -7 -28 -12 -15 -11 -16 4 -4 9 8 23 10 30 6
7 -4 4 2 -6 14 -20 23 -32 29 -21 12z" />
                <path d="M5116 3975 c-3 -9 -10 -13 -16 -10 -5 3 -10 1 -10 -4 0 -6 4 -11 9
-11 12 0 35 29 29 36 -3 3 -8 -2 -12 -11z" />
                <path d="M5575 3980 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z" />
                <path d="M5656 3978 c3 -5 10 -6 15 -3 13 9 11 12 -6 12 -8 0 -12 -4 -9 -9z" />
                <path d="M5732 3985 c4 -4 0 -13 -8 -20 -15 -11 -15 -12 -1 -12 20 0 30 24 14
33 -7 4 -9 4 -5 -1z" />
                <path d="M5966 3981 c-3 -5 1 -11 9 -14 9 -4 12 -1 8 9 -6 16 -10 17 -17 5z" />
                <path d="M5630 3960 c6 -11 13 -20 16 -20 2 0 0 9 -6 20 -6 11 -13 20 -16 20
-2 0 0 -9 6 -20z" />
                <path d="M5885 3970 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z" />
                <path d="M5523 3955 c0 -8 4 -12 9 -9 4 3 8 9 8 15 0 5 -4 9 -8 9 -5 0 -9 -7
-9 -15z" />
                <path d="M5935 3960 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z" />
                <path d="M5597 3945 c3 -8 9 -12 14 -9 12 7 11 11 -5 17 -10 4 -13 1 -9 -8z" />
                <path d="M205 3940 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7
-4 -4 -10z" />
                <path d="M805 3940 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z" />
                <path d="M5123 3943 c-16 -6 -17 -33 -1 -33 6 0 8 3 5 7 -4 3 -2 12 4 20 12
14 11 14 -8 6z" />
                <path d="M5900 3940 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z" />
                <path d="M910 3930 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z" />
                <path d="M4966 3925 c-3 -9 0 -15 9 -15 9 0 12 6 9 15 -4 8 -7 15 -9 15 -2 0
-5 -7 -9 -15z" />
                <path d="M1115 3920 c-16 -7 -17 -9 -3 -9 9 -1 20 4 23 9 7 11 7 11 -20 0z" />
                <path d="M5000 3926 c0 -2 7 -7 16 -10 8 -3 12 -2 9 4 -6 10 -25 14 -25 6z" />
                <path d="M5476 3922 c-3 -5 1 -9 9 -9 8 0 15 4 15 9 0 4 -4 8 -9 8 -6 0 -12
-4 -15 -8z" />
                <path d="M5650 3924 c0 -3 7 -12 15 -21 13 -12 13 -18 3 -31 -11 -13 -10 -14
9 -4 28 15 40 34 16 25 -10 -3 -15 -3 -11 2 4 4 1 14 -7 21 -14 15 -25 18 -25
8z" />
                <path d="M5550 3910 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z" />
                <path d="M4941 3894 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M5756 3893 c-4 -11 -1 -11 14 -3 24 13 25 17 5 17 -8 0 -16 -6 -19
-14z" />
                <path d="M688 3883 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M846 3878 c3 -5 10 -6 15 -3 13 9 11 12 -6 12 -8 0 -12 -4 -9 -9z" />
                <path d="M5060 3878 c0 -5 7 -8 16 -8 12 0 15 -7 11 -26 -6 -32 8 -18 16 16 5
21 3 25 -18 25 -14 0 -25 -3 -25 -7z" />
                <path d="M5216 3881 c-4 -6 -2 -11 4 -11 7 0 9 -7 5 -17 -5 -14 -3 -15 5 -6 8
7 9 17 2 28 -6 12 -11 14 -16 6z" />
                <path d="M5415 3880 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z" />
                <path d="M5506 3881 c-3 -5 1 -11 9 -14 9 -4 12 -1 8 9 -6 16 -10 17 -17 5z" />
                <path d="M5573 3883 c4 -3 3 -11 -3 -17 -6 -8 -3 -12 10 -12 15 0 16 4 9 18
-5 10 -13 18 -16 18 -3 0 -3 -3 0 -7z" />
                <path d="M5805 3880 c-4 -6 -10 -8 -15 -5 -4 3 -11 -2 -14 -10 -4 -13 -2 -13
14 -5 18 10 36 30 26 30 -3 0 -8 -5 -11 -10z" />
                <path d="M620 3870 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z" />
                <path d="M5015 3870 c4 -6 -1 -21 -12 -33 -18 -22 -18 -22 3 -4 29 24 44 21
44 -9 0 -14 4 -23 9 -20 15 10 0 44 -26 62 -14 9 -22 11 -18 4z" />
                <path d="M5148 3874 c-4 -3 2 -15 12 -27 11 -11 17 -25 13 -30 -3 -6 -1 -7 6
-3 6 4 9 12 5 17 -3 5 0 18 8 27 12 15 11 16 -4 4 -14 -11 -18 -11 -25 3 -5 8
-12 13 -15 9z" />
                <path d="M555 3845 c-22 -8 -34 -14 -26 -14 11 -1 10 -6 -5 -23 -17 -20 -16
-20 12 2 17 14 40 30 50 37 23 15 19 14 -31 -2z" />
                <path d="M710 3846 c0 -8 4 -17 9 -21 6 -3 9 4 8 15 -1 23 -17 28 -17 6z" />
                <path d="M5353 3843 c-15 -5 -17 -23 -4 -23 5 0 11 7 15 15 3 8 4 15 3 14 -1
0 -8 -3 -14 -6z" />
                <path d="M5530 3839 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z" />
                <path d="M5932 3830 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z" />
                <path d="M5465 3829 c-4 -6 -4 -13 -1 -16 3 -3 0 -13 -7 -21 -9 -11 -4 -11 16
2 31 21 35 28 10 19 -12 -5 -15 -2 -10 10 7 19 2 23 -8 6z" />
                <path d="M5590 3825 c-7 -9 -20 -13 -29 -10 -8 3 -12 3 -8 -1 4 -4 1 -14 -6
-22 -10 -13 -9 -14 3 -7 8 4 23 15 33 24 17 14 20 14 37 -9 10 -13 17 -27 14
-31 -2 -4 4 -10 13 -13 10 -4 14 -4 10 0 -4 4 -1 14 6 22 9 13 9 14 0 8 -24
-14 -35 5 -16 27 15 18 15 20 1 8 -18 -13 -43 -6 -33 10 10 15 -12 10 -25 -6z" />
                <path d="M475 3820 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z" />
                <path d="M665 3820 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7
-4 -4 -10z" />
                <path d="M5114 3814 c-18 -14 -18 -15 4 -4 12 6 22 13 22 15 0 8 -5 6 -26 -11z" />
                <path d="M6010 3805 c-11 -13 -10 -14 4 -9 9 3 16 10 16 15 0 13 -6 11 -20 -6z" />
                <path d="M5019 3783 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8 -17
-17z" />
                <path d="M5053 3779 c-18 -12 -33 -22 -33 -23 0 -1 19 0 41 2 25 3 36 7 29 12
-7 4 -9 13 -6 19 10 15 6 14 -31 -10z" />
                <path d="M5940 3785 c0 -8 4 -15 10 -15 5 0 7 7 4 15 -4 8 -8 15 -10 15 -2 0
-4 -7 -4 -15z" />
                <path d="M355 3780 c-19 -8 -19 -9 2 -9 12 -1 25 4 28 9 7 12 -2 12 -30 0z" />
                <path d="M5490 3777 c0 -16 24 -17 37 -1 4 5 4 6 -1 2 -5 -4 -15 -3 -23 3 -10
9 -13 8 -13 -4z" />
                <path d="M5573 3773 c-10 -10 -14 -15 -8 -11 7 4 14 5 17 2 3 -2 8 2 11 11 8
19 4 19 -20 -2z" />
                <path d="M316 3767 c3 -10 9 -15 12 -12 3 3 0 11 -7 18 -10 9 -11 8 -5 -6z" />
                <path d="M5845 3771 c-3 -5 -1 -12 5 -16 5 -3 10 1 10 9 0 18 -6 21 -15 7z" />
                <path d="M5380 3749 c-20 -11 -27 -19 -18 -19 9 0 20 5 23 10 4 6 10 8 15 5 4
-3 10 2 14 10 3 8 4 15 3 14 -1 0 -18 -9 -37 -20z" />
                <path d="M6077 3754 c-23 -12 -30 -34 -11 -34 3 0 2 5 -1 10 -3 6 -2 10 2 10
5 0 18 7 29 15 25 19 17 18 -19 -1z" />
                <path d="M5454 3744 c-18 -14 -18 -15 4 -4 12 6 22 13 22 15 0 8 -5 6 -26 -11z" />
                <path d="M5588 3740 c-14 -10 -28 -16 -32 -13 -3 3 -6 1 -6 -5 0 -7 5 -12 11
-12 5 0 7 -5 3 -12 -4 -7 -3 -8 5 -4 6 4 9 11 6 16 -3 4 7 18 22 29 16 11 25
21 22 21 -4 0 -18 -9 -31 -20z" />
                <path d="M5799 3739 l-24 -20 28 17 c15 9 27 18 27 20 0 8 -8 4 -31 -17z" />
                <path d="M5849 3729 c-23 -19 -23 -20 -2 -10 12 6 25 16 28 21 10 16 -1 12
-26 -11z" />
                <path d="M5945 3741 c-3 -5 -1 -12 5 -16 5 -3 10 1 10 9 0 18 -6 21 -15 7z" />
                <path d="M5410 3720 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z" />
                <path d="M5734 3710 c0 -13 4 -16 10 -10 7 7 7 13 0 20 -6 6 -10 3 -10 -10z" />
                <path d="M6018 3723 c-10 -2 -18 -9 -18 -14 0 -6 8 -5 20 1 11 6 20 13 20 15
0 3 -1 4 -2 4 -2 -1 -11 -3 -20 -6z" />
                <path d="M5230 3709 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z" />
                <path d="M5367 3705 c-4 -8 -2 -17 3 -20 6 -4 10 3 10 14 0 25 -6 27 -13 6z" />
                <path d="M5890 3709 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z" />
                <path d="M5130 3700 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z" />
                <path d="M5165 3699 c-4 -6 -4 -13 -1 -16 3 -4 6 -1 6 6 0 8 8 11 20 8 11 -3
20 -1 20 4 0 13 -37 11 -45 -2z" />
                <path d="M6080 3690 c6 -11 13 -20 16 -20 2 0 0 9 -6 20 -6 11 -13 20 -16 20
-2 0 0 -9 6 -20z" />
                <path d="M5426 3683 c-4 -11 -1 -11 14 -3 24 13 25 17 5 17 -8 0 -16 -6 -19
-14z" />
                <path d="M5690 3685 c8 -11 15 -21 16 -23 1 -2 5 5 8 15 4 9 4 14 0 10 -4 -4
-14 -1 -23 6 -14 11 -15 10 -1 -8z" />
                <path d="M5272 3681 c-11 -7 -11 -9 2 -14 10 -4 16 -1 16 8 0 17 -1 17 -18 6z" />
                <path d="M5757 3669 c4 -13 8 -18 11 -10 2 7 -1 18 -6 23 -8 8 -9 4 -5 -13z" />
                <path d="M5839 3673 c-13 -15 -12 -15 9 -4 23 12 28 21 13 21 -5 0 -15 -7 -22
-17z" />
                <path d="M5961 3685 c1 -19 18 -51 18 -35 0 8 -4 22 -9 30 -5 8 -9 11 -9 5z" />
                <path d="M5028 3673 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z" />
                <path d="M5223 3672 c-17 -5 -20 -11 -13 -22 6 -10 10 -11 10 -2 0 6 7 12 15
12 8 0 15 5 15 10 0 6 -1 10 -2 9 -2 -1 -13 -4 -25 -7z" />
                <path d="M5380 3659 c0 -4 -10 -10 -22 -12 -21 -4 -20 -4 3 -6 15 0 32 5 38
12 8 10 7 14 -4 14 -8 0 -15 -4 -15 -8z" />
                <path d="M20 3640 c6 -11 13 -20 16 -20 2 0 0 9 -6 20 -6 11 -13 20 -16 20 -2
0 0 -9 6 -20z" />
                <path d="M5166 3645 c4 -8 8 -15 10 -15 2 0 4 7 4 15 0 8 -4 15 -10 15 -5 0
-7 -7 -4 -15z" />
                <path d="M5850 3650 c-1 -8 -2 -19 -1 -24 1 -4 -4 -15 -11 -24 -8 -10 -9 -13
-1 -9 7 5 13 -1 15 -15 3 -20 5 -18 9 7 3 17 2 41 -2 55 -4 14 -8 18 -9 10z" />
                <path d="M5108 3643 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M5425 3640 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z" />
                <path d="M5768 3630 c-14 -10 -28 -17 -30 -14 -3 3 -8 -2 -12 -11 -5 -14 -2
-14 25 2 29 17 57 43 47 43 -3 0 -17 -9 -30 -20z" />
                <path d="M4980 3630 c0 -6 7 -10 15 -10 8 0 15 2 15 4 0 2 -7 6 -15 10 -8 3
-15 1 -15 -4z" />
                <path d="M5048 3633 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M5223 3623 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z" />
                <path d="M6027 3617 c-3 -8 1 -14 9 -14 16 0 19 13 5 21 -5 3 -11 0 -14 -7z" />
                <path d="M5178 3613 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M5290 3607 c0 -10 8 -17 18 -17 9 0 13 4 7 8 -5 4 -13 11 -17 16 -5
5 -8 2 -8 -7z" />
                <path d="M5790 3601 c0 -10 19 -25 25 -20 1 2 -3 10 -11 17 -8 7 -14 8 -14 3z" />
                <path d="M5884 3594 c-18 -14 -18 -15 4 -4 12 6 22 13 22 15 0 8 -5 6 -26 -11z" />
                <path d="M5056 3585 c4 -8 7 -15 9 -15 2 0 5 7 9 15 3 9 0 15 -9 15 -9 0 -12
-6 -9 -15z" />
                <path d="M5180 3583 c0 -17 4 -20 22 -15 16 4 18 7 8 10 -8 3 -18 10 -22 16
-5 6 -8 2 -8 -11z" />
                <path d="M5690 3580 c13 -24 17 -25 17 -5 0 8 -6 16 -14 19 -11 4 -11 1 -3
-14z" />
                <path d="M5985 3590 c-3 -6 1 -7 9 -4 18 7 21 14 7 14 -6 0 -13 -4 -16 -10z" />
                <path d="M60 3576 c0 -2 8 -10 18 -17 15 -13 16 -12 3 4 -13 16 -21 21 -21 13z" />
                <path d="M4948 3573 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z" />
                <path d="M5646 3557 c3 -10 9 -15 12 -12 3 3 0 11 -7 18 -10 9 -11 8 -5 -6z" />
                <path d="M5805 3552 c-3 -9 -12 -12 -23 -7 -13 5 -14 4 -5 -6 10 -10 15 -10
27 0 11 10 16 9 24 -5 8 -15 9 -15 15 0 5 12 3 15 -5 10 -7 -5 -9 -2 -6 8 4 8
0 15 -8 15 -7 0 -16 -7 -19 -15z" />
                <path d="M5908 3563 c6 -2 10 -8 8 -12 -3 -4 1 -8 9 -8 8 0 15 4 15 8 0 7 -26
20 -38 18 -4 0 -1 -3 6 -6z" />
                <path d="M6056 3555 c-3 -8 -1 -14 4 -12 5 1 16 -7 24 -18 l16 -20 -7 20 c-11
32 -30 47 -37 30z" />
                <path d="M5060 3549 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z" />
                <path d="M5002 3530 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z" />
                <path d="M5411 3534 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M93 3505 c0 -22 2 -30 4 -17 2 12 2 30 0 40 -3 9 -5 -1 -4 -23z" />
                <path d="M5604 3524 c-18 -14 -18 -15 4 -4 12 6 22 13 22 15 0 8 -5 6 -26 -11z" />
                <path d="M4918 3523 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M5949 3514 c6 -12 8 -24 5 -26 -3 -3 3 -9 13 -12 9 -4 14 -4 10 0 -4
4 -1 14 6 22 10 13 9 14 -1 8 -8 -5 -19 -1 -28 10 -14 18 -15 18 -5 -2z" />
                <path d="M5544 3500 c0 -11 2 -17 5 -15 2 3 9 1 15 -5 8 -6 12 -3 12 10 0 11
-2 17 -5 15 -2 -3 -9 -1 -15 5 -8 6 -12 3 -12 -10z" />
                <path d="M5825 3500 c-16 -11 -25 -20 -20 -20 10 0 64 39 55 40 -3 0 -18 -9
-35 -20z" />
                <path d="M5370 3490 c0 -11 2 -20 4 -20 2 0 6 9 9 20 3 11 1 20 -4 20 -5 0 -9
-9 -9 -20z" />
                <path d="M5241 3484 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M5684 3470 c0 -13 4 -16 10 -10 7 7 7 13 0 20 -6 6 -10 3 -10 -10z" />
                <path d="M5141 3453 c-1 -16 5 -23 17 -23 10 0 13 3 6 8 -6 4 -14 14 -17 22
-4 10 -6 8 -6 -7z" />
                <path d="M5302 3450 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z" />
                <path d="M5320 3461 c0 -6 4 -13 10 -16 6 -3 7 1 4 9 -7 18 -14 21 -14 7z" />
                <path d="M5245 3450 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z" />
                <path d="M5368 3453 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M5660 3442 c6 -12 8 -28 4 -34 -4 -6 -3 -8 3 -5 12 8 36 -17 26 -26
-3 -4 -1 -7 5 -7 18 0 23 18 6 24 -9 4 -14 13 -10 21 3 8 1 14 -4 12 -5 -1
-16 7 -25 18 -16 20 -16 19 -5 -3z" />
                <path d="M5090 3435 c0 -8 4 -15 10 -15 5 0 7 7 4 15 -4 8 -8 15 -10 15 -2 0
-4 -7 -4 -15z" />
                <path d="M5195 3440 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z" />
                <path d="M5431 3434 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M5777 3441 c2 -2 -2 -10 -9 -18 -9 -11 -7 -12 7 -6 14 5 17 3 13 -9
-4 -9 0 -15 8 -15 18 0 17 8 -4 32 -9 11 -16 18 -15 16z" />
                <path d="M5040 3427 c0 -10 8 -17 18 -17 9 0 13 4 7 8 -5 4 -13 11 -17 16 -5
5 -8 2 -8 -7z" />
                <path d="M5840 3431 c0 -5 7 -15 17 -22 15 -13 15 -12 4 9 -12 23 -21 28 -21
13z" />
                <path d="M4881 3414 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M5250 3422 c0 -6 -8 -13 -17 -15 -16 -4 -16 -5 -1 -6 18 -1 34 16 24
26 -3 4 -6 1 -6 -5z" />
                <path d="M5381 3414 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M5616 3421 c-12 -5 -15 -10 -9 -14 6 -4 16 0 23 8 14 17 13 17 -14 6z" />
                <path d="M5150 3402 c0 -15 4 -20 16 -15 9 3 12 9 7 12 -4 3 -11 10 -15 15 -5
5 -8 0 -8 -12z" />
                <path d="M5201 3404 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M5310 3410 c18 -12 30 -13 30 -2 0 4 -10 9 -22 9 -18 2 -20 0 -8 -7z" />
                <path d="M5276 3393 c-6 -14 -5 -15 5 -6 7 7 10 15 7 18 -3 3 -9 -2 -12 -12z" />
                <path d="M5081 3374 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M5440 3381 c0 -5 9 -7 20 -4 11 3 20 7 20 9 0 2 -9 4 -20 4 -11 0
-20 -4 -20 -9z" />
                <path d="M5600 3369 l-25 -20 25 12 c14 7 29 12 33 11 5 -1 6 2 2 8 -8 13 -5
13 -35 -11z" />
                <path d="M5000 3362 c0 -15 6 -18 33 -13 l32 6 -29 3 c-22 3 -26 6 -15 13 11
7 11 9 -3 9 -11 0 -18 -7 -18 -18z" />
                <path d="M5107 3369 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 -14 6 -15 5 -6 -5z" />
                <path d="M5391 3364 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M5544 3373 c4 -6 -2 -14 -11 -16 -17 -4 -17 -5 0 -6 9 0 17 -5 17
-11 0 -5 5 -10 10 -10 14 0 12 13 -6 36 -8 10 -13 14 -10 7z" />
                <path d="M5735 3370 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z" />
                <path d="M116 3349 c10 -11 12 -19 4 -22 -6 -3 -5 -4 2 -3 7 2 22 -4 33 -13
16 -13 15 -11 -2 10 -13 14 -23 30 -23 35 0 6 -7 11 -15 11 -13 0 -13 -3 1
-18z" />
                <path d="M5288 3353 c-21 -25 -12 -43 20 -42 24 2 24 2 5 6 -25 5 -30 22 -11
41 7 7 10 12 7 12 -3 0 -13 -8 -21 -17z" />
                <path d="M5338 3345 c3 -18 10 -25 26 -24 18 1 18 2 3 6 -13 3 -17 11 -14 24
3 11 0 19 -8 19 -8 0 -11 -9 -7 -25z" />
                <path d="M5211 3348 c0 -9 -7 -18 -13 -20 -7 -3 -3 -7 9 -10 14 -4 24 -1 27 9
3 8 2 11 -3 8 -5 -3 -12 3 -14 12 -4 16 -5 16 -6 1z" />
                <path d="M5482 3352 c-9 -6 -5 -12 13 -22 14 -7 28 -10 32 -7 3 4 -1 7 -10 7
-8 0 -17 7 -19 15 -2 9 -8 11 -16 7z" />
                <path d="M5641 3355 c0 -5 6 -18 13 -28 12 -16 14 -16 20 -2 3 9 2 13 -3 10
-6 -3 -14 3 -20 12 -6 10 -10 14 -10 8z" />
                <path d="M5702 3351 c-11 -7 -11 -9 0 -14 9 -3 15 1 15 9 0 8 -1 14 -1 14 -1
0 -7 -4 -14 -9z" />
                <path d="M5435 3340 c-16 -7 -17 -9 -3 -9 9 -1 19 -7 21 -13 3 -7 6 -3 6 10 1
12 0 22 -1 21 -2 0 -12 -4 -23 -9z" />
                <path d="M5160 3330 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z" />
                <path d="M5395 3309 c0 -16 3 -29 8 -29 4 0 7 11 7 24 0 14 -3 27 -7 29 -5 3
-8 -8 -8 -24z" />
                <path d="M5546 3312 c6 -4 14 -14 17 -22 4 -10 6 -8 6 8 1 15 -5 22 -16 22
-11 0 -14 -3 -7 -8z" />
                <path d="M5910 3311 c0 -6 5 -11 11 -11 5 0 7 -4 4 -10 -3 -5 -1 -10 4 -10 16
0 13 16 -4 30 -10 9 -15 9 -15 1z" />
                <path d="M5955 3310 c-3 -6 1 -7 9 -4 18 7 21 14 7 14 -6 0 -13 -4 -16 -10z" />
                <path d="M5290 3285 c7 -8 22 -14 34 -14 17 1 17 2 4 6 -10 2 -18 9 -18 14 0
5 -7 9 -16 9 -14 0 -14 -3 -4 -15z" />
                <path d="M5351 3284 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M5438 3293 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z" />
                <path d="M5867 3289 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 -14 6 -15 5 -6 -5z" />
                <path d="M5999 3277 c6 -8 7 -18 3 -22 -4 -5 -1 -5 6 -1 10 6 10 11 1 22 -6 8
-14 14 -16 14 -3 0 0 -6 6 -13z" />
                <path d="M5786 3252 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6 -4
-9 -8z" />
                <path d="M5911 3214 c11 -19 18 -37 15 -42 -3 -5 1 -9 9 -9 8 0 17 7 19 14 3
8 2 12 -3 9 -11 -7 -44 41 -37 53 3 4 -1 8 -9 8 -11 0 -10 -8 6 -33z" />
                <path d="M5953 3243 c4 -3 2 -12 -3 -19 -8 -8 -7 -11 2 -10 7 0 13 -2 13 -6 0
-4 9 -13 19 -21 17 -13 17 -14 2 -20 -10 -4 -14 -11 -11 -17 4 -6 12 -5 21 5
13 13 12 19 -12 55 -15 22 -29 40 -32 40 -3 0 -2 -3 1 -7z" />
                <path d="M6023 3235 c0 -8 4 -12 9 -9 5 3 6 10 3 15 -9 13 -12 11 -12 -6z" />
                <path d="M5572 3220 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z" />
                <path d="M5665 3229 c-19 -7 -19 -8 0 -8 15 -1 16 -4 7 -13 -7 -7 -12 -16 -12
-21 0 -5 7 -1 16 7 22 22 15 46 -11 35z" />
                <path d="M5717 3220 c9 -11 19 -17 21 -15 6 6 -18 35 -29 35 -5 0 -1 -9 8 -20z" />
                <path d="M5814 3224 c-18 -14 -18 -15 4 -4 12 6 22 13 22 15 0 8 -5 6 -26 -11z" />
                <path d="M5522 3210 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z" />
                <path d="M5631 3214 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M5864 3214 c-18 -14 -18 -15 4 -4 12 6 22 13 22 15 0 8 -5 6 -26 -11z" />
                <path d="M5468 3208 c-6 -17 2 -48 12 -48 8 0 5 48 -3 57 -3 2 -7 -2 -9 -9z" />
                <path d="M6075 3210 c-4 -6 -11 -7 -17 -4 -7 4 -8 2 -4 -5 6 -9 11 -9 22 0 14
11 18 19 10 19 -3 0 -8 -5 -11 -10z" />
                <path d="M5696 3193 c-6 -14 -5 -15 5 -6 7 7 10 15 7 18 -3 3 -9 -2 -12 -12z" />
                <path d="M5822 3200 c2 -8 7 -18 12 -21 5 -4 5 -13 0 -20 -10 -16 -14 -62 -5
-53 3 3 6 15 6 27 1 12 6 21 13 20 17 -4 14 8 -8 37 -11 14 -19 18 -18 10z" />
                <path d="M5735 3180 c-3 -5 1 -10 9 -10 9 0 16 5 16 10 0 6 -4 10 -9 10 -6 0
-13 -4 -16 -10z" />
                <path d="M5582 3160 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z" />
                <path d="M6055 3170 c-3 -6 1 -7 9 -4 9 3 16 2 16 -3 0 -5 7 -18 15 -29 14
-17 14 -15 0 14 -16 33 -29 40 -40 22z" />
                <path d="M5518 3163 c6 -2 9 -10 6 -15 -4 -7 -2 -8 5 -4 6 4 20 2 29 -5 13
-11 12 -8 -2 9 -11 12 -26 22 -35 21 -10 0 -12 -2 -3 -6z" />
                <path d="M5630 3160 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z" />
                <path d="M5686 3155 c4 -8 8 -15 10 -15 2 0 4 7 4 15 0 8 -4 15 -10 15 -5 0
-7 -7 -4 -15z" />
                <path d="M5766 3157 c-17 -13 -18 -14 -2 -20 10 -4 15 -11 12 -16 -3 -5 1 -12
10 -15 8 -3 12 -10 9 -16 -3 -5 -1 -10 4 -10 16 0 13 12 -9 40 -13 18 -16 28
-8 37 14 17 7 16 -16 0z" />
                <path d="M5999 3133 c-13 -16 -12 -17 3 -5 14 11 17 10 23 -7 3 -10 13 -25 23
-33 15 -11 16 -11 5 3 -7 9 -10 19 -6 22 3 4 1 7 -5 7 -7 0 -12 7 -12 15 0 20
-14 19 -31 -2z" />
                <path d="M5856 3132 c-3 -5 1 -9 9 -9 8 0 15 4 15 9 0 4 -4 8 -9 8 -6 0 -12
-4 -15 -8z" />
                <path d="M5651 3096 c-1 -24 1 -27 14 -16 16 14 21 25 6 15 -5 -3 -12 3 -14
12 -3 11 -5 6 -6 -11z" />
                <path d="M5695 3111 c-3 -5 -1 -12 5 -16 6 -4 8 -11 5 -16 -3 -5 2 -6 11 -2
12 4 15 3 10 -5 -5 -8 -1 -10 10 -5 11 4 15 3 10 -5 -3 -6 -1 -14 5 -18 8 -5
9 -3 4 6 -6 10 -4 12 8 7 11 -4 17 -1 17 8 0 10 -6 12 -17 8 -15 -6 -16 -4 -5
9 9 11 10 18 2 23 -6 4 -9 1 -8 -6 2 -6 -3 -14 -11 -17 -8 -2 -11 0 -7 6 3 5
-2 9 -12 8 -9 0 -16 5 -14 12 2 14 -4 16 -13 3z" />
                <path d="M5886 3107 c-17 -13 -18 -14 -2 -20 10 -4 15 -11 12 -16 -3 -5 1 -12
10 -15 14 -5 14 -9 3 -23 -13 -15 -12 -15 8 -5 l22 12 -25 27 c-18 20 -21 29
-13 39 15 18 8 18 -15 1z" />
                <path d="M5615 3100 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z" />
                <path d="M5983 3085 c0 -8 6 -16 14 -19 11 -4 11 -1 3 14 -13 24 -17 25 -17 5z" />
                <path d="M5675 3060 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z" />
                <path d="M5815 3060 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z" />
                <path d="M6066 3057 c3 -10 9 -15 12 -12 3 3 0 11 -7 18 -10 9 -11 8 -5 -6z" />
                <path d="M5715 3041 c-3 -6 3 -15 14 -21 14 -7 22 -7 26 0 4 6 3 10 -2 9 -20
-3 -34 2 -28 11 3 6 4 10 1 10 -3 0 -7 -4 -11 -9z" />
                <path d="M5781 3041 c-10 -6 -9 -10 3 -14 8 -3 18 -2 21 3 8 13 -9 20 -24 11z" />
                <path d="M6016 3036 c7 -19 20 -21 30 -3 4 6 4 9 -1 5 -4 -4 -14 -3 -22 4 -11
8 -12 7 -7 -6z" />
                <path d="M275 3030 c-19 -8 -19 -9 3 -9 12 -1 22 4 22 9 0 6 -1 10 -2 9 -2 0
-12 -4 -23 -9z" />
                <path d="M5819 3023 c-12 -16 -12 -17 2 -6 9 7 19 10 22 6 4 -3 7 -1 7 5 0 17
-16 15 -31 -5z" />
                <path d="M138 3003 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M5760 3004 c0 -1 6 -7 14 -13 10 -9 15 -8 19 2 3 8 -3 13 -14 13 -11
0 -19 -1 -19 -2z" />
                <path d="M5943 2979 c-36 -23 -43 -32 -16 -22 13 5 15 2 10 -11 -4 -11 -3 -15
4 -11 6 4 8 13 5 20 -6 18 5 27 18 15 8 -6 12 -3 12 11 0 10 0 19 -1 19 0 0
-15 -10 -32 -21z" />
                <path d="M6040 2996 c0 -2 9 -6 20 -9 11 -3 18 -1 14 4 -5 9 -34 13 -34 5z" />
                <path d="M5870 2971 c5 -11 15 -23 21 -27 6 -3 3 5 -6 20 -20 30 -30 35 -15 7z" />
                <path d="M6096 2972 c-7 -20 -10 -21 -24 -10 -15 11 -15 11 -4 -4 17 -22 -3
-35 -26 -16 -15 12 -16 11 -4 -4 8 -9 11 -22 7 -28 -12 -19 3 -10 35 21 17 17
29 39 27 48 -2 12 -5 10 -11 -7z" />
                <path d="M5996 2961 c-14 -15 -15 -21 -4 -27 7 -4 10 -3 5 1 -4 5 0 17 10 27
9 10 14 18 11 18 -3 0 -13 -9 -22 -19z" />
                <path d="M5867 2929 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 -14 6 -15 5 -6 -5z" />
                <path d="M5988 2913 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M5920 2885 c14 -17 26 -32 28 -34 1 -3 1 7 0 22 -1 14 -6 23 -11 20
-4 -2 -16 1 -25 8 -9 8 -6 0 8 -16z" />
                <path d="M372 2865 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z" />
                <path d="M6083 2875 c0 -8 4 -12 9 -9 5 3 6 10 3 15 -9 13 -12 11 -12 -6z" />
                <path d="M5990 2852 c0 -10 36 -9 46 1 4 4 -5 7 -19 7 -15 0 -27 -4 -27 -8z" />
                <path d="M160 2766 c0 -2 8 -10 18 -17 15 -13 16 -12 3 4 -13 16 -21 21 -21
13z" />
                <path d="M216 2717 c3 -10 9 -15 12 -12 3 3 0 11 -7 18 -10 9 -11 8 -5 -6z" />
                <path d="M331 2717 c-6 -8 -8 -17 -4 -20 12 -12 19 -7 19 13 0 24 0 24 -15 7z" />
                <path d="M237 2697 c-4 -10 3 -12 24 -9 16 2 29 8 29 13 0 14 -47 10 -53 -4z" />
                <path d="M368 2703 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z" />
                <path d="M424 2659 c-4 -7 -3 -9 4 -5 6 3 15 -2 21 -11 6 -10 11 -13 11 -7 0
20 -27 37 -36 23z" />
                <path d="M100 2626 c0 -7 40 -14 44 -7 3 4 -6 8 -20 9 -13 1 -24 0 -24 -2z" />
                <path d="M586 2606 c4 -10 -3 -16 -18 -19 -18 -3 -16 -4 5 -3 21 1 32 -6 42
-24 8 -14 14 -21 15 -16 0 10 -39 76 -46 76 -2 0 -1 -6 2 -14z" />
                <path d="M331 2557 l-25 -32 32 29 c33 31 37 36 25 35 -5 0 -19 -14 -32 -32z" />
                <path d="M468 2583 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z" />
                <path d="M288 2573 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M941 2564 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M111 2503 c-10 -26 -10 -27 4 -9 8 11 15 23 15 28 0 15 -7 8 -19 -19z" />
                <path d="M289 2503 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21 -13z" />
                <path d="M985 2469 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z" />
                <path d="M833 2433 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z" />
                <path d="M738 2423 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z" />
                <path d="M658 2403 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M290 2372 c0 -6 6 -13 13 -15 9 -4 9 -7 0 -14 -9 -6 -7 -14 6 -31
l17 -23 -4 35 c-4 32 -32 74 -32 48z" />
                <path d="M525 2359 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z" />
                <path d="M698 2353 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M521 2314 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M488 2303 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M792 2290 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z" />
                <path d="M818 2283 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z" />
                <path d="M648 2273 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M330 2266 c0 -2 9 -6 20 -9 11 -3 18 -1 14 4 -5 9 -34 13 -34 5z" />
                <path d="M416 2245 c-11 -8 -15 -15 -9 -15 6 0 16 7 23 15 16 19 11 19 -14 0z" />
                <path d="M568 2253 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M658 2234 c-3 -24 -1 -31 9 -27 8 3 13 -2 13 -13 0 -9 3 -14 7 -11 3
4 1 17 -5 30 -6 12 -12 29 -15 37 -2 8 -6 1 -9 -16z" />
                <path d="M201 2228 l-14 -23 24 20 c13 11 26 21 28 22 2 2 -2 3 -10 3 -8 0
-20 -10 -28 -22z" />
                <path d="M143 2233 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z" />
                <path d="M759 2223 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21 -13z" />
                <path d="M550 2213 c0 -10 4 -14 8 -8 4 6 11 13 16 18 5 4 2 7 -7 7 -10 0 -17
-8 -17 -17z" />
                <path d="M466 2202 c-2 -4 4 -8 14 -8 10 0 16 4 14 8 -3 4 -9 8 -14 8 -5 0
-11 -4 -14 -8z" />
                <path d="M718 2203 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M178 2173 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M535 2170 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7
-4 -4 -10z" />
                <path d="M210 2159 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z" />
                <path d="M556 2152 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6 -4
-9 -8z" />
                <path d="M316 2142 c-3 -5 8 -6 25 -4 16 2 29 6 29 8 0 8 -49 4 -54 -4z" />
                <path d="M174 2108 l-29 -33 33 29 c17 17 32 31 32 33 0 8 -8 1 -36 -29z" />
                <path d="M229 2053 l-24 -28 30 25 c17 14 32 26 34 28 2 1 0 2 -6 2 -5 0 -20
-12 -34 -27z" />
                <path d="M318 2063 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M688 2013 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z" />
                <path d="M670 1986 c0 -9 30 -14 35 -6 4 6 -3 10 -14 10 -12 0 -21 -2 -21 -4z" />
                <path d="M560 1970 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z" />
                <path d="M645 1950 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z" />
                <path d="M549 1935 c-1 -5 -1 -14 0 -19 1 -5 -4 -13 -11 -18 -9 -6 -7 -8 7 -5
11 2 19 9 17 17 -2 8 4 20 13 27 16 11 15 12 -4 10 -11 -1 -22 -6 -22 -12z" />
                <path d="M5138 1943 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z" />
                <path d="M5233 1943 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z" />
                <path d="M475 1930 c-3 -5 -2 -10 4 -10 5 0 13 5 16 10 3 6 2 10 -4 10 -5 0
-13 -4 -16 -10z" />
                <path d="M673 1929 c-43 -12 -42 -18 2 -16 20 1 35 7 35 15 0 6 -1 12 -2 11
-2 0 -18 -5 -35 -10z" />
                <path d="M5513 1912 c16 -7 15 -11 -9 -47 -14 -22 -17 -30 -6 -18 11 12 22 20
24 18 3 -3 5 1 5 8 0 6 2 18 4 26 2 9 -4 16 -16 18 -17 2 -18 2 -2 -5z" />
                <path d="M470 1895 c-14 -8 -20 -14 -15 -14 6 0 21 6 35 14 14 8 21 14 15 14
-5 0 -21 -6 -35 -14z" />
                <path d="M5984 1895 c-3 -8 -2 -32 4 -52 9 -38 9 -38 8 14 -1 56 -3 62 -12 38z" />
                <path d="M6028 1903 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M40 1885 c0 -8 2 -15 4 -15 2 0 6 7 10 15 3 8 1 15 -4 15 -6 0 -10
-7 -10 -15z" />
                <path d="M217 1889 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 -14 6 -15 5 -6 -5z" />
                <path d="M713 1893 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z" />
                <path d="M500 1879 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z" />
                <path d="M5635 1880 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z" />
                <path d="M160 1870 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z" />
                <path d="M546 1872 c-3 -5 1 -9 9 -9 8 0 15 4 15 9 0 4 -4 8 -9 8 -6 0 -12 -4
-15 -8z" />
                <path d="M605 1860 c-10 -11 -22 -17 -26 -14 -5 3 -9 0 -9 -6 0 -5 -19 -19
-42 -29 -96 -42 -134 -64 -59 -33 10 4 9 -2 -4 -21 -9 -15 -22 -24 -28 -20 -6
4 -7 1 -2 -6 5 -9 10 -10 18 -2 6 6 27 12 47 12 l35 2 -34 6 c-32 6 -32 7 -15
22 11 9 43 28 71 41 29 14 50 27 48 30 -3 3 2 11 12 19 15 12 16 12 10 -3 -4
-12 -2 -15 9 -11 11 4 12 9 3 19 -14 17 -12 18 -34 -6z" />
                <path d="M5668 1873 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M5920 1876 c0 -2 8 -10 18 -17 15 -13 16 -12 3 4 -13 16 -21 21 -21
13z" />
                <path d="M5616 1853 c-6 -14 -5 -15 5 -6 7 7 10 15 7 18 -3 3 -9 -2 -12 -12z" />
                <path d="M515 1850 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7
-4 -4 -10z" />
                <path d="M710 1849 c0 -5 9 -9 20 -9 11 0 20 2 20 4 0 2 -9 6 -20 9 -11 3 -20
1 -20 -4z" />
                <path d="M358 1843 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M430 1842 c0 -4 6 -16 13 -26 10 -14 14 -15 14 -4 0 7 -6 19 -14 26
-7 7 -13 9 -13 4z" />
                <path d="M480 1840 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z" />
                <path d="M5565 1840 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z" />
                <path d="M402 1828 c-5 -7 -6 -22 -2 -33 6 -17 8 -15 12 13 5 36 5 37 -10 20z" />
                <path d="M640 1830 c0 -5 -7 -10 -17 -10 -9 0 -14 -3 -10 -6 3 -4 14 -3 24 1
10 5 24 9 31 11 26 5 25 14 -1 14 -15 0 -27 -4 -27 -10z" />
                <path d="M258 1815 c10 -20 12 -27 12 -45 0 -5 4 -10 8 -10 15 0 8 36 -11 55
-19 20 -20 20 -9 0z" />
                <path d="M5590 1819 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z" />
                <path d="M5365 1796 c0 -18 3 -22 13 -14 9 8 9 14 1 24 -15 18 -14 18 -14 -10z" />
                <path d="M5800 1798 c0 -6 -8 -21 -17 -32 -13 -16 -11 -15 9 3 15 13 25 28 22
32 -7 13 -14 11 -14 -3z" />
                <path d="M618 1793 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M6002 1775 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z" />
                <path d="M543 1783 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z" />
                <path d="M663 1774 c-3 -8 -1 -20 5 -26 8 -8 9 -4 5 12 -5 17 -3 21 7 15 9 -5
11 -4 6 3 -10 16 -15 15 -23 -4z" />
                <path d="M618 1773 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M207 1744 c3 -8 -5 -16 -21 -20 -26 -6 -33 -18 -17 -28 5 -3 12 1 15
10 4 10 14 14 25 11 14 -3 18 0 14 17 -3 15 0 13 13 -9 11 -20 13 -30 5 -33
-6 -2 -11 -9 -11 -17 0 -7 -7 -18 -15 -25 -17 -14 -20 -40 -4 -40 5 0 7 4 4
10 -9 14 44 80 64 80 13 1 12 3 -4 12 -11 6 -26 18 -33 26 -15 20 -42 25 -35
6z" />
                <path d="M611 1728 c2 -30 2 -30 6 -6 2 15 12 29 21 31 12 3 10 5 -5 6 -20 1
-23 -4 -22 -31z" />
                <path d="M389 1733 c-13 -17 -13 -17 6 -3 11 8 22 16 24 17 2 2 0 3 -6 3 -6 0
-17 -8 -24 -17z" />
                <path d="M5727 1736 c-4 -10 -1 -13 8 -9 8 3 12 9 9 14 -7 12 -11 11 -17 -5z" />
                <path d="M5428 1733 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M38 1689 c-9 -16 -13 -31 -8 -34 5 -3 12 5 16 17 4 13 11 26 16 29 6
4 6 9 1 12 -5 3 -16 -8 -25 -24z" />
                <path d="M136 1707 c3 -10 9 -15 12 -12 3 3 0 11 -7 18 -10 9 -11 8 -5 -6z" />
                <path d="M300 1710 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z" />
                <path d="M426 1703 c-3 -3 -5 -18 -5 -32 1 -21 2 -22 6 -6 3 11 10 23 15 26 7
4 7 9 0 12 -5 4 -12 4 -16 0z" />
                <path d="M315 1680 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7
-4 -4 -10z" />
                <path d="M388 1683 c-10 -2 -18 -7 -18 -9 0 -10 30 -36 31 -27 0 4 2 16 4 26
2 9 3 16 2 16 -1 -1 -10 -3 -19 -6z" />
                <path d="M70 1670 c-8 -5 -10 -10 -5 -10 6 0 17 5 25 10 8 5 11 10 5 10 -5 0
-17 -5 -25 -10z" />
                <path d="M121 1675 c0 -5 6 -21 14 -35 8 -14 14 -20 14 -15 0 6 -6 21 -14 35
-8 14 -14 21 -14 15z" />
                <path d="M567 1660 c-3 -11 -1 -20 4 -20 5 0 9 9 9 20 0 11 -2 20 -4 20 -2 0
-6 -9 -9 -20z" />
                <path d="M335 1660 c-11 -5 -14 -9 -6 -9 9 -1 10 -5 3 -13 -7 -9 -6 -17 5 -27
13 -12 14 -11 8 8 -7 24 4 27 25 9 8 -7 7 -4 -3 8 -9 11 -14 24 -10 27 8 9 3
8 -22 -3z" />
                <path d="M440 1659 c0 -5 11 -9 25 -9 14 0 25 2 25 4 0 2 -11 6 -25 8 -14 3
-25 1 -25 -3z" />
                <path d="M5818 1663 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M280 1651 c0 -5 5 -13 10 -16 6 -3 10 -2 10 4 0 5 -4 13 -10 16 -5 3
-10 2 -10 -4z" />
                <path d="M502 1640 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z" />
                <path d="M532 1629 c-2 -29 2 -38 18 -42 13 -3 20 0 20 9 0 7 -6 11 -14 8 -11
-4 -16 4 -19 28 l-4 33 -1 -36z" />
                <path d="M5900 1655 c0 -5 5 -17 10 -25 5 -8 10 -10 10 -5 0 6 -5 17 -10 25
-5 8 -10 11 -10 5z" />
                <path d="M235 1620 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7
-4 -4 -10z" />
                <path d="M390 1618 c0 -9 -6 -19 -12 -21 -10 -4 -10 -6 0 -6 14 -1 28 26 18
36 -3 4 -6 -1 -6 -9z" />
                <path d="M417 1617 c-5 -12 -1 -17 12 -17 11 0 22 -6 24 -12 4 -10 6 -10 6 0
1 19 29 14 33 -5 3 -15 5 -14 10 5 6 20 3 22 -32 22 -21 0 -40 5 -42 12 -3 7
-7 6 -11 -5z" />
                <path d="M5851 1608 c16 -32 17 -32 15 -4 0 14 -7 26 -14 26 -10 0 -10 -5 -1
-22z" />
                <path d="M47 1600 c6 -23 14 -25 32 -7 11 10 12 7 6 -13 -4 -18 -3 -21 3 -11
9 12 11 12 15 0 2 -8 2 -3 0 11 -6 33 -10 35 -28 20 -13 -11 -14 -10 -9 4 4
10 1 16 -9 16 -10 0 -13 -7 -10 -20z" />
                <path d="M180 1611 c0 -6 4 -13 10 -16 6 -3 7 1 4 9 -7 18 -14 21 -14 7z" />
                <path d="M26 1585 c9 -38 10 -39 26 -28 11 6 8 13 -10 33 l-24 25 8 -30z" />
                <path d="M130 1601 c-25 -7 -25 -7 -2 -13 13 -4 22 -2 22 5 0 7 5 5 10 -3 8
-13 10 -12 10 3 0 18 -2 19 -40 8z" />
                <path d="M259 1581 c7 -13 8 -22 1 -26 -13 -8 -13 -25 1 -25 5 0 7 5 4 10 -3
6 2 14 12 18 10 4 20 14 21 22 2 8 0 12 -3 8 -4 -4 -16 -3 -27 3 -17 9 -18 8
-9 -10z" />
                <path d="M335 1579 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z" />
                <path d="M150 1565 c0 -5 5 -17 10 -25 5 -8 10 -10 10 -5 0 6 -5 17 -10 25 -5
8 -10 11 -10 5z" />
                <path d="M437 1563 c-11 -11 -8 -20 7 -20 8 0 12 6 9 14 -6 15 -7 15 -16 6z" />
                <path d="M5631 1553 c17 -28 32 -29 50 -5 13 15 12 16 -4 3 -15 -12 -20 -11
-39 5 -21 19 -21 19 -7 -3z" />
                <path d="M285 1540 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z" />
                <path d="M5855 1540 c4 -6 11 -8 16 -5 14 9 11 15 -7 15 -8 0 -12 -5 -9 -10z" />
                <path d="M90 1525 c0 -8 -5 -15 -12 -15 -6 0 -9 -2 -6 -5 9 -10 35 5 35 20 0
8 -4 15 -9 15 -4 0 -8 -7 -8 -15z" />
                <path d="M470 1525 c0 -8 2 -15 4 -15 2 0 6 7 10 15 3 8 1 15 -4 15 -6 0 -10
-7 -10 -15z" />
                <path d="M515 1532 c-5 -4 -11 -15 -11 -24 -1 -14 2 -15 17 -5 11 7 15 13 9
15 -6 2 -8 8 -4 13 6 11 3 11 -11 1z" />
                <path d="M6051 1524 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M20 1520 c0 -6 7 -10 15 -10 19 0 19 6 0 14 -8 3 -15 1 -15 -4z" />
                <path d="M5807 1516 c-4 -10 -1 -13 8 -9 8 3 12 9 9 14 -7 12 -11 11 -17 -5z" />
                <path d="M158 1513 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M379 1511 c7 -5 11 -13 7 -19 -4 -6 2 -10 14 -9 11 1 20 3 20 6 0 7
-34 30 -45 31 -5 0 -4 -4 4 -9z" />
                <path d="M5665 1510 c-3 -6 1 -7 9 -4 9 4 18 -1 22 -10 3 -9 11 -16 17 -16 5
0 2 9 -8 20 -20 22 -31 25 -40 10z" />
                <path d="M338 1503 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M5952 1490 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z" />
                <path d="M245 1491 c-3 -5 -1 -12 5 -16 5 -3 10 1 10 9 0 18 -6 21 -15 7z" />
                <path d="M457 1486 c-4 -10 1 -12 14 -9 23 6 24 9 5 16 -8 3 -17 0 -19 -7z" />
                <path d="M5475 1475 c0 -13 4 -21 9 -18 4 3 12 -1 17 -8 5 -9 7 -4 6 15 -3 35
-32 45 -32 11z" />
                <path d="M5907 1480 c10 -11 19 -20 21 -20 1 0 -2 9 -8 20 -6 11 -15 20 -20
20 -6 0 -2 -9 7 -20z" />
                <path d="M5405 1479 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z" />
                <path d="M10 1468 c0 -4 13 -8 30 -8 39 0 39 6 0 12 -17 3 -30 1 -30 -4z" />
                <path d="M270 1476 c0 -2 7 -6 15 -10 8 -3 15 -1 15 4 0 6 -7 10 -15 10 -8 0
-15 -2 -15 -4z" />
                <path d="M330 1470 c0 -5 7 -7 15 -4 8 4 15 8 15 10 0 2 -7 4 -15 4 -8 0 -15
-4 -15 -10z" />
                <path d="M5760 1445 c19 -19 37 -35 41 -35 4 0 -9 16 -28 35 -19 19 -38 35
-41 35 -3 0 9 -16 28 -35z" />
                <path d="M5983 1466 c-21 -12 -21 -12 -1 -25 12 -8 17 -8 13 -1 -4 6 -1 17 5
25 14 17 13 17 -17 1z" />
                <path d="M405 1460 c-3 -5 -2 -10 4 -10 5 0 13 5 16 10 3 6 2 10 -4 10 -5 0
-13 -4 -16 -10z" />
                <path d="M135 1413 c0 -43 0 -43 35 -42 30 2 31 3 8 6 -23 4 -28 9 -28 34 0
26 3 29 34 29 19 0 37 4 41 10 3 5 -14 8 -42 7 l-48 -2 0 -42z" />
                <path d="M5391 1434 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M5665 1440 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z" />
                <path d="M5922 1438 c-7 -7 -12 -17 -12 -22 0 -6 5 -4 10 4 9 13 11 13 20 0 7
-12 9 -10 7 8 -1 25 -8 27 -25 10z" />
                <path d="M211 1424 c-12 -14 -10 -15 10 -12 12 1 24 9 27 16 5 17 -20 14 -37
-4z" />
                <path d="M5877 1429 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 -14 6 -15 5 -6 -5z" />
                <path d="M5501 1426 c2 -2 14 -9 26 -15 18 -9 22 -9 18 2 -3 7 -15 13 -26 14
-12 1 -20 1 -18 -1z" />
                <path d="M5703 1410 c8 -14 18 -24 21 -22 4 2 15 -7 25 -19 12 -15 20 -19 25
-11 4 7 1 12 -6 12 -7 0 -19 9 -26 21 -7 12 -16 18 -19 15 -3 -3 -13 2 -21 12
-12 14 -12 13 1 -8z" />
                <path d="M5850 1410 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z" />
                <path d="M5635 1400 c3 -5 10 -10 16 -10 5 0 9 5 9 10 0 6 -7 10 -16 10 -8 0
-12 -4 -9 -10z" />
                <path d="M5896 1384 c-5 -13 -9 -14 -21 -4 -9 7 -15 8 -15 2 0 -14 28 -23 35
-11 4 5 11 7 16 4 5 -3 6 1 3 9 -8 20 -10 20 -18 0z" />
                <path d="M6010 1396 c0 -2 8 -10 18 -17 15 -13 16 -12 3 4 -13 16 -21 21 -21
13z" />
                <path d="M468 1378 c5 -5 16 -8 23 -6 8 3 3 7 -10 11 -17 4 -21 3 -13 -5z" />
                <path d="M111 1364 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M206 1365 c-9 -26 -7 -32 5 -12 6 10 9 21 6 23 -2 3 -7 -2 -11 -11z" />
                <path d="M441 1373 c-1 -6 -4 -20 -7 -30 -5 -17 -5 -17 6 0 6 10 9 23 6 30 -3
9 -5 9 -5 0z" />
                <path d="M517 1365 c2 -7 13 -11 24 -8 25 7 24 10 -5 15 -16 3 -23 1 -19 -7z" />
                <path d="M5650 1335 c0 -27 2 -46 4 -44 8 8 10 78 3 85 -4 4 -7 -14 -7 -41z" />
                <path d="M265 1360 c3 -5 12 -7 20 -3 21 7 19 13 -6 13 -11 0 -18 -4 -14 -10z" />
                <path d="M6054 1342 c0 -10 8 -18 18 -18 16 0 16 2 1 18 -9 10 -17 18 -17 18
-1 0 -2 -8 -2 -18z" />
                <path d="M862 1330 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z" />
                <path d="M5780 1337 c0 -7 9 -13 19 -13 15 0 17 3 9 13 -6 7 -14 13 -19 13 -5
0 -9 -6 -9 -13z" />
                <path d="M110 1336 c0 -2 13 -6 29 -8 17 -2 28 -1 25 4 -5 8 -54 12 -54 4z" />
                <path d="M238 1333 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M5691 1337 c2 -1 13 -9 24 -17 19 -14 19 -14 6 3 -7 9 -18 17 -24 17
-6 0 -8 -1 -6 -3z" />
                <path d="M427 1313 c-4 -3 -7 -16 -6 -27 0 -19 1 -19 10 3 10 24 8 36 -4 24z" />
                <path d="M5768 1299 c-4 -9 2 -21 15 -29 19 -11 20 -11 11 1 -6 8 -13 21 -16
28 -4 13 -5 13 -10 0z" />
                <path d="M6011 1301 c-7 -5 -12 -14 -10 -20 2 -6 10 -2 17 9 14 22 13 23 -7
11z" />
                <path d="M36 1293 c5 -5 12 -12 16 -18 4 -6 8 -2 8 8 0 9 -7 17 -17 17 -9 0
-12 -3 -7 -7z" />
                <path d="M103 1256 c1 -17 9 -31 17 -33 10 -3 11 -2 4 4 -7 4 -14 19 -17 33
-4 22 -5 21 -4 -4z" />
                <path d="M780 1269 c0 -5 10 -14 22 -20 21 -11 21 -12 3 -25 -10 -8 -14 -14
-8 -14 7 0 22 15 34 33 12 17 16 26 9 20 -18 -17 -30 -16 -30 0 0 8 -7 14 -15
14 -8 0 -15 -4 -15 -8z" />
                <path d="M5320 1265 c-7 -9 -8 -15 -2 -15 5 0 12 7 16 15 3 8 4 15 2 15 -2 0
-9 -7 -16 -15z" />
                <path d="M550 1255 c0 -9 6 -12 15 -9 8 4 15 7 15 9 0 2 -7 5 -15 9 -9 3 -15
0 -15 -9z" />
                <path d="M190 1251 c0 -5 -7 -17 -16 -25 -8 -9 -10 -16 -4 -16 6 0 14 -10 19
-22 6 -16 8 -9 8 25 0 26 -2 47 -4 47 -1 0 -3 -4 -3 -9z" />
                <path d="M507 1241 c-3 -13 -1 -18 9 -14 7 2 10 11 7 19 -7 19 -10 18 -16 -5z" />
                <path d="M5393 1236 c-9 -11 -6 -19 15 -39 25 -23 28 -24 42 -9 13 14 12 15
-4 9 -24 -10 -48 11 -41 34 7 22 4 23 -12 5z" />
                <path d="M6059 1233 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21 -13z" />
                <path d="M5939 1218 c21 -24 41 -29 41 -11 0 4 -3 3 -7 0 -3 -4 -18 3 -32 15
l-26 23 24 -27z" />
                <path d="M476 1213 c-6 -14 -5 -15 5 -6 7 7 10 15 7 18 -3 3 -9 -2 -12 -12z" />
                <path d="M41 1204 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M5382 1170 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z" />
                <path d="M5600 1170 c0 -5 7 -7 15 -4 8 4 15 8 15 10 0 2 -7 4 -15 4 -8 0 -15
-4 -15 -10z" />
                <path d="M5731 1158 c-1 -10 -7 -18 -13 -18 -9 0 -10 -3 -2 -8 6 -4 11 -22 12
-39 1 -32 -1 -33 -39 -33 -21 0 -39 -5 -39 -11 0 -5 5 -7 10 -4 6 3 10 -1 10
-10 0 -9 5 -13 10 -10 6 4 7 11 4 17 -4 7 5 9 28 6 26 -3 34 0 31 9 -3 7 1 13
8 13 10 0 10 3 1 12 -16 16 -16 52 1 42 9 -6 9 -4 1 7 -6 8 -14 21 -17 29 -4
12 -6 11 -6 -2z" />
                <path d="M338 1153 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M5452 1152 c-8 -6 -2 -9 18 -9 20 0 26 3 18 9 -7 4 -15 8 -18 8 -3 0
-11 -4 -18 -8z" />
                <path d="M5652 1130 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z" />
                <path d="M5781 1137 c-8 -10 -7 -14 4 -14 8 0 11 5 8 10 -4 6 1 8 11 4 10 -4
15 -3 11 3 -8 14 -20 12 -34 -3z" />
                <path d="M5510 1136 c0 -2 8 -10 17 -17 9 -8 14 -9 10 -2 -4 7 0 13 10 16 11
3 8 5 -9 6 -16 0 -28 -1 -28 -3z" />
                <path d="M5400 1126 c0 -2 8 -10 18 -17 15 -13 16 -12 3 4 -13 16 -21 21 -21
13z" />
                <path d="M50 1110 c0 -6 7 -10 15 -10 19 0 19 6 0 14 -8 3 -15 1 -15 -4z" />
                <path d="M646 1112 c-3 -2 -2 -10 1 -18 3 -8 0 -14 -6 -14 -6 0 -11 -11 -11
-25 0 -14 5 -25 10 -25 6 0 10 10 10 23 0 12 6 32 14 43 13 18 13 21 0 21 -8
0 -16 -2 -18 -5z" />
                <path d="M869 1099 c-1 -13 -1 -28 0 -32 2 -10 -20 -32 -39 -40 -8 -3 1 -4 20
-3 34 3 34 4 31 47 -3 49 -10 65 -12 28z" />
                <path d="M921 1104 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M5620 1090 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z" />
                <path d="M5490 1081 c0 -10 19 -25 25 -20 1 2 -3 10 -11 17 -8 7 -14 8 -14 3z" />
                <path d="M6010 1081 c0 -5 7 -11 14 -14 10 -4 13 -1 9 9 -6 15 -23 19 -23 5z" />
                <path d="M756 1064 c-8 -22 -7 -34 3 -34 5 0 11 11 13 25 6 28 -6 34 -16 9z" />
                <path d="M5578 1073 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M5791 1062 c-1 -8 -6 -10 -13 -6 -7 4 -3 -4 10 -18 20 -22 21 -26 7
-38 -9 -7 -13 -20 -10 -27 3 -9 0 -13 -7 -10 -7 2 -12 11 -10 19 1 9 -4 20
-11 27 -10 8 -14 7 -14 -4 0 -8 4 -12 9 -9 4 3 8 1 8 -5 0 -5 -4 -12 -9 -15
-12 -8 -34 21 -26 33 3 7 0 8 -9 5 -19 -7 -21 -21 -5 -26 9 -3 9 -9 0 -26 -10
-18 -9 -21 4 -16 8 3 12 10 9 15 -3 5 -1 9 5 9 22 0 22 -24 0 -42 -13 -11 -17
-16 -9 -12 8 4 23 14 33 22 16 14 20 14 39 -6 20 -20 21 -22 5 -40 -15 -16
-15 -21 -3 -37 12 -16 17 -17 37 -7 l24 12 -26 -5 c-40 -7 -41 16 -3 55 l34
34 -22 22 c-13 12 -25 19 -28 17 -3 -2 6 -12 18 -22 21 -15 22 -19 8 -30 -17
-14 -40 -6 -30 11 4 6 2 8 -3 5 -18 -11 -12 43 6 56 10 7 21 19 26 27 7 12 6
13 -7 3 -22 -19 -31 -3 -11 21 15 17 15 18 1 8 -13 -10 -17 -10 -21 0 -4 11
-6 10 -6 0z" />
                <path d="M5605 1050 c-13 -6 -15 -9 -5 -9 8 0 22 4 30 9 18 12 2 12 -25 0z" />
                <path d="M5920 1053 c1 -30 42 -40 61 -16 13 17 13 17 -4 3 -17 -12 -20 -12
-28 3 -10 17 -29 23 -29 10z" />
                <path d="M537 1034 c12 -3 24 -13 27 -22 3 -12 4 -11 3 3 -2 14 -10 21 -27 22
-21 1 -21 1 -3 -3z" />
                <path d="M781 1014 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M640 1009 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z" />
                <path d="M5906 978 c2 -25 -2 -46 -9 -50 -6 -4 -8 -10 -5 -14 9 -9 59 46 52
57 -3 5 -10 6 -16 3 -6 -4 -9 -3 -5 2 3 5 0 17 -7 27 -11 15 -13 11 -10 -25z
m29 -18 c-3 -5 -12 -10 -18 -10 -7 0 -6 4 3 10 19 12 23 12 15 0z" />
                <path d="M842 985 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z" />
                <path d="M5606 996 c3 -8 12 -17 20 -20 11 -4 12 -2 1 14 -14 23 -29 27 -21 6z" />
                <path d="M660 991 c0 -6 9 -15 19 -21 24 -12 81 -13 81 -1 0 4 -11 6 -25 3
-14 -2 -36 3 -50 12 -14 9 -25 12 -25 7z" />
                <path d="M5870 985 c-11 -13 -10 -14 4 -9 9 3 16 10 16 15 0 13 -6 11 -20 -6z" />
                <path d="M5955 984 c13 -13 13 -19 3 -33 -12 -14 -11 -15 4 -2 14 10 15 18 7
32 -5 10 -14 19 -20 19 -6 0 -3 -7 6 -16z" />
                <path d="M793 983 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z" />
                <path d="M5666 974 c-5 -14 -4 -15 9 -4 17 14 19 20 6 20 -5 0 -12 -7 -15 -16z" />
                <path d="M188 973 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M1092 953 c-10 -4 -9 -8 5 -19 10 -7 23 -13 28 -13 6 0 2 4 -8 10 -9
6 -15 14 -12 20 7 10 6 10 -13 2z" />
                <path d="M58 943 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M428 933 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M758 933 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M478 923 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z" />
                <path d="M678 923 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z" />
                <path d="M1286 916 c3 -7 -2 -20 -10 -29 -15 -15 -12 -27 7 -27 6 0 7 3 4 7
-4 3 0 16 8 29 12 19 12 23 0 28 -9 3 -12 0 -9 -8z" />
                <path d="M568 913 c12 -2 30 -2 40 0 9 3 -1 5 -23 4 -22 0 -30 -2 -17 -4z" />
                <path d="M1088 913 c6 -2 10 -8 7 -13 -3 -4 3 -14 13 -21 16 -13 16 -13 2 5
-14 18 -13 19 5 13 20 -7 20 -7 1 8 -11 8 -25 15 -30 14 -6 0 -5 -3 2 -6z" />
                <path d="M1158 913 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M5585 910 c-3 -6 1 -7 9 -4 18 7 21 14 7 14 -6 0 -13 -4 -16 -10z" />
                <path d="M5963 899 c-2 -23 3 -25 10 -4 4 8 3 16 -1 19 -4 3 -9 -4 -9 -15z" />
                <path d="M1216 893 c-6 -14 -5 -15 5 -6 7 7 10 15 7 18 -3 3 -9 -2 -12 -12z" />
                <path d="M339 847 c-8 -23 -20 -41 -26 -40 -7 1 -9 -6 -5 -19 5 -21 5 -21 14
2 l9 23 20 -22 c11 -11 17 -26 14 -31 -3 -5 0 -7 7 -5 16 6 65 -41 55 -52 -4
-3 -17 2 -29 13 l-23 19 18 -22 c19 -22 15 -49 -5 -37 -6 4 -8 2 -4 -4 9 -15
-13 -27 -26 -14 -8 8 -7 16 3 28 13 16 12 16 -8 3 -20 -12 -21 -15 -7 -30 14
-16 13 -20 -12 -48 -15 -17 -30 -29 -34 -26 -4 2 -7 -2 -7 -9 0 -7 6 -13 13
-13 7 0 12 5 11 11 -1 6 4 10 11 8 8 -1 11 2 8 7 -4 5 -1 13 5 17 7 4 24 -6
41 -25 15 -17 28 -28 28 -23 0 5 -11 19 -25 32 -27 26 -33 45 -11 37 8 -3 13
1 12 11 0 9 5 16 12 14 8 -1 11 2 8 7 -10 15 14 24 29 11 16 -13 10 -34 -6
-25 -5 3 -6 -1 -2 -10 3 -10 0 -21 -8 -26 -12 -7 -12 -9 1 -9 9 1 27 27 42 63
16 34 21 53 13 43 -8 -10 -16 -24 -18 -30 -3 -8 -8 -7 -18 1 -10 10 -8 18 12
40 13 15 16 21 6 14 -15 -12 -21 -11 -43 10 -13 12 -22 29 -20 36 3 7 -1 10
-8 7 -7 -3 -20 4 -29 14 -14 16 -15 24 -6 51 6 18 9 34 7 36 -2 2 -11 -15 -19
-38z" />
                <path d="M1190 866 c0 -3 9 -10 20 -16 11 -6 20 -8 20 -6 0 3 -9 10 -20 16
-11 6 -20 8 -20 6z" />
                <path d="M93 853 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z" />
                <path d="M410 850 c-13 -8 -13 -10 0 -10 11 0 11 -3 2 -12 -16 -16 -15 -29 1
-25 6 1 11 -4 9 -11 -1 -8 2 -11 8 -7 6 4 17 3 23 -2 7 -4 3 1 -10 12 -28 25
-30 39 -4 32 13 -3 18 -1 14 9 -2 7 -12 10 -20 7 -11 -4 -14 -2 -9 5 9 14 6
15 -14 2z" />
                <path d="M5615 849 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z" />
                <path d="M1316 833 c-6 -14 -5 -15 5 -6 7 7 10 15 7 18 -3 3 -9 -2 -12 -12z" />
                <path d="M5669 843 c-1 -4 -1 -11 0 -15 1 -8 -16 -12 -34 -8 -5 1 -1 -8 9 -19
20 -22 31 -28 21 -11 -9 14 14 42 27 34 6 -4 5 -10 -3 -16 -10 -7 -8 -8 8 -3
15 4 25 0 32 -12 8 -14 12 -15 20 -6 6 7 8 11 5 8 -4 -2 -24 9 -45 26 -22 17
-40 27 -40 22z" />
                <path d="M5751 841 c-7 -5 -10 -14 -7 -20 11 -18 25 -13 23 9 -1 11 -1 20 -2
20 0 0 -6 -4 -14 -9z" />
                <path d="M1186 832 c-2 -4 -1 -14 5 -22 7 -12 9 -10 9 8 0 23 -5 28 -14 14z" />
                <path d="M1250 824 c0 -8 5 -12 10 -9 6 4 8 11 5 16 -9 14 -15 11 -15 -7z" />
                <path d="M488 798 c9 -12 10 -18 2 -23 -8 -5 -8 -11 -1 -19 6 -7 9 -15 6 -17
-2 -3 4 -5 14 -5 11 0 17 6 14 13 -3 7 -9 10 -14 7 -5 -3 -9 2 -9 11 0 11 5
15 15 11 23 -9 18 0 -12 20 -22 14 -25 14 -15 2z" />
                <path d="M5764 785 c-18 -20 -19 -25 -7 -30 13 -4 13 -8 3 -21 -11 -12 -11
-17 0 -27 10 -9 11 -9 6 0 -4 7 2 23 14 35 13 15 17 25 10 32 -20 20 -9 29 13
10 l22 -19 -19 23 c-11 12 -20 22 -20 22 -1 0 -11 -11 -22 -25z m20 -26 c-3
-5 -10 -7 -15 -3 -5 3 -7 10 -3 15 3 5 10 7 15 3 5 -3 7 -10 3 -15z" />
                <path d="M4195 791 c-3 -5 -2 -12 3 -15 5 -3 9 1 9 9 0 17 -3 19 -12 6z" />
                <path d="M5886 773 c-6 -14 -5 -15 5 -6 7 7 10 15 7 18 -3 3 -9 -2 -12 -12z" />
                <path d="M4246 768 c5 -7 9 -16 9 -20 0 -14 13 -18 18 -5 3 7 -4 19 -15 26
-16 10 -19 10 -12 -1z" />
                <path d="M4165 750 c-3 -6 1 -7 9 -4 18 7 21 14 7 14 -6 0 -13 -4 -16 -10z" />
                <path d="M67 743 c-4 -3 -7 -11 -7 -17 0 -6 5 -5 12 2 6 6 9 14 7 17 -3 3 -9
2 -12 -2z" />
                <path d="M1208 743 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M286 724 c-9 -23 -2 -28 13 -10 7 8 8 17 3 20 -6 3 -13 -1 -16 -10z" />
                <path d="M998 733 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M1152 731 c-11 -7 -10 -9 3 -14 9 -4 14 -3 10 2 -3 5 1 12 7 14 7 3
9 6 3 6 -5 0 -16 -3 -23 -8z" />
                <path d="M891 714 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M1083 723 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z" />
                <path d="M315 700 c-10 -12 -24 -19 -31 -16 -7 3 -15 -2 -18 -10 -3 -9 -11
-12 -18 -8 -7 4 -4 -2 6 -14 24 -27 26 -27 18 0 -4 16 -1 20 9 16 8 -3 24 7
37 23 27 33 24 39 -3 9z" />
                <path d="M758 713 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M4238 706 c-10 -7 -15 -16 -11 -20 4 -4 1 -12 -7 -17 -13 -9 -13 -10
0 -6 8 3 35 -14 60 -37 24 -22 37 -32 27 -20 -9 11 -15 24 -12 27 3 4 2 5 -2
2 -3 -3 -17 4 -29 16 -18 17 -21 26 -14 45 11 28 11 28 -12 10z" />
                <path d="M45 700 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8
-4 -11 -10z" />
                <path d="M500 706 c0 -9 50 -12 62 -5 8 6 -1 9 -24 9 -21 0 -38 -2 -38 -4z" />
                <path d="M571 688 c-7 -13 -10 -20 -6 -16 4 4 16 3 26 -3 16 -8 19 -6 18 13 0
13 -3 17 -6 11 -2 -7 -9 -13 -14 -13 -4 0 -6 7 -3 15 9 22 1 18 -15 -7z" />
                <path d="M6043 703 c4 -3 1 -13 -6 -22 -11 -14 -10 -14 5 -2 16 12 16 31 1 31
-4 0 -3 -3 0 -7z" />
                <path d="M75 691 c-3 -5 -2 -12 3 -15 5 -3 9 1 9 9 0 17 -3 19 -12 6z" />
                <path d="M633 693 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z" />
                <path d="M740 681 c0 -5 9 -7 20 -4 11 3 20 7 20 9 0 2 -9 4 -20 4 -11 0 -20
-4 -20 -9z" />
                <path d="M958 683 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M26 663 c-6 -14 -5 -15 5 -6 7 7 10 15 7 18 -3 3 -9 -2 -12 -12z" />
                <path d="M194 672 c-6 -4 -8 -16 -4 -27 6 -17 7 -16 12 8 3 15 5 27 4 27 0 0
-6 -4 -12 -8z" />
                <path d="M526 664 c-9 -23 -8 -24 12 -23 12 0 13 2 3 6 -10 4 -10 7 -1 13 8 5
8 10 2 14 -5 3 -13 -1 -16 -10z" />
                <path d="M1397 669 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 -14 6 -15 5 -6 -5z" />
                <path d="M1550 655 c0 -14 4 -25 9 -25 4 0 6 11 3 25 -2 14 -6 25 -8 25 -2 0
-4 -11 -4 -25z" />
                <path d="M480 660 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z" />
                <path d="M4153 663 c12 -8 8 -33 -5 -29 -7 1 -10 1 -5 -1 4 -3 7 -12 7 -20 0
-11 -7 -14 -26 -9 -15 4 -23 3 -20 -3 3 -5 1 -11 -6 -13 -9 -3 -9 -6 0 -12 7
-4 12 -2 12 3 0 6 11 11 25 11 16 0 25 6 25 15 0 8 8 15 18 15 14 0 15 2 2 10
-13 9 -13 11 0 20 9 6 10 10 3 10 -6 0 -17 2 -25 3 -7 2 -10 2 -5 0z" />
                <path d="M4323 653 c4 -3 2 -12 -4 -20 -15 -17 -2 -17 16 1 14 14 10 26 -8 26
-6 0 -7 -3 -4 -7z" />
                <path d="M772 634 c-14 -16 -5 -18 17 -5 7 5 9 11 5 14 -5 3 -15 -1 -22 -9z" />
                <path d="M877 630 c-3 -12 0 -20 7 -20 6 0 12 9 12 20 0 11 -3 20 -7 20 -4 0
-9 -9 -12 -20z" />
                <path d="M1300 640 c-18 -12 -2 -12 25 0 13 6 15 9 5 9 -8 0 -22 -4 -30 -9z" />
                <path d="M1400 621 c0 -17 2 -31 4 -31 8 0 13 51 5 56 -5 3 -9 -9 -9 -25z" />
                <path d="M4206 635 c-9 -24 -7 -32 3 -16 5 7 14 10 21 6 9 -6 9 -10 -1 -17
-11 -8 -11 -9 1 -5 8 3 30 -9 47 -26 32 -30 32 -31 15 -51 -17 -21 -17 -21 4
-4 20 17 21 17 43 -6 22 -24 22 -25 4 -43 -10 -11 -19 -26 -21 -34 -1 -8 10 0
24 16 23 27 26 28 21 8 -3 -13 -1 -23 4 -23 5 0 9 -7 9 -15 0 -8 4 -15 10 -15
6 0 6 9 0 26 -13 33 -13 34 8 35 9 0 12 3 5 5 -7 3 -10 11 -7 19 3 7 1 16 -5
20 -6 3 -9 0 -5 -8 3 -8 1 -18 -5 -21 -6 -4 -14 8 -20 26 -5 18 -10 27 -10 19
-1 -11 -4 -11 -16 -1 -14 12 -11 35 4 26 4 -3 8 1 8 9 0 20 -13 19 -21 -2 -6
-14 -16 -7 -60 36 -43 43 -54 49 -60 36z" />
                <path d="M6068 636 c-17 -13 -14 -26 5 -26 6 0 7 3 4 7 -4 3 -2 12 4 20 14 16
9 16 -13 -1z" />
                <path d="M11 624 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M240 631 c0 -5 7 -15 17 -22 15 -13 15 -12 4 9 -12 23 -21 28 -21 13z" />
                <path d="M584 620 c0 -11 4 -20 8 -20 4 0 8 9 8 20 0 11 -4 20 -8 20 -4 0 -8
-9 -8 -20z" />
                <path d="M1659 628 c-1 -7 0 -19 1 -27 1 -9 -4 -12 -14 -8 -24 9 -19 1 10 -18
17 -11 24 -12 18 -4 -4 8 -7 26 -5 41 1 16 0 28 -3 28 -3 0 -7 -6 -7 -12z" />
                <path d="M4367 621 c-4 -15 -10 -20 -18 -15 -8 5 -10 3 -4 -5 10 -17 39 11 33
30 -3 8 -7 4 -11 -10z" />
                <path d="M4393 625 c-3 -9 -3 -18 -1 -21 3 -3 8 4 11 16 6 23 -1 27 -10 5z" />
                <path d="M500 621 c0 -5 -8 -12 -17 -14 -14 -4 -13 -5 3 -6 12 0 24 6 28 14 3
8 1 15 -4 15 -6 0 -10 -4 -10 -9z" />
                <path d="M717 624 c-3 -3 -2 -16 3 -29 5 -13 6 -26 3 -29 -4 -3 -2 -6 4 -6 6
0 13 7 17 15 3 8 1 15 -5 15 -6 0 -9 7 -6 15 6 15 -6 29 -16 19z" />
                <path d="M1220 620 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z" />
                <path d="M1580 626 c0 -3 9 -10 20 -16 11 -6 20 -8 20 -6 0 3 -9 10 -20 16
-11 6 -20 8 -20 6z" />
                <path d="M4070 600 c-6 -11 -8 -20 -6 -20 3 0 10 9 16 20 6 11 8 20 6 20 -3 0
-10 -9 -16 -20z" />
                <path d="M830 606 c0 -2 7 -6 15 -10 8 -3 15 -1 15 4 0 6 -7 10 -15 10 -8 0
-15 -2 -15 -4z" />
                <path d="M165 591 c-3 -5 -2 -12 3 -15 5 -3 9 1 9 9 0 17 -3 19 -12 6z" />
                <path d="M241 586 c-1 -19 25 -45 44 -45 6 0 2 4 -8 10 -10 6 -22 20 -27 32
-8 19 -9 20 -9 3z" />
                <path d="M610 591 c0 -5 9 -7 20 -4 11 3 20 7 20 9 0 2 -9 4 -20 4 -11 0 -20
-4 -20 -9z" />
                <path d="M666 589 c3 -5 12 -9 20 -9 8 0 14 -5 14 -11 0 -5 5 -7 10 -4 15 9 4
22 -25 27 -13 3 -22 1 -19 -3z" />
                <path d="M770 593 c0 -5 5 -15 10 -23 7 -12 9 -10 7 8 -1 19 -17 33 -17 15z" />
                <path d="M968 593 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M1556 585 c-3 -8 -1 -15 4 -15 13 0 22 18 11 24 -5 3 -11 -1 -15 -9z" />
                <path d="M4190 590 c0 -4 9 -10 20 -13 11 -3 20 -2 20 3 0 4 -9 10 -20 13 -11
3 -20 2 -20 -3z" />
                <path d="M4447 593 c-11 -11 -8 -20 7 -20 8 0 12 6 9 14 -6 15 -7 15 -16 6z" />
                <path d="M202 570 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z" />
                <path d="M886 582 c6 -4 14 -14 17 -22 4 -10 6 -8 6 8 1 15 -5 22 -16 22 -11
0 -14 -3 -7 -8z" />
                <path d="M550 576 c0 -2 9 -6 20 -9 11 -3 20 -1 20 4 0 5 -9 9 -20 9 -11 0
-20 -2 -20 -4z" />
                <path d="M637 573 c-8 -13 12 -53 25 -52 10 0 10 2 1 6 -21 8 -15 22 7 18 30
-6 38 -13 35 -33 -1 -9 0 -11 2 -4 4 11 7 11 20 0 15 -12 15 -11 2 10 -8 12
-22 25 -31 28 -10 3 -18 9 -18 14 0 4 -10 6 -22 2 -14 -3 -19 -2 -14 6 4 7 5
12 2 12 -3 0 -7 -3 -9 -7z" />
                <path d="M998 573 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M1136 571 c-3 -5 1 -11 9 -14 9 -4 12 -1 8 9 -6 16 -10 17 -17 5z" />
                <path d="M1392 560 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z" />
                <path d="M4140 564 c0 -8 5 -12 10 -9 6 4 8 11 5 16 -9 14 -15 11 -15 -7z" />
                <path d="M350 566 c0 -2 8 -10 18 -17 15 -13 16 -12 3 4 -13 16 -21 21 -21 13z" />
                <path d="M490 560 c0 -6 7 -10 15 -10 8 0 15 2 15 4 0 2 -7 6 -15 10 -8 3 -15
1 -15 -4z" />
                <path d="M4493 556 c0 -8 6 -12 14 -9 7 3 13 9 13 14 0 5 -6 9 -13 9 -8 0 -14
-6 -14 -14z" />
                <path d="M153 550 c-30 -12 -29 -18 2 -12 14 2 25 8 25 13 0 5 -1 9 -2 8 -2 0
-13 -4 -25 -9z" />
                <path d="M1570 544 c0 -8 5 -12 10 -9 6 4 8 11 5 16 -9 14 -15 11 -15 -7z" />
                <path d="M1690 556 c0 -3 9 -10 20 -16 11 -6 20 -8 20 -6 0 3 -9 10 -20 16
-11 6 -20 8 -20 6z" />
                <path d="M228 538 c-4 -10 -3 -20 2 -23 5 -3 6 -13 3 -23 -3 -9 -4 -15 -2 -12
2 3 13 15 24 28 15 18 16 22 3 17 -11 -4 -17 0 -20 12 -3 17 -4 17 -10 1z" />
                <path d="M550 546 c0 -9 30 -14 35 -6 4 6 -3 10 -14 10 -12 0 -21 -2 -21 -4z" />
                <path d="M870 540 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4
-4 -4 -10z" />
                <path d="M1646 535 c4 -8 8 -15 10 -15 2 0 4 7 4 15 0 8 -4 15 -10 15 -5 0 -7
-7 -4 -15z" />
                <path d="M4080 540 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z" />
                <path d="M4536 539 c3 -5 -2 -9 -11 -9 -10 0 -13 -5 -9 -12 6 -10 4 -10 -8 0
-14 11 -19 9 -37 -14 -15 -19 -18 -30 -10 -35 8 -5 7 -8 -2 -13 -8 -3 -6 -5 6
-4 38 3 67 -12 62 -33 -3 -10 -2 -19 3 -19 15 0 18 39 3 44 -8 4 -13 13 -9 21
7 20 -11 29 -22 10 -7 -14 -10 -14 -21 -2 -9 12 -9 17 0 23 8 4 9 3 5 -4 -4
-7 -3 -12 3 -12 5 0 13 4 16 10 4 6 15 4 30 -6 14 -9 22 -21 18 -27 -4 -6 -1
-7 7 -2 10 6 12 3 8 -13 -4 -12 -1 -25 4 -29 7 -3 8 -1 4 5 -4 7 -2 12 4 12 6
0 9 4 5 9 -3 5 -1 12 4 15 5 4 12 2 15 -3 4 -5 2 -12 -4 -16 -12 -8 -13 -55
-1 -55 5 0 7 8 4 18 -2 10 3 24 11 31 9 8 16 12 17 10 7 -35 4 -47 -14 -73
-14 -20 -16 -26 -5 -18 13 11 22 11 40 1 37 -19 68 -51 68 -71 0 -17 1 -17 18
-1 10 11 13 20 7 22 -5 2 -12 7 -15 10 -3 3 -14 11 -25 18 -11 6 -19 16 -18
22 2 6 -4 8 -12 5 -15 -6 -21 7 -9 19 9 9 64 -21 64 -35 0 -7 8 -2 17 12 12
17 13 25 5 28 -22 7 -12 23 11 18 12 -3 16 -3 9 0 -6 3 -10 10 -7 15 4 5 -2 6
-11 2 -13 -5 -15 -3 -9 7 5 9 4 11 -4 6 -6 -4 -9 -11 -6 -16 3 -5 1 -11 -4
-14 -5 -4 -12 -2 -16 3 -3 5 -14 8 -25 6 -11 -2 -33 10 -55 30 -35 34 -35 35
-19 60 15 23 15 25 0 19 -9 -3 -14 -10 -11 -14 2 -4 -4 -15 -15 -25 -11 -10
-21 -15 -21 -12 -1 4 -2 10 -3 15 -3 17 -18 32 -27 27 -5 -3 -6 1 -3 9 3 8 12
12 20 9 8 -3 14 -1 14 5 0 5 -9 12 -20 15 -11 3 -18 1 -14 -4z m123 -165 c-14
-18 -24 -11 -15 11 3 9 11 13 16 10 8 -5 7 -11 -1 -21z m69 8 c12 -7 19 -18
16 -24 -5 -7 -11 -6 -19 5 -7 9 -14 14 -17 12 -3 -3 -11 1 -17 9 -15 18 2 17
37 -2z" />
                <path d="M387 525 c-4 -8 -2 -17 2 -20 5 -2 11 4 14 15 6 23 -8 27 -16 5z" />
                <path d="M335 520 c4 -6 11 -8 16 -5 14 9 11 15 -7 15 -8 0 -12 -5 -9 -10z" />
                <path d="M938 523 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z" />
                <path d="M1380 520 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z" />
                <path d="M480 511 c0 -5 -9 -11 -20 -14 -11 -3 -20 -11 -19 -19 0 -10 2 -10 6
0 2 6 13 12 24 12 10 0 19 7 19 15 0 8 -2 15 -5 15 -3 0 -5 -4 -5 -9z" />
                <path d="M555 510 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z" />
                <path d="M1634 511 c4 -6 22 -18 39 -27 30 -14 31 -14 12 1 -30 25 -59 39 -51
26z" />
                <path d="M1808 502 c-4 -12 1 -18 13 -18 12 0 15 4 9 12 -6 6 -7 14 -3 17 3 4
2 7 -4 7 -6 0 -13 -8 -15 -18z" />
                <path d="M785 490 c10 -11 20 -20 23 -20 3 0 -3 9 -13 20 -10 11 -20 20 -23
20 -3 0 3 -9 13 -20z" />
                <path d="M1580 461 c0 -37 4 -50 18 -56 14 -5 15 -4 5 6 -7 7 -13 28 -13 47 0
24 3 31 13 26 8 -5 8 -2 -2 9 -7 9 -15 17 -17 17 -2 0 -4 -22 -4 -49z" />
                <path d="M4160 499 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z" />
                <path d="M348 493 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M648 488 c5 -5 16 -8 23 -6 8 3 3 7 -10 11 -17 4 -21 3 -13 -5z" />
                <path d="M4260 485 c-7 -9 -8 -15 -2 -15 5 0 12 7 16 15 3 8 4 15 2 15 -2 0
-9 -7 -16 -15z" />
                <path d="M380 486 c0 -2 7 -7 16 -10 8 -3 12 -2 9 4 -6 10 -25 14 -25 6z" />
                <path d="M740 480 c0 -5 4 -10 9 -10 6 0 13 5 16 10 3 6 -1 10 -9 10 -9 0 -16
-4 -16 -10z" />
                <path d="M1860 480 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z" />
                <path d="M4635 480 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7
-4 -4 -10z" />
                <path d="M1046 434 c-32 -57 -32 -59 -4 -61 16 -2 19 0 9 6 -10 7 -9 17 9 51
30 58 18 62 -14 4z" />
                <path d="M1192 460 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z" />
                <path d="M1630 466 c16 -16 12 -26 -7 -19 -22 8 -17 3 27 -27 31 -21 33 -21
17 -3 -10 11 -17 24 -16 29 3 20 -2 31 -16 31 -11 0 -12 -4 -5 -11z" />
                <path d="M3990 464 c0 -8 5 -12 10 -9 6 4 8 11 5 16 -9 14 -15 11 -15 -7z" />
                <path d="M4140 476 c0 -2 12 -12 28 -21 l27 -18 -19 21 c-17 20 -36 29 -36 18z" />
                <path d="M231 443 c2 -24 2 -25 6 -5 5 24 18 29 26 10 4 -10 6 -10 6 0 1 14
28 17 33 3 2 -5 9 -3 16 5 11 12 5 14 -38 14 -48 0 -50 -1 -49 -27z" />
                <path d="M1770 455 c14 -17 -1 -27 -19 -12 -14 10 -14 10 -3 -5 19 -23 6 -43
-16 -26 -15 12 -16 11 -3 -5 13 -16 13 -20 0 -28 -8 -5 -9 -9 -4 -9 6 0 1 -7
-9 -15 -11 -8 -16 -15 -12 -15 5 0 3 -7 -4 -15 -7 -8 -10 -15 -6 -15 3 0 18
18 32 40 15 22 30 37 35 34 5 -3 7 1 4 8 -3 7 3 26 13 41 17 24 20 26 32 12
10 -13 8 -22 -15 -55 -15 -22 -32 -37 -39 -33 -6 3 -8 3 -4 -2 4 -4 3 -14 -3
-22 -6 -7 -7 -13 -3 -13 5 0 15 9 22 20 7 12 18 18 24 14 7 -4 8 -3 4 5 -4 6
-2 18 4 27 10 12 16 12 29 2 14 -11 14 -11 3 4 -11 13 -11 21 -1 40 6 13 8 20
4 16 -5 -4 -15 -3 -22 4 -20 16 -56 19 -43 3z" />
                <path d="M4198 463 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M4670 455 c0 -8 7 -15 16 -15 8 0 13 -4 10 -9 -7 -11 21 -8 31 4 4 4
3 5 -3 2 -6 -3 -21 3 -32 14 -18 16 -22 17 -22 4z" />
                <path d="M1101 444 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M1863 444 c10 -12 15 -29 11 -40 -5 -18 -5 -18 6 0 10 15 8 22 -11
40 -23 21 -23 21 -6 0z" />
                <path d="M4226 444 c-3 -8 -11 -12 -17 -8 -8 4 -9 3 -5 -4 4 -7 3 -12 -3 -12
-10 0 -9 -19 3 -38 4 -7 2 -20 -5 -30 -10 -12 -8 -12 9 2 19 17 21 21 7 28
-13 8 -13 12 1 33 9 14 23 25 31 25 8 0 11 5 8 10 -9 15 -22 12 -29 -6z" />
                <path d="M390 439 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z" />
                <path d="M521 434 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M575 430 c11 -5 29 -9 40 -9 l20 0 -20 9 c-11 5 -29 9 -40 9 l-20 0
20 -9z" />
                <path d="M4140 427 c0 -15 -3 -16 -21 -7 -11 7 -23 9 -27 6 -3 -3 0 -6 6 -6 6
0 17 -6 24 -13 18 -18 41 3 27 24 -7 11 -9 10 -9 -4z" />
                <path d="M40 426 c0 -2 8 -10 18 -17 15 -13 16 -12 3 4 -13 16 -21 21 -21 13z" />
                <path d="M724 421 c4 -5 0 -12 -6 -14 -10 -4 -9 -6 1 -6 8 -1 23 -9 33 -18 18
-16 18 -16 12 0 -3 9 -10 17 -15 17 -5 0 -9 7 -9 15 0 8 -5 15 -11 15 -5 0 -8
-4 -5 -9z" />
                <path d="M932 416 c7 -8 16 -12 21 -9 11 7 -2 23 -19 23 -12 0 -12 -2 -2 -14z" />
                <path d="M658 413 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M4237 413 c-10 -9 -9 -23 1 -23 5 0 9 7 9 15 0 17 -1 18 -10 8z" />
                <path d="M4306 412 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6 -4
-9 -8z" />
                <path d="M4488 413 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M282 387 c-18 -10 -32 -23 -32 -29 0 -5 7 -2 16 6 8 9 18 16 22 17 4
0 18 2 31 5 14 2 28 -1 33 -8 6 -10 8 -10 8 0 0 33 -31 36 -78 9z" />
                <path d="M470 401 c0 -9 -12 -12 -45 -9 -25 2 -45 0 -45 -4 0 -5 35 -7 78 -7
42 1 66 4 52 6 -14 3 -28 10 -32 17 -6 8 -8 7 -8 -3z" />
                <path d="M1141 394 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M235 390 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7
-4 -4 -10z" />
                <path d="M1625 390 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7
-4 -4 -10z" />
                <path d="M4387 384 c3 -9 9 -12 12 -7 3 4 10 11 15 16 5 4 0 7 -12 7 -15 0
-20 -4 -15 -16z" />
                <path d="M205 380 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z" />
                <path d="M1091 372 c-1 -19 3 -22 27 -16 37 9 40 14 10 14 -15 0 -29 6 -31 13
-3 6 -6 2 -6 -11z" />
                <path d="M4117 379 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 -14 6 -15 5 -6 -5z" />
                <path d="M4266 377 c2 -7 -5 -23 -16 -35 -17 -18 -18 -22 -5 -22 8 0 15 7 15
16 0 10 6 14 14 11 11 -4 13 -1 9 10 -5 13 -3 14 15 4 14 -7 19 -17 16 -29 -5
-14 -4 -15 5 -2 16 22 14 25 -24 43 -24 11 -33 12 -29 4z" />
                <path d="M135 371 c-3 -5 -1 -12 5 -16 5 -3 10 1 10 9 0 18 -6 21 -15 7z" />
                <path d="M681 363 c-1 -16 5 -23 17 -23 10 0 13 3 6 8 -6 4 -14 14 -17 22 -4
10 -6 8 -6 -7z" />
                <path d="M895 369 c8 -21 -11 -34 -28 -20 -9 7 -13 5 -13 -9 0 -10 4 -16 8
-14 4 3 8 0 8 -7 0 -6 10 0 21 15 17 21 19 30 10 39 -9 9 -11 8 -6 -4z" />
                <path d="M1340 370 c0 -13 11 -13 30 0 12 8 11 10 -7 10 -13 0 -23 -4 -23 -10z" />
                <path d="M1590 370 c0 -5 -16 -10 -35 -10 -19 0 -35 -3 -35 -8 0 -4 18 -6 40
-4 26 3 40 9 40 18 0 8 -2 14 -5 14 -3 0 -5 -4 -5 -10z" />
                <path d="M4476 365 c4 -8 8 -15 10 -15 2 0 4 7 4 15 0 8 -4 15 -10 15 -5 0 -7
-7 -4 -15z" />
                <path d="M363 352 c-7 -12 -8 -24 -2 -33 5 -8 9 -9 10 -4 0 6 2 20 5 33 5 27
2 28 -13 4z" />
                <path d="M1401 354 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M1610 366 c0 -3 9 -10 20 -16 11 -6 20 -8 20 -6 0 3 -9 10 -20 16
-11 6 -20 8 -20 6z" />
                <path d="M4156 358 c3 -4 9 -8 15 -8 5 0 9 4 9 8 0 5 -7 9 -15 9 -8 0 -12 -4
-9 -9z" />
                <path d="M1168 353 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M4097 353 c8 -3 11 -15 8 -31 -5 -26 -5 -26 5 -4 11 26 6 42 -13 41
-9 0 -9 -2 0 -6z" />
                <path d="M4350 336 c-15 -39 -12 -46 6 -13 9 16 13 31 10 34 -3 3 -10 -6 -16
-21z" />
                <path d="M321 334 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M518 338 c-7 -16 7 -45 14 -32 3 5 2 18 -2 28 -5 16 -8 17 -12 4z" />
                <path d="M4390 340 c-20 -12 -10 -19 14 -10 11 3 15 9 10 13 -6 3 -16 2 -24
-3z" />
                <path d="M1240 329 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z" />
                <path d="M2071 324 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M4050 330 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z" />
                <path d="M4141 330 c-9 -5 -5 -9 10 -13 28 -7 31 -6 14 10 -6 6 -18 8 -24 3z" />
                <path d="M25 313 c11 -11 22 -19 24 -17 2 2 11 -2 19 -9 13 -10 14 -9 8 1 -4
6 -22 19 -39 28 -32 16 -32 16 -12 -3z" />
                <path d="M1081 314 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M1131 314 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M1323 323 c-7 -3 -13 -12 -13 -21 0 -15 2 -15 10 -2 9 13 11 13 20 0
5 -8 10 -10 10 -5 0 18 -15 32 -27 28z" />
                <path d="M1915 320 c-4 -6 3 -10 14 -10 25 0 27 6 6 13 -8 4 -17 2 -20 -3z" />
                <path d="M1998 323 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M4458 323 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M620 316 c0 -2 7 -6 15 -10 8 -3 15 -1 15 4 0 6 -7 10 -15 10 -8 0
-15 -2 -15 -4z" />
                <path d="M881 290 c-10 -16 -20 -28 -23 -25 -2 3 -5 -2 -5 -10 0 -10 4 -12 12
-5 7 5 16 6 20 2 5 -4 5 -1 1 6 -4 7 0 24 8 37 9 14 14 25 11 25 -3 0 -13 -13
-24 -30z" />
                <path d="M1522 305 c-11 -13 -10 -15 7 -15 14 0 19 5 15 15 -7 18 -6 18 -22 0z" />
                <path d="M4410 304 c0 -10 5 -26 10 -34 8 -11 9 -7 4 15 -8 37 -14 45 -14 19z" />
                <path d="M4496 305 c4 -8 8 -15 10 -15 2 0 4 7 4 15 0 8 -4 15 -10 15 -5 0 -7
-7 -4 -15z" />
                <path d="M4524 305 c-9 -21 5 -38 20 -26 7 6 16 8 20 4 4 -4 4 1 0 11 -7 18
-8 18 -22 0 -13 -18 -14 -18 -7 4 7 24 -2 31 -11 7z" />
                <path d="M4614 309 c-2 -4 0 -10 5 -13 5 -4 13 -1 17 6 5 8 10 6 15 -8 7 -18
8 -17 8 3 1 16 -4 21 -20 20 -11 -1 -23 -5 -25 -8z" />
                <path d="M1360 306 c0 -2 7 -7 16 -10 8 -3 12 -2 9 4 -6 10 -25 14 -25 6z" />
                <path d="M4225 300 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z" />
                <path d="M4295 300 c3 -5 11 -10 16 -10 6 0 7 5 4 10 -3 6 -11 10 -16 10 -6 0
-7 -4 -4 -10z" />
                <path d="M4430 306 c0 -2 8 -10 18 -17 15 -13 16 -12 3 4 -13 16 -21 21 -21
13z" />
                <path d="M4835 300 c3 -5 11 -10 16 -10 6 0 7 5 4 10 -3 6 -11 10 -16 10 -6 0
-7 -4 -4 -10z" />
                <path d="M20 291 c0 -6 4 -13 10 -16 6 -3 7 1 4 9 -7 18 -14 21 -14 7z" />
                <path d="M926 283 c-6 -14 -5 -15 5 -6 7 7 10 15 7 18 -3 3 -9 -2 -12 -12z" />
                <path d="M450 280 l-55 -7 58 -1 c32 -1 57 2 57 8 0 6 -1 9 -2 8 -2 -1 -28 -4
-58 -8z" />
                <path d="M1172 270 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z" />
                <path d="M1461 274 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M1597 268 c11 -51 12 -53 29 -36 20 20 10 58 -16 58 -14 0 -17 -6
-13 -22z m26 -13 c4 -8 2 -17 -3 -20 -6 -4 -10 3 -10 14 0 25 6 27 13 6z" />
                <path d="M4158 283 c6 -2 12 -11 12 -19 0 -7 -6 -12 -12 -10 -7 1 -10 1 -5 -1
4 -3 7 -11 7 -18 0 -8 4 -16 9 -19 5 -4 7 3 4 14 -3 12 0 20 6 20 7 0 9 5 6
10 -3 6 0 10 7 11 14 0 -21 18 -37 18 -5 -1 -4 -3 3 -6z" />
                <path d="M4247 283 c-8 -13 20 -26 35 -16 7 3 8 1 4 -6 -4 -6 -16 -9 -27 -6
-30 10 -22 -2 9 -13 24 -8 27 -7 28 15 2 20 -2 24 -17 20 -10 -3 -20 0 -22 6
-2 8 -5 8 -10 0z" />
                <path d="M4590 279 c-13 -8 -13 -10 -1 -18 11 -7 10 -10 -5 -14 -10 -2 -5 -4
13 -3 26 1 29 4 20 15 -7 8 -10 16 -9 18 8 10 -5 11 -18 2z" />
                <path d="M4876 279 c5 -9 -1 -10 -22 -5 -21 5 -25 4 -14 -4 9 -6 10 -10 3 -10
-6 0 -15 5 -18 10 -3 6 -14 10 -23 10 -14 0 -14 -2 -3 -9 7 -5 11 -13 8 -18
-4 -6 4 -8 17 -6 13 3 34 -1 47 -8 22 -11 23 -11 10 5 -13 15 -12 18 8 23 17
4 19 8 9 14 -19 12 -30 11 -22 -2z" />
                <path d="M280 269 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z" />
                <path d="M980 269 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z" />
                <path d="M1290 276 c0 -2 7 -7 16 -10 8 -3 12 -2 9 4 -6 10 -25 14 -25 6z" />
                <path d="M1331 264 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M1945 270 c-11 -5 -17 -9 -13 -9 3 -1 13 -3 21 -6 8 -4 14 0 14 10 0
8 -1 15 -1 14 -1 0 -10 -4 -21 -9z" />
                <path d="M4085 270 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7
-4 -4 -10z" />
                <path d="M107 256 c-3 -8 0 -16 7 -19 6 -3 13 4 13 14 2 22 -12 25 -20 5z" />
                <path d="M522 250 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z" />
                <path d="M1028 263 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M4640 242 c0 -19 5 -29 15 -29 11 0 12 4 4 13 -6 7 -8 18 -5 23 4 5
2 12 -4 16 -6 4 -10 -6 -10 -23z" />
                <path d="M5338 263 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M905 250 c-8 -13 9 -20 24 -11 10 6 9 10 -3 14 -8 3 -18 2 -21 -3z" />
                <path d="M1070 256 c0 -2 14 -6 30 -8 17 -3 30 -1 30 4 0 4 -13 8 -30 8 -16 0
-30 -2 -30 -4z" />
                <path d="M1558 253 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z" />
                <path d="M1880 250 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z" />
                <path d="M5408 253 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z" />
                <path d="M965 240 c-3 -5 1 -10 10 -10 9 0 13 5 10 10 -3 6 -8 10 -10 10 -2 0
-7 -4 -10 -10z" />
                <path d="M1452 230 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z" />
                <path d="M4071 241 c-8 -6 -9 -11 -3 -15 6 -3 14 -1 17 5 9 14 2 20 -14 10z" />
                <path d="M4431 234 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M4482 233 c-15 -13 -15 -13 3 -5 11 6 24 10 28 10 16 0 17 9 2 9 -9
0 -23 -7 -33 -14z" />
                <path d="M24 225 c-8 -20 2 -45 18 -45 10 0 10 2 -1 9 -8 5 -11 16 -6 30 7 24
-2 29 -11 6z" />
                <path d="M435 231 c33 -7 41 -35 15 -51 -8 -5 -10 -10 -4 -10 5 0 15 5 22 12
8 8 15 8 25 -1 11 -9 17 -7 28 6 11 15 11 16 -1 6 -11 -10 -17 -10 -31 3 -10
9 -15 22 -12 30 4 11 -4 14 -33 13 -37 -2 -38 -2 -9 -8z" />
                <path d="M1940 230 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z" />
                <path d="M2062 226 c7 -8 15 -12 17 -11 5 6 -10 25 -20 25 -5 0 -4 -6 3 -14z" />
                <path d="M5370 230 c42 -6 42 -9 0 -23 -9 -4 -6 -6 8 -6 12 -1 22 -5 22 -10 0
-5 7 -12 16 -15 10 -4 13 -2 7 7 -12 20 -12 37 0 37 7 0 5 5 -3 10 -8 5 -33 9
-55 8 l-40 -1 45 -7z" />
                <path d="M550 220 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z" />
                <path d="M715 193 c-8 -20 -13 -38 -10 -41 3 -3 5 0 5 7 0 8 8 10 23 6 22 -7
22 -7 2 9 -11 8 -15 16 -10 16 6 0 11 9 11 20 0 28 -4 25 -21 -17z" />
                <path d="M996 202 l-20 -27 22 18 c11 11 25 16 30 13 5 -3 9 1 9 9 0 23 -20
17 -41 -13z" />
                <path d="M2095 220 c-3 -6 1 -7 9 -4 18 7 21 14 7 14 -6 0 -13 -4 -16 -10z" />
                <path d="M4775 220 c-3 -6 1 -7 9 -4 18 7 21 14 7 14 -6 0 -13 -4 -16 -10z" />
                <path d="M4900 228 c0 -2 14 -16 30 -31 17 -16 30 -24 30 -19 0 6 -13 20 -30
32 -16 12 -30 20 -30 18z" />
                <path d="M125 210 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z" />
                <path d="M418 213 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M1474 200 c0 -11 4 -20 8 -20 4 0 8 6 8 14 0 8 6 17 13 19 6 3 3 6
-8 6 -14 1 -21 -5 -21 -19z" />
                <path d="M5295 210 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z" />
                <path d="M1104 186 c-9 -20 -9 -23 8 -18 10 2 18 13 18 23 0 26 -13 24 -26 -5z" />
                <path d="M1150 200 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z" />
                <path d="M1548 203 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z" />
                <path d="M1707 204 c-8 -8 1 -24 12 -24 4 0 8 7 8 15 0 16 -9 20 -20 9z" />
                <path d="M2101 201 c-10 -7 -7 -9 12 -8 15 1 27 5 27 10 0 10 -22 9 -39 -2z" />
                <path d="M4150 199 c0 -6 -7 -8 -16 -5 -8 3 -12 2 -9 -4 10 -15 35 -12 35 5 0
8 -2 15 -5 15 -3 0 -5 -5 -5 -11z" />
                <path d="M4206 196 c10 -8 21 -12 24 -10 5 6 -21 24 -34 24 -6 0 -1 -6 10 -14z" />
                <path d="M5091 194 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M5233 203 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z" />
                <path d="M88 193 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M1195 190 c-3 -5 1 -10 10 -10 9 0 13 5 10 10 -3 6 -8 10 -10 10 -2
0 -7 -4 -10 -10z" />
                <path d="M1443 185 c-3 -9 -3 -18 -1 -21 3 -3 8 4 11 16 6 23 -1 27 -10 5z" />
                <path d="M2006 188 c7 -10 34 -10 34 0 0 4 -9 8 -19 8 -11 0 -17 -4 -15 -8z" />
                <path d="M4440 189 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z" />
                <path d="M4535 190 c-3 -6 1 -7 9 -4 18 7 21 14 7 14 -6 0 -13 -4 -16 -10z" />
                <path d="M4714 191 c4 -6 2 -19 -5 -27 -10 -12 -9 -13 5 -8 19 7 21 30 4 40
-7 4 -8 3 -4 -5z" />
                <path d="M1915 180 c3 -5 14 -10 23 -10 15 0 15 2 2 10 -20 13 -33 13 -25 0z" />
                <path d="M4349 170 c-8 -9 -13 -22 -11 -29 3 -8 -1 -12 -9 -9 -8 3 -13 14 -11
24 2 15 1 16 -7 5 -9 -15 7 -54 19 -46 4 2 14 -4 23 -13 37 -40 46 -44 62 -28
20 20 19 32 -1 15 -14 -11 -18 -11 -29 5 -7 9 -16 17 -19 17 -17 -2 -17 0 -5
16 10 11 10 14 2 9 -16 -9 -16 -1 -2 26 14 25 8 29 -12 8z" />
                <path d="M5303 165 c2 -26 6 -29 32 -30 18 0 29 -5 28 -12 -2 -7 3 -10 10 -7
7 2 13 13 13 24 0 14 -3 16 -13 8 -8 -6 -13 -7 -13 -1 0 6 -11 8 -24 6 -19 -4
-25 0 -29 18 -4 18 -5 17 -4 -6z" />
                <path d="M662 175 c4 -4 3 -14 -4 -22 -6 -7 -9 -15 -7 -18 3 -2 10 4 17 15 9
15 9 21 -1 26 -6 4 -9 4 -5 -1z" />
                <path d="M784 154 c-1 -14 3 -21 10 -18 16 6 17 32 2 37 -6 3 -12 -6 -12 -19z" />
                <path d="M896 173 c6 -4 14 -15 17 -23 5 -11 6 -9 4 4 -1 11 -9 21 -17 23 -10
3 -11 2 -4 -4z" />
                <path d="M1175 160 c10 -11 20 -20 23 -20 3 0 -3 9 -13 20 -10 11 -20 20 -23
20 -3 0 3 -9 13 -20z" />
                <path d="M1230 163 c0 -10 4 -14 8 -8 4 6 11 13 16 18 5 4 2 7 -7 7 -10 0 -17
-8 -17 -17z" />
                <path d="M1748 173 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z" />
                <path d="M2140 169 c0 -23 -36 -53 -52 -43 -7 4 -4 -2 6 -14 22 -25 28 -28 20
-8 -3 7 7 23 22 35 21 17 25 24 16 33 -9 9 -12 8 -12 -3z" />
                <path d="M4268 168 c5 -5 16 -8 23 -6 8 3 3 7 -10 11 -17 4 -21 3 -13 -5z" />
                <path d="M5546 171 c-4 -6 4 -16 18 -23 14 -6 26 -15 26 -19 0 -15 -20 -20
-40 -9 -16 8 -18 8 -14 -4 3 -9 10 -14 14 -13 8 2 10 -3 10 -23 0 -5 -10 -19
-22 -30 l-23 -22 25 4 c18 2 24 8 22 22 -2 10 1 15 7 11 7 -4 8 0 4 11 -4 11
-3 15 5 10 6 -3 14 -1 18 5 5 8 3 9 -6 4 -8 -5 -11 -3 -8 6 3 8 11 13 17 12
19 -5 12 12 -18 41 -18 17 -31 24 -35 17z" />
                <path d="M6023 174 c-15 -7 -17 -44 -3 -44 6 0 10 9 10 20 0 11 4 20 9 20 5 0
7 -10 5 -22 l-5 -23 10 23 c12 25 21 29 21 8 0 -8 -8 -23 -17 -32 -17 -17 -17
-18 0 -11 10 4 24 7 30 7 8 0 8 3 2 8 -5 4 -10 16 -10 27 0 20 -27 29 -52 19z" />
                <path d="M285 157 c-15 -19 -16 -37 -2 -31 7 2 13 13 14 24 2 23 1 23 -12 7z" />
                <path d="M950 159 c0 -5 9 -9 20 -9 14 0 19 -6 17 -22 -2 -18 3 -21 35 -22 21
-1 46 -10 59 -21 l23 -20 -22 29 c-25 33 -28 51 -8 43 10 -4 13 -1 9 9 -8 22
-22 17 -29 -11 -7 -29 -16 -31 -34 -10 -12 14 -7 19 13 16 5 -1 6 3 2 9 -5 8
-11 8 -20 0 -8 -6 -16 -7 -19 -2 -8 13 -46 22 -46 11z m60 -33 c0 -3 -4 -8
-10 -11 -5 -3 -10 -1 -10 4 0 6 5 11 10 11 6 0 10 -2 10 -4z" />
                <path d="M1278 163 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M4205 161 c-3 -5 -2 -12 3 -15 5 -3 9 1 9 9 0 17 -3 19 -12 6z" />
                <path d="M4483 153 c-15 -10 -23 -11 -23 -4 0 8 -4 8 -14 -1 -9 -8 -11 -17 -5
-22 6 -6 13 -6 20 1 13 13 42 6 33 -8 -3 -5 1 -6 9 -3 7 2 14 11 14 18 0 9 -7
12 -16 8 -14 -5 -14 -3 -2 11 16 21 13 21 -16 0z" />
                <path d="M4903 160 c-13 -5 -23 -15 -22 -22 0 -10 2 -10 6 0 2 6 11 12 18 12
8 0 17 5 20 10 7 12 7 12 -22 0z" />
                <path d="M4980 160 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z" />
                <path d="M5470 162 c0 -5 12 -14 28 -21 l27 -13 -22 21 c-24 23 -33 26 -33 13z" />
                <path d="M1336 145 c4 -8 8 -15 10 -15 2 0 4 7 4 15 0 8 -4 15 -10 15 -5 0 -7
-7 -4 -15z" />
                <path d="M1988 153 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M4385 150 c-3 -5 1 -10 10 -10 9 0 13 5 10 10 -3 6 -8 10 -10 10 -2
0 -7 -4 -10 -10z" />
                <path d="M4786 138 c10 -14 21 -24 23 -22 3 3 -6 15 -18 27 l-24 22 19 -27z" />
                <path d="M4926 138 c-9 -12 -16 -30 -16 -40 0 -9 -4 -20 -10 -23 -5 -3 -10 -2
-10 3 0 5 -7 9 -15 9 -20 0 -19 -2 10 -21 14 -9 24 -13 24 -9 -1 4 1 16 4 26
4 9 9 24 12 33 4 11 9 13 18 7 14 -11 37 -11 37 0 0 4 0 10 0 13 0 4 -6 1 -14
-5 -16 -13 -32 2 -21 19 12 20 -4 9 -19 -12z" />
                <path d="M5243 153 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z" />
                <path d="M840 140 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z" />
                <path d="M1430 140 c0 -6 7 -10 15 -10 8 0 15 2 15 4 0 2 -7 6 -15 10 -8 3
-15 1 -15 -4z" />
                <path d="M1710 130 c11 -7 11 -10 2 -10 -7 0 -10 -4 -7 -10 3 -5 1 -10 -5 -10
-6 0 -8 -4 -5 -10 3 -5 0 -10 -7 -10 -9 0 -9 -3 2 -10 8 -5 22 -10 30 -10 12
0 12 2 1 9 -15 10 -6 51 12 51 7 0 6 4 -3 10 -8 5 -19 10 -25 10 -5 0 -3 -5 5
-10z" />
                <path d="M1780 130 c8 -5 20 -10 25 -10 6 0 3 5 -5 10 -8 5 -19 10 -25 10 -5
0 -3 -5 5 -10z" />
                <path d="M4185 131 c-3 -5 -2 -12 3 -15 5 -3 9 1 9 9 0 17 -3 19 -12 6z" />
                <path d="M4232 117 l-20 -22 25 -19 c15 -11 23 -14 19 -8 -3 6 4 18 16 26 12
9 20 17 17 19 -2 1 -11 8 -20 15 -13 10 -20 8 -37 -11z m38 -9 c0 -5 -7 -8
-14 -5 -11 4 -13 1 -9 -11 5 -14 3 -15 -7 -5 -11 10 -11 15 0 27 13 16 30 13
30 -6z" />
                <path d="M5027 129 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 -14 6 -15 5 -6 -5z" />
                <path d="M5231 124 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M5400 120 c-9 -16 -8 -19 6 -13 13 5 15 3 9 -7 -6 -9 -4 -11 5 -5 9
6 12 4 8 -7 -4 -9 0 -15 8 -15 8 0 12 2 9 5 -2 3 1 14 7 26 10 18 9 19 -4 8
-12 -10 -17 -10 -27 1 -6 8 -8 17 -4 20 3 4 3 7 0 7 -3 0 -11 -9 -17 -20z" />
                <path d="M626 122 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6 -4
-9 -8z" />
                <path d="M1650 121 c0 -10 19 -25 25 -20 1 2 -3 10 -11 17 -8 7 -14 8 -14 3z" />
                <path d="M2692 110 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z" />
                <path d="M4088 123 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M4380 126 c0 -2 7 -7 16 -10 8 -3 12 -2 9 4 -6 10 -25 14 -25 6z" />
                <path d="M4732 105 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z" />
                <path d="M141 104 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M941 104 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M1814 107 c-6 -7 -9 -18 -6 -25 2 -6 -1 -12 -8 -12 -6 0 -8 -5 -5
-10 7 -12 26 -14 24 -2 -1 4 -1 9 1 12 3 10 10 50 7 50 -1 -1 -7 -6 -13 -13z" />
                <path d="M1973 105 c-6 -6 -8 -18 -3 -24 5 -9 9 -5 13 10 7 28 6 31 -10 14z" />
                <path d="M4530 110 c0 -5 7 -10 16 -10 9 0 12 -5 8 -12 -4 -7 -3 -8 4 -4 16
10 15 14 -8 26 -14 7 -20 7 -20 0z" />
                <path d="M4828 109 c10 -13 10 -19 -2 -29 -18 -14 -40 -4 -29 13 5 8 2 8 -9 0
-8 -7 -18 -10 -22 -6 -4 4 -4 0 -1 -9 5 -12 -2 -21 -24 -33 -33 -16 -41 -32
-16 -32 8 0 12 3 10 7 -2 4 9 17 26 29 30 22 55 20 45 -5 -3 -8 0 -11 9 -7 8
3 12 9 9 15 -3 5 1 17 10 27 15 17 15 19 -1 32 -16 12 -17 12 -5 -2z" />
                <path d="M5317 113 c-12 -12 -7 -19 15 -20 13 -1 18 1 13 5 -6 4 -13 11 -16
15 -3 4 -9 4 -12 0z" />
                <path d="M6006 104 c-3 -9 -2 -12 5 -9 6 4 18 0 27 -8 9 -8 28 -20 42 -26 21
-10 22 -10 6 1 -11 7 -30 23 -43 36 -28 26 -29 26 -37 6z" />
                <path d="M183 103 c15 -2 37 -2 50 0 12 2 0 4 -28 4 -27 0 -38 -2 -22 -4z" />
                <path d="M680 100 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4
-4 -4 -10z" />
                <path d="M710 95 c0 -8 4 -15 10 -15 5 0 7 7 4 15 -4 8 -8 15 -10 15 -2 0 -4
-7 -4 -15z" />
                <path d="M1206 95 c-3 -8 -1 -15 4 -15 6 0 10 7 10 15 0 8 -2 15 -4 15 -2 0
-6 -7 -10 -15z" />
                <path d="M1857 94 c3 -7 0 -14 -6 -14 -6 0 -8 -7 -5 -15 4 -8 2 -15 -3 -15 -5
0 -9 -10 -10 -21 -2 -26 0 -24 25 28 15 33 17 43 6 47 -8 3 -11 0 -7 -10z" />
                <path d="M4465 81 c5 -44 12 -49 17 -12 2 16 1 28 -3 25 -4 -2 -10 2 -12 8 -3
7 -4 -2 -2 -21z" />
                <path d="M5062 96 c7 -8 15 -12 17 -11 5 6 -10 25 -20 25 -5 0 -4 -6 3 -14z" />
                <path d="M5268 103 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z" />
                <path d="M1634 88 c-4 -6 -3 -8 4 -4 5 3 12 1 14 -6 3 -8 6 -9 11 -1 4 6 0 13
-8 17 -8 3 -17 0 -21 -6z" />
                <path d="M4292 83 c-7 -10 -17 -25 -22 -33 -7 -12 -12 -12 -22 -2 -16 16 -25
15 -32 -4 -5 -14 -4 -15 9 -4 12 10 16 9 21 -4 5 -13 9 -14 20 -5 10 8 18 8
27 1 9 -7 17 -3 32 16 13 19 14 23 3 14 -19 -15 -31 -2 -22 22 8 21 2 20 -14
-1z m13 -33 c3 -5 2 -10 -4 -10 -5 0 -13 5 -16 10 -3 6 -2 10 4 10 5 0 13 -4
16 -10z" />
                <path d="M4995 89 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z" />
                <path d="M5231 83 c0 -13 -5 -23 -11 -23 -5 0 -7 -7 -3 -16 4 -11 8 -12 13 -4
4 7 13 9 19 6 6 -4 11 -2 11 3 0 6 -4 11 -9 11 -5 0 -12 10 -14 23 l-4 22 -2
-22z" />
                <path d="M5469 98 c-8 -26 -5 -36 9 -31 11 5 13 3 7 -7 -6 -9 -4 -11 5 -5 10
6 10 11 -3 20 -9 7 -14 15 -10 18 3 4 3 7 0 7 -4 0 -7 -1 -8 -2z" />
                <path d="M210 83 c0 -6 -10 -14 -22 -16 -16 -3 -13 -5 11 -6 l33 -1 -16 -27
c-16 -27 -16 -27 8 2 17 20 22 31 13 34 -6 2 -15 9 -19 15 -6 8 -8 8 -8 -1z" />
                <path d="M1048 79 c6 -9 8 -20 4 -24 -4 -5 -2 -5 5 -1 6 3 14 2 17 -3 4 -5 -2
-12 -11 -14 -14 -4 -13 -5 5 -6 12 0 22 -6 22 -12 0 -7 9 0 20 14 22 28 25 43
10 52 -5 3 -7 0 -4 -8 10 -26 -27 -29 -55 -5 -14 13 -20 16 -13 7z" />
                <path d="M1146 82 c-2 -4 0 -14 6 -22 8 -12 9 -11 4 5 -6 19 -5 19 8 2 11 -15
15 -15 19 -3 3 8 -1 17 -9 20 -20 8 -22 8 -28 -2z" />
                <path d="M1758 70 c-15 -17 -15 -18 5 -24 12 -3 23 -3 26 -1 2 3 -1 5 -8 5 -8
0 -10 7 -6 20 8 24 5 24 -17 0z" />
                <path d="M2320 80 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z" />
                <path d="M4643 76 c-9 -11 -9 -15 0 -19 7 -3 14 3 14 14 2 22 2 22 -14 5z" />
                <path d="M750 50 c0 -16 4 -30 8 -30 5 0 7 13 4 30 -2 17 -6 30 -8 30 -2 0 -4
-13 -4 -30z" />
                <path d="M1246 71 c-4 -5 3 -7 14 -4 22 6 30 -22 8 -29 -7 -3 -6 -7 5 -11 14
-5 17 -1 17 23 0 23 -5 30 -19 30 -11 0 -22 -4 -25 -9z" />
                <path d="M2829 63 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8 -17
-17z" />
                <path d="M4190 65 c-7 -8 -15 -13 -19 -11 -4 3 -7 -4 -7 -14 0 -10 4 -16 9
-13 4 2 16 -1 25 -8 16 -13 16 -12 0 7 -17 19 -17 21 -1 37 10 9 15 17 11 17
-3 0 -11 -7 -18 -15z" />
                <path d="M4600 69 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z" />
                <path d="M5096 60 c-10 -10 -16 -25 -13 -32 4 -8 6 -7 6 5 1 9 8 17 16 17 8 0
15 7 15 15 0 18 -1 18 -24 -5z" />
                <path d="M5706 63 c-6 -14 -5 -15 5 -6 7 7 10 15 7 18 -3 3 -9 -2 -12 -12z" />
                <path d="M1207 56 c-3 -8 -25 -19 -49 -25 -39 -10 -40 -10 -7 -7 20 3 42 -1
49 -7 10 -9 11 -9 5 2 -5 9 -2 19 9 27 9 6 13 15 8 18 -6 3 -12 -1 -15 -8z" />
                <path d="M1609 53 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8 -17
-17z" />
                <path d="M2126 54 c-3 -8 -2 -13 3 -9 5 3 12 -1 14 -7 4 -8 6 -7 6 4 1 23 -15
32 -23 12z" />
                <path d="M5509 53 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8 -17
-17z" />
                <path d="M513 53 c-15 -5 -17 -23 -4 -23 5 0 11 7 15 15 3 8 4 15 3 14 -1 0
-8 -3 -14 -6z" />
                <path d="M2321 44 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
                <path d="M4409 43 c-13 -16 -12 -17 3 -5 14 11 18 10 26 -4 8 -15 10 -15 16 2
4 10 4 15 0 11 -4 -4 -13 -2 -19 3 -9 7 -17 5 -26 -7z" />
                <path d="M4866 47 c3 -8 11 -14 19 -14 20 0 19 4 -5 17 -15 8 -18 8 -14 -3z" />
                <path d="M5278 53 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z" />
                <path d="M5356 43 c-4 -9 -2 -21 4 -27 7 -7 10 -3 10 12 0 15 5 20 15 16 8 -4
12 -10 9 -15 -3 -5 0 -9 5 -9 18 0 12 19 -8 30 -26 13 -28 13 -35 -7z" />
                <path d="M951 41 c-8 -5 -9 -11 -3 -15 5 -3 12 1 16 9 6 17 6 18 -13 6z" />
                <path d="M4329 23 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8 -17
-17z" />
                <path d="M4485 29 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z" />
                <path d="M4845 31 c-3 -5 -1 -12 5 -16 5 -3 10 1 10 9 0 18 -6 21 -15 7z" />
                <path d="M4998 33 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z" />
                <path d="M5580 29 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z" />
                <path d="M5775 30 c-4 -6 -11 -7 -17 -4 -7 4 -8 2 -4 -5 6 -8 12 -9 20 -2 7 6
17 7 21 3 5 -4 5 -1 1 6 -9 15 -13 15 -21 2z" />
                <path d="M5965 29 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z" />
                <path d="M6026 31 c-3 -5 1 -11 9 -14 9 -4 12 -1 8 9 -6 16 -10 17 -17 5z" />
                <path d="M18 23 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
                <path d="M276 22 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6 -4 -9
-8z" />
                <path d="M976 18 c3 -5 10 -6 15 -3 13 9 11 12 -6 12 -8 0 -12 -4 -9 -9z" />
                <path d="M1938 23 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
            </g>
        </svg>
    )
}